(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mayday-modules"] = factory();
	else
		root["mayday-modules"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 8764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__(9742)
const ieee754 = __webpack_require__(645)
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

const K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 6077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 5787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(7976);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 3658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var isArray = __webpack_require__(3157);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var definePropertyModule = __webpack_require__(3070);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 5117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 4154:
/***/ (function(module) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ (function(module) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 3678:
/***/ (function(module) {

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),

/***/ 8113:
/***/ (function(module) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 1060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 5668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var aCallable = __webpack_require__(9662);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(9662);
var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 9587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var setPrototypeOf = __webpack_require__(7674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(4811);
var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 3157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 6277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(1340);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 7674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(5668);
var anObject = __webpack_require__(9670);
var aPossiblePrototype = __webpack_require__(6077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 9405:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

// eslint-disable-next-line es/no-set -- safe
var SetPrototype = Set.prototype;

module.exports = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis(SetPrototype.add),
  has: uncurryThis(SetPrototype.has),
  remove: uncurryThis(SetPrototype['delete']),
  proto: SetPrototype,
  $has: SetPrototype.has,
  $keys: SetPrototype.keys
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.29.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.29.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 1340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(648);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 6330:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 4811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(6293);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 7658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var setArrayLength = __webpack_require__(3658);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var fails = __webpack_require__(7293);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 541:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var setArrayLength = __webpack_require__(3658);
var deletePropertyOrThrow = __webpack_require__(5117);
var doesNotExceedSafeInteger = __webpack_require__(7207);

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return setArrayLength(O, len + argCount);
  }
});


/***/ }),

/***/ 2801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var getBuiltIn = __webpack_require__(5005);
var createPropertyDescriptor = __webpack_require__(9114);
var defineProperty = (__webpack_require__(3070).f);
var hasOwn = __webpack_require__(2597);
var anInstance = __webpack_require__(5787);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var DOMExceptionConstants = __webpack_require__(3678);
var clearErrorStack = __webpack_require__(1060);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),

/***/ 7856:
/***/ (function(module) {

/*! @license DOMPurify 2.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.5/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.5';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ 645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 1296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 2235:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='21' height='26' viewBox='0 0 21 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cmask id='path-1-inside-1' fill='white'%3e %3crect width='20.73' height='26' rx='0.5'/%3e %3c/mask%3e %3crect width='20.73' height='26' rx='0.5' stroke='%23FCBF49' stroke-width='2' mask='url(%23path-1-inside-1)'/%3e %3crect x='2' y='3' width='10' height='7' rx='0.5' fill='%23FCBF49' fill-opacity='0.4'/%3e %3cline x1='2.5' y1='12.5' x2='18.8982' y2='12.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3cline x1='2.5' y1='15.5' x2='18.8982' y2='15.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3cline x1='14.5' y1='3.5' x2='18.5' y2='3.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3cline x1='14.5' y1='6.5' x2='18.5' y2='6.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3cline x1='14.5' y1='9.5' x2='18.5' y2='9.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3cline x1='2.5' y1='18.5' x2='18.8982' y2='18.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3cline x1='2.5' y1='21.5' x2='12.5' y2='21.5' stroke='%23FCBF49' stroke-linecap='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 436:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0)'%3e %3crect x='5.25' y='3.25' width='14.1115' height='17.8261' rx='0.25' stroke='%23FCBF49' stroke-width='0.5'/%3e %3crect x='6.40965' y='5.11458' width='7.0485' height='4.93395' rx='0.5' fill='%23FCBF49' fill-opacity='0.4'/%3e %3cline x1='6.65965' y1='11.9131' x2='18.4228' y2='11.9131' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3cline x1='6.65965' y1='14.0276' x2='18.4228' y2='14.0276' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3cline x1='15.118' y1='5.56935' x2='18.1422' y2='5.56935' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3cline x1='15.118' y1='7.68394' x2='18.1422' y2='7.68395' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3cline x1='15.118' y1='9.79854' x2='18.1422' y2='9.79854' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3cline x1='6.65965' y1='16.1421' x2='18.4228' y2='16.1421' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3cline x1='6.65965' y1='18.2567' x2='13.913' y2='18.2567' stroke='%23FCBF49' stroke-width='0.5' stroke-linecap='round'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='24' height='24' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e"

/***/ }),

/***/ 3298:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e %3csvg width='102px' height='102px' viewBox='0 0 102 102' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 49.3 (51167) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3eclose-icon%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e%3c/defs%3e %3cg id='close-icon' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e %3cg id='Group' transform='translate(50.568542%2c 50.568542) rotate(45.000000) translate(-50.568542%2c -50.568542) translate(10.568542%2c 10.568542)' stroke='%239B9B9B' stroke-width='11'%3e %3cpath d='M40%2c0 L40%2c80' id='Line'%3e%3c/path%3e %3cpath d='M0%2c40 L80%2c40' id='Line'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/svg%3e"

/***/ }),

/***/ 6271:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='15' height='17' viewBox='0 0 15 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='2.54716' y='1.41663' width='11.462' height='4.25' rx='0.5' fill='%230081F9'/%3e %3crect x='2.54716' y='7.08337' width='11.462' height='4.25' rx='0.5' fill='%230081F9'/%3e %3crect x='2.54716' y='12.75' width='11.462' height='4.25' rx='0.5' fill='%230081F9' fill-opacity='0.3'/%3e %3cline x1='0.25' y1='0.25' x2='0.25' y2='14.625' stroke='%230081F9' stroke-width='0.5' stroke-linecap='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 6520:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='6.74585' y='4.40717' width='12.3561' height='4.58152' rx='0.5' fill='%230081F9'/%3e %3crect x='6.74585' y='10.5159' width='12.3561' height='4.58153' rx='0.5' fill='%230081F9'/%3e %3crect x='6.74585' y='16.6246' width='12.3561' height='4.58152' rx='0.5' fill='%230081F9' fill-opacity='0.3'/%3e %3cline x1='4.25' y1='3.13' x2='4.25' y2='18.6653' stroke='%230081F9' stroke-width='0.5' stroke-linecap='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 1311:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='2' y='5' width='9.43928' height='3.5' rx='0.5' fill='%230081F9'/%3e %3cline x1='0.25' y1='0.25' x2='0.25' y2='12' stroke='%230081F9' stroke-width='0.5' stroke-linecap='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 3320:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='23' height='26' viewBox='0 0 23 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='4.52051' y='2.16699' width='17.5301' height='6.5' rx='0.5' fill='%230081F9'/%3e %3crect x='4.52051' y='10.833' width='17.5301' height='6.5' rx='0.5' fill='%230081F9'/%3e %3crect x='4.52051' y='19.5' width='17.5301' height='6.5' rx='0.5' fill='%230081F9' fill-opacity='0.3'/%3e %3cline x1='0.875' y1='0.25' x2='0.875' y2='22.5' stroke='%230081F9' stroke-width='0.5' stroke-linecap='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 4816:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='6.74586' y='4.59081' width='12.3561' height='4.77242' rx='0.5' fill='%230081F9'/%3e %3crect x='6.74586' y='10.9541' width='12.3561' height='4.77242' rx='0.5' fill='%230081F9'/%3e %3crect x='6.74586' y='17.3173' width='12.3561' height='4.77242' rx='0.5' fill='%230081F9' fill-opacity='0.3'/%3e %3cline x1='4.25' y1='3.25' x2='4.25' y2='19.4535' stroke='%230081F9' stroke-width='0.5' stroke-linecap='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 4759:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M13.8741 3.14527L12.1249 10.5569H16.7615C16.9559 10.5569 17.0669 10.7717 16.9559 10.9328L10.2092 20.9493C10.1537 21.0567 9.98711 20.9761 10.0149 20.8687L11.6807 13.108H7.23847C7.04412 13.108 6.93306 12.8932 7.04412 12.732L13.7075 3.03785C13.7353 2.95729 13.9018 3.011 13.8741 3.14527Z' fill='%23FCBF49'/%3e %3c/svg%3e"

/***/ }),

/***/ 9171:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='22' height='23' viewBox='0 0 22 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='15' cy='7' r='6.5' stroke='%23ADB5BD'/%3e %3cline x1='10' y1='12.7071' x2='0.707107' y2='22' stroke='%23ADB5BD' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e"

/***/ }),

/***/ 8510:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e %3c!-- Generator: Adobe Illustrator 24.0.1%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e %3csvg version='1.1' id='Calque_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 139 106.8' style='enable-background:new 0 0 139 106.8%3b' xml:space='preserve'%3e %3cstyle type='text/css'%3e .st0%7bfill:%23EAEEF9%3b%7d .st1%7bfill:url(%23SVGID_1_)%3b%7d .st2%7bfill:%23D5DDEA%3b%7d .st3%7bfill:white%3b%7d .st4%7bfill:%23E3EAF2%3b%7d %3c/style%3e %3cpath class='st0' d='M69.4%2c103.9c27.5%2c0%2c49.7-22.3%2c49.7-49.8c0-27.6-22.4-49.8-49.7-49.8C42%2c4.3%2c19.7%2c26.5%2c19.7%2c54.1 S42%2c103.9%2c69.4%2c103.9z'/%3e %3cpath class='st0' d='M23.8%2c16.2c0-0.2-0.2-0.2-0.3-0.2s-0.3%2c0.1-0.3%2c0.2l-0.7%2c1.6L20.8%2c18c-0.1%2c0-0.2%2c0.1-0.3%2c0.3 c0%2c0.1%2c0%2c0.3%2c0.1%2c0.4l1.2%2c1.2l-0.3%2c1.7c0%2c0.1%2c0%2c0.3%2c0.1%2c0.4s0.3%2c0.1%2c0.4%2c0l1.5-0.8L25%2c22c0.1%2c0.1%2c0.3%2c0.1%2c0.4%2c0s0.2-0.2%2c0.1-0.4 l-0.3-1.7l1.2-1.2c0.1-0.1%2c0.1-0.2%2c0.1-0.4c0-0.1-0.2-0.2-0.3-0.3l-1.6-0.2L23.8%2c16.2z'/%3e %3cg%3e %3clinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='69.3' y1='721.3596' x2='69.3' y2='813.2112' gradientTransform='matrix(1 0 0 1 0 -716.0887)'%3e %3cstop offset='0' style='stop-color:%23FDFEFF'/%3e %3cstop offset='0.9964' style='stop-color:%23ECF0F5'/%3e %3c/linearGradient%3e %3cpath class='st1' d='M103.2%2c29.2l0.8%2c63.1c0%2c2.2-1.8%2c3.8-3.9%2c3.8H38.5c-2.2%2c0-3.9-1.8-3.9-3.8V11.2c0-2.2%2c1.8-3.8%2c3.9-3.8h44.6 L103.2%2c29.2z'/%3e %3c/g%3e %3cpath class='st2' d='M64.6%2c83.5h-12c-0.5%2c0-0.9-0.5-0.9-1.1s0.4-1.1%2c0.9-1.1h12.1c0.5%2c0%2c0.9%2c0.5%2c0.9%2c1.1 C65.5%2c83.1%2c65.1%2c83.5%2c64.6%2c83.5z'/%3e %3cpath class='st2' d='M57.7%2c83.5H44.6c-0.5%2c0-0.9-0.5-0.9-1.1s0.4-1.1%2c0.9-1.1h13.1c0.5%2c0%2c0.9%2c0.5%2c0.9%2c1.1 C58.6%2c83.1%2c58.2%2c83.5%2c57.7%2c83.5z'/%3e %3cpath class='st2' d='M74.5%2c20.6H45c-0.7%2c0-1.3-0.6-1.3-1.3c0-0.7%2c0.6-1.3%2c1.3-1.3h29.5c0.7%2c0%2c1.3%2c0.6%2c1.3%2c1.3S75.2%2c20.6%2c74.5%2c20.6z' /%3e %3cpath class='st2' d='M56.4%2c27.6H45c-0.7%2c0-1.3-0.6-1.3-1.3c0-0.7%2c0.6-1.3%2c1.3-1.3h11.3c0.7%2c0%2c1.3%2c0.6%2c1.3%2c1.3S57%2c27.6%2c56.4%2c27.6z'/%3e %3cpath class='st2' d='M83.1%2c7.3v17.5c0%2c2.5%2c2.2%2c4.4%2c4.6%2c4.4h15.5'/%3e %3cpath class='st3' d='M89.9%2c19.4c-0.1-0.2-0.2-0.3-0.4-0.3c-0.2%2c0-0.4%2c0.1-0.4%2c0.3l-1%2c2.1l-2.2%2c0.3c-0.2%2c0-0.3%2c0.2-0.4%2c0.3 c-0.1%2c0.2%2c0%2c0.4%2c0.1%2c0.5l1.6%2c1.6l-0.4%2c2.3c0%2c0.2%2c0%2c0.4%2c0.2%2c0.5s0.3%2c0.1%2c0.5%2c0l1.9-1.1l1.9%2c1.1c0.2%2c0.1%2c0.4%2c0.1%2c0.5%2c0 c0.2-0.1%2c0.2-0.3%2c0.2-0.5l-0.4-2.3l1.6-1.6c0.1-0.1%2c0.2-0.3%2c0.1-0.5s-0.2-0.3-0.4-0.3l-2.2-0.3L89.9%2c19.4z'/%3e %3cpath class='st2' d='M94.5%2c66.5h-34h-3.7H45.4c-0.5%2c0-0.9%2c0.5-0.9%2c1.1c0%2c0.5%2c0.4%2c1.1%2c0.9%2c1.1h11.3h3.7h34c0.5%2c0%2c0.9-0.5%2c0.9-1.1 S94.9%2c66.5%2c94.5%2c66.5z'/%3e %3cpath class='st2' d='M94.4%2c58.6H81.8h-4.3H45.4c-0.5%2c0-0.9%2c0.5-0.9%2c1.1c0%2c0.5%2c0.4%2c1.1%2c0.9%2c1.1h32.1h4.3h12.6c0.5%2c0%2c0.9-0.5%2c0.9-1.1 C95.2%2c59%2c94.8%2c58.6%2c94.4%2c58.6z'/%3e %3cpath class='st2' d='M94.7%2c50.5h-3.3h-3.3H45.4c-0.5%2c0-0.9%2c0.5-0.9%2c1.1c0%2c0.5%2c0.4%2c1.1%2c0.9%2c1.1h42.7h3.7h2.8c0.5%2c0%2c0.9-0.5%2c0.9-1.1 C95.6%2c51.1%2c95.1%2c50.5%2c94.7%2c50.5z'/%3e %3cpath class='st4' d='M58.8%2c84.3H45.4c-0.5%2c0-0.9-0.5-0.9-1.1c0-0.5%2c0.4-1.1%2c0.9-1.1h13.4c0.5%2c0%2c0.9%2c0.5%2c0.9%2c1.1 C59.7%2c84%2c59.3%2c84.3%2c58.8%2c84.3z'/%3e %3cpath class='st2' d='M95%2c42.5H84.3h-2.7H45.4c-0.5%2c0-0.9%2c0.5-0.9%2c1.1c0%2c0.5%2c0.4%2c1.1%2c0.9%2c1.1h36.3h2.7H95c0.6%2c0%2c1-0.5%2c1-1.1 C95.9%2c43.1%2c95.6%2c42.5%2c95%2c42.5z'/%3e %3cpath class='st0' d='M120.9%2c15.2c-0.1-0.2-0.2-0.3-0.4-0.3c-0.2%2c0-0.4%2c0.1-0.4%2c0.3l-1%2c2.1l-2.2%2c0.3c-0.2%2c0-0.3%2c0.2-0.4%2c0.3 c-0.1%2c0.2%2c0%2c0.4%2c0.1%2c0.5l1.6%2c1.6l-0.4%2c2.3c0%2c0.2%2c0%2c0.4%2c0.2%2c0.5c0.1%2c0.1%2c0.3%2c0.1%2c0.5%2c0l1.9-1.1l1.9%2c1.1c0.2%2c0.1%2c0.4%2c0.1%2c0.5%2c0 c0.2-0.1%2c0.2-0.3%2c0.2-0.5l-0.4-2.3l1.6-1.6c0.1-0.1%2c0.2-0.3%2c0.1-0.5s-0.2-0.3-0.4-0.3l-2.2-0.3L120.9%2c15.2z'/%3e %3cpath class='st0' d='M7.1%2c63.4C7%2c63.1%2c6.8%2c63%2c6.5%2c63S6%2c63.2%2c5.8%2c63.4l-1.5%2c3.1L1.1%2c67c-0.3%2c0-0.5%2c0.2-0.6%2c0.5s0%2c0.6%2c0.2%2c0.8l2.4%2c2.4 l-0.6%2c3.4c0%2c0.3%2c0.1%2c0.6%2c0.3%2c0.7C3%2c75%2c3.3%2c75%2c3.6%2c74.9l2.9-1.6l2.9%2c1.6C9.7%2c75%2c10%2c75%2c10.2%2c74.8s0.3-0.5%2c0.3-0.7l-0.6-3.4l2.4-2.4 c0.2-0.2%2c0.3-0.5%2c0.2-0.8S12.2%2c67%2c11.9%2c67l-3.3-0.5L7.1%2c63.4z'/%3e %3cpath class='st0' d='M136.2%2c0.7c-0.1-0.2-0.2-0.2-0.3-0.2c-0.2%2c0-0.3%2c0.1-0.3%2c0.2l-0.8%2c1.6l-1.7%2c0.2c-0.2%2c0-0.2%2c0.2-0.3%2c0.2 c-0.1%2c0.2%2c0%2c0.3%2c0.1%2c0.4l1.2%2c1.2l-0.3%2c1.8c0%2c0.2%2c0%2c0.3%2c0.2%2c0.4c0.1%2c0.1%2c0.2%2c0.1%2c0.4%2c0l1.4-0.8l1.4%2c0.8c0.2%2c0.1%2c0.3%2c0.1%2c0.4%2c0 c0.2-0.1%2c0.2-0.2%2c0.2-0.4l-0.3-1.8l1.2-1.2c0.1-0.1%2c0.2-0.2%2c0.1-0.4s-0.2-0.2-0.3-0.2l-1.7-0.2L136.2%2c0.7z'/%3e %3c/svg%3e"

/***/ }),

/***/ 7374:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='230' height='191' viewBox='0 0 230 191' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M111.418 170.5C156.346 170.5 192.769 134.084 192.769 89.0061C192.769 43.9278 156.185 7.51221 111.418 7.51221C66.4904 7.51221 30.0669 43.9278 30.0669 89.0061C30.0669 134.084 66.4904 170.5 111.418 170.5Z' fill='%23EAEEF9'/%3e %3cg filter='url(%23filter0_d_159_116263)'%3e %3cpath d='M166.775 48.2597L168.059 151.571C168.059 155.1 165.171 157.827 161.641 157.827H60.8743C57.3443 157.827 54.4561 154.94 54.4561 151.571V18.7423C54.4561 15.213 57.3443 12.4858 60.8743 12.4858H133.882L166.775 48.2597Z' fill='url(%23paint0_linear_159_116263)'/%3e %3c/g%3e %3cg clip-path='url(%23clip0_159_116263)'%3e %3cpath d='M130.328 65.2151L140.089 102.235C140.295 103.018 139.823 103.828 139.04 104.034C138.257 104.24 137.447 103.769 137.24 102.986L136.971 101.962L118.535 102.119C118.755 106.277 116.093 110.081 111.981 111.165C107.184 112.429 102.427 109.59 101.184 104.874C100.968 104.055 100.875 103.233 100.889 102.42L88.3947 102.582L88.6645 103.605C88.8709 104.388 88.4026 105.197 87.6157 105.404C86.8292 105.611 86.0226 105.139 85.8162 104.356L82.0622 90.1173C81.8557 89.3342 82.3244 88.5254 83.1109 88.3181C83.8978 88.1108 84.704 88.5835 84.9105 89.3666L85.1803 90.39L127.75 66.99L127.48 65.9658C127.273 65.1791 127.745 64.373 128.529 64.1666C129.312 63.9602 130.121 64.4285 130.328 65.2151ZM136.196 99.0255L128.524 69.9249L85.9546 93.3267L87.6204 99.645L136.196 99.0255ZM111.23 108.317C114.007 107.586 115.79 104.994 115.605 102.235L103.84 102.385C103.738 102.973 103.88 103.545 104.032 104.123C104.86 107.265 108.088 109.145 111.23 108.317Z' fill='%23D5DDEA'/%3e %3c/g%3e %3cpath d='M103.556 137.132H83.8196C83.0173 137.132 82.3755 136.33 82.3755 135.368C82.3755 134.405 83.0173 133.603 83.8196 133.603H103.556C104.358 133.603 105 134.405 105 135.368C105 136.491 104.358 137.132 103.556 137.132Z' fill='%23D5DDEA'/%3e %3cpath d='M92.3241 137.132H70.823C70.0207 137.132 69.3789 136.33 69.3789 135.368C69.3789 134.405 70.0207 133.603 70.823 133.603H92.3241C93.1264 133.603 93.7682 134.405 93.7682 135.368C93.7682 136.491 93.1264 137.132 92.3241 137.132Z' fill='%23D5DDEA'/%3e %3cpath d='M119.762 34.1421H71.4648C70.3416 34.1421 69.3789 33.1796 69.3789 32.0567C69.3789 30.9337 70.3416 29.9712 71.4648 29.9712H119.762C120.885 29.9712 121.848 30.9337 121.848 32.0567C121.848 33.1796 120.885 34.1421 119.762 34.1421Z' fill='%23D5DDEA'/%3e %3cpath d='M90.0777 45.6924H71.4648C70.3416 45.6924 69.3789 44.7299 69.3789 43.607C69.3789 42.484 70.3416 41.5215 71.4648 41.5215H89.9173C91.0405 41.5215 92.0032 42.484 92.0032 43.607C92.0032 44.7299 91.0405 45.6924 90.0777 45.6924Z' fill='%23D5DDEA'/%3e %3cpath d='M133.882 12.4858V41.0408C133.882 45.0513 137.412 48.2597 141.423 48.2597H166.775' fill='%23D5DDEA'/%3e %3cellipse cx='39.5458' cy='31.5843' rx='4.90909' ry='4.90803' fill='%23EAEEF9'/%3e %3cellipse cx='188.455' cy='165.737' rx='4.90909' ry='4.90803' fill='%23EAEEF9'/%3e %3cellipse cx='224.455' cy='5.40803' rx='4.90909' ry='4.90803' fill='%23EAEEF9'/%3e %3cellipse cx='214.637' cy='28.3121' rx='6.54545' ry='6.54403' fill='%23EAEEF9'/%3e %3cellipse cx='8.45477' cy='115.02' rx='8.18182' ry='8.18004' fill='%23EAEEF9'/%3e %3cdefs%3e %3cfilter id='filter0_d_159_116263' x='32.4561' y='1.48584' width='157.603' height='189.341' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='11'/%3e %3cfeGaussianBlur stdDeviation='11'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_159_116263'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_159_116263' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_159_116263' x1='111.22' y1='9.12395' x2='111.22' y2='159.394' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23FDFEFF'/%3e %3cstop offset='0.9964' stop-color='%23ECF0F5'/%3e %3c/linearGradient%3e %3cclipPath id='clip0_159_116263'%3e %3crect width='53.0198' height='53.0098' fill='white' transform='matrix(0.966984 -0.254838 0.254941 0.966957 77.1821 71.6074)'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e"

/***/ }),

/***/ 5363:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='146' height='148' viewBox='0 0 146 148' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M99.5019 18.5654C99.5019 27.8819 92.0927 35.586 82.8765 36.1235C82.515 36.1235 82.1536 36.1235 81.7922 36.1235C78.7201 36.1235 75.648 35.2276 73.1181 33.7943C67.6967 30.7485 64.0825 25.0153 64.0825 18.3862C64.0825 13.9071 65.7089 9.78633 68.6003 6.74054C71.8531 3.15726 76.5516 0.828125 81.7922 0.828125C88.6592 0.828125 94.6227 4.76974 97.5141 10.503C98.779 13.0113 99.5019 15.6988 99.5019 18.5654Z' fill='url(%23paint0_linear_195_43808)'/%3e %3cpath opacity='0.1' d='M99.3461 18.565C99.3461 27.8815 91.937 35.5856 82.7207 36.1231C79.2872 35.5856 76.0344 34.6898 72.9623 33.9731C67.541 30.9273 63.9268 25.1941 63.9268 18.565C63.9268 14.0859 65.5532 9.96513 68.4445 6.91934C74.408 6.74017 81.275 7.27766 88.3227 8.53181C91.5755 9.0693 94.6476 9.78596 97.539 10.5026C98.6233 13.0109 99.3461 15.6984 99.3461 18.565Z' fill='black'/%3e %3cpath d='M120.954 30.4228C122.318 22.8243 105.501 13.5025 83.3936 9.60193C61.2858 5.70134 42.2582 8.69903 40.8943 16.2975C39.5304 23.8959 56.3467 33.2177 78.4546 37.1183C100.562 41.0189 119.59 38.0212 120.954 30.4228Z' fill='url(%23paint1_linear_195_43808)'/%3e %3cpath d='M77.7577 13.9411C77.8583 12.6586 75.8425 11.4573 73.2554 11.2578C70.6683 11.0584 68.4895 11.9364 68.3889 13.2189C68.2883 14.5014 70.3041 15.7027 72.8912 15.9021C75.4783 16.1015 77.6571 15.2236 77.7577 13.9411Z' fill='white'/%3e %3cpath d='M55.0191 17.2344C57.5066 16.5022 59.2238 14.909 58.8545 13.6759C58.4853 12.4429 56.1694 12.0368 53.6819 12.769C51.1945 13.5012 49.4773 15.0943 49.8466 16.3274C50.2158 17.5605 52.5317 17.9666 55.0191 17.2344Z' fill='white'/%3e %3cpath d='M96.0333 18.6547C96.2606 17.3882 94.3739 15.9962 91.8192 15.5455C89.2645 15.0948 87.0093 15.756 86.7819 17.0224C86.5546 18.2888 88.4413 19.6808 90.996 20.1316C93.5507 20.5823 95.8059 19.9211 96.0333 18.6547Z' fill='white'/%3e %3cpath d='M109.752 28.0229C110.347 26.8796 108.959 24.9969 106.653 23.8179C104.346 22.6388 101.995 22.6098 101.4 23.7531C100.805 24.8964 102.193 26.7791 104.499 27.9581C106.806 29.1372 109.157 29.1662 109.752 28.0229Z' fill='white'/%3e %3cpath d='M78.6707 24.9819L61.6839 24.8027L37.4924 69.7987L105.392 76.9395L97.8261 31.0735L78.6707 24.9819Z' fill='url(%23paint2_linear_195_43808)'/%3e %3cpath d='M97.7179 31.5366C98.3299 28.127 90.7014 23.9296 80.6792 22.1613C70.657 20.393 62.0363 21.7235 61.4243 25.1331C60.8123 28.5426 68.4408 32.7401 78.463 34.5084C88.4852 36.2766 97.1059 34.9461 97.7179 31.5366Z' fill='url(%23paint3_linear_195_43808)'/%3e %3cpath d='M32.8249 48.0479C32.8249 48.0479 26.5825 49.6328 28.4742 50.9007C30.3658 52.1052 34.8426 54.1973 39.0672 52.8026C43.2918 51.4078 39.0672 49.4426 39.1302 49.4426C39.1933 49.4426 32.8249 48.0479 32.8249 48.0479Z' fill='%23CED7E2'/%3e %3cpath d='M25.1953 47.5407C27.4652 48.238 34.4642 47.0969 38.941 44.1807C42.472 48.555 43.7961 49.6961 45.0572 49.8229C43.1025 51.7882 36.608 54.958 32.9509 50.8372C28.6633 53.5633 25.1953 47.5407 25.1953 47.5407Z' fill='%23E9EEF8'/%3e %3cpath d='M100.172 53.2473C102.568 53.3741 109.063 50.4579 112.594 46.5273C117.134 49.8873 118.647 50.6481 119.971 50.4579C118.521 52.8669 114.107 58.1288 107.865 58.5092C103.325 55.8466 100.172 53.2473 100.172 53.2473Z' fill='%23E9EEF8'/%3e %3cpath d='M79.4068 53.3261C78.9328 50.974 74.4907 45.4106 69.8045 42.97C71.9277 37.7363 72.2876 36.0812 71.7735 34.8462C74.4679 35.6506 80.6634 38.6145 82.5867 44.5653C81.1388 49.6253 79.4068 53.3261 79.4068 53.3261Z' fill='white'/%3e %3cpath d='M37.7414 127.742C53.231 127.742 65.7878 115.185 65.7878 99.6958C65.7878 84.2062 53.231 71.6494 37.7414 71.6494C22.2519 71.6494 9.69507 84.2062 9.69507 99.6958C9.69507 115.185 22.2519 127.742 37.7414 127.742Z' fill='%23EFF3FA'/%3e %3cpath d='M140.239 130.474H7.10938L27.8345 102.646L36.722 90.8445L44.4802 99.2584L45.9736 100.861L62.6557 77.7683L69.7948 67.8975L75.3677 76.02L94.3445 103.666L101.993 94.924L105.891 90.4438L109.205 94.414L140.239 130.474Z' fill='%23D9E0EC'/%3e %3cpath d='M36.722 90.8447L36.3577 130.474H7.10938L27.8345 102.646L36.722 90.8447Z' fill='%23E8EDF8'/%3e %3cpath d='M69.7946 67.8975L68.5926 126.321L45.9734 100.861L69.7946 67.8975Z' fill='%23E8EDF8'/%3e %3cpath d='M106.583 124.755L94.3445 103.665L105.891 90.4434L106.583 124.755Z' fill='%23E8EDF8'/%3e %3cpath d='M1.5 130.474H36.3576H140.238H144.5' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M76.6787 136.374H85.9304' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M102.175 136.374H111.427' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M96.53 136.374H98.4969' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M35.0825 136.374H68.2282' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M21.0959 136.374H25.2847' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M127.563 136.374H139.218' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M3.43042 136.374H14.7582' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M12.4634 141.292H49.0693' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M70.7053 141.292H96.5298' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M109.824 141.292H135.649' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M59.9236 141.292H65.5693' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M88.5527 146.172H119.804' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M56.063 146.172H76.6789' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M42.9502 146.172H49.0694' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M20.1128 146.172H33.626' stroke='%23CDD6E1' stroke-width='2.7208' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M50.1261 121.04C50.1261 123.334 48.2685 124.354 46.0102 124.354C43.7519 124.354 41.8943 123.334 41.8943 121.04C41.8943 118.745 46.0102 104.576 46.0102 104.576C46.0102 104.576 50.1261 118.781 50.1261 121.04Z' fill='white'/%3e %3cpath d='M45.9739 117.033V130.037' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M45.9739 119.291L47.4673 117.943' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M45.974 122.388L43.825 119.838' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M87.1324 120.02C87.1324 122.57 85.0563 123.699 82.543 123.699C79.9934 123.699 77.9536 122.57 77.9536 120.02C77.9536 117.471 82.543 101.699 82.543 101.699C82.543 101.699 87.1324 117.507 87.1324 120.02Z' fill='white'/%3e %3cpath d='M82.5432 115.54V130.037' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M82.5432 118.09L84.1823 116.561' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M82.5431 121.55L80.1392 118.673' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M102.066 123.918C102.066 125.484 100.791 126.176 99.2617 126.176C97.6954 126.176 96.457 125.484 96.457 123.918C96.457 122.352 99.2617 112.699 99.2617 112.699C99.2617 112.699 102.066 122.352 102.066 123.918Z' fill='white'/%3e %3cpath d='M99.2249 121.186V130.037' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M99.2249 122.715L100.245 121.805' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M99.2253 124.828L97.7683 123.08' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M117.109 122.169C117.109 124.172 115.506 125.046 113.503 125.046C111.5 125.046 109.897 124.172 109.897 122.169C109.897 120.166 113.503 107.745 113.503 107.745C113.503 107.745 117.109 120.166 117.109 122.169Z' fill='white'/%3e %3cpath d='M113.503 118.636V130.036' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M113.503 120.603L114.778 119.438' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M113.503 123.334L111.609 121.076' stroke='%23B9C0D0' stroke-width='1.81387' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath opacity='0.8' d='M46.3015 101.08L40.0366 101.626L37.1227 104.613L33.626 103.994L27.8346 107.6L26.0134 105.232L36.8313 90.8447L46.3015 101.08Z' fill='white'/%3e %3cpath opacity='0.6' d='M78.2085 80.1359L75.2582 79.4802L72.235 80.9008L69.7946 80.2816L67.4635 84.4339L63.8211 82.722L59.7416 84.4339L59.0496 82.8312L69.7946 67.8975L78.2085 80.1359Z' fill='white'/%3e %3cpath opacity='0.6' d='M111.136 96.5261L108.076 98.9301L105.235 97.3639L101.228 99.695L100.099 97.2546L106.036 90.4434L111.136 96.5261Z' fill='white'/%3e %3cpath d='M33.9538 80.0633C34.5366 79.9176 35.0829 79.8812 35.6657 79.8812C36.2121 79.8812 36.7949 79.9176 37.3412 79.9904C37.8876 80.0633 38.4704 80.209 39.0167 80.4639C39.5631 80.7189 40.1094 81.0831 40.4372 81.7023L39.818 81.5566L40.4737 81.0467C40.7286 80.901 40.9472 80.7189 41.1657 80.5732C41.6392 80.2818 42.1492 80.0268 42.6955 79.8447C43.2419 79.6626 43.7882 79.5169 44.3346 79.4441C44.9174 79.4076 45.4637 79.4076 46.0465 79.5533C46.1558 79.5898 46.1922 79.699 46.1558 79.7719C46.1194 79.8811 46.0465 79.9176 45.9372 79.8812H45.9008C45.4273 79.7719 44.881 79.8083 44.371 79.8812C43.8611 79.954 43.3512 80.1361 42.8776 80.3547C42.4041 80.5732 41.967 80.8282 41.53 81.1196C41.3114 81.2653 41.0929 81.4474 40.9108 81.5931L40.328 82.103C40.1459 82.2487 39.9273 82.2123 39.7816 82.0666L39.7452 82.103L39.7088 82.0302C39.5631 81.6295 39.1624 81.3017 38.7253 81.0831C38.2882 80.8646 37.7783 80.6825 37.2319 80.5732C36.722 80.4639 36.1757 80.3911 35.6293 80.3547C35.0829 80.3182 34.5366 80.3182 34.0631 80.4275H34.0267C33.9174 80.4639 33.8445 80.3911 33.8081 80.2818C33.8081 80.1725 33.8445 80.0633 33.9538 80.0633Z' fill='%23989FB0'/%3e %3cpath d='M17.7817 90.0428C18.3645 89.8971 18.9108 89.8606 19.4936 89.8606C20.04 89.8606 20.6227 89.8971 21.1691 89.9699C21.7155 90.0428 22.2982 90.1885 22.8446 90.4434C23.391 90.6984 23.9373 91.0626 24.2651 91.6818L23.6459 91.5361L24.3015 91.0262C24.5565 90.8805 24.7751 90.6984 24.9936 90.5527C25.4671 90.2613 25.977 90.0063 26.5234 89.8242C27.0698 89.6421 27.6161 89.4964 28.1625 89.4236C28.7453 89.3871 29.2916 89.3871 29.8744 89.5328C29.9837 89.5693 30.0201 89.6785 29.9837 89.7514C29.9472 89.8606 29.8744 89.8971 29.7651 89.8606H29.7287C29.2552 89.7514 28.7088 89.7878 28.1989 89.8606C27.689 89.9335 27.179 90.1156 26.7055 90.3342C26.232 90.5527 25.7949 90.8077 25.3578 91.0991C25.1393 91.2447 24.9208 91.4269 24.7386 91.5726L24.1559 92.0825C23.9737 92.2282 23.7552 92.1918 23.6095 92.0461L23.5731 92.0096L23.5366 91.9368C23.391 91.5361 22.9903 91.2083 22.5532 90.9898C22.1161 90.7712 21.6062 90.5891 21.0598 90.4798C20.5499 90.3706 20.0035 90.2977 19.4572 90.2613C18.9108 90.2249 18.3645 90.2249 17.891 90.3342H17.8545C17.7453 90.3706 17.6724 90.2977 17.636 90.1885C17.636 90.152 17.7088 90.0428 17.7817 90.0428Z' fill='%23989FB0'/%3e %3cpath d='M37.8874 88.6228C38.4702 88.4771 39.0165 88.4407 39.5993 88.4407C40.1457 88.4407 40.7285 88.4771 41.2748 88.55C41.8212 88.6228 42.404 88.7685 42.9503 89.0235C43.4967 89.2785 44.043 89.6427 44.3708 90.2619L43.7516 90.1162L44.4073 89.6063C44.6622 89.4606 44.8808 89.2785 45.0993 89.1328C45.5728 88.8414 46.0828 88.5864 46.6291 88.4043C47.1755 88.2222 47.7218 88.0765 48.2682 88.0036C48.851 87.9672 49.3973 87.9672 49.9801 88.1129C50.0894 88.1493 50.1258 88.2586 50.0894 88.3314C50.053 88.4407 49.9801 88.4771 49.8708 88.4407H49.8344C49.3609 88.3314 48.8145 88.3679 48.3046 88.4407C47.7947 88.5136 47.2847 88.6957 46.8112 88.9142C46.3377 89.1328 45.9006 89.3877 45.4636 89.6791C45.245 89.8248 45.0265 90.0069 44.8443 90.1526L44.2616 90.6626C44.0794 90.8083 43.8609 90.7718 43.7152 90.6262L43.6788 90.5897L43.6424 90.5169C43.4967 90.1162 43.096 89.7884 42.6589 89.5699C42.2218 89.3513 41.7119 89.1692 41.1655 89.0599C40.6556 88.9507 40.1092 88.8778 39.5629 88.8414C39.0165 88.805 38.4702 88.805 37.9967 88.9142H37.9602C37.851 88.9507 37.7781 88.8778 37.7417 88.7685C37.7417 88.7321 37.7781 88.6228 37.8874 88.6228Z' fill='%23989FB0'/%3e %3cg filter='url(%23filter0_d_195_43808)'%3e %3cpath d='M96.4566 89.1211C96.4566 91.2172 94.7614 92.9124 92.647 92.9124C92.6105 92.9124 92.3007 92.9124 90.0222 92.9124C88.4364 92.9124 85.9028 92.9124 81.8562 92.9124H79.9241C77.3905 92.9671 75.3672 90.9438 75.3672 88.5013C75.3672 86.0406 77.4087 83.9991 79.9788 84.1267C82.1843 77.2366 92.2824 78.2027 93.1391 85.3297C95.0348 85.5667 96.4566 87.1707 96.4566 89.1211Z' fill='url(%23paint4_linear_195_43808)'/%3e %3c/g%3e %3cpath d='M92.6472 92.9128C94.7434 92.9128 96.4568 91.2176 96.4568 89.1214C96.4568 87.0252 94.7434 85.3301 92.6472 85.3301C90.551 85.3301 88.8376 87.0252 88.8376 89.1214C88.8376 91.2176 90.551 92.9128 92.6472 92.9128Z' fill='url(%23paint5_linear_195_43808)'/%3e %3cpath d='M86.4316 92.9487C90.1682 92.9487 93.2122 89.9229 93.2122 86.1863C93.2122 82.4496 90.1682 79.4238 86.4316 79.4238C82.6949 79.4238 79.6509 82.4496 79.6509 86.1863C79.6509 89.9229 82.6767 92.9487 86.4316 92.9487Z' fill='url(%23paint6_linear_195_43808)'/%3e %3cg filter='url(%23filter1_d_195_43808)'%3e %3cpath d='M63.3634 95.7902C63.3634 97.3702 62.0856 98.648 60.4918 98.648C60.4644 98.648 60.2308 98.648 58.5133 98.648C57.318 98.648 55.4082 98.648 52.3581 98.648H50.9017C48.9919 98.6892 47.4668 97.1641 47.4668 95.323C47.4668 93.4682 49.0056 91.9294 50.9429 92.0255C52.6054 86.832 60.217 87.5602 60.8628 92.9323C62.2917 93.111 63.3634 94.32 63.3634 95.7902Z' fill='url(%23paint7_linear_195_43808)'/%3e %3c/g%3e %3cpath d='M60.4922 98.6482C62.0722 98.6482 63.3637 97.3705 63.3637 95.7904C63.3637 94.2104 62.0722 92.9326 60.4922 92.9326C58.9121 92.9326 57.6206 94.2104 57.6206 95.7904C57.6206 97.3705 58.9121 98.6482 60.4922 98.6482Z' fill='url(%23paint8_linear_195_43808)'/%3e %3cpath d='M55.8069 98.6752C58.6235 98.6752 60.918 96.3944 60.918 93.5778C60.918 90.7612 58.6235 88.4805 55.8069 88.4805C52.9903 88.4805 50.6958 90.7612 50.6958 93.5778C50.6958 96.3944 52.9766 98.6752 55.8069 98.6752Z' fill='url(%23paint9_linear_195_43808)'/%3e %3cdefs%3e %3cfilter id='filter0_d_195_43808' x='55.4146' y='69.4642' width='60.9944' height='53.3777' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='9.97627'/%3e %3cfeGaussianBlur stdDeviation='9.97627'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_195_43808'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_195_43808' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_d_195_43808' x='27.5143' y='78.5169' width='55.8016' height='50.0603' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='9.97627'/%3e %3cfeGaussianBlur stdDeviation='9.97627'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_195_43808'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_195_43808' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_195_43808' x1='81.795' y1='2.05424' x2='81.795' y2='21.8652' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23B0BACC'/%3e %3cstop offset='1' stop-color='%23969EAE'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_195_43808' x1='43.6759' y1='16.786' x2='88.5886' y2='24.8476' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23E3E7EE'/%3e %3cstop offset='1' stop-color='%23D1D6DF'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_195_43808' x1='71.4467' y1='26.6139' x2='71.4467' y2='55.8777' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23BDC4D1' stop-opacity='0.53'/%3e %3cstop offset='1' stop-color='%235D7CB8' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint3_linear_195_43808' x1='79.5711' y1='33.0995' x2='82.2458' y2='23.8672' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23B0BACC'/%3e %3cstop offset='1' stop-color='%23969EAE'/%3e %3c/linearGradient%3e %3clinearGradient id='paint4_linear_195_43808' x1='85.9119' y1='85.008' x2='85.905' y2='93.0587' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='white'/%3e %3cstop offset='0.9964' stop-color='%23ECF0F5'/%3e %3c/linearGradient%3e %3clinearGradient id='paint5_linear_195_43808' x1='88.4322' y1='84.5138' x2='91.8094' y2='88.2074' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23BCCBE1'/%3e %3cstop offset='0.9942' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint6_linear_195_43808' x1='79.0159' y1='83.0832' x2='84.3386' y2='85.1661' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23E2E8F0'/%3e %3cstop offset='0.9942' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint7_linear_195_43808' x1='55.4151' y1='92.6899' x2='55.4099' y2='98.7583' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='white'/%3e %3cstop offset='0.9964' stop-color='%23ECF0F5'/%3e %3c/linearGradient%3e %3clinearGradient id='paint8_linear_195_43808' x1='57.315' y1='92.3173' x2='59.8606' y2='95.1015' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23BCCBE1'/%3e %3cstop offset='0.9942' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3clinearGradient id='paint9_linear_195_43808' x1='50.2172' y1='91.2388' x2='54.2293' y2='92.8088' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23E2E8F0'/%3e %3cstop offset='0.9942' stop-color='white' stop-opacity='0'/%3e %3c/linearGradient%3e %3c/defs%3e %3c/svg%3e"

/***/ }),

/***/ 1878:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='168' height='168' viewBox='0 0 168 168' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_340_148)'%3e %3cpath d='M84.9264 152.378C114.626 152.378 138.826 128.278 138.826 98.6785C138.826 68.9785 114.726 44.9785 84.9264 44.9785C55.1264 44.8785 31.0264 68.8785 31.0264 98.5785C31.0264 128.278 55.1264 152.378 84.9264 152.378Z' fill='%23EAEEF9'/%3e %3cpath d='M75.4263 79.8785L74.0263 75.9785C73.7263 74.9785 72.7263 74.3785 71.7263 74.3785H47.1263C45.0263 74.3785 43.4263 75.9785 43.4263 78.0785V133.179V124.079H127.426V85.1785C127.426 83.0785 125.826 81.4785 123.726 81.4785H77.7263C76.7263 81.4785 75.8263 80.8785 75.4263 79.8785Z' fill='url(%23paint0_linear_340_148)'/%3e %3cg filter='url(%23filter0_d_340_148)'%3e %3cpath d='M45.8263 48.0785L62.6263 77.2785C63.1263 78.2785 62.8263 79.5785 61.8263 80.0785L33.2263 96.0785C32.2263 96.5785 30.9263 96.2785 30.4263 95.2785L9.32631 57.4785C8.62631 56.4785 9.12631 55.1785 10.1263 54.6785L30.9263 43.0785L45.8263 48.0785Z' fill='white'/%3e %3c/g%3e %3cpath d='M30.7263 51.1785L16.9263 58.8785C16.6263 59.0785 16.1263 58.9785 16.0263 58.5785C15.8263 58.2785 15.9263 57.7785 16.2263 57.6785L30.0263 50.0785C30.3263 49.8785 30.8263 49.9785 30.9263 50.2785C31.1263 50.5785 31.0263 51.0785 30.7263 51.1785Z' fill='%23D5DDEA'/%3e %3cpath d='M24.0263 59.2785L18.7263 62.1785C18.4263 62.3785 18.0263 62.2785 17.9263 61.9785C17.7263 61.6785 17.8263 61.1785 18.1263 61.0785L23.3263 58.1785C23.6263 57.9785 24.1263 58.0785 24.2263 58.3785C24.5263 58.5785 24.4263 59.0785 24.0263 59.2785Z' fill='%23D5DDEA'/%3e %3cpath d='M30.9263 43.0785L35.5263 51.1785C36.2263 52.2785 37.7263 52.6785 38.8263 52.0785L46.1263 48.0785' fill='%23D5DDEA'/%3e %3cpath d='M47.5263 65.8785C46.6263 64.0785 45.4263 61.9785 43.9263 60.4785C43.1263 59.6785 42.1263 59.1785 40.9263 59.1785C39.7263 59.1785 38.6263 59.5785 37.4263 60.1785C35.3263 61.0785 33.4263 61.9785 31.5263 63.1785C29.8263 64.1785 27.8263 65.2785 26.5263 66.8785C24.8263 69.1785 25.7263 71.4785 26.9263 73.8785C27.8263 75.6785 29.0263 77.7785 30.5263 79.2785C31.7263 80.4785 33.3263 80.8785 34.9263 80.3785C37.0263 79.8785 40.9263 77.6785 42.7263 76.5785C44.3263 75.5785 46.2263 74.6785 47.4263 73.1785C49.7263 70.8785 48.9263 68.4785 47.5263 65.8785ZM33.5263 68.3785C33.2263 67.7785 33.4263 67.2785 34.2263 67.3785C36.3263 67.4785 38.3263 67.4785 40.3263 67.5785C41.1263 67.5785 41.3263 67.9785 41.0263 68.6785C40.0263 70.3785 39.0263 72.1785 38.0263 73.9785C37.6263 74.5785 37.1263 74.5785 36.8263 74.0785C36.5263 73.7785 33.8263 68.8785 33.5263 68.3785Z' fill='%23D5DDEA'/%3e %3cpath d='M109.426 99.0784L108.526 98.4785C108.326 98.2785 108.326 98.0785 108.526 97.8785C108.726 97.6785 108.926 97.6785 109.226 97.7785L110.126 98.3785C110.326 98.4785 110.326 98.7785 110.226 98.9785C109.926 99.1785 109.626 99.1784 109.426 99.0784Z' fill='%23E3EAF2'/%3e %3cpath d='M107.026 97.1785L101.926 93.1785C101.726 93.0785 101.726 92.7785 101.826 92.5785C101.926 92.3785 102.226 92.3785 102.526 92.4785L107.626 96.4785C107.826 96.5785 107.826 96.8785 107.726 97.0785C107.526 97.2785 107.226 97.3785 107.026 97.1785Z' fill='%23E3EAF2'/%3e %3cg filter='url(%23filter1_d_340_148)'%3e %3cpath d='M158.926 71.4785L139.826 96.1785C139.226 97.0785 138.026 97.1785 137.126 96.4785L113.326 77.7785C112.426 77.1785 112.326 75.9785 113.026 75.0785L137.826 43.5785C138.426 42.6785 139.626 42.5785 140.526 43.2785L157.826 56.8785L158.926 71.4785Z' fill='white'/%3e %3c/g%3e %3cpath d='M150.826 59.5785L139.326 50.5785C139.126 50.3785 139.026 50.0785 139.226 49.6785C139.426 49.4785 139.726 49.3785 140.126 49.5785L151.626 58.5785C151.826 58.7785 151.926 59.0785 151.726 59.4785C151.426 59.7785 151.126 59.7785 150.826 59.5785Z' fill='%23D5DDEA'/%3e %3cpath d='M141.626 56.7785L137.326 53.2785C137.126 53.0785 137.026 52.7785 137.226 52.3785C137.426 52.0785 137.726 52.0785 138.126 52.2785L142.426 55.7785C142.626 55.9785 142.726 56.2785 142.526 56.6785C142.226 56.9785 141.826 56.9785 141.626 56.7785Z' fill='%23D5DDEA'/%3e %3cpath d='M157.826 56.8785L152.526 63.5785C151.726 64.5785 152.026 65.9785 152.926 66.6785L159.026 71.4785' fill='%23D5DDEA'/%3e %3cpath d='M151.526 72.9785L145.526 68.3785L139.326 63.4785L133.626 58.9785C133.026 58.4785 132.026 58.5785 131.526 59.2785L123.326 69.6785C122.826 70.2785 122.926 71.2785 123.526 71.7785L141.526 85.9785C142.126 86.4785 143.126 86.3785 143.626 85.6785L151.826 75.2785C152.326 74.3785 152.226 73.5785 151.526 72.9785ZM132.526 72.8785L134.326 70.4785L139.826 74.7785L138.026 77.1785L132.526 72.8785ZM137.526 77.8785L135.826 80.0785L130.326 75.7785L132.026 73.5785L137.526 77.8785ZM142.226 71.7785L140.426 74.1785L134.926 69.8785L136.726 67.4785L142.226 71.7785ZM137.226 66.7785L139.226 64.3785L144.726 68.6785L142.926 71.0785L137.226 66.7785ZM147.226 79.4785L141.126 74.6785L142.926 72.2785L149.026 77.0785L147.226 79.4785ZM134.226 69.2785L128.326 64.6785L130.126 62.2785L136.026 66.8785L134.226 69.2785ZM127.726 65.3785L133.626 69.9785L131.826 72.3785L125.926 67.7785L127.726 65.3785ZM140.626 75.3785L146.726 80.1785L144.926 82.5785L138.826 77.7785L140.626 75.3785ZM151.126 74.5785L149.626 76.4785L143.526 71.6785L145.326 69.2785L150.926 73.6785C151.326 73.8785 151.326 74.2785 151.126 74.5785ZM133.026 59.4785L138.426 63.7785L136.626 66.1785L130.726 61.5785L132.226 59.6785C132.426 59.3785 132.826 59.3785 133.026 59.4785ZM124.026 70.0785L125.326 68.4785L131.226 73.0785L129.526 75.2785L124.026 70.9785C123.826 70.7785 123.826 70.2785 124.026 70.0785ZM142.126 84.9785L136.526 80.5785L138.226 78.3785L144.326 83.1785L142.926 84.8785C142.726 85.2785 142.326 85.2785 142.126 84.9785Z' fill='%23D5DDEA'/%3e %3cpath d='M102.326 95.2785L96.6263 94.6785C96.3263 94.6785 96.1263 94.3785 96.2263 94.0785C96.2263 93.7785 96.5263 93.5785 96.9263 93.6785L102.626 94.2785C102.926 94.2785 103.126 94.5785 103.026 94.8785C102.926 95.1785 102.626 95.4785 102.326 95.2785Z' fill='url(%23paint1_linear_340_148)'/%3e %3cpath d='M129.126 100.679L122.926 128.379C122.526 129.979 120.626 131.279 118.226 131.279H50.9263C48.6263 131.279 46.6263 130.079 46.2263 128.379L41.1263 105.679C40.7263 103.979 42.6263 102.379 45.0263 102.379H83.0263C84.2263 102.379 85.1263 101.779 85.5263 101.079L86.6263 98.6785C87.0263 97.8785 88.0263 97.3785 89.1263 97.3785H125.326C127.626 97.3785 129.426 98.9785 129.126 100.679Z' fill='white'/%3e %3cg filter='url(%23filter2_d_340_148)'%3e %3cpath d='M134.026 96.9785L127.126 139.478C126.726 141.978 124.526 143.878 121.926 143.878H46.9264C44.3264 143.878 42.1264 142.078 41.7264 139.478L36.0264 104.578C35.6264 101.978 37.6264 99.4785 40.3264 99.4785H82.6264C83.9264 99.4785 85.0264 98.5785 85.4264 97.3785L86.6264 93.6785C87.0264 92.4785 88.1264 91.5785 89.4264 91.5785H129.726C132.326 91.8785 134.426 94.2785 134.026 96.9785Z' fill='url(%23paint2_linear_340_148)'/%3e %3c/g%3e %3cg filter='url(%23filter3_d_340_148)'%3e %3cpath d='M111.226 41.3785L108.026 76.0785C107.926 77.2785 106.826 78.1785 105.626 77.9785L71.8263 74.4785C70.6263 74.3785 69.7263 73.2785 69.8263 72.0785L74.4263 27.5785C74.5263 26.3785 75.6263 25.4785 76.8263 25.6785L101.326 28.1785L111.226 41.3785Z' fill='white'/%3e %3c/g%3e %3cpath d='M101.426 28.2785L100.426 37.7785C100.326 39.0785 101.326 40.3785 102.726 40.4785L111.326 41.3785' fill='%23D5DDEA'/%3e %3cpath d='M104.626 66.6785L76.9263 63.5785C76.2263 63.4785 75.7263 62.9785 75.8263 62.2785L77.9263 44.5785C78.0263 43.9785 78.6263 43.3785 79.2263 43.4785L106.926 46.4785C107.626 46.5785 108.126 47.0785 108.026 47.7785L105.926 65.4785C105.826 66.1785 105.226 66.6785 104.626 66.6785Z' fill='%23ECF0F8'/%3e %3cpath d='M92.1263 62.3785L79.3263 60.8785L86.5263 54.3785L92.1263 62.3785Z' fill='%23D5DDEA'/%3e %3cpath d='M102.726 63.5785L84.2263 61.3785L94.7263 52.0785L102.726 63.5785Z' fill='white'/%3e %3cpath d='M85.5262 51.5785C86.9262 51.5785 88.0262 50.4785 88.0262 49.0785C88.0262 47.6785 86.9262 46.5785 85.5262 46.5785C84.1262 46.5785 83.0262 47.6785 83.0262 49.0785C83.0262 50.4785 84.1262 51.5785 85.5262 51.5785Z' fill='%23D5DDEA'/%3e %3cpath d='M96.2263 34.0785L79.4263 32.1785C79.2263 32.1785 79.0263 31.9785 79.1263 31.7785V31.5785C79.1263 31.3785 79.3263 31.1785 79.5263 31.2785L96.3263 33.1785C96.5263 33.1785 96.7263 33.3785 96.6263 33.5785V33.7785C96.7263 33.9785 96.5263 34.1785 96.2263 34.0785Z' fill='%23D5DDEA'/%3e %3cpath d='M96.1263 37.2785L79.1263 35.3785C78.9263 35.3785 78.7263 35.1785 78.8263 34.9785V34.7785C78.8263 34.5785 79.0263 34.3785 79.2263 34.4785L96.2263 36.3785C96.4263 36.3785 96.6263 36.5785 96.5263 36.7785V36.9785C96.6263 37.0785 96.3263 37.2785 96.1263 37.2785Z' fill='%23D5DDEA'/%3e %3cpath d='M96.7263 69.9785L75.6263 67.5785C75.3263 67.5785 75.1263 67.2785 75.2263 66.9785C75.2263 66.6785 75.5263 66.4785 75.9263 66.5785L96.9263 68.9785C97.2263 68.9785 97.4263 69.2785 97.3263 69.5785C97.2263 69.8785 97.0263 70.0785 96.7263 69.9785Z' fill='%23D5DDEA'/%3e %3cpath d='M93.6263 40.2785L78.8263 38.5785C78.5263 38.5785 78.3263 38.2785 78.4263 37.9785C78.4263 37.6785 78.7263 37.4785 79.1263 37.5785L93.9263 39.2785C94.2263 39.2785 94.4263 39.5785 94.3263 39.8785C94.2263 40.0785 94.0263 40.2785 93.6263 40.2785Z' fill='%23D5DDEA'/%3e %3cpath d='M104.526 74.0785L75.1263 70.5785C74.8263 70.5785 74.6263 70.2785 74.7263 69.9785C74.7263 69.6785 75.0263 69.4785 75.4263 69.5785L104.826 72.9785C105.126 72.9785 105.326 73.2785 105.226 73.5785C105.126 73.8785 104.826 74.0785 104.526 74.0785Z' fill='%23D5DDEA'/%3e %3cpath d='M74.0263 21.0785C73.6263 21.2785 73.1263 21.0785 72.9263 20.6785L71.1263 16.1785C70.9263 15.7785 71.1263 15.2785 71.5263 15.0785C71.9263 14.8785 72.4263 15.0785 72.6263 15.4785L74.4263 19.9785C74.7263 20.5785 74.5263 20.9785 74.0263 21.0785Z' fill='%23D5DDEA'/%3e %3cpath d='M70.7263 25.4785C70.5263 25.6785 70.3263 25.7785 69.9263 25.6785L65.2263 24.7785C64.8263 24.6785 64.4263 24.2785 64.5263 23.7785C64.6263 23.3785 65.0263 22.9785 65.5263 23.1785L70.2263 24.0785C70.6263 24.1785 71.0263 24.5785 70.9263 25.0785C70.8263 25.1785 70.8263 25.3785 70.7263 25.4785Z' fill='%23D5DDEA'/%3e %3cpath d='M80.2263 20.5785C80.1263 20.5785 80.0263 20.4785 79.8263 20.4785C79.5263 20.1785 79.4263 19.6785 79.7263 19.2785L82.6263 15.4785C82.9263 15.1785 83.4263 15.0785 83.8263 15.3785C84.1263 15.6785 84.2263 16.1785 83.9263 16.5785L81.0263 20.3785C80.7263 20.4785 80.4263 20.5785 80.2263 20.5785Z' fill='%23D5DDEA'/%3e %3cpath d='M105.126 137.179C104.726 138.879 104.126 140.679 103.426 142.179C101.526 145.879 98.5263 148.779 94.8263 150.679C91.0263 152.579 86.5263 153.379 82.0263 152.379C71.4263 150.179 64.6263 139.779 66.8263 129.179C69.0263 118.579 79.3263 111.679 89.9263 113.979C93.7263 114.779 97.0263 116.679 99.8263 119.279C104.526 123.979 106.526 130.779 105.126 137.179Z' fill='url(%23paint3_linear_340_148)'/%3e %3cpath d='M92.6123 141C92.0398 141 92.248 141.053 87.8239 136.579C83.556 139.789 77.6226 136.684 77.6226 131.421C77.6226 127.895 80.4852 125 83.9724 125C89.021 125 92.1439 130.737 89.1772 135.105L93.289 139.263C93.9656 139.895 93.5492 141 92.6123 141ZM84.0244 127.053C81.6302 127.053 79.6524 129 79.6524 131.474C79.6524 133.947 81.5782 135.895 84.0244 135.895C84.2847 135.895 84.5449 135.895 84.8052 135.842C85.0654 135.789 85.3256 135.737 85.5338 135.632C85.7941 135.526 86.0023 135.421 86.2105 135.316C86.4707 135.158 86.6789 135 86.8871 134.789C87.0432 134.632 87.2514 134.421 87.4076 134.263C87.5637 134.053 87.7198 133.842 87.8239 133.632C87.928 133.421 88.0321 133.158 88.1362 132.895C88.2403 132.632 88.2924 132.368 88.2924 132.105C88.2924 131.895 88.3444 131.737 88.3444 131.526C88.3965 129 86.4186 127.053 84.0244 127.053Z' fill='white'/%3e %3c/g%3e %3cdefs%3e %3cfilter id='filter0_d_340_148' x='-13' y='32.0785' width='97.8638' height='97.2375' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='11'/%3e %3cfeGaussianBlur stdDeviation='11'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_340_148'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_340_148' result='shape'/%3e %3c/filter%3e %3cfilter id='filter1_d_340_148' x='90.5669' y='31.8191' width='90.3594' height='98.1188' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='11'/%3e %3cfeGaussianBlur stdDeviation='11'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_340_148'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_340_148' result='shape'/%3e %3c/filter%3e %3cfilter id='filter2_d_340_148' x='13.9753' y='80.5785' width='142.1' height='96.3' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='11'/%3e %3cfeGaussianBlur stdDeviation='11'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_340_148'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_340_148' result='shape'/%3e %3c/filter%3e %3cfilter id='filter3_d_340_148' x='47.8187' y='14.6506' width='85.4076' height='96.3558' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='11'/%3e %3cfeGaussianBlur stdDeviation='11'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_340_148'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_340_148' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_340_148' x1='85.4329' y1='76.4212' x2='85.4329' y2='109.425' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23B0BACC'/%3e %3cstop offset='1' stop-color='%23969EAE'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_340_148' x1='96.0953' y1='94.0605' x2='102.92' y2='94.8476' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%2383A6FF'/%3e %3cstop offset='1' stop-color='%235A78FF'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_340_148' x1='84.9934' y1='90.3687' x2='84.9934' y2='144.442' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23FDFEFF'/%3e %3cstop offset='0.9964' stop-color='%23ECF0F5'/%3e %3c/linearGradient%3e %3clinearGradient id='paint3_linear_340_148' x1='85.9921' y1='114.9' x2='85.9921' y2='136.945' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23B0BACC'/%3e %3cstop offset='1' stop-color='%23969EAE'/%3e %3c/linearGradient%3e %3cclipPath id='clip0_340_148'%3e %3crect width='168' height='168' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e"

/***/ }),

/***/ 6590:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='185' height='161' viewBox='0 0 185 161' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M90.3 142.621C118.3 142.621 141 119.921 141 91.8209C141 63.7209 118.2 41.0209 90.3 41.0209C62.3 41.0209 39.6 63.7209 39.6 91.8209C39.6 119.921 62.3 142.621 90.3 142.621Z' fill='%23EAEEF9'/%3e %3cpath d='M144.15 124.598C146.414 124.598 148.25 122.762 148.25 120.498C148.25 118.233 146.414 116.398 144.15 116.398C141.886 116.398 140.05 118.233 140.05 120.498C140.05 122.762 141.886 124.598 144.15 124.598Z' fill='%23EAEEF9'/%3e %3cpath d='M150.15 108.598C151.696 108.598 152.95 107.344 152.95 105.798C152.95 104.251 151.696 102.998 150.15 102.998C148.604 102.998 147.35 104.251 147.35 105.798C147.35 107.344 148.604 108.598 150.15 108.598Z' fill='%23EAEEF9'/%3e %3cpath d='M42.3 58.4209C43.8464 58.4209 45.1 57.1673 45.1 55.6209C45.1 54.0745 43.8464 52.8209 42.3 52.8209C40.7536 52.8209 39.5 54.0745 39.5 55.6209C39.5 57.1673 40.7536 58.4209 42.3 58.4209Z' fill='%23EAEEF9'/%3e %3cpath d='M25.2 112.421C28.0719 112.421 30.4 110.093 30.4 107.221C30.4 104.349 28.0719 102.021 25.2 102.021C22.3281 102.021 20 104.349 20 107.221C20 110.093 22.3281 112.421 25.2 112.421Z' fill='%23EAEEF9'/%3e %3cpath d='M96.6613 110.239H85.3941C82.7834 110.239 80.585 112.647 80.585 115.507V121.679C80.585 128 85.2567 133.118 91.0277 133.118C96.7987 133.118 101.47 128 101.47 121.679V115.507C101.47 112.497 99.272 110.239 96.6613 110.239Z' fill='white'/%3e %3cg filter='url(%23filter0_d_331_2)'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M95.6613 51.1047C106.686 53.6549 114.898 63.5283 114.898 75.3274V78.4867C114.898 105.135 134.959 122.58 134.959 122.58H44.959C44.959 122.58 65.1575 105.135 65.1575 78.4867V75.3274C65.1575 63.5283 73.3694 53.6548 84.3941 51.1047V50.0526C84.3941 46.8933 86.8674 44.4208 90.0277 44.4208C93.188 44.4208 95.6613 46.8933 95.6613 50.0526V51.1047Z' fill='url(%23paint0_linear_331_2)'/%3e %3c/g%3e %3cpath d='M79.5849 89.3384C76.1498 89.3384 73.2643 87.1406 72.1651 83.9812C71.8902 83.2944 72.3025 82.6076 72.9895 82.3329C73.6765 82.0582 74.3635 82.4702 74.6383 83.1571C75.3254 85.2175 77.3864 86.7285 79.5849 86.7285C81.7834 86.7285 83.8444 85.3549 84.5315 83.1571C84.8063 82.4702 85.4933 82.0582 86.1803 82.3329C86.8673 82.6076 87.2796 83.2944 87.0048 83.9812C85.9055 87.2779 83.02 89.3384 79.5849 89.3384Z' fill='%23ADB6C8'/%3e %3cpath d='M100.333 89.3384C96.8978 89.3384 94.0123 87.1406 92.9131 83.9812C92.6383 83.2944 93.0505 82.6076 93.7375 82.3329C94.4246 82.0582 95.1116 82.4702 95.3864 83.1571C96.0734 85.2175 98.1345 86.7285 100.333 86.7285C102.531 86.7285 104.592 85.3549 105.28 83.1571C105.554 82.4702 106.241 82.0582 106.928 82.3329C107.615 82.6076 108.028 83.2944 107.753 83.9812C106.654 87.2779 103.768 89.3384 100.333 89.3384Z' fill='%23ADB6C8'/%3e %3cpath d='M90.0277 106.157C91.7731 106.157 93.188 104.743 93.188 102.998C93.188 101.253 91.7731 99.8384 90.0277 99.8384C88.2823 99.8384 86.8674 101.253 86.8674 102.998C86.8674 104.743 88.2823 106.157 90.0277 106.157Z' fill='%23ADB6C8'/%3e %3cpath d='M106.962 28.6497V24H124.932V28.6497L112.67 43.4441H125.143V48.0937H106.328V43.4441L118.59 28.6497H106.962V28.6497Z' fill='url(%23paint1_linear_331_2)'/%3e %3cpath d='M121.761 63.5222V60.5633H133.389V63.5222L125.566 73.0329H133.6V75.9917H121.338V73.0329L129.16 63.5222H121.761Z' fill='url(%23paint2_linear_331_2)'/%3e %3cdefs%3e %3cfilter id='filter0_d_331_2' x='22.959' y='33.4208' width='134' height='122.159' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='11'/%3e %3cfeGaussianBlur stdDeviation='11'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_331_2'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_331_2' result='shape'/%3e %3c/filter%3e %3clinearGradient id='paint0_linear_331_2' x1='89.9297' y1='42.6129' x2='89.9297' y2='123.423' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23FDFEFF'/%3e %3cstop offset='0.9964' stop-color='%23ECF0F5'/%3e %3c/linearGradient%3e %3clinearGradient id='paint1_linear_331_2' x1='115.737' y1='24.837' x2='115.737' y2='38.3606' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23B0BACC'/%3e %3cstop offset='1' stop-color='%23969EAE'/%3e %3c/linearGradient%3e %3clinearGradient id='paint2_linear_331_2' x1='127.47' y1='61.0993' x2='127.47' y2='69.7591' gradientUnits='userSpaceOnUse'%3e %3cstop stop-color='%23B0BACC'/%3e %3cstop offset='1' stop-color='%23969EAE'/%3e %3c/linearGradient%3e %3c/defs%3e %3c/svg%3e"

/***/ }),

/***/ 3597:
/***/ (function(module) {

module.exports = "data:image/svg+xml,%3csvg width='276' height='276' viewBox='0 0 276 276' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg filter='url(%23filter0_d)'%3e %3ccircle cx='138' cy='134' r='128' fill='white'/%3e %3c/g%3e %3ccircle cx='138.438' cy='134.438' r='106.521' fill='%23F0F3F7'/%3e %3cpath d='M120.402 57.6265C125.455 52.6302 134.027 56.2092 134.027 63.3149L134.028 124.123C134.028 128.542 130.446 132.123 126.028 132.123L64.5359 132.123C57.3871 132.123 53.8276 123.462 58.9107 118.435L120.402 57.6265Z' fill='%230081F9'/%3e %3cpath d='M153.368 213.053C148.313 218.047 139.742 214.463 139.746 207.358L139.778 146.549C139.781 142.131 143.364 138.551 147.782 138.554L209.274 138.586C216.423 138.59 219.978 147.253 214.892 152.277L153.368 213.053Z' fill='%230081F9'/%3e %3cpath d='M214.493 118.935C219.503 123.974 215.947 132.557 208.841 132.576L148.033 132.739C143.615 132.751 140.024 129.179 140.012 124.761L139.846 63.2695C139.827 56.1207 148.479 52.5379 153.519 57.6075L214.493 118.935Z' fill='%23CADEF2'/%3e %3cdefs%3e %3cfilter id='filter0_d' x='0' y='0' width='276' height='276' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='4'/%3e %3cfeGaussianBlur stdDeviation='5'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.113715 0 0 0 0 0.298909 0 0 0 0 0.545833 0 0 0 0.25 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3e %3c/filter%3e %3c/defs%3e %3c/svg%3e"

/***/ }),

/***/ 3631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en.json": 790,
	"./fr.json": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3631;

/***/ }),

/***/ 4687:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),

/***/ 8837:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFMSURBVHgBpVLLVcMwEJxVYvO4uYSkApIOLA68hEtMBQkVABVAB5ASaAL7wHsyFUAJLsG3AHG0WIkNxt+8ZC6WVuuRZmaBDmzU9DF5vfC6+gS64aHXuzmK6FtdjhgYpMsRK9c5mIg0L7Kls4HtHkwkBGa/pBCztl5qOjCyBPi9UIp7WA1JhnEtUaKminY+bJF6EmXLAQr1DGF2u/Gr4BmHtFKTgQ1SXP1pX4Rr8PVWGivPSfTXAwl0xlyEBu5s6T9lr/xDoiYLAt3v8bpIg65s+fKRFypmG6kWyJhcOzfM/NanT69selP8jcNHRGd1yVWILA0X7XDWauJ2EkHQvLhN/Vpq5ud/PZq8ViLjT/pxs23MYGlJ/9Y+DxYmobwvTXfeSlSQZWZjbMkgzM9MzGltSLuBrcgTJVkzc3Nf+vJUBhFKMDWBkzFrLFHy8gc3Tm/LsWx/IAAAAABJRU5ErkJggg==";

/***/ }),

/***/ 8450:
/***/ (function(module) {

"use strict";
module.exports = "data:image/png;base64,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";

/***/ }),

/***/ 790:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"version-deprecated":"Mayday has an update available!\\n Restart Chrome to install the update and reconnect with Mayday.","login":{"baseline":{"title":"Welcome 👋","subtitle":"Login to access all the knowledge !"},"instructions":"Fill in your login details","sso-instructions":"Fill in your company\'s Mayday domain name","weak-connection":"Poor internet connection, charging may take time.","please-wait":"Please wait","back-to-login":"Login differently","form":{"email":"Email","password":"Password","domain":"Domain name","login":"Login","sso-cta":"Continue","or":"OR","google-signin":"Login with Google","microsoft-signin":"Login with Office 365","sso-signin":"Single Sign-On"},"errors":{"server":"The server has a problem, please try again in a few moments","authentication":"The email / password combination is incorrect","invalid-domain":"The domain name provided is invalid","permissions":"You do not have sufficient access rights, please ask an administrator to assign you a group","unverified":"Your account is still pending approval, please contact an administrator","too-many-attempts":"Too many attempts, please try again in 30s","default":"An error has occurred. Please try again","tab-1":"There was a problem with the current tab. Please","tab-2":"clean your cache","tab-3":"then try again."},"forgot-password":"Forgot Password?","register":{"question":"Not registered?","action":"Create account"}},"search":{"cta":"Express Search","no-results":"No search results 🤔"},"knowledge":{"show-more":"Show more","show-less":"Show less","automation":"Automation detected","flowy-tooltip":"Display guides architecture","diag-viewer":{"description":"The problem is about","linked-articles":"Linked articles","linked-files":"Linked files"},"zoom-element":"Element zoom","zoom-open-tab":"Click to enlarge","empty-collection":{"title":"Empty folder","description":"This may be related to your access rights","cta":"Go back"},"empty-step":{"title":"Empty step","description":"This may be related to your access rights","cta":"Go back"},"actions":{"favorite-add":"Add as favorite","favorite-remove":"Remove from favorites","copy-url":"Copy URL","open-page":"Open in full page","open-actions":"Open suggested macro","open-knowledge-actions":"Update Salesforce Case"},"notification":{"add-favorite":"The content was successfully added to favorites!","remove-favorite":"The content was successfully removed from favorites!","copy":"The URL was successfully copied!","feedback":"Message successfully sent ✉️","satisfaction":"Thanks for your feedback!","access-rights":"You do not have the rights to access this content"},"satisfaction":{"title":"Was this content helpful?","cta":"Send feedback to improve it"},"ai-collapse":{"summary":"Summary","action-items":"Action items","edited-at":"Manually updated on","generated-at":"Generated on"}},"ask":{"label-text":"Feedback","link":"Link current content to your feedback","label-target":"Addressee","target-placeholder":"Select a recipient","placeholder":"What would you to share ?","success-message":"Message successfully sent ✉️","cta":"Send","cancel":"Cancel","tab-new":"New","tab-history":"Sent","sent-at":"Sent the","sent-to":"To","groups":"Groups","collaborators":"Collaborators","add":"Add","attachment":"Attached file :| Attached file :| Attached files :","disable-file-upload":"Maximum number of attached files is reached.","too-many-files":"You can\'t attach more than 3 files","file-too-big":"File size exceeds allowed limit.","upload-problem":"File couldn\'t be uploaded, please try again.","existing-file":"A file that you want to attach is already in your attached files.","status":{"doing":"Pending","sent":"Sent","to-do":"To do","archived":"Archived","over":"Done"},"content":"Linked content :","comments":"Messages","answer":"Answer","show-more":"Show more","new-feedback":"Send a feedback","empty":"You did not send any feedback yet !"},"modals":{"copy-article":"Article successfully copied 🖇️","copy-link":"Link successfully copied 🖇️","copy-answer":"Answer successfully copied 🖇️","lightbox":{"open":"Open in a new tab","close":"Close"}},"notifications":{"title":"Notifications","tabs":{"all":"All","info":"Info","feedback":"Feedback"},"you":"You","read-all":"Read all","get-more":"Show more","time-ago":"{time} ago","yesterday":"Yesterday","now":"Now","urgent":"Urgent notification","filters":{"button":"Filter","unread":"Unread","feedback":"Feedback","infos":"Information","date":"Date","reset":"Reset","timeframes":{"3-last-days":"Last 3 days","last-week":"Last week","2-last-weeks":"Last 2 weeks","last-month":"Last month","3-last-months":"Last 3 months"}},"empty":{"title":"No notification","description":"You have no notification to display for the moment","filtered-title":"No results!","filtered-description":"Delete or change your filters to display results","cta":"Reset filters","close":"Close"},"footer":"Click on the notifications to send a confirmation of reading","feedback":{"title":{"TaskMineComment":"commented this feedback on the content: | commented a global feedback","TaskComment":"commented this feedback on the content: | commented a global feedback","MentionTaskComment":"mentioned you in this feedback on the content: | mentioned you in a global feedback","UsedToBeMentionTaskComment":"commented the feedback where you were mentioned on the content: | commented a global feedback where you have been mention","InternalTaskMineComment":"created an internal note about this feedback on the content: | created an internal note about a global feedback","InternalTaskComment":"created an internal note about this feedback on the content: | created an internal note about a global feedback","MentionInternalTaskComment":"mentioned you in an internal note about the feedback on the content: | mentioned you in an internal note about a global feedback","TaskMoved":"is processing your feedback on the content: | is processing your global feedback","TaskUpvoted":"liked your feedback on the content: | liked your global feedback","TaskAssigned":"assigned you a task on the content: | assigned you a task on a global feedback","Feedback":"sent you a feedback on the content: | sent you a global feedback","ContentToVerify":"have to verify this content: ","ContentMention":"mentioned you on the content: ","ContentThreadMessage":"commented the content: ","ContentThreadMention":"mentioned you in a comment related to the content: ","ContentThreadStatus":{"SOLVED":"resolved a thread related to the content: ","ARCHIVED":"archived a thread related to the content: "}},"response":{"button":"Reply","placeholder":"Type your answer"}},"info":{"attached-content":"Open content","task":"Open task","content-error":"The content seems removed","author-error":"A deleted user","edited":"(edited)"},"show-more":"Show one comment | Show {count} comments","show-less":"Show less","notifications":{"check-update":"Check the updates","success-message":"✨ Congratulations ✨","success-description":"No notifications left! You are a Customer Care champion!"},"urgents":{"label":"Urgent Notification","display":"Display","linked-content":"View content","count":"Notification","slide":{"all-read":"You have read all urgent notifications.","reread":"Re-read","hide":"hide"}}},"preferences":{"title":"Preferences ⚙️","appearance":"Appearances","productivity":"Productivity","custom-width":{"title":"📐 App width","description":"Choose the app width in your window"},"position":{"title":"🖥️ App location","description":"Choose the app location in your window"},"notifications":{"title":"🔔 Read notifications","description":"Do you want to hide read notifications?"},"language":{"title":"Language","description":"Do you want to translate the app in french?"},"open-command":{"title":"Open the extension","description":"You can open the extension with the cmd + maj + k (ctrl + shift + k) shortcut"},"copy-paste-article":{"title":"📋 Articles copy-paste","description":"Activate the CMD + C shortcut for articles copy-paste?"},"copy-paste-diagnostic":{"title":"📋 Guides copy-paste","description":"Activate the CMD + C shortcut for guides copy-paste?"},"closure":{"title":"🚪 Modals closing","description":"Activate the CMD + ESC shortcut for modals closure?"},"automations":{"title":"🤖 Automations","description":"Should Mayday automatically apply automations when detected?"},"reset-nav":{"title":"Navigation path reset","description":"Should Mayday reset navigation path at every app opening?"},"yes":"Yes","no":"No"},"starred":{"favorites":"Favorites","no-favorites":"No favorite articles so far 🕵 Add one!","magic-answers":"Magic","no-magic-answers":"No magic answers so far 🕵"},"super-search":{"search":"I AM LOOKING FOR ...","more-filters":"Display more filters","less-filters":"Display less filters","type":"Type","labels":"Labels","content-status":"Content state","product-univers":"Product universe","family":"Family","brands":"Brands","content":"Contents","product":"Product","products":"Products","article":"Article","articles":"Articles","diagnostic":"Diagnostic","diagnostics":"Diagnostics","case":"Case","draft":"Draft","published":"Published","verified":"Verified","to-be-verified":"To be verified","suggestions":"SUGGESTIONS","should-filter":"You should filter your search","click-on-product":"Click on the corresponding product","select-univers":"Select a product universe","select-families":"Select one or more families","show":"Display","result":"result","results":"results","results-count-exceeds":"Show more than 10,000 results","search-in":"Express Search","delete":"Delete","enter":"enter","show-less":"Display less","show-more":"Display more","restore":"Restore","delete-definitively":"⚠️ Delete permanently","terms":"Search Terms","collections":"collections","select":"Select","archive":"Archive","edit":"Change product settings","search-results":"Search results","empty-state":"No results"},"favorites":{"modify":"Modify","cancel":"Complete","empty-state":{"user-favorites":{"title":"You don\'t have any favorite!","subtitle":"Click on the ”star” icon to add an article or diagnosis to your favorites."},"company-favorites":{"title":"You don\'t have any company favorites","subtitle":"Your company doesn\'t have favorites yet. Make them a feedback to let them know !"}},"search-empty-state":{"title":"No favorite found!","subtitle":"Please change your search terms"}},"list-item":{"show-more":"Show more","show-less":"Show less","actions":{"favorite-add":"Add as favorite","favorite-remove":"Remove from favorites","copy-url":"Copy URL","open-page":"Open in full page","open-summary":"Open summary","close-summary":"Close summary"}}}');

/***/ }),

/***/ 844:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"version-deprecated":"Une nouvelle version de Mayday est disponible !\\n Redémarrez Chrome pour installer la dernière version de Mayday.","login":{"baseline":{"title":"Bienvenue 👋","subtitle":"Connectez-vous pour libérer le potentiel de la connaissance !"},"instructions":"Renseignez vos informations de connexion","sso-instructions":"Renseignez le nom de domaine Mayday de votre entreprise","weak-connection":"Connexion internet faible, le chargement peut prendre du temps.","please-wait":"Merci de patienter","back-to-login":"Se connecter autrement","form":{"email":"Adresse email","password":"Mot de passe","domain":"Nom de domaine","login":"Se connecter","sso-cta":"Continuer","or":"OU","google-signin":"Se connecter avec Google","microsoft-signin":"Se connecter avec Office 365","sso-signin":"Authentification Unique (SSO)"},"errors":{"server":"Le serveur rencontre un problème, veuillez réessayer dans quelques instants","authentication":"La combinaison email, mot de passe est incorrecte","invalid-domain":"Le nom de domaine renseigné est invalide","permissions":"Vous n\'avez pas les droits d\'accès suffisants, veuillez demander à un administrateur de vous assigner un groupe","unverified":"Votre compte est encore en cours de validation, veuillez contacter un administrateur","too-many-attempts":"Trop de tentatives, veuillez réessayer dans 30s","default":"Une erreur est survenue, veuillez réessayer","tab-1":"Un problème lié à l\'onglet actuel est survenu. Veuillez","tab-2":"vider votre cache","tab-3":"et réessayer."},"forgot-password":"Mot de passe oublié ?","register":{"question":"Pas inscrit ?","action":"Créer un compte"}},"search":{"cta":"Recherche express","no-results":"🧐 Il ne semble pas y avoir de résultats pour cette recherche"},"knowledge":{"show-more":"Afficher plus","show-less":"Afficher moins","automation":"Raccourci détecté","flowy-tooltip":"Afficher l\'architecture du diagnostic","diag-viewer":{"description":"Le problème concerne","linked-articles":"Articles Liés","linked-files":"Fichiers Liés"},"zoom-element":"Zoom sur l\'élément","zoom-open-tab":"Cliquer ici pour agrandir","empty-collection":{"title":"Ce dossier est vide","description":"Cela peut être dû à vos droits d\'accès","cta":"Revenir en arrière"},"empty-step":{"title":"Cette étape est vide","description":"Cela peut être dû à vos droits d\'accès","cta":"Revenir en arrière"},"actions":{"favorite-add":"Mettre en favori","favorite-remove":"Retirer des favoris","copy-url":"Copier l\'URL","open-page":"Ouvrir en pleine page","open-actions":"Ouvrir la réponse suggérée","open-knowledge-actions":"Mettre à jour le Case Salesforce"},"notification":{"add-favorite":"Le contenu a bien été ajouté aux favoris !","remove-favorite":"Le contenu a bien été retiré des favoris !","copy":"L\'url a bien été copiée !","feedback":"Votre message a bien été envoyé ✉️","satisfaction":"Merci pour votre retour de satisfaction !","access-rights":"Vous n\'avez pas les droits pour accéder à ce contenu"},"satisfaction":{"title":"Ce contenu vous a été utile ?","cta":"Envoyer un feedback pour l\'améliorer"},"ai-collapse":{"summary":"Résumé","action-items":"Action items","edited-at":"Édite manuellement le","generated-at":"Généré le"}},"ask":{"label-text":"Feedback","link":"Lier le contenu en cours de lecture","label-target":"Destinataire","target-placeholder":"Sélectionnez un destinataire","placeholder":"Que souhaitez vous partager ?","success-message":"Votre message a bien été envoyé ✉️","cta":"Envoyer","cancel":"Annuler","tab-new":"Nouveau","tab-history":"Envoyés","sent-at":"Envoyé le","sent-to":"À","groups":"Groupes","collaborators":"Collaborateurs","add":"Ajouter","attachment":"Pièce jointe: |Pièce jointe : | Pièces jointes :","disable-file-upload":"Le nombre de pièces jointes maximum est atteint.","too-many-files":"Vous ne pouvez pas joindre plus de 3 fichiers","file-too-big":"La taille du fichier dépasse la limite autorisée.","upload-problem":"Le fichier n\'a pas pu être téléchargé, veuillez réessayer.","existing-file":"Un fichier que vous voulez joindre se trouve déjà dans vos pièces jointes.","status":{"doing":"En cours","sent":"Envoyé","to-do":"À faire","archived":"Archivé","over":"Traité"},"content":"Contenu lié :","comments":"Messages","answer":"Répondre","show-more":"Voir plus","new-feedback":"Rédiger un feedback","empty":"Vous n’avez pas envoyé de feedback !"},"modals":{"copy-article":"L\'article a bien été copié 🖇️","copy-link":"Le lien a bien été copié 🖇️","copy-answer":"La réponse a bien été copiée 🖇️","lightbox":{"open":"Ouvrir dans un nouvel onglet","close":"Fermer"}},"notifications":{"title":"Notifications","tabs":{"all":"Tout","info":"Info","feedback":"Feedback"},"you":"Vous","read-all":"Lire tout","get-more":"Afficher Plus","time-ago":"il y a {time}","yesterday":"Hier","now":"Maintenant","urgent":"Notification urgente","filters":{"button":"Filtrer","unread":"Non lue","feedback":"Feedback","infos":"Information","date":"Date","reset":"Réinitialiser","timeframes":{"3-last-days":"3 derniers jours","last-week":"La semaine dernière","2-last-weeks":"Les 2 dernières semaines","last-month":"Le mois dernier","3-last-months":"Les 3 derniers mois"}},"empty":{"title":"Aucune notification","description":"Vous n’avez pour le moment aucune notification à afficher","filtered-title":"Aucun résultat !","filtered-description":"Effacez ou modifiez vos filtres pour afficher de meilleurs résultats.","cta":"Effacer les filtres","close":"Fermer"},"footer":"Cliquez sur les notifications pour envoyer une confirmation de lecture","feedback":{"title":{"TaskMineComment":"avez répondu au feedback lié au contenu : | avez répondu au feedback global","TaskComment":"vous a fait un commentaire sur le feedback lié au contenu : | vous a fait un commentaire sur ce feedback global","MentionTaskComment":"vous a mentionné dans un commentaire sur le feedback lié au contenu : | vous a mentionné dans un commentaire sur ce feedback global","UsedToBeMentionTaskComment":"vous a fait un commentaire sur le feedback où vous avez été mentionné lié au contenu : | vous a fait un commentaire sur ce feedback global où vous avez été mentionné","InternalTaskMineComment":"avez créé une note interne sur le feedback lié au contenu : | avez créé une note interne sur ce feedback global","InternalTaskComment":"a créé une note en interne sur le feedback lié au contenu : | a créé une note en interne sur ce feedback global","MentionInternalTaskComment":"vous a mentionné dans un commentaire en interne sur le feedback lié au contenu : | vous a mentionné dans un commentaire en interne sur ce feedback global","TaskMoved":"est en train de traiter votre feedback sur le contenu : | est en train de traiter votre feedback global","TaskUpvoted":"a aimé votre feedback sur le contenu : | a aimé votre feedback global","TaskAssigned":"vous a assigné à une tâche sur le contenu : | vous a assigné à une tâche sur un feedback global","Feedback":"vous a fait un feedback sur le contenu : | vous a fait un feedback global","ContentToVerify":"avez une vérification à faire sur un contenu : ","ContentMention":"vous a mentionné sur le contenu : ","ContentThreadMessage":"a ajouté un commentaire sur le contenu : ","ContentThreadMention":"vous a mentionné dans un commentaire sur le contenu : ","ContentThreadVote":"a aimé votre commentaire sur le contenu : ","ContentThreadStatus":{"SOLVED":"a résolu un fil de discussion sur le contenu : ","ARCHIVED":"a archivé un fil de discussion sur le contenu : "}},"response":{"button":"Répondre","placeholder":"Taper votre réponse"}},"info":{"attached-content":"Consulter le contenu","task":"Consulter la tâche","content-error":"Le contenu semble introuvable","author-error":"Un utilisateur supprimé","edited":"(modifié)"},"show-more":"Afficher un commentaire | Afficher {count} commentaires","show-less":"Afficher moins","notifications":{"check-update":"Voir la modification","success-message":"","success-description":"Vous avez lu toutes les notifications"},"urgents":{"label":"Notification urgente","display":"Afficher","linked-content":"Consulter le contenu","count":"Notification","slide":{"all-read":"Vous avez lu toutes les notifications urgentes.","reread":"Relire","hide":"Masquer"}}},"preferences":{"title":"Préférences ⚙️","appearance":"Apparences","productivity":"Productivité","custom-width":{"title":"📐 Taille du volet Mayday","description":"Choisissez la taille du volet Mayday sur la fenêtre"},"position":{"title":"🖥️ Position du volet Mayday","description":"Choisissez la position du volet Mayday sur la fenêtre"},"notifications":{"title":"🔔 Notifications lues","description":"Voulez-vous retirer de la liste de notification celles que vous avez déjà lues ?"},"language":{"title":"Langue","description":"Souhaitez-vous que l\'application soit en anglais ?"},"open-command":{"title":"Ouvrir l\'extension","description":"Vous pouvez ouvrir l\'extension en utilisant le raccourci cmd + maj + k (ctrl + shift + k)"},"copy-paste-article":{"title":"📋 Copier - coller articles","description":"Voulez-vous copier un article en utilisant le raccourci cmd (ctrl) + c ?"},"copy-paste-diagnostic":{"title":"📋 Copier - coller diagnostics","description":"Voulez-vous copier la réponse du diagnostic en utilisant le raccourci cmd (ctrl) + c ?"},"closure":{"title":"🚪 Fermeture modale","description":"Voulez-vous fermer la modale d\'article ou de réponse de diagnostic avec le raccourci cmd (ctrl) + echap ?"},"automations":{"title":"🤖 Automatisations","description":"Quand Mayday détecte un raccourci intelligent, voulez-vous qu\'il l\'applique automatiquement ?"},"reset-nav":{"title":"Réinitialisation du parcours de navigation","description":"Souhaitez-vous que le parcours de navigation soit réinitialisé à chaque ouverture de l\'extension ?"},"yes":"Oui","no":"Non"},"starred":{"favorites":"Favoris","no-favorites":"Il n\'y a pas encore d\'articles favoris 🕵 ! Ajoutez-en !","magic-answers":"Magique","no-magic-answers":"Il n\'y a pas encore de réponses magiques 🕵"},"super-search":{"search":"JE RECHERCHE ...","more-filters":"Afficher plus de filtres","less-filters":"Afficher moins de filtres","type":"Type","labels":"Labels","content-status":"État du contenu","product-univers":"Univers produit","family":"Famille","brands":"Marques","content":"Contenu","product":"Produit","products":"produits","article":"Article","articles":"articles","diagnostic":"Diagnostic","diagnostics":"diagnostics","case":"Case","draft":"Brouillon","published":"Publié","verified":"Vérifié","to-be-verified":"À vérifier","suggestions":"SUGGESTIONS","should-filter":"Vous devriez filtrer votre recherche","click-on-product":"Cliquez sur l\'élément correspondant","select-univers":"Sélectionner un univers produit","select-families":"Sélectionner une ou plusieurs familles","show":"Afficher","result":"résultat","results":"résultats","results-count-exceeds":"Afficher plus de 10 000 résultats","search-in":"Recherche Express","delete":"Effacer","enter":"enter","show-less":"Afficher moins","show-more":"Afficher plus","restore":"Restaurer","delete-definitively":"⚠️ Supprimer définitivement","terms":"Termes de recherche","collections":"collections","select":"Sélectionner","archive":"Archiver","edit":"Modifier les paramètres produit","search-results":"Résultats de recherche","empty-state":"Aucun résultat"},"favorites":{"modify":"Modifier","cancel":"Terminer","empty-state":{"user-favorites":{"title":"Vous n’avez pas de favori !","subtitle":"Cliquez sur l’icône “étoile” pour ajouter un article ou un diagnostic à vos favoris."},"company-favorites":{"title":"Vous n’avez pas de favoris d\'entreprise !","subtitle":"Votre entreprise n\'a pas encore mis en place de favoris. Faites leur feedback pour leur en faire part !"}},"search-empty-state":{"title":"Aucun favori trouvé !","subtitle":"Veuillez modifier vos termes de recherche"}},"list-item":{"show-more":"Afficher plus","show-less":"Afficher moins","actions":{"favorite-add":"Mettre en favori","favorite-remove":"Retirer des favoris","copy-url":"Copier l\'URL","open-page":"Ouvrir en pleine page","open-summary":"Ouvrir le résumé","close-summary":"Fermer le résumé"}}}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AdminModule": function() { return /* reexport */ AdminModule; },
  "FeedbackModule": function() { return /* reexport */ FeedbackModule; },
  "KnowledgeModule": function() { return /* reexport */ KnowledgeModule; },
  "LogModule": function() { return /* reexport */ LogModule; },
  "ModalModule": function() { return /* reexport */ ModalModule; },
  "NotificationModule": function() { return /* reexport */ NotificationModule; },
  "SearchModule": function() { return /* reexport */ SearchModule; },
  "UserFavoritesModule": function() { return /* reexport */ UserFavoritesModule; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./src/modules/knowledge/service/index.ts

class KnowledgeService {
  constructor(apiClient) {
    _defineProperty(this, "apiClient", void 0);
    this.apiClient = apiClient;
  }
  // KNOWLEDGE
  async getKnowledges() {
    const res = await this.apiClient.get("knowledges");
    return res.data || res;
  }
  async getKnowledgeRootContent(id, skipOrdered = false) {
    const res = await this.apiClient.get(`knowledge/${id}/roots?skipOrdered=${skipOrdered}`);
    return res.data || res;
  }
  // CASE
  async getCase(id) {
    const res = await this.apiClient.get(`case/${id}`);
    return res.data || res;
  }
  async getCaseAncestors(id) {
    const res = await this.apiClient.get(`case/${id}/ancestors`);
    return res.data || res;
  }
  // CONTENT
  async getContent(id) {
    const res = await this.apiClient.get(`content/${id}`);
    return res.data || res;
  }
  async getContentAncestors(id) {
    const res = await this.apiClient.get(`content/${id}/ancestors`);
    return res.data || res;
  }
  async getContentDescendents(id) {
    const res = await this.apiClient.get(`content/${id}/descendents`);
    return res.data || res;
  }
  addContentSatisfactionMark(contentId, thumbType) {
    const res = this.apiClient.post(`content/${contentId}/satisfaction`, {
      thumbType
    });
    return res.data || res;
  }
  // ACTION
  dispatchAction(body) {
    const res = this.apiClient.post("action", body);
    return res.data || res;
  }
}
const attachKnowledgeService = knowledgeClient => {
  return new KnowledgeService(knowledgeClient);
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unshift.js
var es_array_unshift = __webpack_require__(541);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ./src/modules/knowledge/store/mutation-types.ts
const LOGOUT = "LOGOUT";
// Error Mutation
const ERROR = "ERROR";
// Knowledge Mutations
const SET_KNOWLEDGES = "SET_KNOWLEDGES";
const UPDATE_KNOWLEDGE_CONTEXT = "UPDATE_KNOWLEDGE_CONTEXT";
const UPDATE_KNOWLEDGE_ID = "UPDATE_KNOWLEDGE_ID";
const UPDATE_KNOWLEDGE_IS_RESTRICTED = "UPDATE_KNOWLEDGE_IS_RESTRICTED";
const UPDATE_KNOWLEDGE_RESTRICTED_NODES_IDS = "UPDATE_KNOWLEDGE_RESTRICTED_NODES_IDS";
const UPDATE_KNOWLEDGE_CONTENT = "UPDATE_KNOWLEDGE_CONTENT";
const UPDATE_KNOWLEDGE_ROOTS = "UPDATE_KNOWLEDGE_ROOTS";
const UPDATE_KNOWLEDGE_IS_LOADING = "UPDATE_KNOWLEDGE_IS_LOADING";
const UPDATE_PATH = "UPDATE_PATH";
const UPDATE_PREVIOUS_NODE = "UPDATE_PREVIOUS_NODE";
// Content Mutations
const UPDATE_CONTENT = "UPDATE_CONTENT";
const UPDATE_CONTENT_CHILDREN = "UPDATE_CONTENT_CHILDREN";
const UPDATE_CONTENT_ATTACHED_CONTENTS = "UPDATE_CONTENT_ATTACHED_CONTENTS";
const UPDATE_CONTENT_PARENTS = "UPDATE_CONTENT_PARENTS";
const RESET_CONTENT = "RESET_CONTENT";
const SET_DIAGNOSTIC_TREE = "SET_DIAGNOSTIC_TREE";
const SET_ARTICLE_CONTENT = "SET_ARTICLE_CONTENT";
;// CONCATENATED MODULE: ./src/utils/resolveDefaultKnowledge.ts
/**
 * Resolves the user default knowledge. It checks user has access to
 * the default knowledge base, and if not returns first knowledge
 * @param {Knowledge[]} knowledges - user accessible knowledges
 * @returns knowledge - Knowledge
 */
/* harmony default export */ function resolveDefaultKnowledge(knowledges) {
  if (!knowledges) return null;
  const defaultKnowledge = knowledges.find(k => k.isDefault);
  return defaultKnowledge || knowledges[0];
}
;// CONCATENATED MODULE: ./src/modules/knowledge/store/actions.ts




const CustomRootContent = {
  id: 0,
  label: "Home",
  type: "Knowledge"
};
const ENTITY_TYPES_MAPPING = {
  Knowledge: "knowledge",
  Case: "case",
  Diagnostic: "contents",
  Step: "contents",
  keyStep: "contents"
};
/* harmony default export */ var actions = ({
  /**
   * GENERAL
   */
  logout({
    commit
  }) {
    commit(LOGOUT);
  },
  resetPath({
    dispatch
  }) {
    dispatch("updatePath", [CustomRootContent]);
  },
  /**
   * KNOWLEDGE
   */
  async getKnowledges({
    commit
  }, accessToken) {
    const {
      knowledges
    } = await this.$knowledgeService.getKnowledges(accessToken);
    const defaultKnowledge = resolveDefaultKnowledge(knowledges);
    if (defaultKnowledge) {
      commit(SET_KNOWLEDGES, knowledges);
    }
    return defaultKnowledge;
  },
  async getKnowledgeRootContent({
    commit
  }, {
    knowledgeId,
    skipOrdered
  }) {
    commit(UPDATE_KNOWLEDGE_IS_LOADING, true);
    try {
      const {
        roots
      } = await this.$knowledgeService.getKnowledgeRootContent(knowledgeId, skipOrdered);
      commit(UPDATE_KNOWLEDGE_ID, knowledgeId);
      commit(UPDATE_KNOWLEDGE_CONTENT, CustomRootContent);
      commit(UPDATE_KNOWLEDGE_ROOTS, roots);
      commit(UPDATE_PATH, [CustomRootContent]);
      commit(RESET_CONTENT);
    } catch (err) {
      console.log(err);
    }
    commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
  },
  updateKnowledgeIsLoading({
    commit
  }, loading) {
    commit(UPDATE_KNOWLEDGE_IS_LOADING, loading);
  },
  updatePath({
    commit,
    state
  }, path) {
    if (path && path.length === 1) {
      const {
        knowledgeContent,
        knowledgeRoots
      } = state;
      commit(UPDATE_CONTENT, knowledgeContent);
      commit(UPDATE_CONTENT_CHILDREN, knowledgeRoots);
    }
    commit(UPDATE_PATH, path);
    commit(UPDATE_CONTENT_PARENTS, []);
    const {
      previousNode
    } = state;
    if (!previousNode || previousNode.type === "Article") return;
    if (path.map(el => el.id).includes(previousNode.to.id)) return;
    commit(UPDATE_PREVIOUS_NODE, null);
  },
  resetPreviousNode({
    commit
  }) {
    commit(UPDATE_PREVIOUS_NODE, null);
  },
  /**
   * CASES AND CONTENTS
   */
  async getEntity({
    commit
  }, {
    id,
    entityType
  }) {
    commit(UPDATE_KNOWLEDGE_IS_LOADING, true);
    try {
      const {
        entity
      } = await this.$knowledgeService[`get${entityType}`](id);
      const {
        children,
        orderedChildrenAndContents,
        ...content
      } = entity;
      const event = {
        content,
        location: "diagnostic",
        deepLoading: false
      };
      const contentChildren = children || orderedChildrenAndContents;
      commit(UPDATE_CONTENT, content);
      commit(UPDATE_CONTENT_CHILDREN, contentChildren);
      commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
      return event;
    } catch (err) {
      console.log(err);
      commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
    }
  },
  async getEntityAncestors({
    commit,
    getters,
    dispatch
  }, {
    id,
    entityType
  }) {
    commit(UPDATE_KNOWLEDGE_IS_LOADING, true);
    try {
      const {
        entity
      } = await this.$knowledgeService[`get${entityType}Ancestors`](id);
      if (!entity) {
        commit(ERROR, {
          errorCode: "NO_ACCESS_RIGHTS",
          errorId: esm_browser_v4()
        });
      }
      const {
        contentAncestors,
        caseAncestors,
        children,
        orderedChildrenAndContents,
        ...content
      } = entity;
      const event = {
        content,
        location: "diagnostic",
        deepLoading: true
      };
      // If content knowledge is different of focus knowledge we update focus knowledge and fetch roots
      const {
        focusKnowledge,
        knowledgeValue
      } = getters;
      if (content.knowledgeId !== focusKnowledge.id) {
        const contentKnowledgeValue = knowledgeValue(content.knowledgeId);
        await dispatch("getKnowledgeRootContent", {
          knowledgeId: contentKnowledgeValue
        });
      }
      const contentChildren = children || orderedChildrenAndContents;
      commit(UPDATE_CONTENT, content);
      commit(UPDATE_CONTENT_CHILDREN, contentChildren);
      let path = [CustomRootContent];
      if (caseAncestors) path = [...path, ...caseAncestors];
      if (["Case", "Diagnostic"].includes(content.type)) {
        path = [...path, content];
      }
      let contentParents = [{
        ...content,
        children
      }];
      if (contentAncestors) {
        const lastChildren = contentAncestors.at(-1).children;
        const newContentAncestors = contentAncestors.map((contentAncestor, idx) => {
          if (idx === 0) {
            return {
              ...contentAncestor,
              children: []
            };
          }
          return {
            ...contentAncestor,
            children: contentAncestors[idx - 1].children
          };
        });
        contentParents = [...newContentAncestors, {
          ...content,
          children: lastChildren
        }];
      }
      if (["Step", "keyStep"].includes(content.type)) {
        path = [...path, contentParents[0]];
      }
      commit(UPDATE_PATH, path);
      commit(UPDATE_CONTENT_PARENTS, contentParents);
      commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
      return event;
    } catch (err) {
      console.log(err);
      commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
    }
  },
  async getContent(_, contentId) {
    const {
      entity
    } = await this.$knowledgeService.getContent(contentId);
    return entity;
  },
  async getArticleContent({
    commit,
    state
  }, {
    articleId
  }) {
    commit(UPDATE_KNOWLEDGE_IS_LOADING, true);
    try {
      const {
        entity
      } = await this.$knowledgeService.getContent(articleId);
      if (!entity) {
        commit(ERROR, {
          errorCode: "NO_ACCESS_RIGHTS",
          errorId: esm_browser_v4()
        });
      }
      const {
        children,
        ...content
      } = entity;
      if (state.previousNode && state.previousNode.type === "Article" && state.previousNode.to !== articleId) {
        commit(UPDATE_PREVIOUS_NODE, null);
      }
      commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
      return content;
    } catch (err) {
      console.log(err);
      commit(UPDATE_KNOWLEDGE_IS_LOADING, false);
    }
  },
  updateContentParents({
    commit
  }, newParents) {
    commit(UPDATE_CONTENT_PARENTS, newParents);
  },
  async getDiagnosticTree({
    getters,
    commit
  }) {
    try {
      const {
        contentParents
      } = getters;
      const diagId = contentParents[0].id;
      const {
        results: descendentsWithRoot
      } = await this.$knowledgeService.getContentDescendents(diagId);
      descendentsWithRoot.root.parentId = -1;
      descendentsWithRoot.descendents.unshift(descendentsWithRoot.root);
      const result = descendentsWithRoot.descendents.map(child => {
        if (!child.parentId) {
          const parent = descendentsWithRoot.descendents.filter(d => d.path.includes(child.id));
          child.parentId = parent.length > 0 ? parent[0].id : descendentsWithRoot.root.id;
        }
        // TODO refactor flowy not to handle data.content.* but child immediately
        child.data = {
          title: child.label,
          content: {
            ...child
          }
        };
        return child;
      });
      commit(SET_DIAGNOSTIC_TREE, result);
      return true;
    } catch (err) {
      return false;
    }
  },
  // MAYDAY EDITOR
  async openInlineLink({
    dispatch
  }, href) {
    try {
      const {
        pathname,
        hash
      } = new URL(href);
      const contentId = pathname.split("/").pop();
      if (contentId && contentId.length === 24) {
        const content = await dispatch("getContent", contentId);
        return {
          content,
          hash
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  },
  handleOnClickInlineContent({
    commit
  }, {
    sourceContent,
    targetContent
  }) {
    if (sourceContent.type === targetContent.type || ["Diagnostic", "keyStep", "Step"].includes(sourceContent.type) && targetContent.type !== "Article") {
      commit(UPDATE_PREVIOUS_NODE, {
        id: sourceContent.id,
        label: sourceContent.label,
        type: sourceContent.type,
        to: String(targetContent.id)
      });
    }
  },
  // NAVIGATION
  updatePathWithChildEntity({
    state,
    dispatch
  }, child) {
    const {
      type
    } = child;
    const {
      path
    } = state;
    if (!ENTITY_TYPES_MAPPING[type]) return;
    dispatch("updatePath", path.concat([child]));
  },
  getParentEntity({
    state,
    dispatch
  }, parentIdx) {
    const {
      path,
      knowledgeId
    } = state;
    const parent = path[parentIdx];
    if (!parent || !ENTITY_TYPES_MAPPING[parent.type]) return;
    // as Home id is 0, this operator allows to set id as
    // knowledgeId when focusing on knowledge
    const id = parent.id || knowledgeId;
    // If user click on Home we want force fetch knowledge Roots without all childrens data
    const forceRoots = parent.type === "Knowledge";
    dispatch("updatePath", path.slice(0, parentIdx + 1));
    // eslint-disable-next-line consistent-return
    return {
      id,
      type: parent.type,
      force: forceRoots,
      skipOrdered: forceRoots
    };
  },
  async unsetPreviousNode({
    commit
  }) {
    commit(UPDATE_PREVIOUS_NODE, null);
  },
  async unsetPreviousNodeIfArticle({
    state,
    commit
  }) {
    if (state.previousNode && state.previousNode.type === "Article") {
      commit(UPDATE_PREVIOUS_NODE, null);
    }
  },
  addContentSatisfactionMark(_, {
    contentId,
    thumbType
  }) {
    if (!thumbType) return null;
    return this.$knowledgeService.addContentSatisfactionMark(contentId, thumbType);
  },
  // ACTIONS
  dispatchKnowledgeAction(_, {
    actionId,
    context,
    contentId
  }) {
    return this.$knowledgeService.dispatchAction({
      actionId,
      contentId,
      context: {
        integration: context.tabSource,
        objectId: context.conversationId
      }
    });
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/store/getters.ts
const getters = {
  // ERROR
  errorCode: state => state.errorCode,
  // KNOWLEDGE
  path: state => state.path,
  knowledgeId: state => state.knowledgeId,
  knowledgeValue: state => knowledgeId => {
    const knowledge = state.knowledges.find(k => k.id === knowledgeId);
    return knowledge.value;
  },
  focusKnowledge: state => {
    return state.knowledges.find(k => k.value === state.knowledgeId);
  },
  focusKnowledgeLanguage: (_, getters) => getters.focusKnowledge.defaultLanguage,
  remainingKnowledges: state => {
    return state.knowledges.filter(k => k.value !== state.knowledgeId);
  },
  knowledgeIsRestricted: state => state.knowledgeIsRestricted,
  knowledgeRestrictedNodesIds: state => state.knowledgeRestrictedNodesIds,
  knowledgeIsLoading: state => state.knowledgeIsLoading,
  previousNode: state => state.previousNode,
  previousNodeIsDiagnostic: state => state.previousNode && ["Diagnostic", "keyStep", "Step"].includes(state.previousNode.type),
  previousNodeIsArticle: state => state.previousNode && state.previousNode.type === "Article",
  // CONTENTS
  content: state => state.content,
  contentChildren: state => state.contentChildren,
  contentAttachedContents: state => state.contentAttachedContents,
  focusIsDiag: state => state.content ? state.content.type === "Diagnostic" : false,
  // NAVIGATION
  rootIsFocused: state => state.path ? state.path.length === 1 : true,
  mainContent: (state, getters) => {
    const {
      rootIsFocused
    } = getters;
    const {
      content,
      knowledgeContent
    } = state;
    return rootIsFocused ? knowledgeContent : content;
  },
  mainContentChildren: (state, getters) => {
    const {
      rootIsFocused
    } = getters;
    const {
      contentChildren,
      knowledgeRoots
    } = state;
    return rootIsFocused ? knowledgeRoots : contentChildren;
  },
  mainAttachedContents: (state, getters) => {
    const {
      rootIsFocused
    } = getters;
    const {
      contentAttachedContents
    } = state;
    return rootIsFocused ? [] : contentAttachedContents;
  },
  isEmptyCollection: (_state, getters) => getters.mainContent && getters.mainContent.type === "Case" && getters.mainContentChildren ? getters.mainContentChildren.length === 0 : false,
  diagnosticIsFocused: (_state, getters) => getters.mainContent ? ["Diagnostic", "Step", "keyStep"].includes(getters.mainContent.type) : false,
  diagnosticTitle: state => state.contentParents.length ? state.contentParents[0].label : "",
  diagnosticTree: state => state.diagnosticTree,
  contentParents: state => state.contentParents,
  contentSiblings: state => state.contentParents.length ? state.contentParents.at(-1).children : []
};
/* harmony default export */ var store_getters = (getters);
;// CONCATENATED MODULE: ./src/modules/knowledge/store/state.ts
const state_state = () => ({
  mounted: false,
  /**
   * ERROR
   */
  errorCode: "",
  errorId: "",
  /**
  /**
   * KNOWLEDGE
   */
  knowledges: [],
  knowledgeId: null,
  knowledgeIsRestricted: false,
  knowledgeRestrictedNodesIds: [],
  knowledgeContent: {},
  knowledgeRoots: [],
  knowledgeIsLoading: false,
  path: [],
  previousNode: null,
  parents: [],
  /**
   * CONTENTS
   */
  contentId: null,
  content: {},
  contentChildren: [],
  contentAttachedContents: [],
  contentParents: [],
  articleContent: "",
  diagnosticTree: []
});
;// CONCATENATED MODULE: ./src/modules/knowledge/store/mutations.ts


const mutations_CustomRootContent = {
  id: 0,
  label: "Home",
  type: "Folder"
};
/* harmony default export */ var mutations = ({
  mounted(state) {
    state.mounted = true;
  },
  /**
   * GENERAL
   */
  [LOGOUT](state) {
    Object.assign(state, state_state());
  },
  /**
   * ERROR
   */
  [ERROR](state, error) {
    const {
      errorCode,
      errorId
    } = error;
    if (state.errorId && state.errorId === errorId) return;
    state.errorCode = errorCode;
    state.errorId = errorId || state.errorId;
  },
  /**
   * KNOWLEDGE
   */
  [SET_KNOWLEDGES](state, knowledges) {
    state.knowledges = knowledges;
  },
  [UPDATE_KNOWLEDGE_CONTEXT](state, payload) {
    state.knowledgeId = payload.knowledgeId;
    state.knowledgeRoots = payload.knowledgeRoots;
    state.knowledgeIsRestricted = payload.knowledgeIsRestricted;
    state.knowledgeRestrictedNodesIds = payload.knowledgeRestrictedNodesIds;
    state.knowledgeContent = mutations_CustomRootContent;
    state.path = [mutations_CustomRootContent];
  },
  [UPDATE_KNOWLEDGE_IS_LOADING](state, payload) {
    state.knowledgeIsLoading = payload;
  },
  [UPDATE_PATH](state, payload) {
    state.path = payload;
  },
  [UPDATE_KNOWLEDGE_ID](state, payload) {
    state.knowledgeId = payload;
  },
  [UPDATE_KNOWLEDGE_IS_RESTRICTED](state, payload) {
    state.knowledgeIsRestricted = payload;
  },
  [UPDATE_KNOWLEDGE_RESTRICTED_NODES_IDS](state, payload) {
    state.knowledgeRestrictedNodesIds = payload;
  },
  [UPDATE_KNOWLEDGE_CONTENT](state, payload) {
    state.knowledgeContent = payload;
  },
  [UPDATE_KNOWLEDGE_ROOTS](state, payload) {
    state.knowledgeRoots = payload;
  },
  [UPDATE_PREVIOUS_NODE](state, payload) {
    state.previousNode = payload;
  },
  /**
   * CONTENTS
   */
  [RESET_CONTENT](state) {
    state.content = {};
    state.contentId = null;
    state.contentChildren = [];
    state.contentAttachedContents = [];
    state.contentParents = [];
  },
  [UPDATE_CONTENT](state, payload) {
    state.content = payload;
  },
  [UPDATE_CONTENT_CHILDREN](state, payload) {
    state.contentChildren = payload;
  },
  [UPDATE_CONTENT_ATTACHED_CONTENTS](state, payload) {
    state.contentAttachedContents = payload;
  },
  [UPDATE_CONTENT_PARENTS](state, payload) {
    state.contentParents = payload;
  },
  [SET_DIAGNOSTIC_TREE](state, payload) {
    state.diagnosticTree = payload;
  },
  [SET_ARTICLE_CONTENT](state, content) {
    state.articleContent = content;
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/store/index.ts




const knowledgeStore = {
  namespaced: true,
  dynamic: true,
  state: state_state,
  getters: store_getters,
  actions: actions,
  mutations: mutations
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Knowledge.vue?vue&type=template&id=88f7d50a&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.previousNodeIsDiagnostic ? _c('PreviousNodeButton', {
    staticClass: "col-12 mb-2 mt-4",
    attrs: {
      "label": _vm.previousNode.label,
      "type": _vm.previousNode.type
    },
    on: {
      "click": function ($event) {
        return _vm.handleOnClickPreviousNode(_vm.previousNode);
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "text-left"
  }, [_c('KnowledgeBreadcrumb', {
    attrs: {
      "custom-width": _vm.customWidth,
      "parents": _vm.path,
      "content-parents": _vm.contentParents,
      "content-siblings": _vm.contentSiblings
    },
    on: {
      "click:folder": _vm.handleClickFolder,
      "click:content": _vm.appearDiagnosticStepParent,
      "click:sibling": _vm.focusContentSibling
    }
  }), _vm._t("default")], 2)], 1);
};
var staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/vuex/dist/vuex.esm.js
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof __webpack_require__.g !== 'undefined'
    ? __webpack_require__.g
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {}

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {}
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {}

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {}
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {}

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {}
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {}
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {}
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {}
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {}
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {}
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {}
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {}
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {}
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {}
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {}
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {}
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {}

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {}
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {}
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {}
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {}
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {}
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {}
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {}
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ var vuex_esm = ((/* unused pure expression or super */ null && (index)));


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/PreviousNodeButton.vue?vue&type=template&id=7bfc6d52&scoped=true&
var PreviousNodeButtonvue_type_template_id_7bfc6d52_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.mainClass],
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('font-awesome-icon', {
    class: [`${_vm.mainClass}__icon`],
    attrs: {
      "icon": ['fas', 'long-arrow-left']
    }
  }), _c('img', {
    class: [`${_vm.mainClass}__type-icon`],
    attrs: {
      "src": _vm.iconSrc
    }
  }), _c('span', {
    class: [`${_vm.mainClass}__label`]
  }, [_vm._v(_vm._s(_vm.label))])], 1);
};
var PreviousNodeButtonvue_type_template_id_7bfc6d52_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./src/assets/icons/article.svg
var article = __webpack_require__(436);
var article_default = /*#__PURE__*/__webpack_require__.n(article);
// EXTERNAL MODULE: ./src/assets/icons/diagnostic.svg
var diagnostic = __webpack_require__(4816);
var diagnostic_default = /*#__PURE__*/__webpack_require__.n(diagnostic);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/PreviousNodeButton.vue?vue&type=script&lang=js&


/* harmony default export */ var PreviousNodeButtonvue_type_script_lang_js_ = ({
  name: "PreviousNodeButton",
  props: {
    label: {
      type: String
    },
    type: {
      type: String,
      default: "Article"
    }
  },
  data() {
    return {
      mainClass: "previous-content"
    };
  },
  computed: {
    iconSrc() {
      return this.type === "Article" ? (article_default()) : (diagnostic_default());
    }
  }
});
;// CONCATENATED MODULE: ./src/library/PreviousNodeButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_PreviousNodeButtonvue_type_script_lang_js_ = (PreviousNodeButtonvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/PreviousNodeButton.vue?vue&type=style&index=0&id=7bfc6d52&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/PreviousNodeButton.vue?vue&type=style&index=0&id=7bfc6d52&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/library/PreviousNodeButton.vue



;


/* normalize component */

var component = normalizeComponent(
  library_PreviousNodeButtonvue_type_script_lang_js_,
  PreviousNodeButtonvue_type_template_id_7bfc6d52_scoped_true_render,
  PreviousNodeButtonvue_type_template_id_7bfc6d52_scoped_true_staticRenderFns,
  false,
  null,
  "7bfc6d52",
  null
  
)

/* harmony default export */ var PreviousNodeButton = (component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumb.vue?vue&type=template&id=3e1960fd&scoped=true&
var KnowledgeBreadcrumbvue_type_template_id_3e1960fd_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "breadcrumb-container"
  }, [_vm.parents.length > 0 ? _c('div', {
    ref: "breadcrumb",
    staticClass: "breadcrumb-wrapper no-side-margin"
  }, _vm._l(_vm.renderedPath, function (parent, idx) {
    return _c('div', {
      key: idx,
      staticClass: "breadcrumb-item"
    }, [idx === 0 ? _c('span', {
      staticClass: "breadcrumb-label",
      on: {
        "click": function ($event) {
          return _vm.handleClick(idx);
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": ['fas', 'home']
      }
    })], 1) : parent.label === '...' ? _c('KnowledgeBreadcrumbDropdown', {
      staticClass: "breadcrumb-label",
      attrs: {
        "custom-width": _vm.customWidth,
        "hidden-parents": _vm.hiddenParents
      },
      on: {
        "click:folder": _vm.handleClick
      }
    }) : parent.type === 'Case' ? _c('TextEllipsis', {
      staticClass: "breadcrumb-label",
      attrs: {
        "width": _vm.maxWidth,
        "text": parent.label
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.handleClick(idx);
        }
      }
    }) : _c('DiagnosticNavigatorBreadcrumb', {
      attrs: {
        "custom-width": _vm.customWidth,
        "content-parents": _vm.contentParents,
        "focus-content-id": _vm.mainContent.id,
        "siblings": _vm.contentSiblings
      },
      on: {
        "click:content": function ($event) {
          return _vm.$emit('click:content', $event);
        },
        "click:sibling": function ($event) {
          return _vm.$emit('click:sibling', $event);
        }
      }
    }), idx + 1 !== _vm.renderedPath.length ? _c('font-awesome-icon', {
      staticClass: "breadcrumb-divider",
      attrs: {
        "icon": ['fas', 'chevron-right']
      }
    }) : _vm._e()], 1);
  }), 0) : _vm._e()]);
};
var KnowledgeBreadcrumbvue_type_template_id_3e1960fd_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorBreadcrumb.vue?vue&type=template&id=0adaa506&scoped=true&
var DiagnosticNavigatorBreadcrumbvue_type_template_id_0adaa506_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "diagnostic-breadcrumb-wrapper",
    style: `max-width: ${_vm.maxWidth}px`
  }, [_c('button', {
    class: {
      'diagnostic-breadcrumb-root-disabled': !_vm.hasChildren,
      'diagnostic-breadcrumb-root': _vm.hasChildren
    },
    on: {
      "click": function ($event) {
        _vm.hasChildren ? _vm.handleClick(0) : '';
      }
    }
  }, [_c('TextEllipsis', {
    attrs: {
      "text": _vm.root.label
    }
  })], 1), _vm.hasChildren ? _c('button', {
    staticClass: "diagnostic-breadcrumb-chevron",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('font-awesome-icon', {
    staticClass: "diagnostic-breadcrumb-chevron-icon",
    class: {
      'diagnostic-breadcrumb-chevron-icon-active': _vm.dropdown
    },
    attrs: {
      "icon": ['fas', 'chevron-down']
    }
  })], 1) : _vm._e(), _vm.dropdown ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.toggleDropdown,
      expression: "toggleDropdown"
    }],
    staticClass: "diagnostic-breadcrumb-dropdown",
    style: `max-width: ${_vm.maxWidth - 15}px`
  }, [_vm._l(_vm.parents, function (child, idx) {
    return _c('div', {
      key: idx,
      staticClass: "diagnostic-breadcrumb-dropdown-item",
      class: [`diagnostic-breadcrumb-dropdown-item-${idx}`],
      on: {
        "click": function ($event) {
          return _vm.handleClick(idx + 1);
        }
      }
    }, [_c('TextEllipsis', {
      attrs: {
        "text": child.label,
        "width": _vm.maxWidth
      }
    })], 1);
  }), _vm._l(_vm.siblings, function (sibling, idx) {
    return _c('div', {
      key: idx,
      staticClass: "diagnostic-breadcrumb-dropdown-item",
      class: {
        'diagnostic-breadcrumb-dropdown-item-active': sibling.id === _vm.focusContentId,
        [`diagnostic-breadcrumb-dropdown-item-${_vm.parents.length}`]: true
      },
      on: {
        "click": function ($event) {
          return _vm.handleFocusSibling(sibling);
        }
      }
    }, [_c('TextEllipsis', {
      attrs: {
        "text": sibling.label,
        "width": _vm.maxWidth
      }
    }), sibling.id === _vm.focusContentId ? _c('span', [_c('font-awesome-icon', {
      attrs: {
        "icon": ['fal', 'check']
      }
    })], 1) : _vm._e()], 1);
  })], 2) : _vm._e()]);
};
var DiagnosticNavigatorBreadcrumbvue_type_template_id_0adaa506_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/TextEllipsis.vue?vue&type=template&id=5ac6329d&scoped=true&
var TextEllipsisvue_type_template_id_5ac6329d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "tooltip-container",
    style: _vm.dynamicWidth
  }, [_c('div', {
    ref: "tooltip-overflow",
    staticClass: "overflow",
    class: {
      'overflow-active': _vm.tooltip
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]), _vm.tooltip ? _c('div', {
    staticClass: "tooltip-text"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]) : _vm._e()]);
};
var TextEllipsisvue_type_template_id_5ac6329d_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/TextEllipsis.vue?vue&type=script&lang=js&
/* harmony default export */ var TextEllipsisvue_type_script_lang_js_ = ({
  name: "text-overflow-tooltip",
  props: {
    text: {
      type: String,
      default: ""
    },
    width: {
      type: Number
    }
  },
  data() {
    return {
      tooltip: true
    };
  },
  mounted() {
    this.isTooltipDisabled();
  },
  methods: {
    isTooltipDisabled() {
      this.$nextTick(() => {
        const textEl = this.$refs["tooltip-overflow"];
        if (textEl) {
          this.tooltip = textEl.scrollWidth > textEl.clientWidth;
        }
      });
    }
  },
  computed: {
    dynamicWidth() {
      return this.width ? `max-width: ${this.width}px` : "max-width: 100%";
    }
  },
  watch: {
    text() {
      this.isTooltipDisabled();
    }
  }
});
;// CONCATENATED MODULE: ./src/library/TextEllipsis.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_TextEllipsisvue_type_script_lang_js_ = (TextEllipsisvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/TextEllipsis.vue?vue&type=style&index=0&id=5ac6329d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/TextEllipsis.vue?vue&type=style&index=0&id=5ac6329d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/TextEllipsis.vue



;


/* normalize component */

var TextEllipsis_component = normalizeComponent(
  library_TextEllipsisvue_type_script_lang_js_,
  TextEllipsisvue_type_template_id_5ac6329d_scoped_true_render,
  TextEllipsisvue_type_template_id_5ac6329d_scoped_true_staticRenderFns,
  false,
  null,
  "5ac6329d",
  null
  
)

/* harmony default export */ var TextEllipsis = (TextEllipsis_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorBreadcrumb.vue?vue&type=script&lang=js&


/* harmony default export */ var DiagnosticNavigatorBreadcrumbvue_type_script_lang_js_ = ({
  name: "DiagnosticNavigatorBreadcrumb",
  components: {
    TextEllipsis: TextEllipsis
  },
  props: {
    customWidth: {
      type: Number,
      required: true
    },
    siblings: {
      type: Array,
      default: () => []
    },
    focusContentId: {
      type: String,
      default: ""
    },
    contentParents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dropdown: false
    };
  },
  computed: {
    root() {
      return this.contentParents.length && this.contentParents[0];
    },
    hasChildren() {
      return this.contentParents.length > 1;
    },
    parents() {
      return this.contentParents.slice(1, -1);
    },
    maxWidth() {
      const margin = 42;
      const start = 36 * 2;
      return this.customWidth - margin - start;
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdown = !this.dropdown;
    },
    handleClick(idx) {
      this.dropdown = false;
      return this.$emit("click:content", idx);
    },
    handleFocusSibling(child) {
      this.dropdown = false;
      return this.$emit("click:sibling", child);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorBreadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var DiagnosticNavigator_DiagnosticNavigatorBreadcrumbvue_type_script_lang_js_ = (DiagnosticNavigatorBreadcrumbvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorBreadcrumb.vue?vue&type=style&index=0&id=0adaa506&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorBreadcrumb.vue?vue&type=style&index=0&id=0adaa506&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorBreadcrumb.vue



;


/* normalize component */

var DiagnosticNavigatorBreadcrumb_component = normalizeComponent(
  DiagnosticNavigator_DiagnosticNavigatorBreadcrumbvue_type_script_lang_js_,
  DiagnosticNavigatorBreadcrumbvue_type_template_id_0adaa506_scoped_true_render,
  DiagnosticNavigatorBreadcrumbvue_type_template_id_0adaa506_scoped_true_staticRenderFns,
  false,
  null,
  "0adaa506",
  null
  
)

/* harmony default export */ var DiagnosticNavigatorBreadcrumb = (DiagnosticNavigatorBreadcrumb_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumbDropdown.vue?vue&type=template&id=39c900a6&scoped=true&
var KnowledgeBreadcrumbDropdownvue_type_template_id_39c900a6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "breadcrumb-hidden"
  }, [_c('button', {
    staticClass: "breadcrumb-hidden-button",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._v(" ... ")]), _vm.hiddenParents.length && _vm.dropdown ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.toggleDropdown,
      expression: "toggleDropdown"
    }],
    staticClass: "breadcrumb-dropdown",
    style: `max-width: ${_vm.maxWidth}px`
  }, _vm._l(_vm.hiddenParents, function (hiddenParent, idx) {
    return _c('div', {
      key: idx,
      staticClass: "breadcrumb-dropdown-item",
      class: `breadcrumb-dropdown-item-${idx}`,
      on: {
        "click": function ($event) {
          return _vm.$emit('click:folder', idx + 1);
        }
      }
    }, [_c('TextEllipsis', {
      attrs: {
        "text": hiddenParent.label,
        "width": _vm.maxWidth
      }
    })], 1);
  }), 0) : _vm._e()]);
};
var KnowledgeBreadcrumbDropdownvue_type_template_id_39c900a6_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumbDropdown.vue?vue&type=script&lang=js&

/* harmony default export */ var KnowledgeBreadcrumbDropdownvue_type_script_lang_js_ = ({
  name: "KnowledgeBreadcrumb",
  components: {
    TextEllipsis: TextEllipsis
  },
  props: {
    customWidth: {
      type: Number,
      required: true
    },
    hiddenParents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dropdown: false
    };
  },
  computed: {
    maxWidth() {
      const margin = 32;
      const start = 40;
      return this.customWidth - margin - start;
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdown = !this.dropdown;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumbDropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var KnowledgeBreadcrumb_KnowledgeBreadcrumbDropdownvue_type_script_lang_js_ = (KnowledgeBreadcrumbDropdownvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumbDropdown.vue?vue&type=style&index=0&id=39c900a6&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumbDropdown.vue?vue&type=style&index=0&id=39c900a6&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumbDropdown.vue



;


/* normalize component */

var KnowledgeBreadcrumbDropdown_component = normalizeComponent(
  KnowledgeBreadcrumb_KnowledgeBreadcrumbDropdownvue_type_script_lang_js_,
  KnowledgeBreadcrumbDropdownvue_type_template_id_39c900a6_scoped_true_render,
  KnowledgeBreadcrumbDropdownvue_type_template_id_39c900a6_scoped_true_staticRenderFns,
  false,
  null,
  "39c900a6",
  null
  
)

/* harmony default export */ var KnowledgeBreadcrumbDropdown = (KnowledgeBreadcrumbDropdown_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumb.vue?vue&type=script&lang=js&




/* harmony default export */ var KnowledgeBreadcrumbvue_type_script_lang_js_ = ({
  name: "KnowledgeBreadcrumb",
  components: {
    DiagnosticNavigatorBreadcrumb: DiagnosticNavigatorBreadcrumb,
    KnowledgeBreadcrumbDropdown: KnowledgeBreadcrumbDropdown,
    TextEllipsis: TextEllipsis
  },
  props: {
    customWidth: {
      type: Number,
      required: true
    },
    parents: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    contentSiblings: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOverflow: false
    };
  },
  mounted() {
    this.computeOverflow();
  },
  computed: {
    renderedPath() {
      if (!this.isOverflow) return this.parents;
      return [this.parents[0], {
        label: "..."
      }, this.parents.at(-1)];
    },
    hiddenParents() {
      if (!this.isOverflow) return [];
      return this.parents.slice(1, -1);
    },
    maxWidth() {
      const margin = 32;
      const start = 36 * 2;
      return this.customWidth - margin - start;
    },
    ...mapGetters("knowledgeModule", ["mainContent"])
  },
  methods: {
    computeOverflow() {
      this.isOverflow = false;
      this.$nextTick(() => {
        const {
          breadcrumb
        } = this.$refs;
        if (!breadcrumb) return;
        this.isOverflow = breadcrumb.scrollWidth > breadcrumb.clientWidth;
      });
    },
    handleClick(idx) {
      if (idx + 1 !== this.parents.length) {
        return this.$emit("click:folder", idx);
      }
      return "";
    }
  },
  watch: {
    parents() {
      this.computeOverflow();
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var KnowledgeBreadcrumb_KnowledgeBreadcrumbvue_type_script_lang_js_ = (KnowledgeBreadcrumbvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumb.vue?vue&type=style&index=0&id=3e1960fd&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumb.vue?vue&type=style&index=0&id=3e1960fd&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/KnowledgeBreadcrumb/KnowledgeBreadcrumb.vue



;


/* normalize component */

var KnowledgeBreadcrumb_component = normalizeComponent(
  KnowledgeBreadcrumb_KnowledgeBreadcrumbvue_type_script_lang_js_,
  KnowledgeBreadcrumbvue_type_template_id_3e1960fd_scoped_true_render,
  KnowledgeBreadcrumbvue_type_template_id_3e1960fd_scoped_true_staticRenderFns,
  false,
  null,
  "3e1960fd",
  null
  
)

/* harmony default export */ var KnowledgeBreadcrumb = (KnowledgeBreadcrumb_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Knowledge.vue?vue&type=script&lang=js&



/* harmony default export */ var Knowledgevue_type_script_lang_js_ = ({
  name: "KnowledgeView",
  components: {
    PreviousNodeButton: PreviousNodeButton,
    KnowledgeBreadcrumb: KnowledgeBreadcrumb
  },
  props: {
    customWidth: {
      type: Number,
      required: true
    },
    modalType: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("knowledgeModule", ["path", "contentParents", "knowledgeId", "previousNode", "previousNodeIsDiagnostic", "contentSiblings"])
  },
  methods: {
    appearDiagnosticStepParent(index) {
      const parent = this.contentParents[index];
      const newParents = this.contentParents.slice(0, index + 1);
      this.updateContentParents(newParents);
      const entity = {
        id: parent.id,
        type: "Content"
      };
      this.$emit("go-to-entity", entity);
    },
    focusContentSibling(content) {
      if (content.redirection) {
        const {
          entityId: id,
          entityType: type
        } = content.redirection;
        return this.$emit("reach-entity", {
          content: {
            id,
            type
          }
        });
      }
      const newParents = this.contentParents.slice(0, -1).concat({
        ...content,
        children: this.contentSiblings
      });
      this.updateContentParents(newParents);
      const entity = {
        id: content.id,
        type: "Content"
      };
      this.$emit("go-to-entity", entity);
    },
    async handleClickFolder(parentIdx) {
      const parent = await this.getParentEntity(parentIdx);
      this.$emit("go-to-entity", parent);
    },
    handleOnClickPreviousNode(previousNode) {
      this.unsetPreviousNode();
      this.$emit("reach-entity", {
        content: previousNode
      });
    },
    ...mapActions("knowledgeModule", ["updateContentParents", "reachSearchContent", "getParentEntity", "unsetPreviousNode"])
  },
  watch: {
    contentParents() {
      if (this.contentParents.length === 0 && this.modalType === "answer") {
        this.$emit("close-modal");
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/Knowledge.vue?vue&type=script&lang=js&
 /* harmony default export */ var knowledge_Knowledgevue_type_script_lang_js_ = (Knowledgevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/knowledge/Knowledge.vue





/* normalize component */
;
var Knowledge_component = normalizeComponent(
  knowledge_Knowledgevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Knowledge = (Knowledge_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Contents.vue?vue&type=template&id=bef145ba&scoped=true&
var Contentsvue_type_template_id_bef145ba_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "contents-viewer"
  }, [_vm.diagnosticIsFocused ? _c('div', [_c('DiagnosticNavigator', {
    attrs: {
      "attachedContents": _vm.mainAttachedContents,
      "children": _vm.mainContentChildren,
      "config": _vm.config,
      "content": _vm.mainContent,
      "diagnostic-title": _vm.diagnosticTitle,
      "parents": _vm.contentParents
    },
    on: {
      "zoom": function ($event) {
        return _vm.$emit('show-zoom', $event);
      },
      "focus-child": _vm.appearDiagnosticStep,
      "focus-attached-content": _vm.openLinkedContent,
      "reach-content": function ($event) {
        return _vm.$emit('reach-entity', $event);
      },
      "open-lightbox": function ($event) {
        return _vm.$emit('open-lightbox', $event);
      },
      "open-flowy": function ($event) {
        return _vm.$emit('open-flowy');
      },
      "open-answer": function ($event) {
        return _vm.$emit('show-answer', $event);
      },
      "close-modal": function ($event) {
        return _vm.$emit('close-modal');
      },
      "route-to-feedback": function ($event) {
        return _vm.$emit('route-to-feedback');
      },
      "notify-app": function ($event) {
        return _vm.$emit('notify-app', $event);
      },
      "log-event": function ($event) {
        return _vm.$emit('log-event', $event);
      },
      "click:back": _vm.backDiagnosticStep
    }
  })], 1) : _c('div', {
    staticClass: "container children-row no-side-margin no-side-padding"
  }, [_vm.isEmptyCollection ? _c('EmptyEntity', {
    on: {
      "click": function ($event) {
        return _vm.reachParentEntity(_vm.path.length - 2);
      }
    }
  }) : _c('div', _vm._l(_vm.mainContentChildren, function (child) {
    return _c('div', {
      key: child.id
    }, [child.type === 'Case' ? _c('FolderCard', {
      staticClass: "cursor",
      attrs: {
        "folder": child,
        "folder-id": String(child.id),
        "is-loading": _vm.knowledgeIsLoading,
        "title": child.label
      },
      on: {
        "folder-clicked": function ($event) {
          return _vm.handleFolderClick(child);
        }
      }
    }) : child.type === 'Diagnostic' ? _c('DiagCard', {
      staticClass: "cursor",
      attrs: {
        "diag-id": String(child.id),
        "is-favorite": _vm.favoriteIds.includes(child.id),
        "is-loading": _vm.knowledgeIsLoading,
        "labels": child.labels,
        "summary": _vm.getSummary(child),
        "title": child.label
      },
      on: {
        "diag-clicked": function ($event) {
          return _vm.appearDiagnosticStep(child, true);
        },
        "toggle-favorite": function ($event) {
          return _vm.$emit('toggle-favorite', $event);
        },
        "copy-link": function ($event) {
          return _vm.$emit('copy-link', $event);
        },
        "open-in-web": function ($event) {
          return _vm.$emit('open-in-web', $event);
        }
      }
    }) : _c('ArticleCard', {
      staticClass: "cursor",
      attrs: {
        "article-id": String(child.id),
        "is-favorite": _vm.favoriteIds.includes(child.id),
        "is-loading": _vm.knowledgeIsLoading,
        "labels": child.labels,
        "summary": _vm.getSummary(child),
        "title": child.label
      },
      on: {
        "article-clicked": function ($event) {
          return _vm.$emit('show-article', $event);
        },
        "toggle-favorite": function ($event) {
          return _vm.$emit('toggle-favorite', $event);
        },
        "copy-link": function ($event) {
          return _vm.$emit('copy-link', $event);
        },
        "open-in-web": function ($event) {
          return _vm.$emit('open-in-web', $event);
        }
      }
    })], 1);
  }), 0)], 1)]);
};
var Contentsvue_type_template_id_bef145ba_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigator.vue?vue&type=template&id=07a95c22&scoped=true&
var DiagnosticNavigatorvue_type_template_id_07a95c22_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container no-side-margin"
  }, [_c('DiagnosticNavigatorTitle', {
    attrs: {
      "content": _vm.content
    },
    on: {
      "click:back": function ($event) {
        return _vm.$emit('click:back');
      },
      "open-flowy": function ($event) {
        return _vm.$emit('open-flowy');
      }
    }
  }), _vm.content.body.length || _vm.children.length ? _c('hr', {
    staticClass: "col-11 mt-2 mb-3"
  }) : _vm._e(), !_vm.content.body.length && !_vm.children.length ? _c('EmptyEntity', {
    attrs: {
      "type": "step"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:back');
      }
    }
  }) : _vm.content.body.length ? _c('DiagnosticNavigatorContentViewer', {
    attrs: {
      "raw-body": _vm.content.body,
      "mentions": _vm.content.enrichedMentions,
      "attached-contents": _vm.attachedContents,
      "custom-width": _vm.config.customWidth
    },
    on: {
      "open-zoom-element": function ($event) {
        return _vm.$emit('zoom', $event);
      },
      "open-lightbox": function ($event) {
        return _vm.$emit('open-lightbox', $event);
      },
      "focus-attached-content": function ($event) {
        return _vm.$emit('focus-attached-content', $event);
      },
      "click:inline-content": function ($event) {
        return _vm.onClickInlineContent({
          sourceContent: _vm.content,
          targetContent: $event
        });
      },
      "open-content": function ($event) {
        return _vm.$emit('reach-content', $event);
      }
    }
  }) : _vm._e(), _vm.validActions ? _c('base-button', {
    staticClass: "action-cta",
    on: {
      "click": function ($event) {
        return _vm.handleActionsMessage(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("knowledge.actions.open-actions")))]) : _vm._e(), _vm.knowledgeAction ? _c('base-button', {
    staticClass: "action-cta",
    on: {
      "click": _vm.handleKnowledgeActions
    }
  }, [_vm.loader.knowledgeAction ? _c('font-awesome-icon', {
    staticClass: "icon-spinner mr-1",
    attrs: {
      "icon": ['fas', 'spinner-third'],
      "spin": ""
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.$t("knowledge.actions.open-knowledge-actions")))], 1) : _vm._e(), !_vm.children.length ? _c('SatisfactionModule', {
    staticClass: "mt-4",
    attrs: {
      "content-id": _vm.content.id
    },
    on: {
      "choice": _vm.handleOnSatisfaction,
      "click:feedback": _vm.handleClickOnFeedback
    }
  }) : _vm._e(), _vm.children.length ? _c('DiagnosticNavigatorChildren', {
    attrs: {
      "children": _vm.children
    },
    on: {
      "click:child": function ($event) {
        return _vm.$emit('focus-child', $event);
      }
    }
  }) : _vm._e()], 1);
};
var DiagnosticNavigatorvue_type_template_id_07a95c22_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue?vue&type=template&id=de9b4b90&scoped=true&
var DiagnosticNavigatorTitlevue_type_template_id_de9b4b90_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "diagnostic-title"
  }, [_c('div', {
    staticClass: "diagnostic-title-wrapper"
  }, [_vm.isRoot ? _c('img', {
    staticClass: "diagnostic-title-icon",
    attrs: {
      "src": __webpack_require__(6520)
    }
  }) : _c('span', {
    staticClass: "diagnostic-back-button",
    on: {
      "click": function ($event) {
        return _vm.$emit('click:back');
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "diagnostic-back-button-icon",
    attrs: {
      "icon": ['fas', 'chevron-left']
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "diagnostic-title-label"
  }, [_vm._v(_vm._s(_vm.content.label))]), _vm.content.labels && _vm.content.labels.length ? _c('div', {
    staticClass: "d-flex align-items-center mt-1"
  }, [_c('ContentListItemFullLabelWrapper', {
    attrs: {
      "labels": _vm.content.labels
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "diagnostic-flowy-icon-wrapper",
    on: {
      "click": function ($event) {
        return _vm.$emit('open-flowy');
      }
    }
  }, [_c('BaseTooltip', {
    attrs: {
      "text": _vm.$t('knowledge.flowy-tooltip')
    }
  }, [_c('div', {
    staticClass: "diagnostic-flowy-icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', 'project-diagram']
    }
  })], 1)])], 1)]);
};
var DiagnosticNavigatorTitlevue_type_template_id_de9b4b90_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue?vue&type=template&id=de9b4b90&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentListItemFullLabelWrapper.vue?vue&type=template&id=2a49175b&scoped=true&
var ContentListItemFullLabelWrappervue_type_template_id_2a49175b_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [!_vm.displayAll && _vm.labelsToDisplay.length ? _c('div', {
    staticClass: "d-flex flex-wrap align-items-center first-display"
  }, [_vm._l(_vm.labelsToDisplay, function (label) {
    return _c('ContentListItemFullLabel', {
      key: label ? label.id : '',
      attrs: {
        "label": label
      }
    });
  }), _vm.orderedLabels.length > 3 ? _c('div', {
    staticClass: "plus-display px-1 mr-1"
  }, [_vm._v(" +" + _vm._s(_vm.orderedLabels.length - 3) + " ")]) : _vm._e(), _vm.orderedLabels.length > 3 ? _c('div', {
    staticClass: "show-button",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.displayAll = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("list-item.show-more")) + " ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "d-flex flex-wrap align-items-center entire-label-list"
  }, [_vm._l(_vm.orderedLabels, function (label) {
    return _c('ContentListItemFullLabel', {
      key: label.id,
      staticClass: "label-item",
      attrs: {
        "label": label
      }
    });
  }), _vm.orderedLabels.length > 3 ? _c('div', {
    staticClass: "show-button ml-1",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.displayAll = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("list-item.show-less")) + " ")]) : _vm._e()], 2)]);
};
var ContentListItemFullLabelWrappervue_type_template_id_2a49175b_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentListItemFullLabel.vue?vue&type=template&id=a198963e&scoped=true&
var ContentListItemFullLabelvue_type_template_id_a198963e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.label.labelName ? _c('div', {
    staticClass: "content-list-item-label px-2",
    style: _vm.computedStyle
  }, [_c('font-awesome-icon', {
    staticClass: "content-label-icon mr-1",
    attrs: {
      "icon": ['fad', _vm.label.icon]
    }
  }), _c('div', {
    staticClass: "label-name"
  }, [_vm._v(" " + _vm._s(_vm.label.labelName) + " ")])], 1) : _vm._e();
};
var ContentListItemFullLabelvue_type_template_id_a198963e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentListItemFullLabel.vue?vue&type=script&lang=js&
/* harmony default export */ var ContentListItemFullLabelvue_type_script_lang_js_ = ({
  name: "ContentListItemFullLabel",
  props: {
    label: {
      type: Object,
      default: () => {
        return {
          labelName: "",
          icon: "",
          color: ""
        };
      }
    }
  },
  computed: {
    computedStyle() {
      return {
        "--label-color": this.label.color,
        "--label-background-color": `${this.label.color}1a`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/library/ListItem/ContentListItemFullLabel.vue?vue&type=script&lang=js&
 /* harmony default export */ var ListItem_ContentListItemFullLabelvue_type_script_lang_js_ = (ContentListItemFullLabelvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentListItemFullLabel.vue?vue&type=style&index=0&id=a198963e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/ListItem/ContentListItemFullLabel.vue?vue&type=style&index=0&id=a198963e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/ListItem/ContentListItemFullLabel.vue



;


/* normalize component */

var ContentListItemFullLabel_component = normalizeComponent(
  ListItem_ContentListItemFullLabelvue_type_script_lang_js_,
  ContentListItemFullLabelvue_type_template_id_a198963e_scoped_true_render,
  ContentListItemFullLabelvue_type_template_id_a198963e_scoped_true_staticRenderFns,
  false,
  null,
  "a198963e",
  null
  
)

/* harmony default export */ var ContentListItemFullLabel = (ContentListItemFullLabel_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentListItemFullLabelWrapper.vue?vue&type=script&lang=js&


/* harmony default export */ var ContentListItemFullLabelWrappervue_type_script_lang_js_ = ({
  name: "ContentListItemFullLabelWrapper",
  components: {
    ContentListItemFullLabel: ContentListItemFullLabel
  },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    labelSearchedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      displayAll: false
    };
  },
  computed: {
    orderedLabels() {
      if (!this.labels) return null;
      return this.labelSearchedIds.reduce((acc, id) => {
        const foundIdx = acc.findIndex(label => label.id === id);
        if (foundIdx === -1) return acc;
        const label = acc[foundIdx];
        acc.splice(foundIdx, 1);
        acc.unshift(label);
        return acc;
      }, this.labels);
    },
    labelsToDisplay() {
      if (this.labels.length > 3) return this.labels.slice(0, 3);
      return this.labels;
    }
  }
});
;// CONCATENATED MODULE: ./src/library/ListItem/ContentListItemFullLabelWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var ListItem_ContentListItemFullLabelWrappervue_type_script_lang_js_ = (ContentListItemFullLabelWrappervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentListItemFullLabelWrapper.vue?vue&type=style&index=0&id=2a49175b&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/ListItem/ContentListItemFullLabelWrapper.vue?vue&type=style&index=0&id=2a49175b&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/ListItem/ContentListItemFullLabelWrapper.vue



;


/* normalize component */

var ContentListItemFullLabelWrapper_component = normalizeComponent(
  ListItem_ContentListItemFullLabelWrappervue_type_script_lang_js_,
  ContentListItemFullLabelWrappervue_type_template_id_2a49175b_scoped_true_render,
  ContentListItemFullLabelWrappervue_type_template_id_2a49175b_scoped_true_staticRenderFns,
  false,
  null,
  "2a49175b",
  null
  
)

/* harmony default export */ var ContentListItemFullLabelWrapper = (ContentListItemFullLabelWrapper_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseTooltip.vue?vue&type=template&id=3b35d2e8&scoped=true&
var BaseTooltipvue_type_template_id_3b35d2e8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "tooltip-container",
    style: _vm.dynamicWidth
  }, [_vm._t("default"), _c('div', {
    staticClass: "tooltip-text",
    class: [_vm.appAtLeft ? 'tooltip-text-left' : 'tooltip-text-right']
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 2);
};
var BaseTooltipvue_type_template_id_3b35d2e8_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseTooltip.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseTooltipvue_type_script_lang_js_ = ({
  name: "BaseTooltip",
  props: {
    appAtLeft: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    },
    width: {
      type: Number
    }
  },
  computed: {
    dynamicWidth() {
      return this.width ? `max-width: ${this.width}px` : "max-width: 100%";
    }
  }
});
;// CONCATENATED MODULE: ./src/library/BaseTooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_BaseTooltipvue_type_script_lang_js_ = (BaseTooltipvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseTooltip.vue?vue&type=style&index=0&id=3b35d2e8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseTooltip.vue?vue&type=style&index=0&id=3b35d2e8&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/BaseTooltip.vue



;


/* normalize component */

var BaseTooltip_component = normalizeComponent(
  library_BaseTooltipvue_type_script_lang_js_,
  BaseTooltipvue_type_template_id_3b35d2e8_scoped_true_render,
  BaseTooltipvue_type_template_id_3b35d2e8_scoped_true_staticRenderFns,
  false,
  null,
  "3b35d2e8",
  null
  
)

/* harmony default export */ var BaseTooltip = (BaseTooltip_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue?vue&type=script&lang=js&


/* harmony default export */ var DiagnosticNavigatorTitlevue_type_script_lang_js_ = ({
  name: "DiagnosticNavigatorTitle",
  props: {
    content: {
      type: Object
    }
  },
  components: {
    ContentListItemFullLabelWrapper: ContentListItemFullLabelWrapper,
    BaseTooltip: BaseTooltip
  },
  computed: {
    isRoot() {
      return this.content.type === "Diagnostic";
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue?vue&type=script&lang=js&
 /* harmony default export */ var DiagnosticNavigator_DiagnosticNavigatorTitlevue_type_script_lang_js_ = (DiagnosticNavigatorTitlevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue?vue&type=style&index=0&id=de9b4b90&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue?vue&type=style&index=0&id=de9b4b90&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorTitle.vue



;


/* normalize component */

var DiagnosticNavigatorTitle_component = normalizeComponent(
  DiagnosticNavigator_DiagnosticNavigatorTitlevue_type_script_lang_js_,
  DiagnosticNavigatorTitlevue_type_template_id_de9b4b90_scoped_true_render,
  DiagnosticNavigatorTitlevue_type_template_id_de9b4b90_scoped_true_staticRenderFns,
  false,
  null,
  "de9b4b90",
  null
  
)

/* harmony default export */ var DiagnosticNavigatorTitle = (DiagnosticNavigatorTitle_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorContentViewer.vue?vue&type=template&id=440e890f&scoped=true&
var DiagnosticNavigatorContentViewervue_type_template_id_440e890f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-12 comment-card",
    style: _vm.dynamicStyle
  }, [_vm.showEditor ? _c('mayday-editor', {
    ref: "diag-viewer-editor",
    staticClass: "me-diagnostic-viewer",
    attrs: {
      "editable": false,
      "options": _vm.options,
      "fetch-inline-content-handler": _vm.getContent,
      "fetch-inline-mention-handler": _vm.handleFetchInlineMention
    },
    on: {
      "open-link-modal": _vm.openLinkModal,
      "click:inline-content": function ($event) {
        return _vm.$emit('click:inline-content', $event);
      },
      "click:image": function ($event) {
        return _vm.openImageModal($event.src);
      },
      "click:attached-file": _vm.handleClickAttachedFile,
      "click:toc": function ($event) {
        return _vm.handleOnTocClick($event);
      },
      "click:focus-hash": _vm.handleFocusHash,
      "click:open-link": _vm.handleOpenLink
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  }) : _vm._e()], 1);
};
var DiagnosticNavigatorContentViewervue_type_template_id_440e890f_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/getShadowRoot.js
/* harmony default export */ function getShadowRoot() {
  const wrapper = window.document.querySelector("#mayday-wrapper");
  if (!wrapper) return null;
  const {
    shadowRoot
  } = wrapper;
  return shadowRoot;
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorContentViewer.vue?vue&type=script&lang=js&


/* harmony default export */ var DiagnosticNavigatorContentViewervue_type_script_lang_js_ = ({
  name: "DiagnosticNavigatorContentViewer",
  props: {
    rawBody: {
      type: String,
      default: ""
    },
    attachedContents: {
      type: Array,
      default: () => []
    },
    mentions: {
      type: Array,
      default: () => []
    },
    searchInput: {
      type: String,
      default: ""
    },
    customWidth: {
      type: Number
    }
  },
  computed: {
    dynamicStyle() {
      return {
        "--custom-width": `${this.customWidth}px`
      };
    },
    body() {
      return this.rawBody;
    }
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      content: "",
      linkModal: {
        display: false,
        src: ""
      },
      showEditor: true,
      options: {
        fontOptions: true,
        extraFontOptions: true,
        colorOptions: true,
        structurationOptions: true,
        extraStructurationOptions: true,
        tableOptions: true,
        richOptions: true,
        tocClickOptions: true,
        allowToc: true
      },
      shadowRoot: getShadowRoot()
    };
  },
  methods: {
    init() {
      this.toggleEditor();
      setTimeout(() => {
        if (!this.$route) return;
        const {
          hash
        } = this.$route;
        this.handleFocusHash(hash);
      }, 1000);
    },
    async handleOpenLink({
      href
    }) {
      if (href.includes("mayday.fr")) {
        const res = await this.openInlineLink(href);
        if (res) {
          return this.$emit("open-content", res);
        }
      }
      return window.open(href, "_blank");
    },
    toggleEditor() {
      this.showEditor = false;
      this.$nextTick(() => {
        this.showEditor = true;
        this.$nextTick(() => {
          this.setEditorContent(this.body);
        });
      });
    },
    setEditorContent(rawContent) {
      const maydayEditor = this.$refs["diag-viewer-editor"];
      this.content = rawContent;
      if (maydayEditor) {
        maydayEditor.editor.commands.setContent(this.content);
        this.$nextTick(() => {
          const editorWrapper = maydayEditor.$el.getElementsByClassName("mayday-editor__content__ProseMirror");
          if (editorWrapper[0]) {
            editorWrapper[0].translate = true;
          }
        });
      }
    },
    openLinkModal(src) {
      this.$emit("open-zoom-element", {
        label: this.$t("knowledge.zoom-element"),
        body: this.resolveZoomLinkContent(src),
        zoom: "link"
      });
    },
    openImageModal(src) {
      this.$emit("open-lightbox", src);
    },
    resolveZoomLinkContent(src) {
      return src;
    },
    handleClickAttachedFile(evt) {
      if (evt && evt.href) {
        window.open(evt.href, "_blank");
      }
    },
    handleOnTocClick({
      id
    }) {
      this.shadowRoot.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
    },
    handleFocusHash(hash) {
      if (!hash) return;
      const id = decodeURI(hash.slice(1));
      const uniqueNode = this.shadowRoot.querySelector(`[data-uid="${id}"], [id="${id}"]`);
      if (!uniqueNode) return;
      uniqueNode.scrollIntoView({
        behavior: "smooth"
      });
    },
    handleFetchInlineMention({
      entityId,
      entityType
    }) {
      const user = this.mentions.find(mention => mention.id === entityId);
      if (!user) return null;
      const {
        username,
        isDeleted
      } = user;
      return {
        entityId,
        entityType,
        label: username,
        isDeleted
      };
    },
    ...mapActions("knowledgeModule", ["openInlineLink", "getContent"])
  },
  watch: {
    body() {
      this.init();
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorContentViewer.vue?vue&type=script&lang=js&
 /* harmony default export */ var DiagnosticNavigator_DiagnosticNavigatorContentViewervue_type_script_lang_js_ = (DiagnosticNavigatorContentViewervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorContentViewer.vue?vue&type=style&index=0&id=440e890f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorContentViewer.vue?vue&type=style&index=0&id=440e890f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorContentViewer.vue



;


/* normalize component */

var DiagnosticNavigatorContentViewer_component = normalizeComponent(
  DiagnosticNavigator_DiagnosticNavigatorContentViewervue_type_script_lang_js_,
  DiagnosticNavigatorContentViewervue_type_template_id_440e890f_scoped_true_render,
  DiagnosticNavigatorContentViewervue_type_template_id_440e890f_scoped_true_staticRenderFns,
  false,
  null,
  "440e890f",
  null
  
)

/* harmony default export */ var DiagnosticNavigatorContentViewer = (DiagnosticNavigatorContentViewer_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorChildren.vue?vue&type=template&id=e7b7d72e&scoped=true&
var DiagnosticNavigatorChildrenvue_type_template_id_e7b7d72e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "diagnostic-navigator-children"
  }, _vm._l(_vm.children, function (child) {
    return _c('div', {
      key: child.id
    }, [_c('button', {
      staticClass: "col-auto children-button",
      on: {
        "click": function ($event) {
          return _vm.$emit('click:child', child);
        }
      }
    }, [child.redirection ? _c('font-awesome-icon', {
      attrs: {
        "icon": ['fas', 'external-link-square']
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(child.label) + " ")], 1)]);
  }), 0);
};
var DiagnosticNavigatorChildrenvue_type_template_id_e7b7d72e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorChildren.vue?vue&type=script&lang=js&
/* harmony default export */ var DiagnosticNavigatorChildrenvue_type_script_lang_js_ = ({
  name: "DiagnosticNavigatorChildren",
  props: {
    children: {
      type: Array,
      default: () => []
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorChildren.vue?vue&type=script&lang=js&
 /* harmony default export */ var DiagnosticNavigator_DiagnosticNavigatorChildrenvue_type_script_lang_js_ = (DiagnosticNavigatorChildrenvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorChildren.vue?vue&type=style&index=0&id=e7b7d72e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorChildren.vue?vue&type=style&index=0&id=e7b7d72e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigatorChildren.vue



;


/* normalize component */

var DiagnosticNavigatorChildren_component = normalizeComponent(
  DiagnosticNavigator_DiagnosticNavigatorChildrenvue_type_script_lang_js_,
  DiagnosticNavigatorChildrenvue_type_template_id_e7b7d72e_scoped_true_render,
  DiagnosticNavigatorChildrenvue_type_template_id_e7b7d72e_scoped_true_staticRenderFns,
  false,
  null,
  "e7b7d72e",
  null
  
)

/* harmony default export */ var DiagnosticNavigatorChildren = (DiagnosticNavigatorChildren_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/SatisfactionModule.vue?vue&type=template&id=8e5929fc&scoped=true&
var SatisfactionModulevue_type_template_id_8e5929fc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "satisfaction-module",
    class: `${_vm.base}`
  }, [_c('div', {
    class: `${_vm.base}__title`
  }, [_c('hr', {
    class: `${_vm.base}__title__divider`
  }), _c('small', {
    class: `${_vm.base}__title__text`
  }, [_vm._v(_vm._s(_vm.$t("knowledge.satisfaction.title")))]), _c('hr', {
    class: `${_vm.base}__title__divider`
  })]), _c('div', {
    class: [`${_vm.base}__cta`, 'mt-4']
  }, [_c('div', {
    class: `${_vm.base}__cta__icon-wrapper`
  }, [_c('font-awesome-icon', {
    class: [`${_vm.base}__cta__icon`, `${_vm.base}__cta__icon--up`, {
      [`${_vm.base}__cta__icon--up--selected`]: _vm.choice === 'up'
    }],
    attrs: {
      "icon": ['fal', 'thumbs-up']
    },
    on: {
      "click": function ($event) {
        return _vm.handleClick('up');
      }
    }
  })], 1), _c('div', {
    class: `${_vm.base}__cta__icon-wrapper`
  }, [_c('font-awesome-icon', {
    class: [`${_vm.base}__cta__icon`, `${_vm.base}__cta__icon--down`, {
      [`${_vm.base}__cta__icon--down--selected`]: _vm.choice === 'down'
    }],
    attrs: {
      "icon": ['fal', 'thumbs-down']
    },
    on: {
      "click": function ($event) {
        return _vm.handleClick('down');
      }
    }
  })], 1)]), _vm.showFeedback ? _c('div', {
    class: `${_vm.base}__feedback`
  }, [_c('small', {
    class: `${_vm.base}__feedback__cta`,
    on: {
      "click": function ($event) {
        return _vm.$emit('click:feedback');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("knowledge.satisfaction.cta")))])]) : _vm._e()]);
};
var SatisfactionModulevue_type_template_id_8e5929fc_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/SatisfactionModule.vue?vue&type=script&lang=js&
const base = "satisfaction-module";
/* harmony default export */ var SatisfactionModulevue_type_script_lang_js_ = ({
  name: "statisfaction-module",
  props: {
    contentId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      base,
      choice: null
    };
  },
  computed: {
    showFeedback() {
      return this.choice === "down";
    }
  },
  methods: {
    handleClick(choice) {
      this.choice = choice;
      this.$emit("choice", choice);
      if (choice === "down") {
        this.$nextTick(() => {
          this.$refs["satisfaction-module"].scrollIntoView({
            block: "end",
            inline: "nearest",
            behavior: "smooth"
          });
        });
      }
    }
  },
  watch: {
    contentId() {
      this.choice = null;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/SatisfactionModule.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SatisfactionModulevue_type_script_lang_js_ = (SatisfactionModulevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/SatisfactionModule.vue?vue&type=style&index=0&id=8e5929fc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/SatisfactionModule.vue?vue&type=style&index=0&id=8e5929fc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/SatisfactionModule.vue



;


/* normalize component */

var SatisfactionModule_component = normalizeComponent(
  components_SatisfactionModulevue_type_script_lang_js_,
  SatisfactionModulevue_type_template_id_8e5929fc_scoped_true_render,
  SatisfactionModulevue_type_template_id_8e5929fc_scoped_true_staticRenderFns,
  false,
  null,
  "8e5929fc",
  null
  
)

/* harmony default export */ var SatisfactionModule = (SatisfactionModule_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/EmptyEntity.vue?vue&type=template&id=0298865c&scoped=true&
var EmptyEntityvue_type_template_id_0298865c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "empty-collection__wrapper"
  }, [_c('img', {
    staticClass: "empty-collection__image",
    attrs: {
      "src": __webpack_require__(1878)
    }
  }), _c('h3', {
    staticClass: "empty-collection__title"
  }, [_vm._v(" " + _vm._s(_vm.$t(`${_vm.i18nPrefix}.title`)) + " ")]), _c('small', {
    staticClass: "empty-collection__description"
  }, [_vm._v(_vm._s(_vm.$t(`${_vm.i18nPrefix}.description`)))]), _c('a', {
    staticClass: "empty-collection__cta",
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`${_vm.i18nPrefix}.cta`)) + " ")])]);
};
var EmptyEntityvue_type_template_id_0298865c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/components/EmptyEntity.vue?vue&type=template&id=0298865c&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/EmptyEntity.vue?vue&type=script&lang=js&
/* harmony default export */ var EmptyEntityvue_type_script_lang_js_ = ({
  name: "EmptyEntity",
  data() {
    return {
      i18nPrefix: `knowledge.empty-${this.type}`
    };
  },
  props: {
    type: {
      type: String,
      default: "collection"
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/EmptyEntity.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_EmptyEntityvue_type_script_lang_js_ = (EmptyEntityvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/EmptyEntity.vue?vue&type=style&index=0&id=0298865c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/EmptyEntity.vue?vue&type=style&index=0&id=0298865c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/EmptyEntity.vue



;


/* normalize component */

var EmptyEntity_component = normalizeComponent(
  components_EmptyEntityvue_type_script_lang_js_,
  EmptyEntityvue_type_template_id_0298865c_scoped_true_render,
  EmptyEntityvue_type_template_id_0298865c_scoped_true_staticRenderFns,
  false,
  null,
  "0298865c",
  null
  
)

/* harmony default export */ var EmptyEntity = (EmptyEntity_component.exports);
;// CONCATENATED MODULE: ./src/utils/index.ts
/* eslint-disable camelcase */
const tmpNodeToContent = node => {
  if (!node) return null;
  const {
    content
  } = node;
  if (!content) return null;
  let attachedObjects = [];
  if (content.attachedTreeNodes) {
    attachedObjects = content.attachedTreeNodes.map(el =>
    // eslint-disable-next-line implicit-arrow-linebreak
    tmpNodeToContent(el));
  }
  let children;
  if (node.type === "Folder") {
    children = node.children;
  }
  return {
    id: node.id,
    label: content.label,
    body: content.body,
    type: node.type,
    attachedObjects,
    attachments: content.attachments,
    published: content.published,
    actions: node.actions,
    path: node.path,
    children
  };
};
/* harmony default export */ var utils = ({
  processing: {
    MagicAnswers(rawMagicAnswers, restrictedNodes = []) {
      return rawMagicAnswers.map(o => {
        let path = this.Ancestors(o.node.ancestors, o.treeNodeId);
        if (restrictedNodes.length > 0) {
          path = this.restrictedAncestorsId(restrictedNodes, path);
        }
        return {
          alias: o.node.content.label,
          path,
          treeNodeId: o.treeNodeId
        };
      }).filter(ma => ma.path.length > 1);
    },
    restrictedGroups(rawGroups, restrictedNodes) {
      const restrictedIds = restrictedNodes.map(({
        id
      }) => id);
      return rawGroups.filter(group => {
        const groupNodeIds = group.ancestors.map(({
          id
        }) => id);
        const restrictionNode = groupNodeIds.find(id => restrictedIds.includes(id));
        return !!restrictionNode;
      });
    },
    languages(knowledges) {
      return knowledges.map(o => {
        const {
          rootDescendents,
          isRestricted,
          restrictedNodes,
          knowledge
        } = o;
        const {
          magicAnswers,
          ...args
        } = knowledge;
        return {
          tree: rootDescendents,
          magicAnswers: this.MagicAnswers(magicAnswers, restrictedNodes
          // rootDescendents
          ),

          isRestricted,
          restrictedNodes,
          ...args
        };
      });
    },
    Favorites(rawFavorites) {
      return rawFavorites.map(o => ({
        id: o.id,
        content: o.content,
        path: this.Ancestors(o.ancestors, o.id),
        knowledgeId: o.knowledgeId
      }));
    },
    Ancestors(ancestors, treeNodeId) {
      return ancestors.sort((a, b) => a.hierarchyLevel - b.hierarchyLevel).map(o => o.id).concat([treeNodeId]);
    },
    restrictedAncestorsId(restrictedNodes, ancestorIds) {
      const restrictionNode = restrictedNodes.find(({
        id
      }) => ancestorIds.includes(id));
      if (restrictionNode) {
        const restrictionIdx = ancestorIds.indexOf(restrictionNode.id);
        return [0].concat(ancestorIds.slice(restrictionIdx));
      }
      return [0];
    },
    fullAncestorIds(restrictedNodes, restrictedAncestorIds) {
      const restrictionNode = restrictedNodes.find(({
        id
      }) => restrictedAncestorIds.includes(id));
      if (restrictionNode) {
        const rootAncestors = restrictionNode.ancestors.sort((a, b) => a.hierarchyLevel - b.hierarchyLevel).map(o => o.id);
        return rootAncestors.concat(restrictedAncestorIds.slice(1)).map(String);
      }
      return [];
    },
    countryFlags(code) {
      const flags = {
        fr: "🇫🇷",
        en: "🇬🇧",
        es: "🇪🇸",
        de: "🇩🇪",
        it: "🇮🇹",
        pt: "🇵🇹",
        ru: "🇷🇺",
        pl: "🇵🇱",
        tmp_dgpst: "",
        tmp_id_num: "",
        tmp_lp_net: "",
        tmp_lp_fr: ""
      };
      return Object.keys(flags).includes(code) ? flags[code] : "🏳️";
    },
    olParsing(htmlStr) {
      const [initStr, ...ols] = htmlStr.split("<ol>");
      return ols.reduce((acc, ol) => {
        const [loc_ol, rem] = ol.split("</ol>");
        const lis = loc_ol.split("<li><p>").slice(1).map(li => li.replace("</p></li>", "")).map((li, idx) => ` ${idx + 1}. ${li}`).join("<br>");
        return `${acc.length > 0 ? `${acc}<br>` : ""}${lis}${rem.length > 0 ? `${rem}` : ""}`;
      }, initStr);
    },
    IntercomAnswer(message) {
      // Markdown to HTML
      let markdown = message.split("&lt;").join("<").split("&gt;").join(">");
      // br parser
      markdown = markdown.split("</p><br>").join("</p><br><br>").split("</ol><br>").join("</ol><br><br>").split("</ul><br>").join("</ul><br><br>");
      if (markdown.includes("<ol>")) {
        markdown = this.olParsing(markdown);
      }
      // List parser
      markdown = markdown.split("</p><ul><li><p>").join("<br> - ");
      markdown = markdown.split("</p></li><li><p>").join("<br> - ");
      markdown = markdown.split("</p></li></ul>").join("<br>");
      markdown = markdown.split("<ul><li>").join(" - ");
      // Paragraph parser
      markdown = markdown.split("</p><p>").join("<br>").split("<p>").join("").split("</p>").join("");
      // Bold parser
      markdown = markdown.split("<strong>").join("<b>");
      markdown = markdown.split("</strong>").join("</b>");
      // Italic parser
      markdown = markdown.split("<em>").join("<i>");
      markdown = markdown.split("</em>").join("</i>");
      return markdown;
    },
    getNode(tree, path) {
      let trans = {
        ...tree
      };
      path.slice(1).forEach(id => {
        trans = trans.children.find(c => String(c.id) === String(id));
      });
      return trans;
    },
    tmpNodeToContent
  }
});
;// CONCATENATED MODULE: ./src/utils/helpdeskService/intercom.js

const findIntercomInputWindow = document => {
  let inputWindow;
  let inputType;
  const intercomNewMessage = document.querySelectorAll(".embercom-composer-editor");
  if (intercomNewMessage.length === 0) {
    inputType = "ROOT";
    let intercomConv = document.querySelectorAll('div[role="textbox"]');
    if (intercomConv.length === 0) {
      intercomConv = document.querySelectorAll(".embercom-prosemirror-composer-editor");
      if (intercomConv.length === 0) {
        inputWindow = null;
      } else {
        inputWindow = intercomConv;
      }
    } else {
      inputWindow = intercomConv;
    }
  } else {
    inputWindow = intercomNewMessage;
    inputType = "NESTED";
  }
  return {
    inputWindow,
    inputType
  };
};
const rootAnswerInsertion = (inputWindow, message) => {
  const answer = message.split("<br>").join("<p></p>");
  const previousHTML = inputWindow[0].innerHTML;
  const previousMessage = inputWindow[0].childNodes[0].innerHTML;
  inputWindow[0].focus();
  inputWindow[0].innerHTML = previousMessage.length > 1 && previousMessage !== "<br>" ? `${previousHTML}${answer}` : answer;
};
const nestedAnswerInsertion = (inputWindow, answer) => {
  const markdown = utils.processing.IntercomAnswer(answer);
  const previousMessage = inputWindow[0].childNodes[0].innerHTML;
  inputWindow[0].focus();
  inputWindow[0].childNodes[0].innerHTML = previousMessage.length > 1 ? `${previousMessage}</br>${markdown}` : markdown;
};
/* harmony default export */ function intercom(document, answer) {
  const {
    inputWindow,
    inputType
  } = findIntercomInputWindow(document);
  if (!inputWindow) {
    return;
  }
  switch (inputType) {
    case "ROOT":
      rootAnswerInsertion(inputWindow, answer);
      break;
    case "NESTED":
      nestedAnswerInsertion(inputWindow, answer);
      break;
    default:
      break;
  }
}
;// CONCATENATED MODULE: ./src/utils/helpdeskService/salesforce.js
const setActiveTab = (document, selectedTab) => {
  if (!selectedTab) return false;
  try {
    const header = document.querySelectorAll("div.oneActionsComposer.forceActionsContainer");
    if (header && header.length) {
      const tabs = header[0].querySelectorAll("li.tabs__item.uiTabItem");
      const tabIndex = [...tabs].findIndex(tab => tab.innerText.toUpperCase().split(" ").join("_") === selectedTab);
      if (tabIndex < 0) return false;
      if (tabs[tabIndex].classList.contains("active")) return false;
      const link = tabs[tabIndex].querySelectorAll("a")[0];
      link.click();
    }
  } catch (e) {
    console.log(e);
  }
  return true;
};
const getActiveTab = document => {
  let activeTab = null;
  try {
    const tabs = document.querySelectorAll("div.oneActionsComposer.forceActionsContainer");
    if (tabs && tabs.length) {
      activeTab = tabs[0].querySelectorAll("li.tabs__item.active.uiTabItem")[0].innerText;
    }
  } catch (e) {
    console.log(e);
  }
  return activeTab ? activeTab.toUpperCase().split(" ").join("_") : null;
};
const selector = {
  EMAIL: document => document.querySelectorAll("div.lafPageHost.active")[0].getElementsByTagName("force-aloha-page")[0].getElementsByTagName("iframe")[0].contentDocument.getElementsByTagName("iframe")[0].contentDocument.getElementsByTagName("body"),
  POST_COMMENT: document => document.querySelectorAll("div.ql-editor.ql-blank.slds-rich-text-area__content"),
  EXTERNAL_MESSAGE: document => document.querySelectorAll("div.slds-rich-text-area__content"),
  REFRESH_TAB: document => {
    const focusedTab = document.getElementsByClassName("oneConsoleTabItem tabItem slds-context-bar__item slds-context-bar__item_tab slds-is-active active hasActions hideAnimation  navexConsoleTabItem")[0] // get focused case tab
    .getElementsByClassName("slds-dropdown-trigger slds-dropdown-trigger_click tabActionsList")[0];
    const tabBtn = focusedTab.getElementsByClassName("slds-button slds-button_icon-container slds-button_icon-x-small")[0];
    tabBtn.click();
    tabBtn.click();
    return focusedTab.getElementsByClassName("slds-dropdown slds-dropdown_right")[0].getElementsByClassName("slds-dropdown__item refreshTab")[0].children[0];
  }
};
const insertToTarget = async (document, answer, activeTab) => {
  const maxTry = 10; // 5s
  let trying = 0;
  let target = selector[activeTab](document);
  while (!target.length && trying < maxTry) {
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, 500));
    target = selector[activeTab](document);
    trying += 1;
  }
  if (trying === maxTry) return;
  target[0].click();
  await new Promise(resolve => setTimeout(resolve, 500));
  target = selector[activeTab](document);
  target[0].innerHTML = `${answer}${target[0].innerHTML}`;
};
const externalMessageInsertion = async (document, answer) => {
  const focusedCase = document.querySelectorAll("div.lafPageHost.active")[0];
  const formerInput = focusedCase.querySelectorAll("button.slds-button.slds-button--neutral.slds-col.slds-no-space.dummyButtonCallToAction.uiButton")[0];
  if (formerInput) formerInput.click();
  await insertToTarget(focusedCase, answer, "EXTERNAL_MESSAGE");
};
/* harmony default export */ var salesforce = ({
  async insertAnswer(document, answer, options) {
    if (!options) return;
    const {
      tab
    } = options;
    setActiveTab(document, tab);
    const activeTab = getActiveTab(document);
    if (!activeTab) {
      return;
    }
    switch (activeTab) {
      case "EMAIL":
        await insertToTarget(document, answer, activeTab);
        break;
      case "POST_COMMENT":
        await insertToTarget(document, answer, activeTab);
        break;
      case "EXTERNAL_MESSAGE":
        await externalMessageInsertion(document, answer);
        break;
      default:
        await insertToTarget(document, answer, "EMAIL");
        break;
    }
  },
  refreshCaseTab(document) {
    try {
      const activeTabRefreshBtn = selector.REFRESH_TAB(document);
      activeTabRefreshBtn.click();
    } catch (err) {
      console.log(err);
    }
  }
});
;// CONCATENATED MODULE: ./src/utils/helpdeskService/gmail.js
/* eslint-disable no-useless-return */
/* harmony default export */ function gmail(document, answer) {
  try {
    const target = document.querySelectorAll("div[contenteditable=true]")[0];
    if (!target) {
      return;
    }
    target.innerHTML = `${answer}${target.innerHTML}`;
    return;
  } catch (_e) {
    return;
  }
}
;// CONCATENATED MODULE: ./src/utils/helpdeskService/frontapp.js
/* eslint-disable no-useless-return */
/* harmony default export */ function frontapp(document, answer) {
  try {
    const target = document.querySelectorAll("div[class*=EmailComposerEditorBase]")[0];
    if (!target) {
      return;
    }
    target.innerHTML = `${answer}${target.innerHTML}`;
    return;
  } catch (_e) {
    return;
  }
}
;// CONCATENATED MODULE: ./node_modules/turndown/lib/turndown.browser.es.js
function extend (destination) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
  }
  return destination
}

function turndown_browser_es_repeat (character, count) {
  return Array(count + 1).join(character)
}

function trimLeadingNewlines (string) {
  return string.replace(/^\n*/, '')
}

function trimTrailingNewlines (string) {
  // avoid match-at-end regexp bottleneck, see #370
  var indexEnd = string.length;
  while (indexEnd > 0 && string[indexEnd - 1] === '\n') indexEnd--;
  return string.substring(0, indexEnd)
}

var blockElements = [
  'ADDRESS', 'ARTICLE', 'ASIDE', 'AUDIO', 'BLOCKQUOTE', 'BODY', 'CANVAS',
  'CENTER', 'DD', 'DIR', 'DIV', 'DL', 'DT', 'FIELDSET', 'FIGCAPTION', 'FIGURE',
  'FOOTER', 'FORM', 'FRAMESET', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'HEADER',
  'HGROUP', 'HR', 'HTML', 'ISINDEX', 'LI', 'MAIN', 'MENU', 'NAV', 'NOFRAMES',
  'NOSCRIPT', 'OL', 'OUTPUT', 'P', 'PRE', 'SECTION', 'TABLE', 'TBODY', 'TD',
  'TFOOT', 'TH', 'THEAD', 'TR', 'UL'
];

function isBlock (node) {
  return is(node, blockElements)
}

var voidElements = [
  'AREA', 'BASE', 'BR', 'COL', 'COMMAND', 'EMBED', 'HR', 'IMG', 'INPUT',
  'KEYGEN', 'LINK', 'META', 'PARAM', 'SOURCE', 'TRACK', 'WBR'
];

function isVoid (node) {
  return is(node, voidElements)
}

function hasVoid (node) {
  return has(node, voidElements)
}

var meaningfulWhenBlankElements = [
  'A', 'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TH', 'TD', 'IFRAME', 'SCRIPT',
  'AUDIO', 'VIDEO'
];

function isMeaningfulWhenBlank (node) {
  return is(node, meaningfulWhenBlankElements)
}

function hasMeaningfulWhenBlank (node) {
  return has(node, meaningfulWhenBlankElements)
}

function is (node, tagNames) {
  return tagNames.indexOf(node.nodeName) >= 0
}

function has (node, tagNames) {
  return (
    node.getElementsByTagName &&
    tagNames.some(function (tagName) {
      return node.getElementsByTagName(tagName).length
    })
  )
}

var rules = {};

rules.paragraph = {
  filter: 'p',

  replacement: function (content) {
    return '\n\n' + content + '\n\n'
  }
};

rules.lineBreak = {
  filter: 'br',

  replacement: function (content, node, options) {
    return options.br + '\n'
  }
};

rules.heading = {
  filter: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],

  replacement: function (content, node, options) {
    var hLevel = Number(node.nodeName.charAt(1));

    if (options.headingStyle === 'setext' && hLevel < 3) {
      var underline = turndown_browser_es_repeat((hLevel === 1 ? '=' : '-'), content.length);
      return (
        '\n\n' + content + '\n' + underline + '\n\n'
      )
    } else {
      return '\n\n' + turndown_browser_es_repeat('#', hLevel) + ' ' + content + '\n\n'
    }
  }
};

rules.blockquote = {
  filter: 'blockquote',

  replacement: function (content) {
    content = content.replace(/^\n+|\n+$/g, '');
    content = content.replace(/^/gm, '> ');
    return '\n\n' + content + '\n\n'
  }
};

rules.list = {
  filter: ['ul', 'ol'],

  replacement: function (content, node) {
    var parent = node.parentNode;
    if (parent.nodeName === 'LI' && parent.lastElementChild === node) {
      return '\n' + content
    } else {
      return '\n\n' + content + '\n\n'
    }
  }
};

rules.listItem = {
  filter: 'li',

  replacement: function (content, node, options) {
    content = content
      .replace(/^\n+/, '') // remove leading newlines
      .replace(/\n+$/, '\n') // replace trailing newlines with just a single one
      .replace(/\n/gm, '\n    '); // indent
    var prefix = options.bulletListMarker + '   ';
    var parent = node.parentNode;
    if (parent.nodeName === 'OL') {
      var start = parent.getAttribute('start');
      var index = Array.prototype.indexOf.call(parent.children, node);
      prefix = (start ? Number(start) + index : index + 1) + '.  ';
    }
    return (
      prefix + content + (node.nextSibling && !/\n$/.test(content) ? '\n' : '')
    )
  }
};

rules.indentedCodeBlock = {
  filter: function (node, options) {
    return (
      options.codeBlockStyle === 'indented' &&
      node.nodeName === 'PRE' &&
      node.firstChild &&
      node.firstChild.nodeName === 'CODE'
    )
  },

  replacement: function (content, node, options) {
    return (
      '\n\n    ' +
      node.firstChild.textContent.replace(/\n/g, '\n    ') +
      '\n\n'
    )
  }
};

rules.fencedCodeBlock = {
  filter: function (node, options) {
    return (
      options.codeBlockStyle === 'fenced' &&
      node.nodeName === 'PRE' &&
      node.firstChild &&
      node.firstChild.nodeName === 'CODE'
    )
  },

  replacement: function (content, node, options) {
    var className = node.firstChild.getAttribute('class') || '';
    var language = (className.match(/language-(\S+)/) || [null, ''])[1];
    var code = node.firstChild.textContent;

    var fenceChar = options.fence.charAt(0);
    var fenceSize = 3;
    var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');

    var match;
    while ((match = fenceInCodeRegex.exec(code))) {
      if (match[0].length >= fenceSize) {
        fenceSize = match[0].length + 1;
      }
    }

    var fence = turndown_browser_es_repeat(fenceChar, fenceSize);

    return (
      '\n\n' + fence + language + '\n' +
      code.replace(/\n$/, '') +
      '\n' + fence + '\n\n'
    )
  }
};

rules.horizontalRule = {
  filter: 'hr',

  replacement: function (content, node, options) {
    return '\n\n' + options.hr + '\n\n'
  }
};

rules.inlineLink = {
  filter: function (node, options) {
    return (
      options.linkStyle === 'inlined' &&
      node.nodeName === 'A' &&
      node.getAttribute('href')
    )
  },

  replacement: function (content, node) {
    var href = node.getAttribute('href');
    var title = cleanAttribute(node.getAttribute('title'));
    if (title) title = ' "' + title + '"';
    return '[' + content + '](' + href + title + ')'
  }
};

rules.referenceLink = {
  filter: function (node, options) {
    return (
      options.linkStyle === 'referenced' &&
      node.nodeName === 'A' &&
      node.getAttribute('href')
    )
  },

  replacement: function (content, node, options) {
    var href = node.getAttribute('href');
    var title = cleanAttribute(node.getAttribute('title'));
    if (title) title = ' "' + title + '"';
    var replacement;
    var reference;

    switch (options.linkReferenceStyle) {
      case 'collapsed':
        replacement = '[' + content + '][]';
        reference = '[' + content + ']: ' + href + title;
        break
      case 'shortcut':
        replacement = '[' + content + ']';
        reference = '[' + content + ']: ' + href + title;
        break
      default:
        var id = this.references.length + 1;
        replacement = '[' + content + '][' + id + ']';
        reference = '[' + id + ']: ' + href + title;
    }

    this.references.push(reference);
    return replacement
  },

  references: [],

  append: function (options) {
    var references = '';
    if (this.references.length) {
      references = '\n\n' + this.references.join('\n') + '\n\n';
      this.references = []; // Reset references
    }
    return references
  }
};

rules.emphasis = {
  filter: ['em', 'i'],

  replacement: function (content, node, options) {
    if (!content.trim()) return ''
    return options.emDelimiter + content + options.emDelimiter
  }
};

rules.strong = {
  filter: ['strong', 'b'],

  replacement: function (content, node, options) {
    if (!content.trim()) return ''
    return options.strongDelimiter + content + options.strongDelimiter
  }
};

rules.code = {
  filter: function (node) {
    var hasSiblings = node.previousSibling || node.nextSibling;
    var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;

    return node.nodeName === 'CODE' && !isCodeBlock
  },

  replacement: function (content) {
    if (!content) return ''
    content = content.replace(/\r?\n|\r/g, ' ');

    var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
    var delimiter = '`';
    var matches = content.match(/`+/gm) || [];
    while (matches.indexOf(delimiter) !== -1) delimiter = delimiter + '`';

    return delimiter + extraSpace + content + extraSpace + delimiter
  }
};

rules.image = {
  filter: 'img',

  replacement: function (content, node) {
    var alt = cleanAttribute(node.getAttribute('alt'));
    var src = node.getAttribute('src') || '';
    var title = cleanAttribute(node.getAttribute('title'));
    var titlePart = title ? ' "' + title + '"' : '';
    return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : ''
  }
};

function cleanAttribute (attribute) {
  return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : ''
}

/**
 * Manages a collection of rules used to convert HTML to Markdown
 */

function Rules (options) {
  this.options = options;
  this._keep = [];
  this._remove = [];

  this.blankRule = {
    replacement: options.blankReplacement
  };

  this.keepReplacement = options.keepReplacement;

  this.defaultRule = {
    replacement: options.defaultReplacement
  };

  this.array = [];
  for (var key in options.rules) this.array.push(options.rules[key]);
}

Rules.prototype = {
  add: function (key, rule) {
    this.array.unshift(rule);
  },

  keep: function (filter) {
    this._keep.unshift({
      filter: filter,
      replacement: this.keepReplacement
    });
  },

  remove: function (filter) {
    this._remove.unshift({
      filter: filter,
      replacement: function () {
        return ''
      }
    });
  },

  forNode: function (node) {
    if (node.isBlank) return this.blankRule
    var rule;

    if ((rule = findRule(this.array, node, this.options))) return rule
    if ((rule = findRule(this._keep, node, this.options))) return rule
    if ((rule = findRule(this._remove, node, this.options))) return rule

    return this.defaultRule
  },

  forEach: function (fn) {
    for (var i = 0; i < this.array.length; i++) fn(this.array[i], i);
  }
};

function findRule (rules, node, options) {
  for (var i = 0; i < rules.length; i++) {
    var rule = rules[i];
    if (filterValue(rule, node, options)) return rule
  }
  return void 0
}

function filterValue (rule, node, options) {
  var filter = rule.filter;
  if (typeof filter === 'string') {
    if (filter === node.nodeName.toLowerCase()) return true
  } else if (Array.isArray(filter)) {
    if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true
  } else if (typeof filter === 'function') {
    if (filter.call(rule, node, options)) return true
  } else {
    throw new TypeError('`filter` needs to be a string, array, or function')
  }
}

/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

/**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */
function collapseWhitespace (options) {
  var element = options.element;
  var isBlock = options.isBlock;
  var isVoid = options.isVoid;
  var isPre = options.isPre || function (node) {
    return node.nodeName === 'PRE'
  };

  if (!element.firstChild || isPre(element)) return

  var prevText = null;
  var keepLeadingWs = false;

  var prev = null;
  var node = next(prev, element, isPre);

  while (node !== element) {
    if (node.nodeType === 3 || node.nodeType === 4) { // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
      var text = node.data.replace(/[ \r\n\t]+/g, ' ');

      if ((!prevText || / $/.test(prevText.data)) &&
          !keepLeadingWs && text[0] === ' ') {
        text = text.substr(1);
      }

      // `text` might be empty at this point.
      if (!text) {
        node = remove(node);
        continue
      }

      node.data = text;

      prevText = node;
    } else if (node.nodeType === 1) { // Node.ELEMENT_NODE
      if (isBlock(node) || node.nodeName === 'BR') {
        if (prevText) {
          prevText.data = prevText.data.replace(/ $/, '');
        }

        prevText = null;
        keepLeadingWs = false;
      } else if (isVoid(node) || isPre(node)) {
        // Avoid trimming space around non-block, non-BR void elements and inline PRE.
        prevText = null;
        keepLeadingWs = true;
      } else if (prevText) {
        // Drop protection if set previously.
        keepLeadingWs = false;
      }
    } else {
      node = remove(node);
      continue
    }

    var nextNode = next(prev, node, isPre);
    prev = node;
    node = nextNode;
  }

  if (prevText) {
    prevText.data = prevText.data.replace(/ $/, '');
    if (!prevText.data) {
      remove(prevText);
    }
  }
}

/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */
function remove (node) {
  var next = node.nextSibling || node.parentNode;

  node.parentNode.removeChild(node);

  return next
}

/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */
function next (prev, current, isPre) {
  if ((prev && prev.parentNode === current) || isPre(current)) {
    return current.nextSibling || current.parentNode
  }

  return current.firstChild || current.nextSibling || current.parentNode
}

/*
 * Set up window for Node.js
 */

var root = (typeof window !== 'undefined' ? window : {});

/*
 * Parsing HTML strings
 */

function canParseHTMLNatively () {
  var Parser = root.DOMParser;
  var canParse = false;

  // Adapted from https://gist.github.com/1129031
  // Firefox/Opera/IE throw errors on unsupported types
  try {
    // WebKit returns null on unsupported types
    if (new Parser().parseFromString('', 'text/html')) {
      canParse = true;
    }
  } catch (e) {}

  return canParse
}

function createHTMLParser () {
  var Parser = function () {};

  {
    if (shouldUseActiveX()) {
      Parser.prototype.parseFromString = function (string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc
      };
    } else {
      Parser.prototype.parseFromString = function (string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc
      };
    }
  }
  return Parser
}

function shouldUseActiveX () {
  var useActiveX = false;
  try {
    document.implementation.createHTMLDocument('').open();
  } catch (e) {
    if (window.ActiveXObject) useActiveX = true;
  }
  return useActiveX
}

var HTMLParser = canParseHTMLNatively() ? root.DOMParser : createHTMLParser();

function RootNode (input, options) {
  var root;
  if (typeof input === 'string') {
    var doc = htmlParser().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + input + '</x-turndown>',
      'text/html'
    );
    root = doc.getElementById('turndown-root');
  } else {
    root = input.cloneNode(true);
  }
  collapseWhitespace({
    element: root,
    isBlock: isBlock,
    isVoid: isVoid,
    isPre: options.preformattedCode ? isPreOrCode : null
  });

  return root
}

var _htmlParser;
function htmlParser () {
  _htmlParser = _htmlParser || new HTMLParser();
  return _htmlParser
}

function isPreOrCode (node) {
  return node.nodeName === 'PRE' || node.nodeName === 'CODE'
}

function Node (node, options) {
  node.isBlock = isBlock(node);
  node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
  node.isBlank = isBlank(node);
  node.flankingWhitespace = flankingWhitespace(node, options);
  return node
}

function isBlank (node) {
  return (
    !isVoid(node) &&
    !isMeaningfulWhenBlank(node) &&
    /^\s*$/i.test(node.textContent) &&
    !hasVoid(node) &&
    !hasMeaningfulWhenBlank(node)
  )
}

function flankingWhitespace (node, options) {
  if (node.isBlock || (options.preformattedCode && node.isCode)) {
    return { leading: '', trailing: '' }
  }

  var edges = edgeWhitespace(node.textContent);

  // abandon leading ASCII WS if left-flanked by ASCII WS
  if (edges.leadingAscii && isFlankedByWhitespace('left', node, options)) {
    edges.leading = edges.leadingNonAscii;
  }

  // abandon trailing ASCII WS if right-flanked by ASCII WS
  if (edges.trailingAscii && isFlankedByWhitespace('right', node, options)) {
    edges.trailing = edges.trailingNonAscii;
  }

  return { leading: edges.leading, trailing: edges.trailing }
}

function edgeWhitespace (string) {
  var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: m[1], // whole string for whitespace-only strings
    leadingAscii: m[2],
    leadingNonAscii: m[3],
    trailing: m[4], // empty for whitespace-only strings
    trailingNonAscii: m[5],
    trailingAscii: m[6]
  }
}

function isFlankedByWhitespace (side, node, options) {
  var sibling;
  var regExp;
  var isFlanked;

  if (side === 'left') {
    sibling = node.previousSibling;
    regExp = / $/;
  } else {
    sibling = node.nextSibling;
    regExp = /^ /;
  }

  if (sibling) {
    if (sibling.nodeType === 3) {
      isFlanked = regExp.test(sibling.nodeValue);
    } else if (options.preformattedCode && sibling.nodeName === 'CODE') {
      isFlanked = false;
    } else if (sibling.nodeType === 1 && !isBlock(sibling)) {
      isFlanked = regExp.test(sibling.textContent);
    }
  }
  return isFlanked
}

var reduce = Array.prototype.reduce;
var escapes = [
  [/\\/g, '\\\\'],
  [/\*/g, '\\*'],
  [/^-/g, '\\-'],
  [/^\+ /g, '\\+ '],
  [/^(=+)/g, '\\$1'],
  [/^(#{1,6}) /g, '\\$1 '],
  [/`/g, '\\`'],
  [/^~~~/g, '\\~~~'],
  [/\[/g, '\\['],
  [/\]/g, '\\]'],
  [/^>/g, '\\>'],
  [/_/g, '\\_'],
  [/^(\d+)\. /g, '$1\\. ']
];

function TurndownService (options) {
  if (!(this instanceof TurndownService)) return new TurndownService(options)

  var defaults = {
    rules: rules,
    headingStyle: 'setext',
    hr: '* * *',
    bulletListMarker: '*',
    codeBlockStyle: 'indented',
    fence: '```',
    emDelimiter: '_',
    strongDelimiter: '**',
    linkStyle: 'inlined',
    linkReferenceStyle: 'full',
    br: '  ',
    preformattedCode: false,
    blankReplacement: function (content, node) {
      return node.isBlock ? '\n\n' : ''
    },
    keepReplacement: function (content, node) {
      return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML
    },
    defaultReplacement: function (content, node) {
      return node.isBlock ? '\n\n' + content + '\n\n' : content
    }
  };
  this.options = extend({}, defaults, options);
  this.rules = new Rules(this.options);
}

TurndownService.prototype = {
  /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */

  turndown: function (input) {
    if (!canConvert(input)) {
      throw new TypeError(
        input + ' is not a string, or an element/document/fragment node.'
      )
    }

    if (input === '') return ''

    var output = process.call(this, new RootNode(input, this.options));
    return postProcess.call(this, output)
  },

  /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */

  use: function (plugin) {
    if (Array.isArray(plugin)) {
      for (var i = 0; i < plugin.length; i++) this.use(plugin[i]);
    } else if (typeof plugin === 'function') {
      plugin(this);
    } else {
      throw new TypeError('plugin must be a Function or an Array of Functions')
    }
    return this
  },

  /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */

  addRule: function (key, rule) {
    this.rules.add(key, rule);
    return this
  },

  /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */

  keep: function (filter) {
    this.rules.keep(filter);
    return this
  },

  /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */

  remove: function (filter) {
    this.rules.remove(filter);
    return this
  },

  /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */

  escape: function (string) {
    return escapes.reduce(function (accumulator, escape) {
      return accumulator.replace(escape[0], escape[1])
    }, string)
  }
};

/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */

function process (parentNode) {
  var self = this;
  return reduce.call(parentNode.childNodes, function (output, node) {
    node = new Node(node, self.options);

    var replacement = '';
    if (node.nodeType === 3) {
      replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
    } else if (node.nodeType === 1) {
      replacement = replacementForNode.call(self, node);
    }

    return join(output, replacement)
  }, '')
}

/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */

function postProcess (output) {
  var self = this;
  this.rules.forEach(function (rule) {
    if (typeof rule.append === 'function') {
      output = join(output, rule.append(self.options));
    }
  });

  return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '')
}

/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */

function replacementForNode (node) {
  var rule = this.rules.forNode(node);
  var content = process.call(this, node);
  var whitespace = node.flankingWhitespace;
  if (whitespace.leading || whitespace.trailing) content = content.trim();
  return (
    whitespace.leading +
    rule.replacement(content, node, this.options) +
    whitespace.trailing
  )
}

/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */

function join (output, replacement) {
  var s1 = trimTrailingNewlines(output);
  var s2 = trimLeadingNewlines(replacement);
  var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
  var separator = '\n\n'.substring(0, nls);

  return s1 + separator + s2
}

/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */

function canConvert (input) {
  return (
    input != null && (
      typeof input === 'string' ||
      (input.nodeType && (
        input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11
      ))
    )
  )
}

/* harmony default export */ var turndown_browser_es = (TurndownService);

;// CONCATENATED MODULE: ./src/utils/helpdeskService/custom.js

/* harmony default export */ function custom(document, answer) {
  const target = document.getElementsByClassName("mayday-autofill")[0];
  const type = target.nodeName;
  if (type === "TEXTAREA") {
    const turndownService = new turndown_browser_es();
    const markdown = turndownService.turndown(answer);
    // eslint-disable-next-line no-param-reassign
    target.innerHTML = markdown;
  } else {
    // eslint-disable-next-line no-param-reassign
    target.innerHTML = answer;
  }
}
;// CONCATENATED MODULE: ./src/utils/helpdeskService/index.js





const retrieveHelpdeskFromUrl = url => {
  // INTERCOM usecase
  if (url.includes("intercom")) {
    return "INTERCOM";
  }

  // SALESFORCE usecase
  if (url.includes("lightning.force.com")) {
    return "SALESFORCE";
  }

  // DYNAMICS 365 usecase
  if (url.includes("dynamics.com")) {
    return "DYNAMICS";
  }

  // SERVICE-NOW usecase
  if (url.includes("service-now.com")) {
    return "SERVICE_NOW";
  }

  // GMAIL usecase
  if (url.includes("mail.google.com")) {
    return "GMAIL";
  }

  // FRONT usecase
  if (url.includes("app.frontapp.com")) {
    return "FRONT";
  }
  return null;
};
/* harmony default export */ var helpdeskService = ({
  insert(url, document, answer, options) {
    const helpdesk = retrieveHelpdeskFromUrl(url);
    switch (helpdesk) {
      case "INTERCOM":
        intercom(document, answer);
        break;
      case "SALESFORCE":
        salesforce.insertAnswer(document, answer, options);
        break;
      case "GMAIL":
        gmail(document, answer);
        break;
      case "FRONT":
        frontapp(document, answer);
        break;
      default:
        custom(document, answer);
        break;
    }
  },
  refreshTab(url, document) {
    const helpdesk = retrieveHelpdeskFromUrl(url);
    switch (helpdesk) {
      case "SALESFORCE":
        salesforce.refreshCaseTab(document);
        break;
      default:
        break;
    }
  }
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.stack.js
var web_dom_exception_stack = __webpack_require__(2801);
;// CONCATENATED MODULE: ./src/utils/sourceRecognition.ts

/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
const services = [["intercom", /^https?:\/\/(?:www\.)?(?:app.intercom\.com|app.intercom\.io|app.eu.intercom\.com)(?:.*)\/(?:conversations|conversation)\/([0-9]{1,})/i], ["salesforce", /^https?:\/\/(?:www\.)?(?:.*)(?:lightning.force.com)(?:.*)\/r\/Case\/(\w{1,})/i]];
const resolveContext = (url, tabSource) => {
  if (tabSource !== "salesforce") return null;
  const {
    hostname
  } = new URL(url);
  return window.btoa(JSON.stringify({
    hostname
  }));
};
const sourceRecognition = url => services.reduce((a, v) => {
  const match = v[1].exec(url);
  if (!match) return a;
  return {
    tabSource: v[0],
    conversationId: match[1],
    context: resolveContext(url, v[0])
  };
}, {
  context: null,
  tabSource: null,
  conversationId: null
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigator.vue?vue&type=script&lang=js&
/* eslint-disable prefer-destructuring */
/* eslint-disable dot-notation */









/* harmony default export */ var DiagnosticNavigatorvue_type_script_lang_js_ = ({
  name: "DiagnosticNavigator",
  components: {
    DiagnosticNavigatorTitle: DiagnosticNavigatorTitle,
    DiagnosticNavigatorContentViewer: DiagnosticNavigatorContentViewer,
    DiagnosticNavigatorChildren: DiagnosticNavigatorChildren,
    SatisfactionModule: SatisfactionModule,
    EmptyEntity: EmptyEntity
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    diagnosticTitle: {
      type: String
    },
    content: {
      type: Object
    },
    children: {
      type: Array,
      default: () => []
    },
    parents: {
      type: Array,
      default: () => []
    },
    attachedContents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      lightbox: false,
      loader: {
        knowledgeAction: false
      }
    };
  },
  computed: {
    actions() {
      if (this.content && this.content.actions) return this.content.actions[0];
      return {};
    },
    validActions() {
      if (!this.actions) return false;
      const {
        id,
        payload
      } = this.actions;
      if (!["CUSTOM_MESSAGE", "ZENDESK_MESSAGE"].includes(id)) {
        return false;
      }
      const {
        message
      } = payload;
      if (["", "<p></p>"].includes(message)) return false;
      return true;
    },
    knowledgeAction() {
      if (!this.content && !this.content.actions && !this.content.actions.length) return null;
      const knowledgeAction = this.content.actions.find(a => ["salesforce.caseUpdate"].includes(a.id));
      if (!knowledgeAction) return null;
      return knowledgeAction;
    },
    ...mapGetters("modalModule", ["keepModalOpen"])
  },
  mounted() {
    this.debounceHandleActionsMessage();
  },
  methods: {
    debounceHandleActionsMessage: lodash_debounce_default()(function () {
      this.handleActionsMessage();
    }, 200),
    handleActionsMessage(auto = true) {
      if (!(this.actions && this.validActions)) return this.keepModalOpen ? this.forceModalOpen(false) : this.$emit("close-modal");
      const {
        id,
        payload
      } = this.actions;
      const {
        message
      } = payload;
      const url = window.location.href;
      if (auto && this.config.manuallyTriggerActions || !auto) {
        return this.$emit("open-answer", {
          label: this.content.label,
          body: message,
          actions: {
            id,
            payload
          }
        });
      }
      const tab = this.config.salesForceFocusTab ? this.config.salesForceFocusTab.value : null;
      try {
        helpdeskService.insert(url, document, message, {
          tab
        });
      } catch (_e) {
        this.$emit("open-answer", {
          label: this.content.label,
          body: message,
          actions: {
            id,
            payload
          }
        });
      }
      return true;
    },
    async handleKnowledgeActions() {
      this.loader.knowledgeAction = true;
      try {
        const url = window.location.href;
        const sourceCtx = sourceRecognition(url);
        await this.dispatchKnowledgeAction({
          actionId: this.knowledgeAction.id,
          contentId: this.content.id,
          context: sourceCtx
        });
        helpdeskService.refreshTab(url, document);
      } catch {
        this.loader.knowledgeAction = false;
      }
      this.loader.knowledgeAction = false;
    },
    onClickInlineContent({
      sourceContent,
      targetContent
    }) {
      this.handleOnClickInlineContent({
        sourceContent,
        targetContent
      });
      this.$emit("reach-content", {
        content: targetContent
      });
    },
    async handleOnSatisfaction(thumbType) {
      const {
        id,
        knowledgeId,
        type
      } = this.parents[0];
      const eventPayload = {
        topic: "CONTENT_SATISFACTION",
        event: {
          content: {
            id,
            knowledgeId,
            type,
            // TODO REMOVE THIS FIELDS FROM LOGS CLIENT VALIDATOR
            caseParameters: [],
            parameters: [],
            labels: [],
            path: []
          },
          satisfaction: thumbType
        },
        url: this.$router.currentRoute.fullPath
      };
      await this.addContentSatisfactionMark({
        contentId: this.parents[0].id,
        thumbType
      });
      this.$emit("notify-app", {
        type: "success",
        key: "satisfaction"
      });
      this.$emit("log-event", eventPayload);
    },
    handleClickOnFeedback() {
      this.$emit("route-to-feedback");
    },
    ...mapActions("knowledgeModule", ["handleOnClickInlineContent", "addContentSatisfactionMark", "dispatchKnowledgeAction"]),
    ...mapActions("modalModule", ["forceModalOpen"])
  },
  watch: {
    actions() {
      this.debounceHandleActionsMessage();
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigator.vue?vue&type=script&lang=js&
 /* harmony default export */ var DiagnosticNavigator_DiagnosticNavigatorvue_type_script_lang_js_ = (DiagnosticNavigatorvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigator.vue?vue&type=style&index=0&id=07a95c22&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigator.vue?vue&type=style&index=0&id=07a95c22&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagnosticNavigator/DiagnosticNavigator.vue



;


/* normalize component */

var DiagnosticNavigator_component = normalizeComponent(
  DiagnosticNavigator_DiagnosticNavigatorvue_type_script_lang_js_,
  DiagnosticNavigatorvue_type_template_id_07a95c22_scoped_true_render,
  DiagnosticNavigatorvue_type_template_id_07a95c22_scoped_true_staticRenderFns,
  false,
  null,
  "07a95c22",
  null
  
)

/* harmony default export */ var DiagnosticNavigator = (DiagnosticNavigator_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/ArticleCard.vue?vue&type=template&id=3d9a6d71&scoped=true&
var ArticleCardvue_type_template_id_3d9a6d71_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "article-card",
    on: {
      "click": _vm.articleClicked
    }
  }, [_c('div', {
    staticClass: "article-attributes w-full"
  }, [_c('div', {
    staticClass: "flex gap-2 items-center article-header"
  }, [_c('div', {
    staticClass: "flex gap-2 items-start overflow-auto"
  }, [_c('img', {
    staticClass: "mayday-article-icon",
    attrs: {
      "src": __webpack_require__(4687)
    }
  }), _c('p', {
    staticClass: "article-title",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('div', {
    staticClass: "actions-container"
  }, [_c('ContentActions', {
    staticClass: "actions-container",
    attrs: {
      "content-id": _vm.articleId,
      "is-favorite": _vm.isFavorite,
      "options": _vm.options
    },
    on: {
      "toggle-favorite": function ($event) {
        return _vm.$emit('toggle-favorite', _vm.articleId);
      },
      "toggle-summary": _vm.toggleSummary,
      "copy-link": function ($event) {
        return _vm.$emit('copy-link', _vm.articleId);
      },
      "open-in-web": function ($event) {
        return _vm.$emit('open-in-web', _vm.articleId);
      }
    }
  })], 1)]), _vm.hasSummary ? _c('div', {
    class: ['summary-container bg-gray-1 ', {
      expanded: _vm.summaryExpanded
    }]
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.summary.body) + " ")])]) : _vm._e(), _vm.labels && _vm.labels.length ? _c('div', {
    staticClass: "d-flex align-items-center ml-3"
  }, [_c('ContentListItemFullLabelWrapper', {
    staticClass: "mt-1",
    attrs: {
      "labels": _vm.labels
    }
  })], 1) : _vm._e(), _vm.root ? _c('p', {
    staticClass: "article-root mb-0 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.root))])]) : _vm._e()])]);
};
var ArticleCardvue_type_template_id_3d9a6d71_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleCard.vue?vue&type=template&id=3d9a6d71&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentActions.vue?vue&type=template&id=ecaa559c&scoped=true&
var ContentActionsvue_type_template_id_ecaa559c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ext-actions-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.tooltipActive ? _c('div', {
    staticClass: "action-tooltip"
  }, [_vm._v(" " + _vm._s(_vm.tooltipText) + " ")]) : _vm._e()]), _vm.options.favorite ? _c('font-awesome-icon', {
    staticClass: "ext-icon ext-margin-right",
    class: {
      'ext-favorite': _vm.isFavorite
    },
    attrs: {
      "icon": [_vm.isFavorite ? 'fas' : 'fal', 'star']
    },
    on: {
      "mouseenter": function ($event) {
        return _vm.toggleTooltip('favorite');
      },
      "mouseleave": function ($event) {
        return _vm.toggleTooltip();
      },
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('toggle-favorite');
      }
    }
  }) : _vm._e(), _vm.options.summary ? _c('font-awesome-icon', {
    staticClass: "ext-icon ext-margin-right",
    attrs: {
      "icon": ['fal', 'clipboard-list-check']
    },
    on: {
      "mouseenter": function ($event) {
        return _vm.toggleTooltip(_vm.summaryOpened ? 'closeSummary' : 'openSummary');
      },
      "mouseleave": function ($event) {
        return _vm.toggleTooltip();
      },
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('toggle-summary');
      }
    }
  }) : _vm._e(), _vm.options.copy ? _c('font-awesome-icon', {
    staticClass: "ext-icon ext-margin-right",
    attrs: {
      "icon": ['fal', 'link']
    },
    on: {
      "mouseenter": function ($event) {
        return _vm.toggleTooltip('copy');
      },
      "mouseleave": function ($event) {
        return _vm.toggleTooltip();
      },
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('copy-link');
      }
    }
  }) : _vm._e(), _vm.options.open ? _c('font-awesome-icon', {
    staticClass: "ext-icon",
    attrs: {
      "icon": ['fal', 'external-link-square']
    },
    on: {
      "mouseenter": function ($event) {
        return _vm.toggleTooltip('open');
      },
      "mouseleave": function ($event) {
        return _vm.toggleTooltip();
      },
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('open-in-web');
      }
    }
  }) : _vm._e()], 1);
};
var ContentActionsvue_type_template_id_ecaa559c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentActions.vue?vue&type=script&lang=js&
/* harmony default export */ var ContentActionsvue_type_script_lang_js_ = ({
  name: "ContentActions",
  props: {
    contentId: {
      type: String,
      default: ""
    },
    isFavorite: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({
        favorite: true,
        copy: true,
        open: true,
        summary: false
      })
    },
    summaryOpened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tooltipActive: false,
      tooltipTextMap: {
        "favorite-add": this.$t("list-item.actions.favorite-add"),
        "favorite-remove": this.$t("list-item.actions.favorite-remove"),
        copy: this.$t("list-item.actions.copy-url"),
        open: this.$t("list-item.actions.open-page"),
        openSummary: this.$t("list-item.actions.open-summary"),
        closeSummary: this.$t("list-item.actions.close-summary")
      }
    };
  },
  methods: {
    toggleTooltip(name) {
      this.tooltipActive = name;
    }
  },
  computed: {
    tooltipText() {
      if (!this.tooltipActive) return "";
      if (this.tooltipActive === "favorite") {
        return this.tooltipTextMap[`${this.tooltipActive}-${this.isFavorite ? "remove" : "add"}`];
      }
      return this.tooltipTextMap[this.tooltipActive];
    }
  }
});
;// CONCATENATED MODULE: ./src/library/ListItem/ContentActions.vue?vue&type=script&lang=js&
 /* harmony default export */ var ListItem_ContentActionsvue_type_script_lang_js_ = (ContentActionsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ContentActions.vue?vue&type=style&index=0&id=ecaa559c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/ListItem/ContentActions.vue?vue&type=style&index=0&id=ecaa559c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/ListItem/ContentActions.vue



;


/* normalize component */

var ContentActions_component = normalizeComponent(
  ListItem_ContentActionsvue_type_script_lang_js_,
  ContentActionsvue_type_template_id_ecaa559c_scoped_true_render,
  ContentActionsvue_type_template_id_ecaa559c_scoped_true_staticRenderFns,
  false,
  null,
  "ecaa559c",
  null
  
)

/* harmony default export */ var ContentActions = (ContentActions_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/ArticleCard.vue?vue&type=script&lang=js&


/* harmony default export */ var ArticleCardvue_type_script_lang_js_ = ({
  name: "ArticleCard",
  components: {
    ContentActions: ContentActions,
    ContentListItemFullLabelWrapper: ContentListItemFullLabelWrapper
  },
  props: {
    title: String,
    root: String,
    isLoading: Boolean,
    isStarred: Boolean,
    articleId: String,
    summary: Object,
    labels: Array,
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      summaryExpanded: false,
      options: {
        favorite: true,
        copy: true,
        open: true,
        summary: false
      }
    };
  },
  created() {
    this.options.summary = this.hasSummary;
  },
  computed: {
    hasSummary() {
      return this.summary && this.summary.body;
    }
  },
  methods: {
    articleClicked() {
      if (!this.isLoading) {
        this.$emit("article-clicked", {
          articleId: this.articleId
        });
      }
    },
    toggleSummary() {
      this.summaryExpanded = !this.summaryExpanded;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ArticleCardvue_type_script_lang_js_ = (ArticleCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/ArticleCard.vue?vue&type=style&index=0&id=3d9a6d71&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleCard.vue?vue&type=style&index=0&id=3d9a6d71&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleCard.vue



;


/* normalize component */

var ArticleCard_component = normalizeComponent(
  components_ArticleCardvue_type_script_lang_js_,
  ArticleCardvue_type_template_id_3d9a6d71_scoped_true_render,
  ArticleCardvue_type_template_id_3d9a6d71_scoped_true_staticRenderFns,
  false,
  null,
  "3d9a6d71",
  null
  
)

/* harmony default export */ var ArticleCard = (ArticleCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagCard.vue?vue&type=template&id=5dc16156&scoped=true&
var DiagCardvue_type_template_id_5dc16156_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "diag-card",
    on: {
      "click": _vm.diagClicked
    }
  }, [_c('div', {
    staticClass: "w-full diag-attributes"
  }, [_c('div', {
    staticClass: "flex gap-2 items-center diag-header"
  }, [_c('div', {
    staticClass: "flex gap-2 items-start overflow-auto"
  }, [_c('img', {
    staticClass: "diag-icon",
    attrs: {
      "src": __webpack_require__(6520)
    }
  }), _c('p', {
    staticClass: "diag-title",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('div', {
    staticClass: "actions-container"
  }, [_c('ContentActions', {
    staticClass: "actions-container",
    attrs: {
      "content-id": _vm.diagId,
      "is-favorite": _vm.isFavorite,
      "options": _vm.options
    },
    on: {
      "toggle-favorite": function ($event) {
        return _vm.$emit('toggle-favorite', _vm.diagId);
      },
      "toggle-summary": _vm.toggleSummary,
      "copy-link": function ($event) {
        return _vm.$emit('copy-link', _vm.diagId);
      },
      "open-in-web": function ($event) {
        return _vm.$emit('open-in-web', _vm.diagId);
      }
    }
  })], 1)]), _vm.hasSummary ? _c('div', {
    class: ['summary-container bg-gray-1 ', {
      expanded: _vm.summaryExpanded
    }]
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.summary.body) + " ")])]) : _vm._e(), _vm.labels && _vm.labels.length ? _c('div', {
    staticClass: "d-flex align-items-center ml-3"
  }, [_c('ContentListItemFullLabelWrapper', {
    staticClass: "mt-1",
    attrs: {
      "labels": _vm.labels
    }
  })], 1) : _vm._e(), _vm.root ? _c('p', {
    staticClass: "diag-root mb-0 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.root))])]) : _vm._e()])]);
};
var DiagCardvue_type_template_id_5dc16156_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagCard.vue?vue&type=template&id=5dc16156&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagCard.vue?vue&type=script&lang=js&


/* harmony default export */ var DiagCardvue_type_script_lang_js_ = ({
  name: "DiagCard",
  components: {
    ContentActions: ContentActions,
    ContentListItemFullLabelWrapper: ContentListItemFullLabelWrapper
  },
  props: {
    title: String,
    root: String,
    isLoading: Boolean,
    isStarred: Boolean,
    diagId: String,
    labels: Array,
    summary: Object,
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      summaryExpanded: false,
      options: {
        favorite: true,
        copy: true,
        open: true,
        summary: false
      }
    };
  },
  created() {
    this.options.summary = this.hasSummary;
  },
  computed: {
    hasSummary() {
      return this.summary && this.summary.body;
    }
  },
  methods: {
    diagClicked() {
      if (!this.isLoading) {
        this.$emit("diag-clicked", {
          diagId: this.diagId
        });
      }
    },
    toggleSummary() {
      this.summaryExpanded = !this.summaryExpanded;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DiagCardvue_type_script_lang_js_ = (DiagCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/DiagCard.vue?vue&type=style&index=0&id=5dc16156&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagCard.vue?vue&type=style&index=0&id=5dc16156&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/DiagCard.vue



;


/* normalize component */

var DiagCard_component = normalizeComponent(
  components_DiagCardvue_type_script_lang_js_,
  DiagCardvue_type_template_id_5dc16156_scoped_true_render,
  DiagCardvue_type_template_id_5dc16156_scoped_true_staticRenderFns,
  false,
  null,
  "5dc16156",
  null
  
)

/* harmony default export */ var DiagCard = (DiagCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/FolderCard.vue?vue&type=template&id=f326a2c2&scoped=true&
var FolderCardvue_type_template_id_f326a2c2_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "folder-card",
    on: {
      "click": _vm.folderClicked
    }
  }, [_c('div', {
    staticClass: "row no-side-margin"
  }, [_c('IconWrapper', {
    staticClass: "folder-icon my-auto",
    attrs: {
      "icon": _vm.folder.icon,
      "size": 20
    }
  }), _c('div', {
    staticClass: "col-10 folder-attributes"
  }, [_c('p', {
    staticClass: "folder-title mb-0",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.folder.label) + " ")])]), _vm.isStarred ? _c('img', {
    staticClass: "favorite-icon",
    attrs: {
      "src": __webpack_require__(8837)
    }
  }) : _vm._e()], 1)]);
};
var FolderCardvue_type_template_id_f326a2c2_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/components/FolderCard.vue?vue&type=template&id=f326a2c2&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/IconWrapper.vue?vue&type=template&id=1f5a9b79&scoped=true&
var IconWrappervue_type_template_id_1f5a9b79_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-inline-flex"
  }, [_vm.isFa ? _c('div', {
    staticClass: "logo-container"
  }, [_c('font-awesome-icon', {
    staticClass: "d-flex icon-fa",
    style: _vm.computedStyle,
    attrs: {
      "icon": ['fad', _vm.formattedIcon.value]
    }
  })], 1) : _vm.isImage ? _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    style: _vm.computedStyle,
    attrs: {
      "src": _vm.formattedIcon.value
    }
  })]) : _vm.isEmoji ? _c('div', {
    staticClass: "logo-container"
  }, [_vm._v(" " + _vm._s(_vm.formattedIcon.value) + " ")]) : _vm._e()]);
};
var IconWrappervue_type_template_id_1f5a9b79_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/IconWrapper.vue?vue&type=script&lang=js&
/* harmony default export */ var IconWrappervue_type_script_lang_js_ = ({
  name: "IconWrapper",
  props: {
    icon: {
      type: Object,
      default: () => ({
        iconType: "fa",
        value: "folder",
        color: null
      })
    },
    miniIcon: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      defaultIcon: {
        iconType: "fa",
        value: "folder",
        color: null
      }
    };
  },
  computed: {
    isFa() {
      return this.formattedIcon.iconType === "fa";
    },
    isImage() {
      return this.formattedIcon.iconType === "url";
    },
    isEmoji() {
      return this.formattedIcon.iconType === "emoji";
    },
    shouldUseMainIcon() {
      return !this.miniIcon.value;
    },
    noIconsDefined() {
      return !this.icon.value && !this.miniIcon.value;
    },
    formattedIcon() {
      if (this.noIconsDefined) return this.defaultIcon;
      if (this.shouldUseMainIcon) return this.icon;
      return this.miniIcon;
    },
    computedStyle() {
      if (this.isFa) {
        return {
          color: this.formattedIcon.color,
          fontSize: `${this.size}px`
        };
      }
      if (this.isImage) {
        return {
          width: `${this.size}px !important`,
          height: `${this.size}px !important`
        };
      }
      return null;
    }
  }
});
;// CONCATENATED MODULE: ./src/library/IconWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_IconWrappervue_type_script_lang_js_ = (IconWrappervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/IconWrapper.vue?vue&type=style&index=0&id=1f5a9b79&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/IconWrapper.vue?vue&type=style&index=0&id=1f5a9b79&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/IconWrapper.vue



;


/* normalize component */

var IconWrapper_component = normalizeComponent(
  library_IconWrappervue_type_script_lang_js_,
  IconWrappervue_type_template_id_1f5a9b79_scoped_true_render,
  IconWrappervue_type_template_id_1f5a9b79_scoped_true_staticRenderFns,
  false,
  null,
  "1f5a9b79",
  null
  
)

/* harmony default export */ var IconWrapper = (IconWrapper_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/FolderCard.vue?vue&type=script&lang=js&

/* harmony default export */ var FolderCardvue_type_script_lang_js_ = ({
  name: "FolderCard",
  components: {
    IconWrapper: IconWrapper
  },
  props: {
    title: String,
    folder: {
      type: Object,
      default() {
        return {
          children: []
        };
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    root: String,
    isStarred: Boolean,
    folderId: String
  },
  methods: {
    folderClicked() {
      if (!this.isLoading) {
        this.$emit("folder-clicked", {
          folderId: this.folderId
        });
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/FolderCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FolderCardvue_type_script_lang_js_ = (FolderCardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/FolderCard.vue?vue&type=style&index=0&id=f326a2c2&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/FolderCard.vue?vue&type=style&index=0&id=f326a2c2&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/FolderCard.vue



;


/* normalize component */

var FolderCard_component = normalizeComponent(
  components_FolderCardvue_type_script_lang_js_,
  FolderCardvue_type_template_id_f326a2c2_scoped_true_render,
  FolderCardvue_type_template_id_f326a2c2_scoped_true_staticRenderFns,
  false,
  null,
  "f326a2c2",
  null
  
)

/* harmony default export */ var FolderCard = (FolderCard_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Contents.vue?vue&type=script&lang=js&






/* harmony default export */ var Contentsvue_type_script_lang_js_ = ({
  name: "ContentsView",
  components: {
    ArticleCard: ArticleCard,
    DiagCard: DiagCard,
    FolderCard: FolderCard,
    DiagnosticNavigator: DiagnosticNavigator,
    EmptyEntity: EmptyEntity
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    favoriteIds: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isFavorite() {
      return this.favoriteIds.map();
    },
    ...mapGetters("knowledgeModule", ["path", "mainContent", "mainContentChildren", "mainAttachedContents", "knowledgeIsLoading", "diagnosticIsFocused", "diagnosticTitle", "contentParents", "isEmptyCollection"])
  },
  methods: {
    // eslint-disable-next-line consistent-return
    openLinkedContent({
      id,
      label,
      type
    }) {
      if (type === "Article") {
        return this.$emit("show-article", {
          articleId: id
        });
      }
      this.updateContentParents([{
        id,
        label
      }]);
      this.$emit("go-to-entity", {
        id,
        type: "Content",
        deepLoading: true
      });
    },
    // eslint-disable-next-line consistent-return
    appearDiagnosticStep(step, isDiag = false) {
      if (step.redirection) {
        const {
          entityId: id,
          entityType: type
        } = step.redirection;
        this.handleOnClickInlineContent({
          sourceContent: this.contentParents.slice(-1)[0],
          targetContent: {
            id,
            type
          }
        });
        return this.$emit("reach-entity", {
          content: {
            id,
            type
          }
        });
      }
      if (isDiag) {
        this.updatePath(this.path.concat([step]));
      }
      this.updateContentParents(this.contentParents.concat([{
        ...step,
        children: this.mainContentChildren
      }]));
      const entity = {
        id: step.id,
        type: "Step"
      };
      this.$emit("go-to-entity", entity);
    },
    backDiagnosticStep() {
      const newParents = this.contentParents.slice(0, -1);
      this.updateContentParents(newParents);
      const entity = {
        id: newParents.at(-1).id,
        type: "Diagnostic"
      };
      this.$emit("go-to-entity", entity);
    },
    async reachParentEntity(parentIdx) {
      const parent = await this.getParentEntity(parentIdx);
      this.$emit("go-to-entity", parent);
    },
    handleFolderClick(child) {
      this.updatePathWithChildEntity(child);
      this.$emit("go-to-entity", child);
    },
    getSummary(content) {
      if (content.summary && content.summary.isVisible && content.summary.body && content.summary.body.length) {
        return content.summary;
      } else if (content.shortSummary && content.shortSummary.isVisible && content.shortSummary.body && content.shortSummary.body.length) {
        return content.shortSummary;
      }
      return null;
    },
    ...mapActions("knowledgeModule", ["updatePath", "updateContentParents", "updatePathWithChildEntity", "getParentEntity", "handleOnClickInlineContent"])
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/Contents.vue?vue&type=script&lang=js&
 /* harmony default export */ var knowledge_Contentsvue_type_script_lang_js_ = (Contentsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Contents.vue?vue&type=style&index=0&id=bef145ba&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/Contents.vue?vue&type=style&index=0&id=bef145ba&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/Contents.vue



;


/* normalize component */

var Contents_component = normalizeComponent(
  knowledge_Contentsvue_type_script_lang_js_,
  Contentsvue_type_template_id_bef145ba_scoped_true_render,
  Contentsvue_type_template_id_bef145ba_scoped_true_staticRenderFns,
  false,
  null,
  "bef145ba",
  null
  
)

/* harmony default export */ var Contents = (Contents_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Automations.vue?vue&type=template&id=1d39f74c&scoped=true&
var Automationsvue_type_template_id_1d39f74c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.recommendationsAvailable ? _c('div', {
    staticClass: "shortcut-notif-container mb-2"
  }, [_c('div', {
    staticClass: "shortcut-container-title"
  }, [_c('h6', {
    staticClass: "shortcut-text division-title mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("knowledge.automation")) + " ")]), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeAutomations
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3298),
      "width": "10px"
    }
  })])]), _vm._l(_vm.automations, function (automation) {
    return _c('div', {
      key: automation.id,
      staticClass: "shortcut my-1 py-1 d-flex",
      on: {
        "click": function ($event) {
          return _vm.applyAutomation(automation);
        }
      }
    }, [_c('img', {
      staticClass: "shortcut-icon ml-2",
      attrs: {
        "src": __webpack_require__(4759),
        "width": "20px"
      }
    }), _c('div', {
      staticClass: "shortcut-description col-11"
    }, [_c('p', {
      staticClass: "shortcut-title mb-0 text-left"
    }, [_vm._v(_vm._s(automation.alias))])])]);
  })], 2) : _vm._e();
};
var Automationsvue_type_template_id_1d39f74c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/Automations.vue?vue&type=template&id=1d39f74c&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Automations.vue?vue&type=script&lang=js&

/* harmony default export */ var Automationsvue_type_script_lang_js_ = ({
  name: "KnowledgeAutomations",
  props: {
    automations: {
      type: Array,
      default: () => []
    },
    recommendationsAvailable: {
      type: Boolean,
      default: false
    },
    hasForcingRecommendation: {
      type: Boolean,
      default: false
    },
    automationsDelay: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      setTimeoutId: null
    };
  },
  watch: {
    recommendationsAvailable() {
      if (this.recommendationsAvailable) {
        if (this.automations.length === 1 && this.hasForcingRecommendation) {
          this.applyAutomation(this.automations[0]);
        }
        this.setTimeoutId = setTimeout(() => {
          this.$emit("deny-automations");
        }, this.automationsDelay);
      }
    }
  },
  methods: {
    // eslint-disable-next-line consistent-return
    closeAutomations() {
      if (this.setTimeoutId) clearTimeout(this.setTimeoutId);
      this.$emit("deny-automations");
    },
    async applyAutomation(automation) {
      const {
        treeNodeId
      } = automation;
      if (!treeNodeId) return null;
      const content = await this.getContent(treeNodeId);
      const eventPayload = {
        topic: "CONTENT_RECOMMENDATION_SUCCESS",
        event: {
          recommendation: automation,
          content,
          location: "diagnostic",
          deepLoading: true
        }
      };
      if (this.setTimeoutId) clearTimeout(this.setTimeoutId);
      this.$emit("apply-automations", {
        content,
        eventPayload
      });
    },
    ...mapActions("knowledgeModule", ["getContent"])
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/Automations.vue?vue&type=script&lang=js&
 /* harmony default export */ var knowledge_Automationsvue_type_script_lang_js_ = (Automationsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/Automations.vue?vue&type=style&index=0&id=1d39f74c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/Automations.vue?vue&type=style&index=0&id=1d39f74c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/Automations.vue



;


/* normalize component */

var Automations_component = normalizeComponent(
  knowledge_Automationsvue_type_script_lang_js_,
  Automationsvue_type_template_id_1d39f74c_scoped_true_render,
  Automationsvue_type_template_id_1d39f74c_scoped_true_staticRenderFns,
  false,
  null,
  "1d39f74c",
  null
  
)

/* harmony default export */ var Automations = (Automations_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/AnswerModalMainBody.vue?vue&type=template&id=052c08a7&scoped=true&
var AnswerModalMainBodyvue_type_template_id_052c08a7_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "row comment-row no-side-margin justify-content-center"
  }, [_vm.copyDone ? _c('ModalToast', {
    staticClass: "col-11",
    attrs: {
      "message-code": "modals.copy-answer"
    }
  }) : _vm._e(), _c('ContentViewer', {
    attrs: {
      "id": "mayday-comment-body",
      "body": _vm.content.body
    },
    on: {
      "open-lightbox": function ($event) {
        return _vm.$emit('open-lightbox', $event);
      }
    }
  })], 1);
};
var AnswerModalMainBodyvue_type_template_id_052c08a7_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ContentViewer.vue?vue&type=template&id=bd8f14f0&scoped=true&
var ContentViewervue_type_template_id_bd8f14f0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showEditor ? _c('mayday-editor', {
    ref: "content-viewer-editor",
    staticClass: "me-content-viewer",
    attrs: {
      "editable": false,
      "options": _vm.options,
      "fetch-inline-content-handler": _vm.getContent,
      "fetch-inline-mention-handler": _vm.handleFetchInlineMention
    },
    on: {
      "click:inline-content": function ($event) {
        return _vm.$emit('click:inline-content', $event);
      },
      "click:attached-file": _vm.handleClickAttachedFile,
      "click:image": function ($event) {
        return _vm.handleOnImageClick($event.src);
      },
      "click:toc": function ($event) {
        return _vm.handleOnTocClick($event);
      },
      "click:focus-hash": _vm.handleFocusHash,
      "click:open-link": _vm.handleOpenLink
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  }) : _vm._e();
};
var ContentViewervue_type_template_id_bd8f14f0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ContentViewer.vue?vue&type=script&lang=js&


/* harmony default export */ var ContentViewervue_type_script_lang_js_ = ({
  name: "ContentViewer",
  props: {
    body: {
      type: String,
      default: ""
    },
    mentions: {
      type: Array,
      default: () => []
    },
    hash: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.toggleEditor();
    setTimeout(() => {
      this.handleFocusHash(this.hash);
    }, 1000);
  },
  data() {
    return {
      content: "",
      linkModal: {
        display: false,
        src: ""
      },
      showEditor: true,
      options: {
        fontOptions: true,
        extraFontOptions: true,
        colorOptions: true,
        structurationOptions: true,
        extraStructurationOptions: true,
        tableOptions: true,
        richOptions: true,
        tocClickOptions: true,
        allowToc: true
      },
      shadowRoot: getShadowRoot()
    };
  },
  methods: {
    async handleOpenLink({
      href
    }) {
      if (href.includes("mayday.fr")) {
        const res = await this.openInlineLink(href);
        if (res) {
          return this.$emit("open-content", res);
        }
      }
      return window.open(href, "_blank");
    },
    toggleEditor() {
      this.showEditor = false;
      this.$nextTick(() => {
        this.showEditor = true;
        this.$nextTick(() => {
          this.setEditorContent(this.body);
        });
      });
    },
    setEditorContent(rawContent) {
      const maydayEditor = this.$refs["content-viewer-editor"];
      this.content = rawContent;
      maydayEditor.editor.commands.setContent(this.content);
      this.$nextTick(() => {
        const editorWrapper = maydayEditor.$el.getElementsByClassName("mayday-editor__content__ProseMirror");
        if (editorWrapper[0]) {
          editorWrapper[0].translate = true;
        }
      });
    },
    handleClickAttachedFile(evt) {
      if (evt && evt.href) {
        window.open(evt.href, "_blank");
      }
    },
    handleOnImageClick(src) {
      if (src) {
        this.$emit("open-lightbox", src);
      }
    },
    scrollToEl(el) {
      const y = el.getBoundingClientRect().top - 150;
      const modal = this.shadowRoot.getElementById("modal-container");
      modal.scrollTo({
        top: y,
        behavior: "smooth"
      });
    },
    handleOnTocClick({
      id
    }) {
      this.scrollToEl(this.shadowRoot.getElementById(id));
    },
    handleFocusHash(hash) {
      if (!hash) return;
      const id = decodeURI(hash.slice(1));
      const uniqueNode = this.shadowRoot.querySelector(`[data-uid="${id}"], [id="${id}"]`);
      if (!uniqueNode) return;
      this.scrollToEl(uniqueNode);
    },
    handleFetchInlineMention({
      entityId,
      entityType
    }) {
      const user = this.mentions.find(mention => mention.id === entityId);
      if (!user) return null;
      const {
        username,
        isDeleted
      } = user;
      return {
        entityId,
        entityType,
        label: username,
        isDeleted
      };
    },
    ...mapActions("knowledgeModule", ["openInlineLink", "getContent"])
  },
  watch: {
    body() {
      this.toggleEditor();
    },
    hash() {
      setTimeout(() => {
        this.handleFocusHash(this.hash);
      }, 1000);
    }
  }
});
;// CONCATENATED MODULE: ./src/library/ContentViewer.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_ContentViewervue_type_script_lang_js_ = (ContentViewervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ContentViewer.vue?vue&type=style&index=0&id=bd8f14f0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/ContentViewer.vue?vue&type=style&index=0&id=bd8f14f0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/ContentViewer.vue



;


/* normalize component */

var ContentViewer_component = normalizeComponent(
  library_ContentViewervue_type_script_lang_js_,
  ContentViewervue_type_template_id_bd8f14f0_scoped_true_render,
  ContentViewervue_type_template_id_bd8f14f0_scoped_true_staticRenderFns,
  false,
  null,
  "bd8f14f0",
  null
  
)

/* harmony default export */ var ContentViewer = (ContentViewer_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalToast.vue?vue&type=template&id=a5a69912&scoped=true&
var ModalToastvue_type_template_id_a5a69912_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('card', {
    staticClass: "toast__card m-2",
    attrs: {
      "id": "copy-notif-card",
      "type": "primary",
      "shadow": ""
    }
  }, [_c('p', {
    staticClass: "feedback-notif text-center",
    staticStyle: {
      "color": "white !important",
      "margin-bottom": "0px !important",
      "font-weight": "500 !important"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.messageCode)) + " ")])]);
};
var ModalToastvue_type_template_id_a5a69912_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalToast.vue?vue&type=script&lang=js&
/* harmony default export */ var ModalToastvue_type_script_lang_js_ = ({
  name: "ModalToast",
  props: {
    messageCode: {
      type: String
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Modal/ModalToast.vue?vue&type=script&lang=js&
 /* harmony default export */ var Modal_ModalToastvue_type_script_lang_js_ = (ModalToastvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalToast.vue?vue&type=style&index=0&id=a5a69912&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Modal/ModalToast.vue?vue&type=style&index=0&id=a5a69912&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Modal/ModalToast.vue



;


/* normalize component */

var ModalToast_component = normalizeComponent(
  Modal_ModalToastvue_type_script_lang_js_,
  ModalToastvue_type_template_id_a5a69912_scoped_true_render,
  ModalToastvue_type_template_id_a5a69912_scoped_true_staticRenderFns,
  false,
  null,
  "a5a69912",
  null
  
)

/* harmony default export */ var ModalToast = (ModalToast_component.exports);
;// CONCATENATED MODULE: ./src/utils/randomQuotes.js
const QUOTES = [{
  quote: "Vous êtes un champion du service client 💪🏼",
  author: "Oscar Wilde"
}, {
  quote: "Vous êtes un as de la relation client  🤩",
  author: "Frank Zappa"
}, {
  quote: "Vous êtes sur le point de résoudre à merveille le problème du client 💯",
  author: "Marcus Tullius Cicero"
}, {
  quote: "Encore un client satisfait grâce à vous  🎉",
  author: "Mae West"
}, {
  quote: "Voici une belle occasion de rendre le client heureux 😉",
  author: "Mahatma Gandhi"
}, {
  quote: "En résolvant le problème du client vous devenez son héros 🦸‍♂️",
  author: "Mark Twain"
}, {
  quote: "Chaque contact avec le client est un moyen de le rendre heureux 🎯",
  author: "Oscar Wilde"
}, {
  quote: "Un client qui arrive énervé peut repartir heureux grâce à vous 💯",
  author: "Frank Zappa"
}, {
  quote: "Le saviez-vous : 9h37 ! C'est le record du monde de l'appel de relation client qui a duré le plus longtemps. Il est détenu par l'entreprise américaine Zappos 🤓",
  author: "Marcus Tullius Cicero"
}, {
  quote: "Mayday vous aide à résoudre les tickets à la vitesse de l'éclair ⚡️",
  author: "Mae West"
}, {
  quote: "Plus qu'une seconde pour connaître les process comme votre poche  ⏳",
  author: "Mahatma Gandhi"
}, {
  quote: "N'hésitez pas à nous faire remonter toutes vos idées pour améliorer Mayday 📢",
  author: "Mark Twain"
}, {
  quote: "Mayday vous accompagne pour traiter tous les tickets 💬",
  author: "Frank Zappa"
}, {
  quote: "Pas un ticket sans Mayday 🚀",
  author: "Marcus Tullius Cicero"
}, {
  quote: 'Si vous ne trouvez pas le processus adapté dans mayday n\'hésitez pas à le dire à vos managers grâce à la fonctionnalité de "feedbacks" 💬',
  author: "Mae West"
}];
/* harmony default export */ function randomQuotes() {
  return QUOTES[Math.floor(Math.random() * Math.floor(QUOTES.length))];
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/AnswerModalMainBody.vue?vue&type=script&lang=js&



/* harmony default export */ var AnswerModalMainBodyvue_type_script_lang_js_ = ({
  name: "AnswerModalMainBody",
  components: {
    ContentViewer: ContentViewer,
    ModalToast: ModalToast
  },
  props: {
    content: {
      type: Object
    },
    copyDone: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      randomQuote: {}
    };
  },
  created() {
    this.randomQuote = randomQuotes();
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/AnswerModalMainBody.vue?vue&type=script&lang=js&
 /* harmony default export */ var knowledge_AnswerModalMainBodyvue_type_script_lang_js_ = (AnswerModalMainBodyvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/AnswerModalMainBody.vue?vue&type=style&index=0&id=052c08a7&prod&lang=css&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/AnswerModalMainBody.vue?vue&type=style&index=0&id=052c08a7&prod&lang=css&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/AnswerModalMainBody.vue



;


/* normalize component */

var AnswerModalMainBody_component = normalizeComponent(
  knowledge_AnswerModalMainBodyvue_type_script_lang_js_,
  AnswerModalMainBodyvue_type_template_id_052c08a7_scoped_true_render,
  AnswerModalMainBodyvue_type_template_id_052c08a7_scoped_true_staticRenderFns,
  false,
  null,
  "052c08a7",
  null
  
)

/* harmony default export */ var AnswerModalMainBody = (AnswerModalMainBody_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=template&id=8a3a4c2c&scoped=true&
var ArticleModalMainBodyvue_type_template_id_8a3a4c2c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "row comment-row no-side-margin justify-content-center"
  }, [_vm.copyDone.body ? _c('ModalToast', {
    staticClass: "col-11",
    attrs: {
      "message-code": "modals.copy-article"
    }
  }) : _vm._e(), _vm.copyDone.link ? _c('ModalToast', {
    staticClass: "col-11",
    attrs: {
      "message-code": "modals.copy-link"
    }
  }) : _vm._e(), _vm.previousNode && _vm.previousNode.type === 'Article' ? _c('ArticleModalPreviousContentButton', {
    staticClass: "m-4",
    attrs: {
      "label": _vm.previousNode.label,
      "type": _vm.previousNode.type
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:previous-node', _vm.previousNode);
      }
    }
  }) : _vm._e(), _vm.hasSummary || _vm.hasActionItems ? _c('ai-agent-collapse', {
    attrs: {
      "summary": _vm.summary,
      "action-items": _vm.actionItems
    }
  }) : _vm._e(), _c('ContentViewer', {
    attrs: {
      "id": "mayday-comment-body",
      "body": _vm.content.body,
      "mentions": _vm.content.enrichedMentions,
      "hash": _vm.content.hash
    },
    on: {
      "click:inline-content": function ($event) {
        return _vm.$emit('click:inline-content', $event);
      },
      "open-content": function ($event) {
        return _vm.$emit('open-content', $event);
      },
      "open-lightbox": function ($event) {
        return _vm.$emit('open-lightbox', $event);
      }
    }
  }), _c('SatisfactionModule', {
    staticClass: "mt-4",
    attrs: {
      "content-id": _vm.content.id
    },
    on: {
      "choice": function ($event) {
        return _vm.$emit('on-satisfaction', $event);
      },
      "click:feedback": function ($event) {
        return _vm.$emit('toggle-feedback');
      }
    }
  })], 1);
};
var ArticleModalMainBodyvue_type_template_id_8a3a4c2c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/ArticleModalPreviousContentButton.vue?vue&type=template&id=7c0d05f0&scoped=true&
var ArticleModalPreviousContentButtonvue_type_template_id_7c0d05f0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: [_vm.mainClass],
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('font-awesome-icon', {
    class: [`${_vm.mainClass}__icon`],
    attrs: {
      "icon": ['fas', 'long-arrow-left']
    }
  }), _c('img', {
    class: [`${_vm.mainClass}__type-icon`],
    attrs: {
      "src": _vm.iconSrc
    }
  }), _c('span', {
    class: [`${_vm.mainClass}__label`]
  }, [_vm._v(_vm._s(_vm.label))])], 1);
};
var ArticleModalPreviousContentButtonvue_type_template_id_7c0d05f0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/ArticleModalPreviousContentButton.vue?vue&type=script&lang=js&


/* harmony default export */ var ArticleModalPreviousContentButtonvue_type_script_lang_js_ = ({
  name: "PreviousNodeButton",
  props: {
    label: {
      type: String
    },
    type: {
      type: String,
      default: "Article"
    }
  },
  data() {
    return {
      mainClass: "previous-content"
    };
  },
  computed: {
    iconSrc() {
      return this.type === "Article" ? (article_default()) : (diagnostic_default());
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleModalPreviousContentButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ArticleModalPreviousContentButtonvue_type_script_lang_js_ = (ArticleModalPreviousContentButtonvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/components/ArticleModalPreviousContentButton.vue?vue&type=style&index=0&id=7c0d05f0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleModalPreviousContentButton.vue?vue&type=style&index=0&id=7c0d05f0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/components/ArticleModalPreviousContentButton.vue



;


/* normalize component */

var ArticleModalPreviousContentButton_component = normalizeComponent(
  components_ArticleModalPreviousContentButtonvue_type_script_lang_js_,
  ArticleModalPreviousContentButtonvue_type_template_id_7c0d05f0_scoped_true_render,
  ArticleModalPreviousContentButtonvue_type_template_id_7c0d05f0_scoped_true_staticRenderFns,
  false,
  null,
  "7c0d05f0",
  null
  
)

/* harmony default export */ var ArticleModalPreviousContentButton = (ArticleModalPreviousContentButton_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/internals/set-helpers.js
var set_helpers = __webpack_require__(9405);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/AiAgentCollapse.vue?vue&type=template&id=45687b58&scoped=true&
var AiAgentCollapsevue_type_template_id_45687b58_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ai-agent-collapse"
  }, [_c('div', {
    staticClass: "ai-agent-collapse__header",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "ai-agent-collapse__tabs"
  }, [_vm.summary ? _c('div', {
    class: ['ai-agent-collapse__tab', {
      selected: _vm.activeTab === 'summary'
    }, {
      expanded: _vm.expanded
    }],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleSelectTab('summary');
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'file-alt']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("knowledge.ai-collapse.summary")) + " ")], 1) : _vm._e(), _vm.actionItems ? _c('div', {
    class: ['ai-agent-collapse__tab', {
      selected: _vm.activeTab === 'action-items'
    }, {
      expanded: _vm.expanded
    }],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleSelectTab('action-items');
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'file-check']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("knowledge.ai-collapse.action-items")) + " ")], 1) : _vm._e()]), _c('font-awesome-icon', {
    class: ['ai-agent-collapse__chevron', {
      expanded: _vm.expanded
    }],
    attrs: {
      "icon": ['fal', 'chevron-right']
    }
  })], 1), _c('div', {
    class: ['ai-agent-collapse__body', {
      expanded: _vm.expanded
    }]
  }, [_vm.summary && _vm.activeTab === 'summary' ? _c('div', {
    staticClass: "ai-agent-collapse__summary"
  }, [_vm._v(" " + _vm._s(_vm.summary.body) + " ")]) : _vm._e(), _vm.activeTab === 'action-items' ? _c('div', {
    staticClass: "ai-agent-collapse__action-items"
  }, _vm._l(_vm.actionItems.body, function (actionItem, i) {
    return _c('div', {
      key: i,
      staticClass: "ai-agent-collapse__action-item"
    }, [_c('input', {
      attrs: {
        "id": i,
        "name": i,
        "type": "checkbox"
      }
    }), _c('label', {
      staticClass: "ai-agent-collapse__action-item-label",
      attrs: {
        "for": i
      }
    }, [_vm._v(" " + _vm._s(actionItem) + " ")])]);
  }), 0) : _vm._e()])]);
};
var AiAgentCollapsevue_type_template_id_45687b58_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/AiAgentCollapse.vue?vue&type=script&lang=js&
/* harmony default export */ var AiAgentCollapsevue_type_script_lang_js_ = ({
  name: "AiAgentCollapse",
  props: {
    summary: {
      type: Object,
      default: null
    },
    actionItems: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    expanded: false,
    activeTab: "summary"
  }),
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    handleSelectTab(tab) {
      this.activeTab = tab;
      if (!this.expanded) this.expanded = true;
    }
  },
  created() {
    if (this.summary) this.activeTab = "summary";else if (this.actionItems) this.activeTab = "action-items";
  }
});
;// CONCATENATED MODULE: ./src/library/AiAgentCollapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_AiAgentCollapsevue_type_script_lang_js_ = (AiAgentCollapsevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/AiAgentCollapse.vue?vue&type=style&index=0&id=45687b58&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/AiAgentCollapse.vue?vue&type=style&index=0&id=45687b58&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/AiAgentCollapse.vue



;


/* normalize component */

var AiAgentCollapse_component = normalizeComponent(
  library_AiAgentCollapsevue_type_script_lang_js_,
  AiAgentCollapsevue_type_template_id_45687b58_scoped_true_render,
  AiAgentCollapsevue_type_template_id_45687b58_scoped_true_staticRenderFns,
  false,
  null,
  "45687b58",
  null
  
)

/* harmony default export */ var AiAgentCollapse = (AiAgentCollapse_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=script&lang=js&







/* harmony default export */ var ArticleModalMainBodyvue_type_script_lang_js_ = ({
  name: "ArticleModalMainBody",
  components: {
    AiAgentCollapse: AiAgentCollapse,
    ContentViewer: ContentViewer,
    ModalToast: ModalToast,
    ArticleModalPreviousContentButton: ArticleModalPreviousContentButton,
    SatisfactionModule: SatisfactionModule
  },
  props: {
    content: {
      type: Object
    },
    copyDone: {
      type: Object,
      default: () => ({
        body: false,
        link: false
      })
    },
    previousNode: {
      type: Object
    }
  },
  data() {
    return {
      randomQuote: {}
    };
  },
  created() {
    this.randomQuote = randomQuotes();
  },
  computed: {
    hasSummary() {
      return this.content.summary && this.content.summary.isVisible && this.content.summary.body && this.content.summary.body.length || this.content.shortSummary && this.content.shortSummary.isVisible && this.content.shortSummary.body && this.content.shortSummary.body.length;
    },
    hasActionItems() {
      return this.content.actionItems && this.content.actionItems.isVisible && this.content.actionItems.body && this.content.actionItems.body.length;
    },
    summary() {
      if (this.content.summary && this.content.summary.isVisible) {
        return this.content.summary;
      } else if (this.content.shortSummary && this.content.shortSummary.isVisible) {
        return this.content.shortSummary;
      }
      return null;
    },
    actionItems() {
      if (this.hasActionItems) {
        return this.content.actionItems;
      }
      return null;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=script&lang=js&
 /* harmony default export */ var knowledge_ArticleModalMainBodyvue_type_script_lang_js_ = (ArticleModalMainBodyvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=style&index=0&id=8a3a4c2c&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=style&index=0&id=8a3a4c2c&prod&lang=scss&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=style&index=1&id=8a3a4c2c&prod&lang=css&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/ArticleModalMainBody.vue?vue&type=style&index=1&id=8a3a4c2c&prod&lang=css&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/ArticleModalMainBody.vue



;



/* normalize component */

var ArticleModalMainBody_component = normalizeComponent(
  knowledge_ArticleModalMainBodyvue_type_script_lang_js_,
  ArticleModalMainBodyvue_type_template_id_8a3a4c2c_scoped_true_render,
  ArticleModalMainBodyvue_type_template_id_8a3a4c2c_scoped_true_staticRenderFns,
  false,
  null,
  "8a3a4c2c",
  null
  
)

/* harmony default export */ var ArticleModalMainBody = (ArticleModalMainBody_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/MaydayFlowy.vue?vue&type=template&id=1e49e973&scoped=true&
var MaydayFlowyvue_type_template_id_1e49e973_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lightbox",
    on: {
      "mousedown": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "diagram-tree flex-column d-flex align-items-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("modals.lightbox.close")) + " ")])]), _vm.loading || !_vm.diagnosticTree.length ? _c('div', {
    staticClass: "to-display-loader"
  }, [_vm.loading ? _c('font-awesome-icon', {
    attrs: {
      "spin": "",
      "icon": ['fas', 'spinner']
    }
  }) : _vm._e()], 1) : _c('flowy', {
    staticClass: "tree-node-by-flowy",
    attrs: {
      "nodes": _vm.diagnosticTree,
      "options": _vm.options
    },
    on: {
      "click:node": _vm.clickOnNode
    },
    scopedSlots: _vm._u([{
      key: "node-title",
      fn: function ({
        node
      }) {
        return [_c('div', {
          staticClass: "flex flex-row items-center"
        }, [_c('div', {
          staticClass: "d-flex flex-shrink bg-blue-2 mr-2"
        }, [node.data.content.type === 'Diagnostic' ? _c('div', {
          staticClass: "img-root-wrapper"
        }, [_c('img', {
          staticClass: "img-root",
          attrs: {
            "src": __webpack_require__(6271)
          }
        })]) : _vm._e(), node.data.content.redirection ? _c('font-awesome-icon', {
          staticClass: "redirect-logo",
          attrs: {
            "icon": ['fa', 'external-link-square']
          }
        }) : _vm._e()], 1), _c('div', {
          staticClass: "header-title"
        }, [_c('span', {
          staticClass: "font-bold"
        }, [_vm._v(_vm._s(node.data.title))])])])];
      }
    }, _vm.hasBody ? {
      key: "node-body",
      fn: function ({
        node
      }) {
        return [_c('div', {
          staticClass: "step-node-body d-flex flex-column justify-center"
        }, [node.data.content.body ? _c('div', {
          staticClass: "body-wrapper"
        }, [_vm.displayNode === node.id ? _c('div', {
          directives: [{
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.hideBody,
            expression: "hideBody"
          }],
          staticClass: "body-preview"
        }, [_c('ContentViewer', {
          attrs: {
            "body": node.data.content.body,
            "mentions": node.data.content.enrichedMentions
          },
          on: {
            "open-content": _vm.clickOnContent,
            "click:inline-content": _vm.handleInlineContent
          }
        }), _c('div', {
          staticClass: "close-preview"
        }, [_c('button', {
          staticClass: "btn-close",
          on: {
            "click": _vm.hideBody
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("modals.lightbox.close")) + " ")])])], 1) : _c('div', {
          staticClass: "body-content",
          on: {
            "click": function ($event) {
              return _vm.displayBody(node);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.firstBodyTag(node.data.content.body)) + " ")])]) : _vm._e(), _c('div', {
          staticClass: "flex flex-row items-center body-footer px-2 pb-1"
        }, [_c('div'), _c('button', {
          staticClass: "icon-redirect",
          on: {
            "click": function ($event) {
              return _vm.clickOnNode(node);
            }
          }
        }, [_c('font-awesome-icon', {
          attrs: {
            "icon": ['fas', 'arrow-right']
          }
        })], 1)])])];
      }
    } : null], null, true)
  })], 1)]);
};
var MaydayFlowyvue_type_template_id_1e49e973_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/knowledge/MaydayFlowy.vue?vue&type=template&id=1e49e973&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/MaydayFlowy.vue?vue&type=script&lang=js&


/* harmony default export */ var MaydayFlowyvue_type_script_lang_js_ = ({
  name: "MaydayFlowy",
  components: {
    ContentViewer: ContentViewer
  },
  data() {
    return {
      hasBody: true,
      loading: false,
      options: {
        hasStats: false,
        isDraggable: false,
        hasMinimap: true,
        isZoomable: true
      },
      error: false,
      displayNode: ""
    };
  },
  async mounted() {
    this.loading = true;
    const res = await this.getDiagnosticTree();
    if (!res) this.error = true;
    this.loading = false;
  },
  computed: {
    ...mapGetters("knowledgeModule", ["contentParents", "diagnosticTree"])
  },
  methods: {
    firstBodyTag(body) {
      if (!body) return "";
      const domParser = new DOMParser().parseFromString(body, "text/html");
      const firstTags = domParser.querySelectorAll("p, h1, h2, h3, h4, h5, h6, div");
      if (firstTags) {
        return firstTags ? firstTags[0].textContent.replace(/<\/?[^>]+(>|$)/g, "") : "";
      }
      return "";
    },
    clickOnContent(e) {
      this.$emit("reach-content", e);
      this.$emit("close");
    },
    clickOnNode(content) {
      if (content.redirection) {
        const {
          entityId: id,
          entityType: type
        } = content.redirection;
        this.$emit("click:inline-content", {
          sourceContent: this.contentParents.slice(-1)[0],
          targetContent: {
            id,
            type
          }
        });
      } else {
        this.$emit("reach-content", {
          content
        });
      }
      this.$emit("close");
    },
    handleInlineContent({
      id,
      type
    }) {
      this.$emit("click:inline-content", {
        sourceContent: this.contentParents.at(-1),
        targetContent: {
          id,
          type
        }
      });
      this.$emit("close");
    },
    displayBody(node) {
      this.displayNode = node.id;
    },
    hideBody() {
      this.displayNode = "";
    },
    ...mapActions("knowledgeModule", ["getDiagnosticTree"])
  }
});
;// CONCATENATED MODULE: ./src/modules/knowledge/MaydayFlowy.vue?vue&type=script&lang=js&
 /* harmony default export */ var knowledge_MaydayFlowyvue_type_script_lang_js_ = (MaydayFlowyvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/knowledge/MaydayFlowy.vue?vue&type=style&index=0&id=1e49e973&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/knowledge/MaydayFlowy.vue?vue&type=style&index=0&id=1e49e973&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/knowledge/MaydayFlowy.vue



;


/* normalize component */

var MaydayFlowy_component = normalizeComponent(
  knowledge_MaydayFlowyvue_type_script_lang_js_,
  MaydayFlowyvue_type_template_id_1e49e973_scoped_true_render,
  MaydayFlowyvue_type_template_id_1e49e973_scoped_true_staticRenderFns,
  false,
  null,
  "1e49e973",
  null
  
)

/* harmony default export */ var MaydayFlowy = (MaydayFlowy_component.exports);
;// CONCATENATED MODULE: ./src/modules/knowledge/index.ts








const knowledgePlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "knowledgeModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      knowledgeClient
    } = options;
    store.registerModule(STORE_MODULE_NAME, knowledgeStore, {
      preserveState: !!store.state[STORE_MODULE_NAME]
    });
    if (knowledgeClient) {
      store.$knowledgeService = attachKnowledgeService(knowledgeClient);
    }
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) {
            options.i18n.mergeLocaleMessage(locale, locales(key));
          }
        }
      });
    }
    Vue.component("knowledge-view", Knowledge);
    Vue.component("knowledge-automations", Automations);
    Vue.component("contents-view", Contents);
    Vue.component("answer-main-body", AnswerModalMainBody);
    Vue.component("article-main-body", ArticleModalMainBody);
    Vue.component("mayday-flowy", MaydayFlowy);
  }
};
const KnowledgeModule = {
  plugin: knowledgePlugin,
  store: knowledgeStore,
  attachService: attachKnowledgeService
};
;// CONCATENATED MODULE: ./src/modules/search/store/mutation-types.ts
const mutation_types_LOGOUT = "LOGOUT";
;// CONCATENATED MODULE: ./src/modules/search/store/actions.ts

/* harmony default export */ var store_actions = ({
  logout({
    commit
  }) {
    commit(mutation_types_LOGOUT);
  },
  async knowledgeSearchAction(_, {
    queryText,
    correlationId,
    searchFilters,
    categories,
    size,
    lang
  }) {
    try {
      const {
        search
      } = await this.$searchService.search({
        ...searchFilters,
        categories,
        queryText,
        correlationId,
        size,
        lang
      });
      search.documents.forEach(el => {
        // eslint-disable-next-line no-underscore-dangle
        // eslint-disable-next-line no-param-reassign
        // eslint-disable-next-line no-underscore-dangle
        if (el.__typename === "Case") el.type = "Case";
      });
      return search;
    } catch (e) {
      e;
    }
  },
  async getContentParameterLabels() {
    return this.$searchService.getContentParameterLabels();
  }
});
;// CONCATENATED MODULE: ./src/modules/search/store/getters.ts
const getters_getters = {
  itemIsFavorite: (_, __, ___, rootGetters) => itemId => {
    const isFavorite = rootGetters["userFavoritesModule/itemIsFavorite"];
    return isFavorite ? !!isFavorite(itemId) : false;
  }
};
/* harmony default export */ var search_store_getters = (getters_getters);
;// CONCATENATED MODULE: ./src/modules/search/store/state.ts
const store_state_state = () => ({
  correlationId: null
});
;// CONCATENATED MODULE: ./src/modules/search/store/mutations.ts


/* harmony default export */ var store_mutations = ({
  [mutation_types_LOGOUT](state) {
    Object.assign(state, store_state_state());
  }
});
;// CONCATENATED MODULE: ./src/modules/search/store/index.ts




const searchStore = {
  namespaced: true,
  state: store_state_state,
  getters: search_store_getters,
  actions: store_actions,
  mutations: store_mutations
};
;// CONCATENATED MODULE: ./src/modules/search/service/index.ts

class SearchService {
  constructor(apiClient) {
    _defineProperty(this, "apiClient", void 0);
    this.apiClient = apiClient;
  }
  async search(searchPayload) {
    const res = await this.apiClient.post("search", searchPayload);
    return res.data || res;
  }
  async getContentParameterLabels() {
    const res = await this.apiClient.get("labels");
    return res.data ? res.data.labels : res.labels;
  }
}
const attachSearchService = knowledgeClient => {
  return new SearchService(knowledgeClient);
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/Search.vue?vue&type=template&id=6e1a0e86&scoped=true&
var Searchvue_type_template_id_6e1a0e86_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.onClickOutside,
      expression: "onClickOutside"
    }],
    staticClass: "search-wrapper"
  }, [_c('search-input', {
    ref: "input",
    staticClass: "search-input",
    attrs: {
      "tags": _vm.selectedTags,
      "tag-number": _vm.tagNumber
    },
    on: {
      "delete-tag": _vm.deleteTag,
      "key-up": _vm.handleKeyUp
    },
    model: {
      value: _vm.searchInputFilter,
      callback: function ($$v) {
        _vm.searchInputFilter = $$v;
      },
      expression: "searchInputFilter"
    }
  }, [_vm.searchInProgress ? _c('div', {
    staticClass: "px-2 flex"
  }, [_c('font-awesome-icon', {
    staticClass: "icon-delete",
    attrs: {
      "icon": ['fal', 'times']
    },
    on: {
      "click": _vm.onDelete
    }
  })], 1) : _vm._e(), _c('font-awesome-icon', {
    staticClass: "icon-filters",
    class: {
      'text-blue': _vm.showFilters
    },
    attrs: {
      "icon": ['fad', 'sliders-v']
    },
    on: {
      "click": _vm.toggleFilters
    }
  })], 1), _c('LoaderLine', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm.searchInProgress || _vm.showFilters ? _c('div', {
    staticClass: "search-dropdown"
  }, [_c('div', {
    staticClass: "overflow"
  }, [_vm.showFilters ? _c('SearchFilters', {
    staticClass: "search-filters",
    attrs: {
      "selected-tags": _vm.selectedTags
    },
    on: {
      "update-selected-tags": _vm.updateTags
    }
  }) : _vm._e(), _c('div', {
    class: {
      'neg-margin': _vm.filtersAndResultsDisplayed
    }
  }, [_vm._t("default", null, {
    "results": _vm.results,
    "hasMore": _vm.hasMore,
    "loading": _vm.loading,
    "hovered": _vm.hovered,
    "labelSearchedIds": _vm.labelSearchedIds,
    "searchInProgress": _vm.searchInProgress
  })], 2)], 1)]) : _vm._e()], 1);
};
var Searchvue_type_template_id_6e1a0e86_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(7658);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/SearchInput.vue?vue&type=template&id=0dc06d62&scoped=true&
var SearchInputvue_type_template_id_0dc06d62_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center search-input-wrapper border",
    class: _vm.focused ? 'focus-input' : 'border-gray-4'
  }, [_c('font-awesome-icon', {
    staticClass: "search-icon",
    class: _vm.focused ? 'text-blue' : 'text-gray-5',
    attrs: {
      "icon": ['fal', 'search']
    }
  }), _c('TagsInputWrapper', {
    attrs: {
      "tags": _vm.tags,
      "tag-number": _vm.tagNumber
    },
    on: {
      "delete": function ($event) {
        return _vm.$emit('delete-tag', $event);
      }
    }
  }), _c('input', _vm._g(_vm._b({
    ref: "search",
    staticClass: "query-input flex-1",
    class: {
      'with-tags': _vm.tags.length
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.focused ? '' : _vm.placeholder,
      "spellcheck": "false",
      "size": "1"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": function ($event) {
        return _vm.$emit('key-up', $event);
      }
    }
  }, 'input', _vm.$attrs, false), _vm.listeners)), _vm._t("default")], 2);
};
var SearchInputvue_type_template_id_0dc06d62_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagsInputWrapper.vue?vue&type=template&id=63139242&scoped=true&
var TagsInputWrappervue_type_template_id_63139242_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "max-width-62 relative"
  }, [_c('div', {
    staticClass: "flex items-center tags-wrapper"
  }, [_vm.tags.length > _vm.tagNumber ? _c('div', {
    staticClass: "px-1",
    on: {
      "!click": function ($event) {
        _vm.showMoreTags = !_vm.showMoreTags;
      }
    }
  }, [_c('TagInput', {
    class: {
      'border-bold': _vm.showPopover
    },
    attrs: {
      "tag": _vm.shortedTag
    }
  })], 1) : _vm._e(), _vm._l(_vm.inputTags, function (tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "px-1 flex-none"
    }, [_c('TagInput', {
      attrs: {
        "tag": tag
      },
      on: {
        "delete": function ($event) {
          return _vm.$emit('delete', $event);
        }
      }
    })], 1);
  })], 2), _vm.showPopover ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.handleClickOutside,
      expression: "handleClickOutside"
    }],
    staticClass: "flex tags-popover",
    class: _vm.firstTags.length > 2 ? 'max-width' : 'max-content'
  }, _vm._l(_vm.firstTags, function (tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "flex-none tag-wrap"
    }, [_c('TagInput', {
      attrs: {
        "tag": tag
      },
      on: {
        "delete": function ($event) {
          return _vm.$emit('delete', $event);
        }
      }
    })], 1);
  }), 0) : _vm._e()]);
};
var TagsInputWrappervue_type_template_id_63139242_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagInput.vue?vue&type=template&id=041942c0&scoped=true&
var TagInputvue_type_template_id_041942c0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center tag",
    style: _vm.tagColor,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('delete', _vm.tag);
      }
    }
  }, [_vm.tag.iconUrl ? _c('img', {
    staticClass: "tag-icon",
    attrs: {
      "src": _vm.tag.iconUrl
    }
  }) : _vm.tag.icon ? _c('font-awesome-icon', {
    staticClass: "tag-icon",
    style: _vm.iconColor,
    attrs: {
      "icon": _vm.tag.icon
    }
  }) : _vm._e(), _c('span', {
    class: {
      'ml-2': _vm.tag.label && _vm.tag.icon || _vm.tag.iconUrl
    }
  }, [_vm._v(_vm._s(_vm.tag.label))]), _c('font-awesome-icon', {
    staticClass: "icon-close",
    attrs: {
      "icon": ['fal', 'times']
    }
  })], 1);
};
var TagInputvue_type_template_id_041942c0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagInput.vue?vue&type=script&lang=js&
/* harmony default export */ var TagInputvue_type_script_lang_js_ = ({
  name: "TagInput",
  props: {
    tag: {
      type: Object,
      default: () => {
        return {
          id: null,
          value: "content",
          type: "type",
          label: undefined.$t("super-search.content"),
          icon: ["fad", "barcode-scan"]
        };
      }
    }
  },
  computed: {
    tagColor() {
      return {
        border: `0.5px solid ${this.tag.color ? this.tag.color : "#ADB5BD"}`,
        background: `${this.tag.color}1A`
      };
    },
    iconColor() {
      return {
        color: this.tag.color
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/TagInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TagInputvue_type_script_lang_js_ = (TagInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagInput.vue?vue&type=style&index=0&id=041942c0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/TagInput.vue?vue&type=style&index=0&id=041942c0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/components/TagInput.vue



;


/* normalize component */

var TagInput_component = normalizeComponent(
  components_TagInputvue_type_script_lang_js_,
  TagInputvue_type_template_id_041942c0_scoped_true_render,
  TagInputvue_type_template_id_041942c0_scoped_true_staticRenderFns,
  false,
  null,
  "041942c0",
  null
  
)

/* harmony default export */ var TagInput = (TagInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagsInputWrapper.vue?vue&type=script&lang=js&

/* harmony default export */ var TagsInputWrappervue_type_script_lang_js_ = ({
  name: "TagsInputWrapper",
  components: {
    TagInput: TagInput
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    tagNumber: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      showMoreTags: false
    };
  },
  computed: {
    shortedTag() {
      return {
        icon: ["fad", "sliders-v"],
        label: `+${this.tagNumber === 1 ? this.tags.length : this.tags.length - 1}`
      };
    },
    firstTags() {
      if (this.tagNumber === 1) return this.tags;
      return this.tags.slice(0, this.tags.length - 1);
    },
    inputTags() {
      if (this.tagNumber === 1 && this.tags.length > 1) {
        return [];
      } else if (this.tags.length > 2) {
        return [this.tags[this.tags.length - 1]];
      } else {
        return this.tags;
      }
    },
    showPopover() {
      return this.showMoreTags && this.firstTags.length;
    }
  },
  watch: {
    tags() {
      if (this.tags.length <= 2) {
        this.showMoreTags = false;
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.showMoreTags = !this.showMoreTags;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/TagsInputWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TagsInputWrappervue_type_script_lang_js_ = (TagsInputWrappervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagsInputWrapper.vue?vue&type=style&index=0&id=63139242&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/TagsInputWrapper.vue?vue&type=style&index=0&id=63139242&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/components/TagsInputWrapper.vue



;


/* normalize component */

var TagsInputWrapper_component = normalizeComponent(
  components_TagsInputWrappervue_type_script_lang_js_,
  TagsInputWrappervue_type_template_id_63139242_scoped_true_render,
  TagsInputWrappervue_type_template_id_63139242_scoped_true_staticRenderFns,
  false,
  null,
  "63139242",
  null
  
)

/* harmony default export */ var TagsInputWrapper = (TagsInputWrapper_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/SearchInput.vue?vue&type=script&lang=js&

/* harmony default export */ var SearchInputvue_type_script_lang_js_ = ({
  name: "SearchInput",
  components: {
    TagsInputWrapper: TagsInputWrapper
  },
  inheritAttrs: false,
  props: {
    value: String,
    placeholder: {
      type: String,
      default() {
        return this.$t("super-search.search-in");
      }
    },
    tags: {
      type: Array,
      default: () => []
    },
    tagNumber: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.focusInput
      };
    }
  },
  methods: {
    updateValue(evt) {
      const value = evt.target.value;
      this.$emit("input", value);
    },
    blurInput() {
      this.focused = false;
      this.$nextTick(() => {
        this.$refs.search.blur();
      });
    },
    focusInput() {
      this.focused = true;
      this.$nextTick(() => {
        const search = this.$refs.search;
        if (!search) return;
        search.focus();
      });
    }
  },
  mounted() {
    this.focusInput();
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/SearchInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SearchInputvue_type_script_lang_js_ = (SearchInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/SearchInput.vue?vue&type=style&index=0&id=0dc06d62&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/SearchInput.vue?vue&type=style&index=0&id=0dc06d62&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/components/SearchInput.vue



;


/* normalize component */

var SearchInput_component = normalizeComponent(
  components_SearchInputvue_type_script_lang_js_,
  SearchInputvue_type_template_id_0dc06d62_scoped_true_render,
  SearchInputvue_type_template_id_0dc06d62_scoped_true_staticRenderFns,
  false,
  null,
  "0dc06d62",
  null
  
)

/* harmony default export */ var SearchInput = (SearchInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/LoaderLine.vue?vue&type=template&id=35f3216e&scoped=true&
var LoaderLinevue_type_template_id_35f3216e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_vm.loading ? _c('div', {
    staticClass: "loading_line_wrapper"
  }, [_vm._m(0)]) : _vm._e()]);
};
var LoaderLinevue_type_template_id_35f3216e_scoped_true_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading_line"
  }, [_c('div', {
    staticClass: "loading_line_inner loading_line_inner--1"
  }), _c('div', {
    staticClass: "loading_line_inner loading_line_inner--2"
  })]);
}];

;// CONCATENATED MODULE: ./src/modules/search/components/LoaderLine.vue?vue&type=template&id=35f3216e&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/LoaderLine.vue?vue&type=script&lang=js&
/* harmony default export */ var LoaderLinevue_type_script_lang_js_ = ({
  name: "LoaderLine",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/LoaderLine.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_LoaderLinevue_type_script_lang_js_ = (LoaderLinevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/LoaderLine.vue?vue&type=style&index=0&id=35f3216e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/LoaderLine.vue?vue&type=style&index=0&id=35f3216e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/components/LoaderLine.vue



;


/* normalize component */

var LoaderLine_component = normalizeComponent(
  components_LoaderLinevue_type_script_lang_js_,
  LoaderLinevue_type_template_id_35f3216e_scoped_true_render,
  LoaderLinevue_type_template_id_35f3216e_scoped_true_staticRenderFns,
  false,
  null,
  "35f3216e",
  null
  
)

/* harmony default export */ var LoaderLine = (LoaderLine_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/SearchFilters.vue?vue&type=template&id=1494cb56&scoped=true&
var SearchFiltersvue_type_template_id_1494cb56_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.display ? _c('div', [_vm.showTypes ? _c('TagsWrapper', {
    staticClass: "mt-2",
    attrs: {
      "label": _vm.$t('super-search.type'),
      "tags": _vm.types,
      "selectedTags": _vm.selectedTags
    },
    on: {
      "select-tag": _vm.handleType
    }
  }) : _vm._e(), _vm.labels.length ? _c('TagsWrapper', {
    staticClass: "mt-2",
    attrs: {
      "label": _vm.$t('super-search.labels'),
      "tags": _vm.labels,
      "selectedTags": _vm.selectedTags
    },
    on: {
      "select-tag": _vm.handleLabel
    }
  }) : _vm._e()], 1) : _vm._e();
};
var SearchFiltersvue_type_template_id_1494cb56_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./src/assets/icons/article-icon-v2.svg
var article_icon_v2 = __webpack_require__(2235);
var article_icon_v2_default = /*#__PURE__*/__webpack_require__.n(article_icon_v2);
// EXTERNAL MODULE: ./src/assets/icons/diag_icon.svg
var diag_icon = __webpack_require__(3320);
var diag_icon_default = /*#__PURE__*/__webpack_require__.n(diag_icon);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagsWrapper.vue?vue&type=template&id=3d9209c4&scoped=true&
var TagsWrappervue_type_template_id_3d9209c4_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.label ? _c('div', {
    staticClass: "label font-bold"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('div', {
    staticClass: "overflow",
    class: {
      'fix-height': !_vm.showMore
    }
  }, [_c('div', {
    ref: "tags",
    staticClass: "flex flex-wrap tags-wrapper"
  }, _vm._l(_vm.tags, function (tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "flex-none p-tag"
    }, [_c('Tag', {
      attrs: {
        "tag": tag,
        "selected": _vm.isSelected(tag.id)
      },
      on: {
        "focus": function ($event) {
          return _vm.$emit('select-tag', tag);
        }
      }
    })], 1);
  }), 0)]), _vm.tagsHeight > _vm.WRAPPER_HEIGHT ? _c('div', {
    staticClass: "label cursor-pointer",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function ($event) {
        _vm.showMore = !_vm.showMore;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showMore ? _vm.$t("super-search.show-less") : _vm.$t("super-search.show-more")) + " ")]) : _vm._e()]);
};
var TagsWrappervue_type_template_id_3d9209c4_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/Tag.vue?vue&type=template&id=a877f1b4&scoped=true&
var Tagvue_type_template_id_a877f1b4_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center tag",
    class: {
      'selected-tag': _vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('focus', _vm.tag);
      }
    }
  }, [_vm.tag.iconUrl ? _c('img', {
    staticClass: "tag-icon",
    attrs: {
      "src": _vm.tag.iconUrl
    }
  }) : _vm.tag.icon ? _c('font-awesome-icon', {
    staticClass: "tag-icon",
    style: _vm.iconColor,
    attrs: {
      "icon": _vm.tag.icon
    }
  }) : _vm._e(), _c('span', {
    class: {
      'ml-2': _vm.tag.label && _vm.tag.icon || _vm.tag.iconUrl
    }
  }, [_vm._v(_vm._s(_vm.tag.label))])], 1);
};
var Tagvue_type_template_id_a877f1b4_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/Tag.vue?vue&type=script&lang=js&
/* harmony default export */ var Tagvue_type_script_lang_js_ = ({
  name: "TagComponent",
  props: {
    tag: {
      type: Object,
      default: () => {
        return {
          id: null,
          value: "content",
          type: "type",
          label: undefined.$t("super-search.content"),
          icon: ["fad", "barcode-scan"]
        };
      }
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconColor() {
      return {
        color: this.tag.color
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/Tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Tagvue_type_script_lang_js_ = (Tagvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/Tag.vue?vue&type=style&index=0&id=a877f1b4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/Tag.vue?vue&type=style&index=0&id=a877f1b4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/components/Tag.vue



;


/* normalize component */

var Tag_component = normalizeComponent(
  components_Tagvue_type_script_lang_js_,
  Tagvue_type_template_id_a877f1b4_scoped_true_render,
  Tagvue_type_template_id_a877f1b4_scoped_true_staticRenderFns,
  false,
  null,
  "a877f1b4",
  null
  
)

/* harmony default export */ var Tag = (Tag_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagsWrapper.vue?vue&type=script&lang=js&

/* harmony default export */ var TagsWrappervue_type_script_lang_js_ = ({
  name: "TagsWrapper",
  components: {
    Tag: Tag
  },
  props: {
    label: String,
    tags: Array,
    selectedTags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showMore: false,
      WRAPPER_HEIGHT: 32,
      tagsHeight: 32
    };
  },
  watch: {
    tags() {
      this.tagsHeight = this.$refs.tags.clientHeight;
    }
  },
  mounted() {
    this.tagsHeight = this.$refs.tags.clientHeight;
  },
  methods: {
    isSelected(tagId) {
      return this.selectedTags.map(t => t.id).includes(tagId);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/TagsWrapper.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TagsWrappervue_type_script_lang_js_ = (TagsWrappervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/TagsWrapper.vue?vue&type=style&index=0&id=3d9209c4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/TagsWrapper.vue?vue&type=style&index=0&id=3d9209c4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/components/TagsWrapper.vue



;


/* normalize component */

var TagsWrapper_component = normalizeComponent(
  components_TagsWrappervue_type_script_lang_js_,
  TagsWrappervue_type_template_id_3d9209c4_scoped_true_render,
  TagsWrappervue_type_template_id_3d9209c4_scoped_true_staticRenderFns,
  false,
  null,
  "3d9209c4",
  null
  
)

/* harmony default export */ var TagsWrapper = (TagsWrapper_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/SearchFilters.vue?vue&type=script&lang=js&






/* harmony default export */ var SearchFiltersvue_type_script_lang_js_ = ({
  components: {
    TagsWrapper: TagsWrapper
  },
  props: {
    selectedTags: {
      type: Array,
      default: () => []
    },
    display: {
      type: Boolean,
      default: true
    },
    showMoreFilters: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      entities: [{
        id: "content",
        key: "entity",
        value: "attached-contents",
        label: this.$t("super-search.content"),
        icon: ["fal", "file-alt"]
      }, {
        id: "product",
        key: "entity",
        value: "new-products",
        label: this.$t("super-search.product"),
        icon: ["fad", "barcode-scan"]
      }],
      chosenEntity: [],
      types: [{
        id: "article",
        key: "type",
        value: "Article",
        label: this.$t("super-search.article"),
        iconUrl: (article_icon_v2_default()),
        color: "#fcbf49"
      }, {
        id: "diagnostic",
        key: "type",
        value: "Diagnostic",
        label: this.$t("super-search.diagnostic"),
        iconUrl: (diag_icon_default()),
        color: "#0081f9"
      }],
      chosenTypes: [],
      status: [{
        id: "draft",
        key: "published",
        value: "false",
        label: this.$t("super-search.draft"),
        icon: ["fas", "ruler-triangle"],
        color: "#adb5bd"
      }, {
        id: "published",
        key: "published",
        value: "true",
        label: this.$t("super-search.published"),
        icon: ["fas", "file-check"],
        color: "#0081f9"
      }, {
        id: "checked",
        key: "isOutdated",
        value: "false",
        label: this.$t("super-search.verified"),
        icon: ["fas", "check-circle"],
        color: "#67c23a"
      }, {
        id: "warning",
        key: "isOutdated",
        value: "true",
        label: this.$t("super-search.to-be-verified"),
        icon: ["fas", "times-circle"],
        color: "#fd0044"
      }],
      chosenStatus: [],
      labels: [],
      chosenLabels: [],
      univers: [],
      chosenUnivers: [],
      families: [],
      chosenFamilies: [],
      brands: [],
      chosenBrands: [],
      isParametric: false,
      hasContributions: false
    };
  },
  computed: {
    showEntities() {
      return !this.chosenEntity.length && this.isParametric;
    },
    showTypes() {
      return (this.chosenEntity.length && this.chosenEntity[0].value === "attached-contents" || !this.isParametric) && !this.chosenTypes.length;
    },
    searchEntity() {
      return this.chosenEntity[0] ? this.chosenEntity[0].value : "";
    },
    newSelectedTags() {
      return [...this.chosenEntity, ...this.chosenTypes, ...this.chosenLabels, ...this.chosenStatus, ...this.chosenUnivers, ...this.chosenFamilies, ...this.chosenBrands];
    }
  },
  watch: {
    async showMoreFilters(show) {
      if (show) {
        this.univers = await this.$services.hierarchies.getHierarchies();
      } else {
        this.univers = [];
        this.families = [];
        this.brands = [];
      }
    },
    selectedTags(tags) {
      this.chosenEntity = tags.filter(t => t.key === "entity");
      this.chosenTypes = tags.filter(t => t.key === "type");
      this.chosenStatus = tags.filter(t => t.key === "published" || t.key === "isOutdated" || t.key === "contribution");
      this.chosenUnivers = tags.filter(t => t.key === "knowledge");
      this.chosenFamilies = tags.filter(t => t.key === "family");
      this.chosenBrands = tags.filter(t => t.key === "brand");
      this.chosenLabels = tags.filter(t => t.key === "categories");
      if (!this.chosenEntity.length && this.isParametric) {
        this.univers = [];
        this.families = [];
        this.brands = [];
        this.labels = [];
      } else if (!this.chosenUnivers.length) {
        this.families = [];
        this.brands = [];
      } else if (!this.chosenFamilies.length) {
        this.brands = [];
      }
    }
  },
  async mounted() {
    if (!this.isParametric) await this.loadLabels();
    if (this.hasContributions) this.status.push({
      id: "contribution",
      key: "contribution",
      value: "true",
      label: "Contributions externes",
      icon: ["fad", "inbox-in"]
    });
  },
  methods: {
    async handleEntity(entity) {
      await this.loadEntityNextLevel(entity);
      this.updateSelectedTags();
    },
    async handleUnivers(univers) {
      const index = this.chosenUnivers.findIndex(u => u.value === univers.value);
      if (index === -1) await this.loadUniversNextLevel(univers);else this.chosenUnivers = [];
      this.updateSelectedTags();
    },
    handleType(type) {
      const index = this.chosenTypes.findIndex(t => t.value === type.value);
      index === -1 ? this.chosenTypes.push(type) : this.chosenTypes.splice(index, 1);
      this.updateSelectedTags();
    },
    handleLabel(label) {
      const index = this.chosenLabels.findIndex(l => l.value === label.value);
      index === -1 ? this.chosenLabels.push(label) : this.chosenLabels.splice(index, 1);
      this.updateSelectedTags();
    },
    handleStatus(status) {
      const index = this.chosenStatus.findIndex(s => s.value === status.value && s.key === status.key);
      index === -1 ? this.chosenStatus.push(status) : this.chosenStatus.splice(index, 1);
      this.updateSelectedTags();
    },
    async handleFamily(family) {
      const index = this.chosenFamilies.findIndex(f => f.value === family.value);
      if (index === -1) {
        family.key = "family";
        this.chosenFamilies.push(family);
      } else {
        this.chosenFamilies.splice(index, 1);
        this.chosenBrands = [];
      }
      await this.loadFamilyNextLevel(this.chosenFamilies);
      this.updateSelectedTags();
    },
    handleBrand(brand) {
      const index = this.chosenBrands.findIndex(b => b.value === brand.value);
      if (index === -1) {
        brand.key = "brand";
        this.chosenBrands.push(brand);
      } else {
        this.chosenBrands.splice(index, 1);
      }
      this.updateSelectedTags();
    },
    async loadEntityNextLevel(entity) {
      this.chosenEntity = [entity];
      if (entity.value === "new-products") {
        this.univers = await this.$services.hierarchies.getHierarchies();
      } else {
        await this.loadLabels();
      }
    },
    async loadUniversNextLevel(univers) {
      this.chosenUnivers = [univers];
      const families = await this.$services.hierarchies.getAggregatedOptions(this.chosenUnivers[0].value);
      this.families = families.map(f => {
        f.key = "family";
        return f;
      });
    },
    async loadFamilyNextLevel(families) {
      const familiesValues = families.map(family => {
        return family.value;
      });
      const brands = await this.$services.hierarchies.getAggregatedOptions(familiesValues);
      this.brands = brands.map(b => {
        b.key = "brand";
        return b;
      });
    },
    async loadLabels() {
      const labels = await this.getContentParameterLabels();
      this.labels = labels.map(label => {
        label.key = "categories";
        label.label = label.labelName;
        label.value = label.id;
        return label;
      });
      if (this.labels.length) {
        this.labels.unshift({
          id: "none",
          key: "categories",
          label: "Pas de label",
          value: null,
          icon: ["fad", "tag"]
        });
      }
    },
    updateSelectedTags() {
      this.$emit("update-selected-tags", this.newSelectedTags);
    },
    enrichTags() {
      const filters = [...this.entities, ...this.types, ...this.status, ...this.labels, ...this.univers, ...this.families, ...this.brands];
      return this.newSelectedTags.reduce((acc, tag) => {
        const newTag = filters.find(f => f.key === tag.key && f.value === tag.value);
        if (newTag) acc.push(newTag);
        return acc;
      }, []);
    },
    async initTags(preTags) {
      this.chosenEntity = [];
      this.chosenTypes = [];
      this.chosenStatus = [];
      this.labels = [];
      this.chosenLabels = [];
      this.univers = [];
      this.chosenUnivers = [];
      this.families = [];
      this.chosenFamilies = [];
      this.brands = [];
      this.chosenBrands = [];
      const entity = preTags.find(t => t.key === "entity");
      if (entity) {
        await this.loadEntityNextLevel(entity);
      }
      const univers = preTags.find(t => t.key === "knowledge");
      if (univers) {
        if (!this.univers.length) {
          this.univers = await this.$services.hierarchies.getHierarchies();
        }
        await this.loadUniversNextLevel(univers);
      }
      const families = preTags.filter(t => t.key === "family");
      if (families.length) {
        this.chosenFamilies = families;
        await this.loadFamilyNextLevel(families);
      }
      const labels = preTags.filter(t => t.key === "categories");
      if (labels.length) {
        this.chosenLabels = labels;
        await this.loadLabels();
      }
      this.chosenEntity = preTags.filter(t => t.key === "entity");
      this.chosenTypes = preTags.filter(t => t.key === "type");
      this.chosenStatus = preTags.filter(t => t.key === "published" || t.key === "isOutdated");
      this.chosenBrands = preTags.filter(t => t.key === "brand");
      return this.enrichTags();
    },
    ...mapActions("searchModule", ["getContentParameterLabels"])
  }
});
;// CONCATENATED MODULE: ./src/modules/search/components/SearchFilters.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SearchFiltersvue_type_script_lang_js_ = (SearchFiltersvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/components/SearchFilters.vue?vue&type=style&index=0&id=1494cb56&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/components/SearchFilters.vue?vue&type=style&index=0&id=1494cb56&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/search/components/SearchFilters.vue



;


/* normalize component */

var SearchFilters_component = normalizeComponent(
  components_SearchFiltersvue_type_script_lang_js_,
  SearchFiltersvue_type_template_id_1494cb56_scoped_true_render,
  SearchFiltersvue_type_template_id_1494cb56_scoped_true_staticRenderFns,
  false,
  null,
  "1494cb56",
  null
  
)

/* harmony default export */ var SearchFilters = (SearchFilters_component.exports);
;// CONCATENATED MODULE: ./src/utils/whitelist.ts
/* harmony default export */ var whitelist = ({
  whitelist: ["zendesk", "intercom", "frontapp", "app.crisp", "mail.google", "getmayday"]
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/Search.vue?vue&type=script&lang=js&







const SEARCH_ENTITIES = ["Case", "Article", "Diagnostic", "keyStep"];
/* harmony default export */ var Searchvue_type_script_lang_js_ = ({
  name: "SuperSearch",
  components: {
    SearchInput: SearchInput,
    LoaderLine: LoaderLine,
    SearchFilters: SearchFilters
  },
  props: {
    focusKnowledge: {
      type: Object,
      default: () => ({})
    },
    isSearchNoSteps: {
      type: Boolean,
      default: true
    },
    hostApp: {
      type: String,
      default: "chome-extension"
    },
    customWidth: {
      type: Number,
      default: 400
    },
    focusEntity: {
      type: Object,
      default: null
    },
    modalEntity: {
      type: Object,
      default: null
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFilters: false,
      searchInputFilter: "",
      selectedTags: [],
      loading: false,
      results: [],
      totalHits: 0,
      correlationId: "",
      debounceSearchFilters: lodash_debounce_default()(() => {
        this.superSearch();
      }, 200),
      hovered: -1,
      sizeCursor: 7
    };
  },
  computed: {
    tagNumber() {
      return this.customWidth <= 400 ? 1 : 2;
    },
    filtersAndResultsDisplayed() {
      return this.showFilters && (this.results.length || this.searchInProgress);
    },
    preFilters() {
      return this.selectedTags.reduce((acc, tag) => {
        if (tag.key !== "entity") {
          if (acc[tag.key]) {
            acc[tag.key].push(tag.value);
          } else {
            acc[tag.key] = [tag.value];
          }
        }
        return acc;
      }, {});
    },
    entityType() {
      return this.preFilters.type || null;
    },
    labels() {
      return this.preFilters.categories || [];
    },
    searchInProgress() {
      return this.selectedTags.length > 0 || this.searchInputFilter !== "";
    },
    searchFilters() {
      const knowledgeId = this.focusKnowledge.value;
      return {
        knowledgeId,
        entitiesType: this.entityType || [...SEARCH_ENTITIES, ...(this.isSearchNoSteps ? [] : ["Step"])],
        correlationId: this.correlationId
      };
    },
    hasMore() {
      return this.sizeCursor < this.totalHits;
    },
    labelSearchedIds() {
      return this.selectedTags.reduce((acc, tag) => {
        if (tag.key === "categories") acc.push(tag.id);
        return acc;
      }, []);
    }
  },
  watch: {
    searchInputFilter() {
      this.handleSearch();
    },
    selectedTags() {
      this.handleSearch();
    },
    sizeCursor() {
      this.handleSearch();
    }
  },
  created() {
    this.generateCorrelationId();
    this.$on("hover", value => this.handleHover(value));
    this.$on("go-to-document", doc => this.selectResult(doc));
    this.$on("display-more", () => this.handleMore());
  },
  beforeDestroy() {
    this.debounceSearchFilters.flush();
  },
  methods: {
    ...mapActions("searchModule", ["knowledgeSearchAction"]),
    handleMore() {
      if (this.totalHits < this.sizeCursor + 10) {
        this.sizeCursor = this.totalHits;
        return;
      }
      this.sizeCursor += 10;
    },
    updateTags(tags) {
      this.selectedTags = tags;
      this.$refs.input.focusInput();
    },
    deleteTag(tag) {
      let tags = [...this.selectedTags];
      const index = tags.findIndex(t => t.id === tag.id && t.key === tag.key);
      tags.splice(index, 1);
      if (tag.key === "entity") {
        tags = [];
      } else if (tag.key === "knowledge") {
        tags = tags.filter(t => t.key === "entity");
      } else if (tag.key === "family") {
        tags = tags.filter(t => t.key === "entity" || t.key === "knowledge");
      }
      this.updateTags(tags);
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      this.$refs.input.focusInput();
    },
    handleKeyUp(e) {
      if (e.key === "Enter" && this.hovered >= 0 && this.hovered <= this.results.length) {
        e.preventDefault();
        const document = this.results[this.hovered];
        this.selectResult(document);
      } else if (e.key === "ArrowUp") {
        this.hovered = this.hovered > 0 ? this.hovered - 1 : this.results.length - 1;
      } else if (e.key === "ArrowDown") {
        this.hovered = this.hovered < this.results.length - 1 ? this.hovered + 1 : 0;
      } else if (e.key === "Escape") {
        this.onDelete();
      }
      e.stopPropagation();
    },
    handleHover(value) {
      this.hovered = value;
    },
    async superSearch() {
      try {
        const searchEvent = this.getSearchEvent();
        const res = await this.knowledgeSearchAction({
          queryText: this.searchInputFilter,
          correlationId: this.correlationId,
          searchFilters: this.searchFilters,
          categories: this.labels,
          size: this.sizeCursor,
          lang: this.focusKnowledge.defaultLanguage
        });
        this.results = res.documents;
        this.totalHits = res.counts.totalCount;
        this.recordSearchInput(searchEvent);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    handleSearch() {
      if (this.searchInProgress) {
        this.loading = true;
        this.debounceSearchFilters();
      } else {
        this.results = [];
        this.totalHits = 0;
        this.sizeCursor = 7;
      }
    },
    getSearchEvent() {
      const url = window.location.href;
      const match = whitelist.whitelist.filter(o => url.includes(o));
      const source = match.length ? url : "";
      return {
        filterType: ["attached-contents", "cases"],
        entityType: this.entityType,
        search: this.searchInputFilter,
        query: this.searchInputFilter,
        knowledge: this.focusKnowledge.value,
        knowledgeId: this.focusKnowledge.id,
        correlationId: this.correlationId,
        product: null,
        cases: null,
        status: [{
          key: "published",
          value: true
        }],
        accessRestrictions: null,
        labels: this.labels,
        isContribution: null,
        searchFrom: 0,
        size: 10,
        focusEntity: this.focusEntity,
        modalEntity: this.modalEntity,
        source
      };
    },
    getEvent(searchEvent) {
      return {
        search: searchEvent,
        displayedHits: this.results.length,
        totalHits: this.totalHits
      };
    },
    recordSearchInput(searchEvent) {
      this.$emit("log-event", {
        topic: "CONTENT_SEARCH",
        url: window.location.href,
        event: this.getEvent(searchEvent)
      });
    },
    onDelete() {
      this.onClickOutside();
      this.$refs.input.focusInput();
    },
    onClickOutside() {
      if (this.searchInProgress) this.triggerAbortSearch();
      this.resetSearch();
    },
    resetSearch() {
      this.searchInputFilter = "";
      this.selectedTags = [];
      this.results = [];
      this.showFilters = false;
      this.hovered = -1;
      this.sizeCursor = 7;
      this.totalHits = 0;
      this.$refs.input.blurInput();
    },
    triggerAbortSearch() {
      this.$emit("log-event", {
        topic: "CONTENT_SEARCH_ABORT",
        event: this.getEvent(this.getSearchEvent()),
        url: window.location.href
      });
      this.generateCorrelationId();
    },
    generateCorrelationId() {
      this.correlationId = `${this.hostApp}-${Math.random().toString(36).slice(2)}`;
    },
    selectResult(hit) {
      this.$emit("select-result", {
        ...hit,
        searchInput: this.searchInputFilter
      });
      this.$emit("log-event", {
        topic: "CONTENT_SEARCH_SUCCESS",
        event: {
          ...this.getEvent(this.getSearchEvent()),
          content: hit
        },
        url: window.location.href
      });
      this.resetSearch();
      this.generateCorrelationId();
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/Search.vue?vue&type=script&lang=js&
 /* harmony default export */ var search_Searchvue_type_script_lang_js_ = (Searchvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/Search.vue?vue&type=style&index=0&id=6e1a0e86&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/Search.vue?vue&type=style&index=0&id=6e1a0e86&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/Search.vue



;


/* normalize component */

var Search_component = normalizeComponent(
  search_Searchvue_type_script_lang_js_,
  Searchvue_type_template_id_6e1a0e86_scoped_true_render,
  Searchvue_type_template_id_6e1a0e86_scoped_true_staticRenderFns,
  false,
  null,
  "6e1a0e86",
  null
  
)

/* harmony default export */ var Search = (Search_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/SearchResults.vue?vue&type=template&id=1f77b196&scoped=true&
var SearchResultsvue_type_template_id_1f77b196_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.results.length || _vm.searchInProgress ? _c('div', [_c('div', {
    staticClass: "search-suggestions"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("super-search.suggestions")) + " ")]), _vm.results.length ? _c('div', [_vm._l(_vm.results, function (result, index) {
    return _c('div', {
      key: result.id
    }, [_c('ResultItem', {
      attrs: {
        "hovered": index === _vm.hovered,
        "item": result,
        "labelSearchedIds": _vm.labelSearchedIds
      },
      on: {
        "go-to-document": function ($event) {
          return _vm.$parent.$emit('go-to-document', result);
        },
        "toggle-favorite": function ($event) {
          return _vm.$emit('toggle-favorite', $event);
        },
        "copy-link": function ($event) {
          return _vm.$emit('copy-link', $event);
        },
        "open-in-web": function ($event) {
          return _vm.$emit('open-in-web', $event);
        }
      },
      nativeOn: {
        "mouseenter": function ($event) {
          return _vm.$parent.$emit('hover', index);
        },
        "mouseleave": function ($event) {
          return _vm.$parent.$emit('hover', -1);
        }
      }
    })], 1);
  }), _vm.hasMore || _vm.loading ? _c('div', {
    staticClass: "display-more-wrapper"
  }, [_c('base-button', {
    staticClass: "display-more",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$parent.$emit('display-more');
      }
    }
  }, [_vm.loading ? _c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', 'spinner'],
      "spin": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("notifications.get-more")) + " ")], 1)], 1) : _vm._e()], 2) : _c('div', {
    staticClass: "empty-state"
  }, [_vm.loading ? _c('font-awesome-icon', {
    staticClass: "icon-spinner",
    attrs: {
      "icon": ['fas', 'spinner-third'],
      "spin": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.$t("super-search.empty-state")))])], 1)])]) : _vm._e();
};
var SearchResultsvue_type_template_id_1f77b196_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseButton.vue?vue&type=template&id=d2896a4a&scoped=true&
var BaseButtonvue_type_template_id_d2896a4a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.tag, {
    tag: "component",
    staticClass: "md-btn",
    class: _vm.classes,
    attrs: {
      "type": _vm.tag === 'button' ? _vm.nativeType : ''
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.$slots.icon || _vm.icon && _vm.$slots.default ? _c('span', {
    staticClass: "md-btn-inner--icon"
  }, [_vm._t("md-icon", function () {
    return [_c('i', {
      class: _vm.icon
    })];
  })], 2) : _vm._e(), !_vm.$slots.default ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm.$slots.icon || _vm.icon && _vm.$slots.default ? _c('span', {
    staticClass: "md-btn-inner--text"
  }, [_vm._t("default", function () {
    return [_vm._v(" " + _vm._s(_vm.text) + " ")];
  })], 2) : _vm._e(), !_vm.$slots.icon && !_vm.icon ? _vm._t("default") : _vm._e()], 2);
};
var BaseButtonvue_type_template_id_d2896a4a_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseButton.vue?vue&type=script&lang=js&

/* harmony default export */ var BaseButtonvue_type_script_lang_js_ = ({
  name: "base-button",
  props: {
    tag: {
      type: String,
      default: "button",
      description: "Button tag (default -> button)"
    },
    type: {
      type: String,
      default: "default",
      description: "Button type (e,g primary, danger etc)"
    },
    size: {
      type: String,
      default: "",
      description: "Button size lg|sm"
    },
    textColor: {
      type: String,
      default: "",
      description: "Button text color (e.g primary, danger etc)"
    },
    nativeType: {
      type: String,
      default: "button",
      description: "Button native type (e.g submit,button etc)"
    },
    icon: {
      type: String,
      default: "",
      description: "Button icon"
    },
    text: {
      type: String,
      default: "",
      description: "Button text in case not provided via default slot"
    },
    outline: {
      type: Boolean,
      default: false,
      description: "Whether button style is outline"
    },
    rounded: {
      type: Boolean,
      default: false,
      description: "Whether button style is rounded"
    },
    iconOnly: {
      type: Boolean,
      default: false,
      description: "Whether button contains only an icon"
    },
    block: {
      type: Boolean,
      default: false,
      description: "Whether button is of block type"
    }
  },
  computed: {
    classes() {
      const btnClasses = [{
        "btn-block": this.block
      }, {
        "rounded-circle": this.rounded
      }, {
        "btn-icon-only": this.iconOnly
      }, {
        [`text-${this.textColor}`]: this.textColor
      }, {
        "btn-icon": this.icon || this.$slots.icon
      }, this.type && !this.outline ? `btn-${this.type}` : "", this.outline ? `btn-outline-${this.type}` : ""];
      if (this.size) {
        btnClasses.push(`btn-${this.size}`);
      }
      return btnClasses;
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
    }
  }
});
;// CONCATENATED MODULE: ./src/library/BaseButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_BaseButtonvue_type_script_lang_js_ = (BaseButtonvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseButton.vue?vue&type=style&index=0&id=d2896a4a&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseButton.vue?vue&type=style&index=0&id=d2896a4a&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/library/BaseButton.vue



;


/* normalize component */

var BaseButton_component = normalizeComponent(
  library_BaseButtonvue_type_script_lang_js_,
  BaseButtonvue_type_template_id_d2896a4a_scoped_true_render,
  BaseButtonvue_type_template_id_d2896a4a_scoped_true_staticRenderFns,
  false,
  null,
  "d2896a4a",
  null
  
)

/* harmony default export */ var BaseButton = (BaseButton_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ResultItem.vue?vue&type=template&id=650b0d5e&scoped=true&
var ResultItemvue_type_template_id_650b0d5e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative flex items-start suggestion-item",
    class: {
      'bachground-grey': _vm.hovered,
      'is-hovered': _vm.hovered
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-document', _vm.item);
      },
      "mouseleave": function ($event) {
        return _vm.toggleTooltip(false);
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.tooltipActive ? _c('div', {
    staticClass: "action-tooltip"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e()]), _c('div', {
    class: [{
      marker: _vm.hovered
    }, _vm.markerColor]
  }), _c('div', {
    staticClass: "pr-2 overflow w-full"
  }, [_c('div', {
    ref: "control",
    staticClass: "flex justify-between items-center gap-2"
  }, [_c('div', {
    staticClass: "flex items-center gap-2 overflow"
  }, [_vm.isArticle ? _c('img', {
    staticClass: "icon mr-2",
    attrs: {
      "src": __webpack_require__(2235)
    }
  }) : _vm.isDiag ? _c('img', {
    staticClass: "icon mr-2",
    attrs: {
      "src": __webpack_require__(3320)
    }
  }) : _vm.isStep ? _c('font-awesome-icon', {
    staticClass: "icon text-blue fa-rotate-90 mr-2",
    attrs: {
      "icon": ['fas', 'level-up']
    }
  }) : _vm.isKeyStep ? _c('font-awesome-icon', {
    staticClass: "icon text-blue mr-2",
    attrs: {
      "icon": ['fad', 'key']
    }
  }) : _vm.isProduct ? _c('font-awesome-icon', {
    staticClass: "icon text-black mr-2",
    attrs: {
      "icon": ['fad', 'barcode-scan']
    }
  }) : _vm.isCase ? _c('font-awesome-icon', {
    staticClass: "icon mr-2",
    attrs: {
      "icon": ['fad', 'folder']
    }
  }) : _vm._e(), _c('div', {
    staticClass: "label",
    on: {
      "mouseover": function ($event) {
        return _vm.toggleTooltip(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")])], 1), _c('div', {
    staticClass: "flex-none"
  }, [_c('ContentActions', {
    staticClass: "content-actions",
    attrs: {
      "content-id": _vm.item.id,
      "options": _vm.options,
      "summary-opened": _vm.summaryExpanded
    },
    on: {
      "copy-link": function ($event) {
        return _vm.$emit('copy-link', _vm.item.id);
      },
      "open-in-web": function ($event) {
        return _vm.$emit('open-in-web', _vm.item.id);
      },
      "toggle-summary": _vm.toggleSummary
    }
  })], 1)]), _vm.hasSummary ? _c('div', {
    class: ['summary-container', {
      expanded: _vm.summaryExpanded
    }]
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.summary) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "middle-ellipsis flex mb-1"
  }, [_c('div', {
    ref: "breadcrumb",
    staticClass: "sized-breadcrumb"
  }, [_vm._v(_vm._s(_vm.breadcrumb))])]), _vm.item.labels && _vm.item.labels.length ? _c('div', {
    staticClass: "flex items-center"
  }, [_c('ContentListItemFullLabelWrapper', {
    attrs: {
      "labelSearchedIds": _vm.labelSearchedIds,
      "labels": _vm.item.labels
    }
  })], 1) : _vm._e()])], 1);
};
var ResultItemvue_type_template_id_650b0d5e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/library/ListItem/ResultItem.vue?vue&type=template&id=650b0d5e&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ResultItem.vue?vue&type=script&lang=js&



/* harmony default export */ var ResultItemvue_type_script_lang_js_ = ({
  name: "ResultItem",
  components: {
    ContentActions: ContentActions,
    ContentListItemFullLabelWrapper: ContentListItemFullLabelWrapper
  },
  props: {
    item: Object,
    hovered: {
      type: Boolean,
      default: false
    },
    labelSearchedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      breadcrumbItems: [],
      tooltipActive: false,
      summaryExpanded: false,
      options: {
        favorite: false,
        copy: true,
        open: true,
        summary: false
      }
    };
  },
  created() {
    this.options.summary = this.hasSummary;
  },
  computed: {
    isProduct() {
      return this.item.__typename === "Product";
    },
    isArticle() {
      return this.item.__typename === "Content" && this.item.type === "Article";
    },
    isDiag() {
      return this.item.__typename === "Content" && this.item.type === "Diagnostic";
    },
    isStep() {
      return this.item.__typename === "Content" && this.item.type === "Step";
    },
    isKeyStep() {
      return this.item.__typename === "Content" && this.item.type === "keyStep";
    },
    isCase() {
      return this.item.__typename === "Case";
    },
    markerColor() {
      if (this.isProduct) return "bg-black";else if (this.isCase) return "bg-grey";else if (this.isArticle) return "bg-yellow";
      return "bg-blue";
    },
    label() {
      return this.isProduct ? this.item.reference : this.item.label;
    },
    breadcrumb() {
      return this.breadcrumbItems.join(" > ");
    },
    hasSummary() {
      return this.item.summary && this.item.summary.isVisible && this.item.summary.body && this.item.summary.body.length || this.item.shortSummary && this.item.shortSummary.isVisible && this.item.shortSummary.body && this.item.shortSummary.body.length;
    },
    summary() {
      if (this.item.summary && this.item.summary.isVisible && this.item.summary.body.length) {
        return this.item.summary.body;
      } else if (this.item.shortSummary && this.item.shortSummary.isVisible && this.item.shortSummary.body.length) {
        return this.item.shortSummary.body;
      }
      return null;
    },
    ...mapGetters("searchModule", ["itemIsFavorite"])
  },
  methods: {
    toggleTooltip(open) {
      const ellipsis = this.$refs.control.scrollWidth > this.$refs.control.clientWidth;
      if (open && ellipsis) {
        this.tooltipActive = true;
        return;
      }
      this.tooltipActive = false;
    },
    toggleSummary() {
      this.summaryExpanded = !this.summaryExpanded;
    }
  },
  watch: {
    breadcrumbItems() {
      this.$nextTick(() => {
        const controlWidth = this.$refs.control.clientWidth;
        const breadcrumbWidth = this.$refs.breadcrumb.clientWidth;
        if (controlWidth < breadcrumbWidth && this.breadcrumbItems.length > 2) {
          const number = this.breadcrumbItems[1] === "..." ? 2 : 1;
          this.breadcrumbItems.splice(1, number, "...");
        }
      });
    }
  },
  mounted() {
    this.breadcrumbItems = this.item.breadcrumb;
  }
});
;// CONCATENATED MODULE: ./src/library/ListItem/ResultItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var ListItem_ResultItemvue_type_script_lang_js_ = (ResultItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/ListItem/ResultItem.vue?vue&type=style&index=0&id=650b0d5e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/ListItem/ResultItem.vue?vue&type=style&index=0&id=650b0d5e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/ListItem/ResultItem.vue



;


/* normalize component */

var ResultItem_component = normalizeComponent(
  ListItem_ResultItemvue_type_script_lang_js_,
  ResultItemvue_type_template_id_650b0d5e_scoped_true_render,
  ResultItemvue_type_template_id_650b0d5e_scoped_true_staticRenderFns,
  false,
  null,
  "650b0d5e",
  null
  
)

/* harmony default export */ var ResultItem = (ResultItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/SearchResults.vue?vue&type=script&lang=js&


/* harmony default export */ var SearchResultsvue_type_script_lang_js_ = ({
  name: "SearchResults",
  components: {
    BaseButton: BaseButton,
    ResultItem: ResultItem
  },
  props: {
    results: {
      type: Array,
      default: () => []
    },
    hovered: {
      type: Number,
      default: -1
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    searchInProgress: {
      type: Boolean,
      default: false
    },
    labelSearchedIds: {
      type: Array,
      default: () => []
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/search/SearchResults.vue?vue&type=script&lang=js&
 /* harmony default export */ var search_SearchResultsvue_type_script_lang_js_ = (SearchResultsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/search/SearchResults.vue?vue&type=style&index=0&id=1f77b196&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/search/SearchResults.vue?vue&type=style&index=0&id=1f77b196&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/search/SearchResults.vue



;


/* normalize component */

var SearchResults_component = normalizeComponent(
  search_SearchResultsvue_type_script_lang_js_,
  SearchResultsvue_type_template_id_1f77b196_scoped_true_render,
  SearchResultsvue_type_template_id_1f77b196_scoped_true_staticRenderFns,
  false,
  null,
  "1f77b196",
  null
  
)

/* harmony default export */ var SearchResults = (SearchResults_component.exports);
;// CONCATENATED MODULE: ./src/modules/search/index.ts




const searchPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "searchModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      knowledgeClient
    } = options;
    if (!store.hasModule(STORE_MODULE_NAME)) {
      store.registerModule(STORE_MODULE_NAME, searchStore, {
        preserveState: false
      });
    }
    if (knowledgeClient) {
      store.$searchService = attachSearchService(knowledgeClient);
    }
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) {
            options.i18n.mergeLocaleMessage(locale, locales(key));
          }
        }
      });
    }
    Vue.component("super-search", Search);
    Vue.component("search-results", SearchResults);
  }
};
const SearchModule = {
  plugin: searchPlugin,
  store: searchStore,
  attachService: attachSearchService
};
;// CONCATENATED MODULE: ./src/modules/modal/store/mutation-types.ts
const store_mutation_types_LOGOUT = "LOGOUT";
// Modal Content Mutations
const UPDATE_MODAL_CONTENT = "UPDATE_MODAL_CONTENT";
const UPDATE_MODAL_TYPE = "UPDATE_MODAL_TYPE";
const CLOSE_MODAL = "CLOSE_MODAL";
const UPDATE_LIGHTBOX = "UPDATE_LIGHTBOX";
const KEEP_MODAL_OPEN = "KEEP_MODAL_OPEN";
;// CONCATENATED MODULE: ./src/modules/modal/store/actions.ts

/* harmony default export */ var modal_store_actions = ({
  logout({
    commit
  }) {
    commit(store_mutation_types_LOGOUT);
  },
  openModal({
    commit
  }, {
    content,
    modalType
  }) {
    commit(UPDATE_MODAL_CONTENT, content);
    commit(UPDATE_MODAL_TYPE, modalType);
  },
  closeModal({
    commit
  }) {
    commit(CLOSE_MODAL);
  },
  toggleLightBox({
    commit
  }, imageUrl) {
    commit(UPDATE_LIGHTBOX, imageUrl);
  },
  forceModalOpen({
    commit
  }, bool) {
    commit(KEEP_MODAL_OPEN, bool);
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/store/getters.ts
const store_getters_getters = {
  showModal: state => state.showModal,
  showLightbox: state => state.lightBoxImageUrl,
  modalType: state => state.modalType,
  modalContent: state => state.modalContent,
  modalComponent: state => {
    const modalType = state.modalType;
    switch (modalType) {
      case "article":
        return "ArticleModal";
      case "answer":
        return "AnswerModal";
      case "zoom":
        return "ZoomModal";
      default:
        return null;
    }
  },
  keepModalOpen: state => state.keepModalOpen
};
/* harmony default export */ var modal_store_getters = (store_getters_getters);
;// CONCATENATED MODULE: ./src/modules/modal/store/state.ts
const modal_store_state_state = () => ({
  showModal: false,
  modalType: null,
  modalContent: {},
  lightBoxImageUrl: "",
  keepModalOpen: false
});
;// CONCATENATED MODULE: ./src/modules/modal/store/mutations.ts


/* harmony default export */ var modal_store_mutations = ({
  [store_mutation_types_LOGOUT](state) {
    Object.assign(state, modal_store_state_state());
  },
  [UPDATE_MODAL_CONTENT](state, payload) {
    state.modalContent = payload;
  },
  [UPDATE_MODAL_TYPE](state, payload) {
    state.modalType = payload;
  },
  [CLOSE_MODAL](state) {
    state.modalContent = {};
    state.modalType = null;
  },
  [UPDATE_LIGHTBOX](state, imageUrl) {
    state.lightBoxImageUrl = imageUrl;
  },
  [KEEP_MODAL_OPEN](state, bool) {
    state.keepModalOpen = bool;
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/store/index.ts




const modalStore = {
  namespaced: true,
  state: modal_store_state_state,
  getters: modal_store_getters,
  actions: modal_store_actions,
  mutations: modal_store_mutations
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/AnswerModal.vue?vue&type=template&id=08c75e48&scoped=true&
var AnswerModalvue_type_template_id_08c75e48_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('modal-layout', {
    attrs: {
      "id": "answer-modal",
      "title": _vm.content.label,
      "focus-type": "answer"
    },
    on: {
      "close": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "sidebar",
      fn: function () {
        return [_c('AnswerModalSidebar', {
          attrs: {
            "is-favorite": false
          },
          on: {
            "click:copy": _vm.copyBody,
            "click:feedback": function ($event) {
              return _vm.$emit('click:feedback');
            },
            "click:action": _vm.handleActionsMessage
          }
        })];
      },
      proxy: true
    }, {
      key: "main-body",
      fn: function () {
        return [_vm._t("default", null, {
          "copyDoneMx": _vm.copyDoneMx
        })];
      },
      proxy: true
    }], null, true)
  });
};
var AnswerModalvue_type_template_id_08c75e48_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/utils/copyCommand.js
const selectText = (document, window, element) => {
  let range;
  if (document.selection) {
    // IE
    range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  } else if (window.getSelection) {
    range = document.createRange();
    range.selectNode(element);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
  }
};
/* harmony default export */ function copyCommand(document, window, element) {
  selectText(document, window, element);
  document.execCommand("copy");
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
}
;// CONCATENATED MODULE: ./src/modules/modal/mixins/modalMixins.js



const MODAL_TOAST_DELAY = 2000;
/* harmony default export */ var modalMixins = ({
  data() {
    return {
      copyDoneMx: {
        body: false,
        link: false
      },
      shadowRoot: getShadowRoot()
    };
  },
  computed: {
    ...mapGetters("modalModule", ["modalType"]),
    copyCommandEnable() {
      if (!this.config) return false;
      return this.modalType === "answer" && this.config.hasAnswerCopyPasteShortcut || this.modalType === "article" && this.config.hasArticleCopyPasteShortcut;
    }
  },
  mounted() {
    document.addEventListener("keydown", this.keyboardCommands);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyboardCommands);
  },
  methods: {
    keyboardCommands(e) {
      if (this.copyCommandEnable) {
        if (e.key === "c" && (e.ctrlKey || e.metaKey)) {
          this.copyBody();
        }
      }
      if (this.config && this.config.hasModalClosureShortcut) {
        if (e.key === "Escape" && (e.ctrlKey || e.metaKey)) {
          this.$emit("close");
        }
      }
    },
    copyBody() {
      const doc = this.shadowRoot ? this.shadowRoot : document;
      const element = doc.getElementById("mayday-comment-body");
      const modalManager = doc.getElementById("modal-manager");
      if (element) {
        // createRange keep background color wrapper
        // toggle transparent background during copy
        modalManager.style.backgroundColor = "transparent";
        copyCommand(document, window, element);
        modalManager.style.backgroundColor = "white";
        this.copyDoneMx.body = true;
        setTimeout(() => {
          this.copyDoneMx.body = false;
        }, MODAL_TOAST_DELAY);
      }
    },
    copyLink(link) {
      navigator.clipboard.writeText(link);
      this.copyDoneMx.link = true;
      setTimeout(() => {
        this.copyDoneMx.link = false;
      }, MODAL_TOAST_DELAY);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalLayout.vue?vue&type=template&id=49688ff5&scoped=true&
var ModalLayoutvue_type_template_id_49688ff5_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "row no-side-margin hosting-row"
  }, [_c('div', {
    staticClass: "left-bar"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('img', {
    staticClass: "main-icon",
    attrs: {
      "src": _vm.icon
    }
  })]), _c('hr', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "col option-selection"
  }, [_vm._t("sidebar")], 2)]), _c('div', {
    staticClass: "container main-container",
    attrs: {
      "id": "modal-container"
    }
  }, [_c('div', {
    staticClass: "row title-row no-side-margin"
  }, [_c('div', {
    staticClass: "col-10 d-flex justify-content-center flex-column"
  }, [_c('h2', {
    staticClass: "text-left mb-0"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "modal-info"
  }, [_vm._t("modal-info")], 2)]), _c('div', {
    staticClass: "col d-flex cross-wrapper"
  }, [_c('a', {
    staticClass: "col d-flex justify-content-center",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": __webpack_require__(3298)
    }
  })])])]), _vm._t("main-body")], 2)])]);
};
var ModalLayoutvue_type_template_id_49688ff5_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/library/Modal/ModalLayout.vue?vue&type=template&id=49688ff5&scoped=true&

// EXTERNAL MODULE: ./src/assets/icons/diag-icon.svg
var icons_diag_icon = __webpack_require__(6520);
var icons_diag_icon_default = /*#__PURE__*/__webpack_require__.n(icons_diag_icon);
// EXTERNAL MODULE: ./src/assets/icons/article_icon.png
var article_icon = __webpack_require__(4687);
// EXTERNAL MODULE: ./src/assets/icons/zoom-icon.svg
var zoom_icon = __webpack_require__(9171);
var zoom_icon_default = /*#__PURE__*/__webpack_require__.n(zoom_icon);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalLayout.vue?vue&type=script&lang=js&



/* harmony default export */ var ModalLayoutvue_type_script_lang_js_ = ({
  name: "ModalLayout",
  props: {
    title: {
      type: String,
      default: ""
    },
    focusType: {
      type: String,
      default: "article"
    }
  },
  computed: {
    icon() {
      switch (this.focusType) {
        case "answer":
          return (icons_diag_icon_default());
        case "zoom":
          return (zoom_icon_default());
        default:
          return article_icon;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Modal/ModalLayout.vue?vue&type=script&lang=js&
 /* harmony default export */ var Modal_ModalLayoutvue_type_script_lang_js_ = (ModalLayoutvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalLayout.vue?vue&type=style&index=0&id=49688ff5&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Modal/ModalLayout.vue?vue&type=style&index=0&id=49688ff5&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/library/Modal/ModalLayout.vue



;


/* normalize component */

var ModalLayout_component = normalizeComponent(
  Modal_ModalLayoutvue_type_script_lang_js_,
  ModalLayoutvue_type_template_id_49688ff5_scoped_true_render,
  ModalLayoutvue_type_template_id_49688ff5_scoped_true_staticRenderFns,
  false,
  null,
  "49688ff5",
  null
  
)

/* harmony default export */ var ModalLayout = (ModalLayout_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/AnswerModalSidebar.vue?vue&type=template&id=507f13c4&
var AnswerModalSidebarvue_type_template_id_507f13c4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "article-modal-sidebar"
  }, [_c('ModalSidebarOption', {
    attrs: {
      "icon": "copy"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:copy');
      }
    }
  }), _vm.canTriggerAction ? _c('div', [_c('ModalSidebarDivider'), _c('ModalSidebarOption', {
    attrs: {
      "icon": "rocket-launch"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:action');
      }
    }
  })], 1) : _vm._e()], 1);
};
var AnswerModalSidebarvue_type_template_id_507f13c4_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalSidebarDivider.vue?vue&type=template&id=62249560&scoped=true&
var ModalSidebarDividervue_type_template_id_62249560_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nav-divider col mb-0 mt-0"
  });
};
var ModalSidebarDividervue_type_template_id_62249560_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalSidebarDivider.vue?vue&type=script&lang=js&
/* harmony default export */ var ModalSidebarDividervue_type_script_lang_js_ = ({
  name: "ModalSidebarDivider"
});
;// CONCATENATED MODULE: ./src/library/Modal/ModalSidebarDivider.vue?vue&type=script&lang=js&
 /* harmony default export */ var Modal_ModalSidebarDividervue_type_script_lang_js_ = (ModalSidebarDividervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalSidebarDivider.vue?vue&type=style&index=0&id=62249560&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Modal/ModalSidebarDivider.vue?vue&type=style&index=0&id=62249560&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Modal/ModalSidebarDivider.vue



;


/* normalize component */

var ModalSidebarDivider_component = normalizeComponent(
  Modal_ModalSidebarDividervue_type_script_lang_js_,
  ModalSidebarDividervue_type_template_id_62249560_scoped_true_render,
  ModalSidebarDividervue_type_template_id_62249560_scoped_true_staticRenderFns,
  false,
  null,
  "62249560",
  null
  
)

/* harmony default export */ var ModalSidebarDivider = (ModalSidebarDivider_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalSidebarOption.vue?vue&type=template&id=4eb31bae&scoped=true&
var ModalSidebarOptionvue_type_template_id_4eb31bae_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "me-nav-btn",
    on: {
      "click": _vm.triggerClick
    }
  }, [_c('font-awesome-icon', {
    staticClass: "me-side-icon filter",
    class: {
      selected: _vm.selected
    },
    attrs: {
      "icon": _vm.faIcon
    }
  }), _vm.popoverActive && _vm.hasPopover ? _c('div', {
    staticClass: "article-popover"
  }, _vm._l(_vm.popoverList, function (item, idx) {
    return _c('a', {
      key: idx,
      staticClass: "my-2",
      attrs: {
        "target": "_blank",
        "href": item
      },
      on: {
        "click": function ($event) {
          _vm.popoverActive = false;
        }
      }
    }, [_vm._v(" " + _vm._s(item.split("/").slice(-1)[0]) + " ")]);
  }), 0) : _vm._e()], 1);
};
var ModalSidebarOptionvue_type_template_id_4eb31bae_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalSidebarOption.vue?vue&type=script&lang=js&
/* harmony default export */ var ModalSidebarOptionvue_type_script_lang_js_ = ({
  name: "ModalSidebarOption",
  props: {
    icon: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    },
    hasPopover: {
      type: Boolean,
      default: false
    },
    popoverList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popoverActive: false
    };
  },
  computed: {
    faIcon() {
      return [this.selected ? "fas" : "far", this.icon];
    }
  },
  methods: {
    triggerClick() {
      return this.hasPopover ? this.triggerPopover() : this.$emit("click");
    },
    triggerPopover() {
      this.popoverActive = !this.popoverActive;
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Modal/ModalSidebarOption.vue?vue&type=script&lang=js&
 /* harmony default export */ var Modal_ModalSidebarOptionvue_type_script_lang_js_ = (ModalSidebarOptionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Modal/ModalSidebarOption.vue?vue&type=style&index=0&id=4eb31bae&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Modal/ModalSidebarOption.vue?vue&type=style&index=0&id=4eb31bae&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Modal/ModalSidebarOption.vue



;


/* normalize component */

var ModalSidebarOption_component = normalizeComponent(
  Modal_ModalSidebarOptionvue_type_script_lang_js_,
  ModalSidebarOptionvue_type_template_id_4eb31bae_scoped_true_render,
  ModalSidebarOptionvue_type_template_id_4eb31bae_scoped_true_staticRenderFns,
  false,
  null,
  "4eb31bae",
  null
  
)

/* harmony default export */ var ModalSidebarOption = (ModalSidebarOption_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/AnswerModalSidebar.vue?vue&type=script&lang=js&


/* harmony default export */ var AnswerModalSidebarvue_type_script_lang_js_ = ({
  name: "AnswerModalSidebar",
  components: {
    ModalSidebarOption: ModalSidebarOption,
    ModalSidebarDivider: ModalSidebarDivider
  },
  props: {
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      useCases: ["intercom", "lightning.force.com", "dynamics.com", "service-now.com", "mail.google.com", "app.frontapp.com"]
    };
  },
  computed: {
    canTriggerAction() {
      const url = window.location.hostname;
      // eslint-disable-next-line no-restricted-syntax
      for (const useCase of this.useCases) {
        if (url.includes(useCase)) {
          return true;
        }
      }
      return false;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/components/AnswerModalSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_AnswerModalSidebarvue_type_script_lang_js_ = (AnswerModalSidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/modal/components/AnswerModalSidebar.vue





/* normalize component */
;
var AnswerModalSidebar_component = normalizeComponent(
  components_AnswerModalSidebarvue_type_script_lang_js_,
  AnswerModalSidebarvue_type_template_id_507f13c4_render,
  AnswerModalSidebarvue_type_template_id_507f13c4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AnswerModalSidebar = (AnswerModalSidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/AnswerModal.vue?vue&type=script&lang=js&




/* harmony default export */ var AnswerModalvue_type_script_lang_js_ = ({
  name: "AnswerModal",
  mixins: [modalMixins],
  components: {
    ModalLayout: ModalLayout,
    AnswerModalSidebar: AnswerModalSidebar
  },
  props: {
    content: {
      type: Object,
      default: () => ({
        label: ""
      })
    },
    companyPreferences: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({
        hasModalClosureShortcut: false,
        hasAnswerCopyPasteShortcut: false
      })
    }
  },
  methods: {
    handleActionsMessage() {
      const {
        id,
        payload
      } = this.content.actions;
      if (!["CUSTOM_MESSAGE", "ZENDESK_MESSAGE"].includes(id)) {
        return this.closeModal();
      }
      const {
        message
      } = payload;
      if (["", "<p></p>"].includes(message)) return this.closeModal();
      const url = window.location.href;
      const focusTab = this.companyPreferences.find(({
        type
      }) => type === "WEB_EXT_SALESFORCE_FOCUS_TAB");
      const tab = focusTab ? focusTab.value : null;
      try {
        helpdeskService.insert(url, document, message, {
          tab
        });
      } catch (e) {
        return this.closeModal();
      }
      return this.closeModal();
    },
    closeModal() {
      this.$emit("close");
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/AnswerModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var modal_AnswerModalvue_type_script_lang_js_ = (AnswerModalvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/AnswerModal.vue?vue&type=style&index=0&id=08c75e48&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/modal/AnswerModal.vue?vue&type=style&index=0&id=08c75e48&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/modal/AnswerModal.vue



;


/* normalize component */

var AnswerModal_component = normalizeComponent(
  modal_AnswerModalvue_type_script_lang_js_,
  AnswerModalvue_type_template_id_08c75e48_scoped_true_render,
  AnswerModalvue_type_template_id_08c75e48_scoped_true_staticRenderFns,
  false,
  null,
  "08c75e48",
  null
  
)

/* harmony default export */ var AnswerModal = (AnswerModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/ArticleModal.vue?vue&type=template&id=6a0bd39f&scoped=true&
var ArticleModalvue_type_template_id_6a0bd39f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('modal-layout', {
    attrs: {
      "id": "article-modal",
      "title": _vm.content.label,
      "focus-type": "article"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "sidebar",
      fn: function () {
        return [_c('ArticleModalSidebar', {
          attrs: {
            "is-favorite": _vm.isFavorite,
            "is-feedback": _vm.isFeedback,
            "attachments": _vm.content.attachments
          },
          on: {
            "click:copy": _vm.copyBody,
            "click:link": function ($event) {
              return _vm.copyLink(_vm.webUrl);
            },
            "click:feedback": function ($event) {
              return _vm.$emit('toggle-feedback');
            },
            "click:favorite": function ($event) {
              return _vm.$emit('toggle-favorite');
            }
          }
        })];
      },
      proxy: true
    }, {
      key: "modal-info",
      fn: function () {
        return [_vm.content.labels && _vm.content.labels.length ? _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('ContentListItemFullLabelWrapper', {
          attrs: {
            "labels": _vm.content.labels
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "main-body",
      fn: function () {
        return [_vm._t("default", null, {
          "copyDoneMx": _vm.copyDoneMx
        })];
      },
      proxy: true
    }], null, true)
  });
};
var ArticleModalvue_type_template_id_6a0bd39f_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/ArticleModalSidebar.vue?vue&type=template&id=bcc097f4&
var ArticleModalSidebarvue_type_template_id_bcc097f4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "article-modal-sidebar"
  }, [_c('ModalSidebarOption', {
    attrs: {
      "icon": "copy"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:copy');
      }
    }
  }), _c('ModalSidebarOption', {
    attrs: {
      "icon": "link"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:link');
      }
    }
  }), _vm.attachments.length > 0 ? _c('ModalSidebarDivider') : _vm._e(), _vm.attachments.length > 0 ? _c('ModalSidebarOption', {
    attrs: {
      "icon": "paperclip",
      "has-popover": true,
      "popover-list": _vm.attachments
    }
  }) : _vm._e(), _c('ModalSidebarDivider'), _c('ModalSidebarOption', {
    attrs: {
      "icon": "star",
      "selected": _vm.isFavorite
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:favorite');
      }
    }
  }), _c('ModalSidebarOption', {
    attrs: {
      "icon": "megaphone",
      "selected": _vm.isFeedback
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click:feedback');
      }
    }
  })], 1);
};
var ArticleModalSidebarvue_type_template_id_bcc097f4_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/ArticleModalSidebar.vue?vue&type=script&lang=js&


/* harmony default export */ var ArticleModalSidebarvue_type_script_lang_js_ = ({
  name: "ArticleModalSidebar",
  components: {
    ModalSidebarOption: ModalSidebarOption,
    ModalSidebarDivider: ModalSidebarDivider
  },
  props: {
    isFavorite: {
      type: Boolean,
      default: false
    },
    isFeedback: {
      type: Boolean,
      default: false
    },
    attachments: {
      type: Array,
      default: () => []
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/components/ArticleModalSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ArticleModalSidebarvue_type_script_lang_js_ = (ArticleModalSidebarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/modal/components/ArticleModalSidebar.vue





/* normalize component */
;
var ArticleModalSidebar_component = normalizeComponent(
  components_ArticleModalSidebarvue_type_script_lang_js_,
  ArticleModalSidebarvue_type_template_id_bcc097f4_render,
  ArticleModalSidebarvue_type_template_id_bcc097f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ArticleModalSidebar = (ArticleModalSidebar_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/ArticleModal.vue?vue&type=script&lang=js&




/* harmony default export */ var ArticleModalvue_type_script_lang_js_ = ({
  name: "ArticleModal",
  mixins: [modalMixins],
  components: {
    ModalLayout: ModalLayout,
    ArticleModalSidebar: ArticleModalSidebar,
    ContentListItemFullLabelWrapper: ContentListItemFullLabelWrapper
  },
  props: {
    content: {
      type: Object,
      default: () => ({
        label: ""
      })
    },
    isFeedback: {
      type: Boolean,
      default: false
    },
    isFavorite: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({
        subdomainUrl: "",
        hasModalClosureShortcut: false,
        hasArticleCopyPasteShortcut: false
      })
    }
  },
  computed: {
    webUrl() {
      return new URL(`/web/content/${this.content.id}`, this.config.subdomainUrl).href;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/ArticleModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var modal_ArticleModalvue_type_script_lang_js_ = (ArticleModalvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/ArticleModal.vue?vue&type=style&index=0&id=6a0bd39f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/modal/ArticleModal.vue?vue&type=style&index=0&id=6a0bd39f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/modal/ArticleModal.vue



;


/* normalize component */

var ArticleModal_component = normalizeComponent(
  modal_ArticleModalvue_type_script_lang_js_,
  ArticleModalvue_type_template_id_6a0bd39f_scoped_true_render,
  ArticleModalvue_type_template_id_6a0bd39f_scoped_true_staticRenderFns,
  false,
  null,
  "6a0bd39f",
  null
  
)

/* harmony default export */ var ArticleModal = (ArticleModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/ZoomModal.vue?vue&type=template&id=3fc141a6&scoped=true&
var ZoomModalvue_type_template_id_3fc141a6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "modal-zoom"
  }, [_c('div', {
    staticClass: "row no-side-margin hosting-row",
    style: _vm.dynamicStyle
  }, [_c('div', {
    staticClass: "container main-container"
  }, [_c('div', {
    staticClass: "row title-row no-side-margin"
  }, [_c('img', {
    staticClass: "main-icon col-2 px-0",
    attrs: {
      "src": __webpack_require__(9171)
    }
  }), _c('h2', {
    staticClass: "col text-left node-title"
  }, [_vm._v(_vm._s(_vm.content.label))]), _c('a', {
    staticClass: "col-1 d-flex align-items-center justify-content-end",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": __webpack_require__(3298)
    }
  })])]), _c('ZoomModalMainBody', {
    attrs: {
      "content": _vm.content
    }
  })], 1)])]);
};
var ZoomModalvue_type_template_id_3fc141a6_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/modal/ZoomModal.vue?vue&type=template&id=3fc141a6&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/ZoomModalMainBody.vue?vue&type=template&id=fc10dcfa&scoped=true&
var ZoomModalMainBodyvue_type_template_id_fc10dcfa_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "mayday-comment-body",
    staticClass: "row comment-row no-side-margin justify-content-center"
  }, [_c('div', [_c('a', {
    staticClass: "link-open",
    attrs: {
      "href": _vm.content.body,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("knowledge.zoom-open-tab")))])]), _vm.content.zoom === 'link' ? _c('iframe', {
    attrs: {
      "src": _vm.content.body,
      "frameborder": "0",
      "allowfullscreen": "true",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    }
  }) : _c('img', {
    staticClass: "zoom-img",
    attrs: {
      "src": _vm.content.body
    }
  }), !_vm.iframeLoaded ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('font-awesome-icon', {
    staticClass: "fa-4x mb-4 yellow",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1), _c('div', {
    staticClass: "col-12 text-center my-2"
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(`${_vm.randomQuote.quote}`))])])])]) : _vm._e()]);
};
var ZoomModalMainBodyvue_type_template_id_fc10dcfa_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/ZoomModalMainBody.vue?vue&type=script&lang=js&

/* harmony default export */ var ZoomModalMainBodyvue_type_script_lang_js_ = ({
  name: "ZoomModalMainBody",
  props: {
    content: {
      type: Object
    }
  },
  data() {
    return {
      randomQuote: {},
      iframeLoaded: true
    };
  },
  created() {
    this.randomQuote = randomQuotes();
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/components/ZoomModalMainBody.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ZoomModalMainBodyvue_type_script_lang_js_ = (ZoomModalMainBodyvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/components/ZoomModalMainBody.vue?vue&type=style&index=0&id=fc10dcfa&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/modal/components/ZoomModalMainBody.vue?vue&type=style&index=0&id=fc10dcfa&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/modal/components/ZoomModalMainBody.vue



;


/* normalize component */

var ZoomModalMainBody_component = normalizeComponent(
  components_ZoomModalMainBodyvue_type_script_lang_js_,
  ZoomModalMainBodyvue_type_template_id_fc10dcfa_scoped_true_render,
  ZoomModalMainBodyvue_type_template_id_fc10dcfa_scoped_true_staticRenderFns,
  false,
  null,
  "fc10dcfa",
  null
  
)

/* harmony default export */ var ZoomModalMainBody = (ZoomModalMainBody_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/ZoomModal.vue?vue&type=script&lang=js&

/* harmony default export */ var ZoomModalvue_type_script_lang_js_ = ({
  name: "ZoomModal",
  components: {
    ZoomModalMainBody: ZoomModalMainBody
  },
  props: {
    content: {
      type: Object,
      default: () => ({
        label: ""
      })
    },
    customWidth: {
      type: Number
    }
  },
  computed: {
    dynamicStyle() {
      return {
        "--custom-width": `${this.customWidth}px`
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/ZoomModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var modal_ZoomModalvue_type_script_lang_js_ = (ZoomModalvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/ZoomModal.vue?vue&type=style&index=0&id=3fc141a6&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/modal/ZoomModal.vue?vue&type=style&index=0&id=3fc141a6&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/modal/ZoomModal.vue



;


/* normalize component */

var ZoomModal_component = normalizeComponent(
  modal_ZoomModalvue_type_script_lang_js_,
  ZoomModalvue_type_template_id_3fc141a6_scoped_true_render,
  ZoomModalvue_type_template_id_3fc141a6_scoped_true_staticRenderFns,
  false,
  null,
  "3fc141a6",
  null
  
)

/* harmony default export */ var ZoomModal = (ZoomModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/LightBox.vue?vue&type=template&id=75f606da&scoped=true&
var LightBoxvue_type_template_id_75f606da_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lightbox",
    style: _vm.companyColorStyle
  }, [_c('div', {
    staticClass: "lightbox-header"
  }, [_c('button', {
    staticClass: "lightbox-header-button",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openInNewTab();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("modals.lightbox.open")) + " ")]), _c('button', {
    staticClass: "lightbox-header-button lightbox-header-button-fill",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("modals.lightbox.close")) + " ")])]), _c('div', {
    staticClass: "lightbox-zoomer",
    on: {
      "mousedown": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_vm.src ? _c('v-zoomer', {
    ref: "gallery",
    staticClass: "lightbox-zoomer-image",
    on: {
      "mousedown": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "src": _vm.src
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "lightbox-actions"
  }, [_c('button', {
    staticClass: "lightbox-actions-button",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$refs.gallery.zoomOut();
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', 'minus']
    }
  })], 1), _c('button', {
    staticClass: "lightbox-actions-button",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$refs.gallery.zoomIn();
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', 'plus']
    }
  })], 1)])], 1)]);
};
var LightBoxvue_type_template_id_75f606da_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/vue-zoomer/dist/vue-zoomer.esm.js
// vue-zoomer v0.3.10 - Jarvis Niu
// https://github.com/jarvisniu/vue-zoomer

/* esm.sh - esbuild bundle(lodash@4.17.20/debounce) esnext production */
if (typeof global === "undefined") var global = window;var ce=Object.create,S=Object.defineProperty,se=Object.getPrototypeOf,ue=Object.prototype.hasOwnProperty,be=Object.getOwnPropertyNames,le=Object.getOwnPropertyDescriptor,ge=e=>S(e,"__esModule",{value:!0}),a=(e,r)=>()=>(r||(r={exports:{}},e(r.exports,r)),r.exports),de=(e,r,n)=>{if(ge(e),r&&typeof r=="object"||typeof r=="function")for(let i of be(r))!ue.call(e,i)&&i!=="default"&&S(e,i,{get:()=>r[i],enumerable:!(n=le(r,i))||n.enumerable});return e},me=e=>e&&e.__esModule?e:de(S(e!=null?ce(se(e)):{},"default",{value:e,enumerable:!0}),e),x=a((rr,E)=>{function pe(e){var r=typeof e;return e!=null&&(r=="object"||r=="function")}E.exports=pe;}),N=a((tr,L)=>{var ye=typeof global=="object"&&global&&global.Object===Object&&global;L.exports=ye;}),O=a((nr,G)=>{var Te=N(),je=typeof self=="object"&&self&&self.Object===Object&&self,Se=Te||je||Function("return this")();G.exports=Se;}),w=a((ir,R)=>{var xe=O(),Oe=function(){return xe.Date.now()};R.exports=Oe;}),v=a((or,P)=>{var ve=O(),qe=ve.Symbol;P.exports=qe;}),$=a((ar,W)=>{var C=v(),M=Object.prototype,he=M.hasOwnProperty,Ie=M.toString,m=C?C.toStringTag:void 0;function _e(e){var r=he.call(e,m),n=e[m];try{e[m]=void 0;var i=!0;}catch(b){}var c=Ie.call(e);return i&&(r?e[m]=n:delete e[m]),c}W.exports=_e;}),B=a((fr,A)=>{var ke=Object.prototype,Ee=ke.toString;function Le(e){return Ee.call(e)}A.exports=Le;}),H=a((cr,F)=>{var U=v(),Ne=$(),Ge=B(),Re="[object Null]",we="[object Undefined]",D=U?U.toStringTag:void 0;function Pe(e){return e==null?e===void 0?we:Re:D&&D in Object(e)?Ne(e):Ge(e)}F.exports=Pe;}),z=a((sr,X)=>{function We(e){return e!=null&&typeof e=="object"}X.exports=We;}),K=a((ur,J)=>{var Ce=H(),Me=z(),$e="[object Symbol]";function Ae(e){return typeof e=="symbol"||Me(e)&&Ce(e)==$e}J.exports=Ae;}),Z=a((br,Q)=>{var V=x(),Be=K(),Y=0/0,Fe=/^\s+|\s+$/g,Ue=/^[-+]0x[0-9a-f]+$/i,De=/^0b[01]+$/i,He=/^0o[0-7]+$/i,Xe=parseInt;function ze(e){if(typeof e=="number")return e;if(Be(e))return Y;if(V(e)){var r=typeof e.valueOf=="function"?e.valueOf():e;e=V(r)?r+"":r;}if(typeof e!="string")return e===0?e:+e;e=e.replace(Fe,"");var n=De.test(e);return n||He.test(e)?Xe(e.slice(2),n?2:8):Ue.test(e)?Y:+e}Q.exports=ze;}),te=a((lr,ee)=>{var Je=x(),q=w(),re=Z(),Ke="Expected a function",Qe=Math.max,Ve=Math.min;function Ye(e,r,n){var i,c,b,u,o,s,l=0,h=!1,g=!1,y=!0;if(typeof e!="function")throw new TypeError(Ke);r=re(r)||0,Je(n)&&(h=!!n.leading,g="maxWait"in n,b=g?Qe(re(n.maxWait)||0,r):b,y="trailing"in n?!!n.trailing:y);function T(t){var f=i,d=c;return i=c=void 0,l=t,u=e.apply(d,f),u}function ie(t){return l=t,o=setTimeout(p,r),h?T(t):u}function oe(t){var f=t-s,d=t-l,k=r-f;return g?Ve(k,b-d):k}function I(t){var f=t-s,d=t-l;return s===void 0||f>=r||f<0||g&&d>=b}function p(){var t=q();if(I(t))return _(t);o=setTimeout(p,oe(t));}function _(t){return o=void 0,y&&i?T(t):(i=c=void 0,u)}function ae(){o!==void 0&&clearTimeout(o),l=0,i=s=c=o=void 0;}function fe(){return o===void 0?u:_(q())}function j(){var t=q(),f=I(t);if(i=arguments,c=this,s=t,f){if(o===void 0)return ie(s);if(g)return clearTimeout(o),o=setTimeout(p,r),T(s)}return o===void 0&&(o=setTimeout(p,r)),u}return j.cancel=ae,j.flush=fe,j}ee.exports=Ye;}),ne=me(te()),Ze=ne.default;

/**
 * Detect double tap events
 * # Deals with:
 * - Time intervals between taps
 * - Swipe will stop the taps
 * # Usage:
 * let tapDetector = new TapDetector()
 * tapDetector.attach(this.$el) // in mounted
 * tapDetector.detach(this.$el) // in destroy
 * tapDetector.onSingle(callback)
 * tapDetector.onDouble(callback)
 */

function TapDetector () {

  // Callbacks -----------------------------------------------------------------

  let singleTapCallbacks = [];
  let doubleTapCallbacks = [];

  function triggerCallbacks (cbList, arg) {
    cbList.forEach(cbItem => {
      cbItem.call(null, arg);
    });
  }

  this.onSingleTap = function (cb) {
    if (typeof cb === 'function' && !singleTapCallbacks.includes(cb)) {
      singleTapCallbacks.push(cb);
    }
  };
  this.onDoubleTap = function (cb) {
    if (typeof cb === 'function' && !doubleTapCallbacks.includes(cb)) {
      doubleTapCallbacks.push(cb);
    }
  };

  this.attach = function (dom) {
    if (!(dom instanceof Element)) {
      console.error('TapDetector.attach: arg must be an Element');
      return
    }
    dom.addEventListener('touchstart', onTouchStart);
    dom.addEventListener('touchmove', onTouchMove);
    dom.addEventListener('touchend', onTouchEnd);
    dom.addEventListener('mousedown', onMouseDown);
    dom.addEventListener('mouseup', onMouseUp);
    dom.addEventListener('mousemove', onMouseMove);
  };

  this.detach = function (dom) {
    dom.removeEventListener('touchstart', onTouchStart);
    dom.removeEventListener('touchmove', onTouchMove);
    dom.removeEventListener('touchend', onTouchEnd);
    dom.removeEventListener('mousedown', onMouseDown);
    dom.removeEventListener('mouseup', onMouseUp);
    dom.removeEventListener('mousemove', onMouseMove);
  };

  // Main logic ----------------------------------------------------------------

  // in touch mode mouse events will be disabled. Otherwise touches will
  // trigger both touchend end mouseup, i.e. one touch triggers two onPointerUp.
  let isTouchMode = false;
  let lastTapTimestamp = 0;
  let tappedCount = 0;
  let touchMovedLength = 0;
  let lastPointerX = 0;
  let lastPointerY = 0;

  function onTouchStart (ev) {
    isTouchMode = true;
    // console.log('onTouchStart')
    if (ev.touches.length === 1) {
      onPointerDown(ev.touches[0].clientX, ev.touches[0].clientY);
    }
  }
  function onTouchEnd (ev) {
    // console.log('onTouchEnd')
    if (ev.touches.length === 0) {
      onPointerUp();
    }
  }
  function onTouchMove (ev) {
    // console.log('onTouchMove', ev)
    if (ev.touches.length === 1) {
      onPointerMove(ev.touches[0].clientX, ev.touches[0].clientY);
    }
  }

  function onMouseDown (ev) {
    if (isTouchMode) return

    // console.log('onMouseDown')
    onPointerDown(ev.clientX, ev.clientY);
  }
  function onMouseUp (ev) {
    if (isTouchMode) return

    // console.log('onMouseUp')
    onPointerUp();
  }
  function onMouseMove (ev) {
    if (isTouchMode) return

    // console.log('onMouseMove', ev)
    if (ev.button === 0) {
      onPointerMove(ev.clientX, ev.clientY);
    }
  }

  function onPointerDown (x, y) {
    lastPointerX = x;
    lastPointerY = y;
    touchMovedLength = 0;
  }
  function onPointerUp () {
    let currTimeStamp = Date.now();
    // console.log('touchMovedLength', touchMovedLength)
    if (touchMovedLength < 10) {
      // Only when no sliding two far is considered as a valid tap
      if (currTimeStamp - lastTapTimestamp < 300) {
        tappedCount += 1;
      } else {
        tappedCount = 1;
      }
      lastTapTimestamp = Date.now();
      // console.log('tappedCount', tappedCount)
      triggerCallbacks(singleTapCallbacks, {
        clientX: lastPointerX,
        clientY: lastPointerY,
      });
      if (tappedCount === 2) {
        triggerCallbacks(doubleTapCallbacks, {
          clientX: lastPointerX,
          clientY: lastPointerY,
        });
        tappedCount = 0; // clear count on maximum tap count
      }
    }
    touchMovedLength = 0;
  }
  function onPointerMove (x, y) {
    let deltaX = lastPointerX - x;
    let deltaY = lastPointerY - y;
    let length = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    // console.log('onTouchMove length', length)
    touchMovedLength += length;
    lastPointerX = x;
    lastPointerY = y;
  }
}

//

var script = {
  props: {
    minScale: { type: Number, default: 1 },
    maxScale: { type: Number, default: 5 },
    zoomed: { type: Boolean, default: false },
    resetTrigger: { type: Number, default: 1e5 },
    aspectRatio: { type: Number, default: 1 },
    backgroundColor: { type: String, default: 'transparent' },
    pivot: { type: String, default: 'cursor' }, // other options: image-center
    zoomingElastic: { type: Boolean, default: true },
    limitTranslation: { type: Boolean, default: true },
    doubleClickToZoom: { type: Boolean, default: true },
    mouseWheelToZoom: { type: Boolean, default: true },
  },
  data () {
    return {
      // Container sizes, used to determin the initial zoomer size.
      // Need to reactive to window resizing.
      containerWidth: 1,
      containerHeight: 1,
      containerLeft: 0,
      containerTop: 0,
      // Store values: Interactions will at last change these values.
      // After rotation or resize, these values will keep still.
      // These three values are all relative to the container size.
      translateX: 0,
      animTranslateX: 0,
      translateY: 0,
      animTranslateY: 0,
      scale: 1,
      animScale: 1,
      // Mouse states
      lastFullWheelTime: 0,
      lastWheelTime: 0,
      lastWheelDirection: 'y',
      isPointerDown: false,
      pointerPosX: -1,
      pointerPosY: -1,
      twoFingerInitDist: 0,
      panLocked: true,
      // Others
      raf: null,
      tapDetector: null,
    }
  },
  computed: {
    wrapperStyle () {
      let translateX = this.containerWidth * this.animTranslateX;
      let translateY = this.containerHeight * this.animTranslateY;
      return {
        transform: [
          `translate(${ translateX }px, ${ translateY }px)`,
          `scale(${ this.animScale })`,
        ].join(' ')
      }
    },
  },
  watch: {
    scale (val) {
      if (val !== 1) {
        this.$emit('update:zoomed', true);
        this.panLocked = false;
      }
    },
    resetTrigger: 'reset',
  },
  mounted () {
    this.tapDetector = new TapDetector();
    this.tapDetector.attach(this.$el);
    if (this.doubleClickToZoom) {
      this.tapDetector.onDoubleTap(this.onDoubleTap);
    }
    // console.log('container size: ', this.containerWidth, this.containerHeight)
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
    this.refreshContainerPos();
    this.loop();
  },
  destroyed () {
    this.tapDetector.detach(this.$el);
    window.removeEventListener('resize', this.onWindowResize);
    window.cancelAnimationFrame(this.raf);
    // console.log('destroy')
  },
  methods: {
    // API ---------------------------------------------------------------------
    reset () {
      this.scale = 1;
      this.panLocked = true;
      this.translateX = 0;
      this.translateY = 0;
    },
    zoomIn(scale = 2) {
      this.tryToScale(scale);
      this.onInteractionEnd();
    },
    zoomOut(scale = 0.5) {
      this.tryToScale(scale);
      this.onInteractionEnd();
    },
    // Main Logic --------------------------------------------------------------
    // scale
    // Zoom the image with the point at the pointer(mouse or pinch center) pinned.
    // Simplify: This can be regard as vector pointer to old-image-center scaling.
    tryToScale (scaleDelta) {
      let newScale = this.scale * scaleDelta;
      if (this.zoomingElastic) {
        // damping
        if (newScale < this.minScale || newScale > this.maxScale) {
          let log = Math.log2(scaleDelta);
          log *= 0.2;
          scaleDelta = Math.pow(2, log);
          newScale = this.scale * scaleDelta;
        }
      } else {
        if (newScale < this.minScale) newScale = this.minScale;
        else if (newScale > this.maxScale) newScale = this.maxScale;
      }
      scaleDelta = newScale / this.scale;
      this.scale = newScale;
      if (this.pivot !== 'image-center') {
        let normMousePosX = (this.pointerPosX - this.containerLeft) / this.containerWidth;
        let normMousePosY = (this.pointerPosY - this.containerTop) / this.containerHeight;
        this.translateX = (0.5 + this.translateX - normMousePosX) * scaleDelta + normMousePosX - 0.5;
        this.translateY = (0.5 + this.translateY - normMousePosY) * scaleDelta + normMousePosY - 0.5;
      }
    },
    setPointerPosCenter () {
      this.pointerPosX = this.containerLeft + this.containerWidth / 2;
      this.pointerPosY = this.containerTop + this.containerHeight / 2;
    },
    // pan
    onPointerMove (newMousePosX, newMousePosY) {
      if (this.isPointerDown) {
        let pixelDeltaX = newMousePosX - this.pointerPosX;
        let pixelDeltaY = newMousePosY - this.pointerPosY;
        // console.log('pixelDeltaX, pixelDeltaY', pixelDeltaX, pixelDeltaY)
        if (!this.panLocked) {
          this.translateX += pixelDeltaX / this.containerWidth;
          this.translateY += pixelDeltaY / this.containerHeight;
        }
      }
      this.pointerPosX = newMousePosX;
      this.pointerPosY = newMousePosY;
    },
    onInteractionEnd: Ze(function ()  {
      this.limit();
      this.panLocked = this.scale === 1;
      this.$emit('update:zoomed', !this.panLocked);
    }, 100),
    // limit the scale between max and min and the translate within the viewport
    limit () {
      // scale
      if (this.scale < this.minScale) {
        this.scale = this.minScale;
        // FIXME this sometimes will not reset when pinching in
        // this.tryToScale(this.minScale / this.scale)
      } else if (this.scale > this.maxScale) {
        this.tryToScale(this.maxScale / this.scale);
      }
      // translate
      if (this.limitTranslation) {
        let translateLimit = this.calcTranslateLimit();
        if (Math.abs(this.translateX) > translateLimit.x) {
          this.translateX *= translateLimit.x / Math.abs(this.translateX);
        }
        if (Math.abs(this.translateY) > translateLimit.y) {
          this.translateY *= translateLimit.y / Math.abs(this.translateY);
        }
      }
    },
    calcTranslateLimit () {
      if (this.getMarginDirection() === 'y') {
        let imageToContainerRatio = this.containerWidth / this.aspectRatio / this.containerHeight;
        let translateLimitY = (this.scale * imageToContainerRatio - 1) / 2;
        if (translateLimitY < 0) translateLimitY = 0;
        return {
          x: (this.scale - 1) / 2,
          y: translateLimitY,
        }
      } else {
        let imageToContainerRatio = this.containerHeight * this.aspectRatio / this.containerWidth;
        let translateLimitX = (this.scale * imageToContainerRatio - 1) / 2;
        if (translateLimitX < 0) translateLimitX = 0;
        return {
          x: translateLimitX,
          y: (this.scale - 1) / 2,
        }
      }
    },
    getMarginDirection () {
      let containerRatio = this.containerWidth / this.containerHeight;
      return containerRatio > this.aspectRatio ? 'x' : 'y'
    },
    onDoubleTap (ev) {
      if (this.scale === 1) {
        if (ev.clientX > 0) {
          this.pointerPosX = ev.clientX;
          this.pointerPosY = ev.clientY;
        }
        this.tryToScale(Math.min(3, this.maxScale));
      } else {
        this.reset();
      }
      this.onInteractionEnd();
    },
    // reactive
    onWindowResize () {
      let styles = window.getComputedStyle(this.$el);
      this.containerWidth = parseFloat(styles.width);
      this.containerHeight = parseFloat(styles.height);
      this.setPointerPosCenter();
      this.limit();
    },
    refreshContainerPos () {
      let rect = this.$el.getBoundingClientRect();
      this.containerLeft = rect.left;
      this.containerTop = rect.top;
    },
    loop () {
      this.animScale = this.gainOn(this.animScale, this.scale);
      this.animTranslateX = this.gainOn(this.animTranslateX, this.translateX);
      this.animTranslateY = this.gainOn(this.animTranslateY, this.translateY);
      this.raf = window.requestAnimationFrame(this.loop);
      // console.log('loop', this.raf)
    },
    gainOn (from, to) {
      let delta = (to - from) * 0.3;
      // console.log('gainOn', from, to, from + delta)
      if (Math.abs(delta) > 1e-5) {
        return from + delta
      } else {
        return to
      }
    },
    // Mouse Events ------------------------------------------------------------
    // Mouse wheel scroll,  TrackPad pinch or TrackPad scroll
    onMouseWheel (ev) {
      if (!this.mouseWheelToZoom) return
      // prevent is used to stop the page scroll elastic effects
      ev.preventDefault();
      if (ev.detail) ev.wheelDelta = ev.detail * -10;
      let currTime = Date.now();
      if (Math.abs(ev.wheelDelta) === 120) {
        // Throttle the TouchPad pinch on Mac, or it will be too sensitive
        if (currTime - this.lastFullWheelTime > 50) {
          this.onMouseWheelDo(ev.wheelDelta);
          this.lastFullWheelTime = currTime;
        }
      } else {
        if (currTime - this.lastWheelTime > 50 && typeof ev.deltaX === 'number') {
          this.lastWheelDirection = (ev.detail == 0 && Math.abs(ev.deltaX) > Math.abs(ev.deltaY)) ? 'x' : 'y';
          if (this.lastWheelDirection === 'x') {
            this.$emit('swipe', ev.deltaX > 0 ? 'left' : 'right');
          }
        }
        if (this.lastWheelDirection === 'y') {
          this.onMouseWheelDo(ev.wheelDelta);
        }
      }
      this.lastWheelTime = currTime;
    },
    onMouseWheelDo (wheelDelta) {
      // Value basis: One mouse wheel (wheelDelta=+-120) means 1.25/0.8 scale.
      let scaleDelta = Math.pow(1.25, wheelDelta / 120);
      this.tryToScale(scaleDelta);
      this.onInteractionEnd();
    },
    onMouseDown (ev) {
      this.refreshContainerPos();
      this.isPointerDown = true;
      // Open the context menu then click other place will skip the mousemove events.
      // This will cause the pointerPosX/Y NOT sync, then we will need to fix it on mousedown event.
      this.pointerPosX = ev.clientX;
      this.pointerPosY = ev.clientY;
      // console.log('onMouseDown', ev)
    },
    onMouseUp (ev) {
      this.isPointerDown = false;
      this.onInteractionEnd();
    },
    onMouseMove (ev) {
      this.onPointerMove(ev.clientX, ev.clientY);
      // console.log('onMouseMove client, offset', ev.clientX, ev.clientY)
    },
    // Touch Events ------------------------------------------------------------
    onTouchStart (ev) {
      if (ev.touches.length === 1) {
        this.refreshContainerPos();
        this.pointerPosX = ev.touches[0].clientX;
        this.pointerPosY = ev.touches[0].clientY;
        this.isPointerDown = true;
      } else if (ev.touches.length === 2) {
        this.isPointerDown = true;
        // pos
        this.pointerPosX = (ev.touches[0].clientX + ev.touches[1].clientX) / 2;
        this.pointerPosY = (ev.touches[0].clientY + ev.touches[1].clientY) / 2;
        // dist
        let distX = ev.touches[0].clientX - ev.touches[1].clientX;
        let distY = ev.touches[0].clientY - ev.touches[1].clientY;
        this.twoFingerInitDist = Math.sqrt(distX * distX + distY * distY);
      }
      // console.log('onTouchStart', ev.touches)
    },
    onTouchEnd (ev) {
      if (ev.touches.length === 0) {
        this.isPointerDown = false;
        // Near 1 to set 1
        if (Math.abs(this.scale - 1) < 0.1) this.scale = 1;
        this.onInteractionEnd();
      } else if (ev.touches.length === 1) {
        this.pointerPosX = ev.touches[0].clientX;
        this.pointerPosY = ev.touches[0].clientY;
      }
      // console.log('onTouchEnd', ev.touches.length)
    },
    onTouchMove (ev) {
      if (ev.touches.length === 1) {
        this.onPointerMove(ev.touches[0].clientX, ev.touches[0].clientY);
      } else if (ev.touches.length === 2) {
        // pos
        let newMousePosX = (ev.touches[0].clientX + ev.touches[1].clientX) / 2;
        let newMousePosY = (ev.touches[0].clientY + ev.touches[1].clientY) / 2;
        this.onPointerMove(newMousePosX, newMousePosY);
        this.pointerPosX = newMousePosX;
        this.pointerPosY = newMousePosY;
        // dist
        let distX = ev.touches[0].clientX - ev.touches[1].clientX;
        let distY = ev.touches[0].clientY - ev.touches[1].clientY;
        let newTwoFingerDist = Math.sqrt(distX * distX + distY * distY);
        this.tryToScale(newTwoFingerDist / this.twoFingerInitDist);
        this.twoFingerInitDist = newTwoFingerDist;
      }
      // console.log('onTouchMove', this.pointerPosX, this.pointerPosY)
    },
  },
};

function vue_zoomer_esm_normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vue-zoomer",
      style: { backgroundColor: _vm.backgroundColor },
      on: {
        mousewheel: _vm.onMouseWheel,
        DOMMouseScroll: _vm.onMouseWheel,
        mousedown: _vm.onMouseDown,
        mouseup: _vm.onMouseUp,
        mousemove: _vm.onMouseMove,
        mouseout: _vm.setPointerPosCenter,
        touchstart: _vm.onTouchStart,
        touchend: _vm.onTouchEnd,
        touchmove: _vm.onTouchMove,
      },
    },
    [
      _c(
        "div",
        { staticClass: "zoomer", style: _vm.wrapperStyle },
        [_vm._t("default")],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e532c06e_0", { source: "\n.vue-zoomer[data-v-e532c06e] {\n  overflow: hidden;\n}\n.zoomer[data-v-e532c06e] {\n  transform-origin: 50% 50%;\n  width: 100%;\n  height: 100%;\n}\n.zoomer > img[data-v-e532c06e] {\n  /* remove the 4px gap below the image */\n  vertical-align: top;\n  user-drag: none;\n  -webkit-user-drag: none;\n  -moz-user-drag: none;\n}\n", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-e532c06e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/vue_zoomer_esm_normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const SLIDE_WIDTH_THRESH = 50; // in px

var script$1 = {
  props: {
    value: { type: Number, required: true },
    list: { type: Array, required: true },
    backgroundColor: { type: String, default: '#333' },
    pivot: { type: String, default: 'cursor' },
    zoomingElastic: { type: Boolean, default: true },
    limitTranslation: { type: Boolean, default: true },
    doubleClickToZoom: { type: Boolean, default: true },
    mouseWheelToZoom: { type: Boolean, default: true },
  },
  data () {
    return {
      // env states
      containerWidth: 1,
      containerHeight: 1,
      // main states
      selIndex: this.value,
      animSelIndex: this.value,
      currentZoomed: false,
      autoSliding: false,
      imageAspectRatios: [], // aspect ratio (width / height) of images
      // interaction states
      isPointerDown: false,
      lastPointerX: 0,
      slideOffsetX: 0,
    }
  },
  computed: {
    middleStyle () {
      return {
        left: `${ 0 + this.slideOffsetX }px`,
      }
    },
    leftStyle () {
      return {
        left: `${ -this.containerWidth + this.slideOffsetX }px`,
      }
    },
    rightStyle () {
      return {
        left: `${ this.containerWidth + this.slideOffsetX }px`,
      }
    },
    slideThresh () {
      return Math.max(SLIDE_WIDTH_THRESH, this.containerWidth * 0.1)
    },
  },
  watch: {
    value (val) {
      if (val !== this.animSelIndex) {
        this.selIndex = val;
        this.animSelIndex = val;
      }
    },
    selIndex() {
      this.$nextTick(() => {
        this.$refs.zoomers.forEach(zoomer => {
          zoomer.refreshContainerPos();
        });
      });
    },
  },
  mounted () {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },
  destroyed () {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    // api ---------------------------------------------------------------------
    reset () {
      this.$refs.zoomers.forEach(zoomer => {
        zoomer.reset();
      });
    },
    zoomIn (scale) {
      if (this.$refs.zoomers[1]) this.$refs.zoomers[1].zoomIn(scale);
    },
    zoomOut (scale) {
      if (this.$refs.zoomers[1]) this.$refs.zoomers[1].zoomOut(scale);
    },
    // events ------------------------------------------------------------------
    onWindowResize () {
      let styles = window.getComputedStyle(this.$el);
      this.containerWidth = parseFloat(styles.width);
      this.containerHeight = parseFloat(styles.height);
    },
    onPointerMove (deltaX) {
      if (this.isPointerDown && !this.currentZoomed) {
        let factor = (
          (this.selIndex === 0 && deltaX > 0 && this.slideOffsetX + deltaX > 0) ||
          (this.selIndex === this.list.length - 1 && deltaX < 0 && this.slideOffsetX + deltaX < 0)
        ) ? 0.3 : 1;
        this.slideOffsetX += deltaX * factor;
      }
    },
    onPointerUp () {
      if (this.slideOffsetX < -this.slideThresh) {
        // next page
        this.paginate(1);
      } else if (this.slideOffsetX > this.slideThresh) {
        // prev page
        this.paginate(-1);
      } else {
        // only apply the animation
        this.paginate(0);
      }
    },
    // Stop Firefox dragging the image
    onImageDragStart(ev) {
      ev.preventDefault();
      return false
    },
    paginate (deltaIndex) {
      let targetIndex = this.selIndex + deltaIndex;
      if (targetIndex < 0 || targetIndex >= this.list.length) {
        this.slideOffsetX = 0;
        return
      }

      this.slideOffsetX = this.containerWidth * -deltaIndex;
      this.autoSliding = true;
      // update the selIndex before the animation to remove the delay feeling
      this.$emit('input', targetIndex);
      this.animSelIndex = targetIndex;
      setTimeout(() => {
        this.selIndex = targetIndex;
        this.slideOffsetX = 0;
        this.autoSliding = false;
      }, 400);
    },
    onMouseDown (ev) {
      this.isPointerDown = true;
      this.lastPointerX = ev.clientX;
    },
    onMouseUp (ev) {
      this.isPointerDown = false;
      this.onPointerUp();
    },
    onMouseMove (ev) {
      if (this.isPointerDown) {
        this.onPointerMove(ev.clientX - this.lastPointerX);
        this.lastPointerX = ev.clientX;
      }
    },
    onTouchStart (ev) {
      if (ev.touches.length === 1) {
        this.isPointerDown = true;
        this.lastPointerX = ev.touches[0].clientX;
      }
    },
    onTouchEnd (ev) {
      if (ev.touches.length === 0) {
        this.isPointerDown = false;
        this.onPointerUp();
      }
    },
    onTouchMove (ev) {
      if (ev.touches.length === 1) {
        this.onPointerMove(ev.touches[0].clientX - this.lastPointerX);
        this.lastPointerX = ev.touches[0].clientX;
      }
    },
    onImageLoad (index, ev) {
      let aspectRatio = ev.target.naturalWidth / ev.target.naturalHeight;
      this.$set(this.imageAspectRatios, index, aspectRatio);
    },
    onImageSwipe (direction) {
      this.paginate(direction == 'right' ? -1 : 1);
    },
  },
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vue-zoomer-gallery",
      class: {
        anim: _vm.autoSliding && !_vm.isPointerDown,
      },
      style: {
        "background-color": _vm.backgroundColor,
      },
      on: {
        mousemove: _vm.onMouseMove,
        mousedown: _vm.onMouseDown,
        mouseout: _vm.onMouseUp,
        mouseup: _vm.onMouseUp,
        touchstart: _vm.onTouchStart,
        touchend: _vm.onTouchEnd,
        touchmove: function ($event) {
          $event.preventDefault();
          return _vm.onTouchMove.apply(null, arguments)
        },
      },
    },
    _vm._l(3, function (n, i) {
      return _c(
        "v-zoomer",
        {
          key: i + "-" + _vm.selIndex,
          ref: "zoomers",
          refInFor: true,
          staticClass: "slide",
          class: ["left", "middle", "right"][i],
          style: [_vm.leftStyle, _vm.middleStyle, _vm.rightStyle][i],
          attrs: {
            "max-scale": 10,
            zoomed: _vm.currentZoomed,
            "reset-trigger": i,
            "aspect-ratio": _vm.imageAspectRatios[_vm.selIndex + i - 1] || 1,
            pivot: _vm.pivot,
            "zooming-elastic": _vm.zoomingElastic,
            "limit-translation": _vm.limitTranslation,
            "double-click-to-zoom": _vm.doubleClickToZoom,
            "mouse-wheel-to-zoom": _vm.mouseWheelToZoom,
          },
          on: {
            "update:zoomed": function ($event) {
              _vm.currentZoomed = $event;
            },
            swipe: _vm.onImageSwipe,
          },
        },
        [
          _vm.selIndex + i - 1 > -1 && _vm.selIndex + i - 1 < _vm.list.length
            ? _c("img", {
                staticStyle: {
                  "object-fit": "contain",
                  width: "100%",
                  height: "100%",
                },
                attrs: {
                  src: _vm.list[_vm.selIndex + i - 1],
                  draggable: "false",
                },
                on: {
                  load: function ($event) {
                    return _vm.onImageLoad(_vm.selIndex + i - 1, $event)
                  },
                  dragstart: _vm.onImageDragStart,
                },
              })
            : _vm._e(),
        ]
      )
    }),
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-fc52b35c_0", { source: "\n.vue-zoomer-gallery[data-v-fc52b35c] {\n  position: relative;\n  overflow: hidden;\n  user-select: none;\n  min-width: 100px;\n  min-height: 100px;\n}\n.vue-zoomer-gallery > *[data-v-fc52b35c] {\n  display: inline-block;\n}\n.vue-zoomer-gallery.anim .slide[data-v-fc52b35c] {\n  transition: left 0.4s;\n}\n.slide[data-v-fc52b35c] {\n  position: absolute;\n  top: 0;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n  -webkit-user-drag: none;\n}\n", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-fc52b35c";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/vue_zoomer_esm_normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

var vue_zoomer_esm_index = {
  install (Vue) {
    Vue.component('VZoomer', __vue_component__);
    Vue.component('VZoomerGallery', __vue_component__$1);
  },
  // for locally register
  Zoomer: __vue_component__,
  Gallery: __vue_component__$1,
};

/* harmony default export */ var vue_zoomer_esm = (vue_zoomer_esm_index);

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/LightBox.vue?vue&type=script&lang=js&

/* harmony default export */ var LightBoxvue_type_script_lang_js_ = ({
  name: "LightBox",
  components: {
    VZoomer: vue_zoomer_esm.Zoomer
  },
  props: {
    companyColor: {
      type: String,
      required: true
    },
    src: {
      type: String,
      default: ""
    }
  },
  computed: {
    companyColorStyle() {
      return `--company-color: ${this.companyColor}`;
    }
  },
  methods: {
    openInNewTab() {
      window.open(this.src, "_blank");
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    const documentClasses = document.body.style;
    documentClasses.overflow = "hidden";
  },
  beforeDestroy() {
    const documentClasses = document.body.style;
    documentClasses.overflow = "auto";
  }
});
;// CONCATENATED MODULE: ./src/modules/modal/LightBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var modal_LightBoxvue_type_script_lang_js_ = (LightBoxvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/modal/LightBox.vue?vue&type=style&index=0&id=75f606da&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/modal/LightBox.vue?vue&type=style&index=0&id=75f606da&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/modal/LightBox.vue



;


/* normalize component */

var LightBox_component = normalizeComponent(
  modal_LightBoxvue_type_script_lang_js_,
  LightBoxvue_type_template_id_75f606da_scoped_true_render,
  LightBoxvue_type_template_id_75f606da_scoped_true_staticRenderFns,
  false,
  null,
  "75f606da",
  null
  
)

/* harmony default export */ var LightBox = (LightBox_component.exports);
;// CONCATENATED MODULE: ./src/modules/modal/index.ts






const modalPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "modalModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store
    } = options;
    store.registerModule(STORE_MODULE_NAME, modalStore, {
      preserveState: !!store.state[STORE_MODULE_NAME]
    });
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) {
            options.i18n.mergeLocaleMessage(locale, locales(key));
          }
        }
      });
    }
    Vue.component("answer-modal", AnswerModal);
    Vue.component("article-modal", ArticleModal);
    Vue.component("zoom-modal", ZoomModal);
    Vue.component("light-box", LightBox);
    Vue.component("mayday-flowy", MaydayFlowy);
  }
};
const ModalModule = {
  plugin: modalPlugin,
  store: modalStore
};
;// CONCATENATED MODULE: ./src/modules/admin/store/mutation-types.ts
const admin_store_mutation_types_LOGOUT = "LOGOUT";
const SET_AUTH = "SET_AUTH";
const SET_ACCOUNT_DATA = "SET_ACCOUNT_DATA";
const LOGIN = "LOGIN";
const AUTH_LOADING = "AUTH_LOADING";
const SSO_LOADING = "SSO_LOADING";
const AUTH_ERROR = "AUTH_ERROR";
const SET_EXTENSION_VERSION = "SET_EXTENSION_VERSION";
const UPDATE_USER_PREFERENCES = "UPDATE_USER_PREFERENCES";
const UPDATE_ROLES = "UPDATE_ROLES";
const SET_COMPANY_DOMAIN = "SET_COMPANY_DOMAIN";
const UPDATE_RECOMMENDATIONS = "UPDATE_RECOMMENDATIONS";
;// CONCATENATED MODULE: ./src/modules/admin/store/actions.ts


/* harmony default export */ var admin_store_actions = ({
  logout({
    commit
  }) {
    commit(admin_store_mutation_types_LOGOUT);
  },
  async userLogin({
    commit,
    dispatch
  }, authData) {
    commit(AUTH_LOADING, true);
    try {
      const auth = await this.$adminService.login(authData);
      if (!auth) return commit(AUTH_ERROR, "TIMEOUT_ERROR");
      const {
        data
      } = auth;
      if (!data) return commit(AUTH_ERROR, "AUTHENTICATION_ERROR");
      const {
        accessToken,
        refreshToken,
        accessExpirationDate
      } = data;
      return dispatch("initSessionFromToken", {
        accessToken,
        refreshToken,
        accessExpirationDate
      });
    } catch (err) {
      let errorCode = null;
      if (err.response && err.response.data) errorCode = String(err.response.data.statusCode);
      commit(AUTH_ERROR, errorCode);
    } finally {
      commit(AUTH_LOADING, false);
    }
  },
  async initSessionFromToken({
    commit
  }, {
    accessToken,
    refreshToken,
    accessExpirationDate
  }) {
    try {
      // reset auth state before login
      commit(SET_AUTH, {
        accessToken: null,
        refreshToken: null,
        accessExpirationDate: 0
      });
      const contextData = await this.$adminService.loginFromToken(accessToken);
      if (!contextData) return commit(AUTH_ERROR, "TIMEOUT_ERROR");
      const {
        user: loginData
      } = contextData;
      if (!loginData) return commit(AUTH_ERROR, "AUTHENTICATION_ERROR");
      const {
        isVerified
      } = loginData;
      if (!isVerified) return;
      commit(SET_AUTH, {
        accessToken,
        refreshToken,
        accessExpirationDate
      });
      commit(AUTH_ERROR, null);
      return {
        loginData,
        accessToken
      };
    } catch (error) {
      try {
        const errorCode = error.response.data.code;
        if (errorCode) {
          commit(AUTH_ERROR, errorCode);
        } else {
          commit(AUTH_ERROR, null);
        }
      } catch (err) {
        commit(AUTH_ERROR, null);
      } finally {
        commit(AUTH_LOADING, false);
      }
    } finally {
      commit(AUTH_LOADING, false);
    }
  },
  async storeAccountData({
    commit
  }, accountData) {
    commit(SET_ACCOUNT_DATA, accountData);
  },
  async refreshRoles({
    state,
    commit
  }) {
    const {
      accessToken
    } = state;
    const res = await this.$adminService.loginFromToken(accessToken);
    const company = res.user.company;
    commit(UPDATE_ROLES, company);
  },
  startSsoLoading({
    commit
  }) {
    commit(SSO_LOADING, true);
    // Add setTimeout in order to avoid infinite SSO
    // protocole attempts
    setTimeout(() => {
      commit(SSO_LOADING, false);
    }, 30000);
  },
  endSsoLoading({
    commit
  }) {
    commit(SSO_LOADING, false);
  },
  async addPreference({
    commit
  }, payload) {
    const {
      data
    } = await this.$adminService.addPreference(payload);
    return commit(UPDATE_USER_PREFERENCES, {
      preferences: data
    });
  },
  async removePreference({
    commit
  }, payload) {
    const {
      data
    } = await this.$adminService.removePreference(payload);
    return commit(UPDATE_USER_PREFERENCES, {
      preferences: data
    });
  },
  storeCompanyDomain({
    commit
  }, domain) {
    commit(SET_COMPANY_DOMAIN, domain);
  },
  setAuthError({
    commit
  }, status) {
    commit(AUTH_ERROR, status);
  },
  // RECOMMENDATIONS
  updateRecommendations({
    commit
  }, recommendations) {
    commit(UPDATE_RECOMMENDATIONS, {
      recommendations
    });
  },
  async getRecommendations({
    commit,
    state,
    getters
  }, {
    tabSource,
    conversationId,
    context
  }) {
    if (!tabSource || !conversationId) return null;
    try {
      const {
        companyHasIntegration
      } = getters;
      if (!companyHasIntegration(tabSource)) return null;
      const hasMultiSalesforcePreference = state.companyPreferences.find(p => p.type === "HAS_MULTI_SALESFORCE_ACCOUNT");
      const res = await this.$adminService.getRecommendations(conversationId, tabSource, hasMultiSalesforcePreference ? context : null);
      let {
        recommendations
      } = res.data;
      const mergeRecommendations = state.companyPreferences.find(p => p.type === "WEB_EXT_MERGE_RECOMMENDATIONS");
      if (mergeRecommendations) {
        recommendations = recommendations.reduce((acc, val) => {
          if (acc.find(r => r.treeNodeId === val.treeNodeId)) {
            return acc;
          }
          acc.push(val);
          return acc;
        }, []);
      }
      return commit(UPDATE_RECOMMENDATIONS, {
        recommendations
      });
    } catch (err) {
      console.log(err);
    }
  },
  setAppVersion({
    commit
  }, payload) {
    commit(SET_EXTENSION_VERSION, payload);
  }
});
;// CONCATENATED MODULE: ./src/modules/admin/store/getters.ts
const sanitizeLabel = str => str.replace(/[\p{Emoji}\u200d]+/gu, "").trim();
const admin_store_getters_getters = {
  loggedIn: state => !!state.accessToken,
  authorizedSession: state => {
    return !!state.accessToken && Date.now() < state.accessExpirationDate;
  },
  /**
   * IMPORTANT: version is defined as a getter and no as a state to
   * avoid conflicts at extension update. Indeed, if a version
   * already exists in the store, it won't be updated by the app.
   * @returns string
   */
  currentVersion: state => state.version,
  latestVersion: state => state.latestVersion,
  isDeprecated: state => {
    const {
      version,
      latestVersion
    } = state;
    if (!latestVersion) return false;
    return version !== latestVersion;
  },
  /**
   * COMPANY
   */
  collaborators: state => state.reachableUsers && state.reachableUsers.length ? state.reachableUsers.map(u => ({
    value: {
      id: u.id,
      type: "collaborator"
    },
    username: u.username
  })) : [],
  groups: state => state.reachableRoles && state.reachableRoles.length ? state.reachableRoles.map(g => ({
    value: {
      id: g.id,
      type: "group"
    },
    username: `Groupe: ${g.name}`,
    reachable: true
  })) : [],
  reportRecipients: (_state, getters) => {
    const receivers = getters.groups.concat(getters.collaborators);
    return receivers.sort((a, b) => sanitizeLabel(a.username).localeCompare(sanitizeLabel(b.username)));
  },
  companyLogo: state => state.logo,
  /**
   * Here we use both companyDomain and companySubdomain to handle
   * chrome update transition. Indeed, at extension update companySubdomain
   * may not be initialized, hence we use companyDomain temporarily
   * @param {Store} state
   * @returns string
   */
  subdomainUrl: state => {
    const {
      companyDomain,
      companySubdomain
    } = state;
    const domain = companySubdomain || companyDomain;
    return domain ? `https://${domain}.mayday.fr` : "https://app.mayday.fr";
  },
  /**
   * USER
   */
  recommendationsAvailable: state => state.recommendations.length > 0,
  recommendations: state => state.recommendations,
  appAtLeft: state => !!state.preferences.find(({
    preference
  }) => preference === "EXTENSION_POSITION"),
  customWidth: state => {
    const customWidthPreference = state.preferences.find(p => p.preference === "SIDEBAR_CUSTOM_WIDTH");
    return customWidthPreference ? parseInt(customWidthPreference.value, 10) : 300;
  },
  hasModalClosureShortcut: state => !!state.preferences.find(({
    preference
  }) => preference === "MODAL_CLOSURE_SHORTCUT"),
  hasArticleCopyPasteShortcut: state => !!state.preferences.find(({
    preference
  }) => preference === "ARTICLE_COPY_PASTE_SHORTCUT"),
  hasAnswerCopyPasteShortcut: state => !!state.preferences.find(({
    preference
  }) => preference === "ANSWER_COPY_PASTE_SHORTCUT"),
  hasForcingRecommendation: state => !!state.preferences.find(({
    preference
  }) => preference === "FORCING_SHORTCUT"),
  hasUnreadNotificationsOnly: state => !!state.preferences.find(({
    preference
  }) => preference === "UNREAD_NOTIFICATIONS_ONLY"),
  resetNavigationPathAtOpening: state => !!state.preferences.find(({
    preference
  }) => preference === "RESET_NAVIGATION_PATH_AT_OPENING"),
  // COMPANY PREFERENCES
  isSearchNoSteps: state => !!state.companyPreferences.find(p => ["WEB_EXT_SEARCH_NO_STEPS", "ZENDESK_SEARCH_NO_STEPS"].includes(p.type)),
  salesForceFocusTab: state => state.companyPreferences.find(({
    type
  }) => type === "WEB_EXT_SALESFORCE_FOCUS_TAB"),
  companyColor: state => {
    const colorPreference = state.companyPreferences.find(p => p.type === "PRIMARY_COLOR");
    return colorPreference ? colorPreference.value : "#0081F9";
  },
  manuallyTriggerActions: state => !!state.companyPreferences.find(({
    type,
    value
  }) => type === "WEB_EXT_MANUALLY_TRIGGER_ACTIONS" && value === "1"),
  automationsDelay: state => {
    const automationsDelayPreference = state.companyPreferences.find(p => p.type === "WEB_EXT_AUTOMATION_DISPLAY_DELAY");
    return automationsDelayPreference ? parseInt(automationsDelayPreference.value, 10) * 1000 : 15 * 1000;
  },
  companyPreferences: state => state.companyPreferences,
  // INTEGRATIONS
  companyIntegrations: state => state.integrations && state.integrations.length ? state.integrations.map(i => i.integration) : [],
  companyHasIntegration: (_state, getters) => integration => !!getters.companyIntegrations.find(i => i.toLowerCase() === integration.toLowerCase())
};
/* harmony default export */ var admin_store_getters = (admin_store_getters_getters);
;// CONCATENATED MODULE: ./src/modules/admin/store/state.ts
const admin_store_state_state = () => ({
  /**
   * APP
   */
  // TODO REMOVE FROM MODULE
  version: "1.21.1",
  latestVersion: null,
  /**
   * AUTH
   */
  accessToken: null,
  refreshToken: null,
  accessExpirationDate: 0,
  esToken: null,
  authIsLoading: false,
  ssoIsLoading: false,
  status: null,
  /**
   * USER
   */
  userId: null,
  username: "",
  preferences: [],
  /**
   * COMPANY
   */
  integrations: [],
  reachableUsers: [],
  reachableRoles: [],
  companyPreferences: [],
  logo: null,
  companySubdomain: null,
  companyDomain: null,
  /**
   * RECOMMENDATIONS
   */
  recommendations: []
});
;// CONCATENATED MODULE: ./src/modules/admin/store/mutations.ts


/* harmony default export */ var admin_store_mutations = ({
  [SET_COMPANY_DOMAIN](state, payload) {
    state.companyDomain = payload;
  },
  [SET_AUTH](state, payload) {
    state.accessToken = payload.accessToken;
    state.accessExpirationDate = payload.accessExpirationDate;
    state.esToken = payload.esToken;
    state.refreshToken = payload.refreshToken;
  },
  [SET_ACCOUNT_DATA](state, payload) {
    if (!payload) {
      state.status = null;
    }
    /**
     * USER
     */
    state.userId = payload.id;
    state.username = payload.username;
    state.preferences = payload.preferences;
    /**
     * COMPANY
     */
    const {
      company
    } = payload;
    state.integrations = company.integrations;
    state.reachableUsers = company.reachableUsers;
    state.reachableRoles = company.reachableRoles;
    state.companyPreferences = company.preferences;
    state.logo = company.logo;
    state.companySubdomain = company.subdomain;
  },
  [AUTH_LOADING](state, payload) {
    state.authIsLoading = payload;
  },
  [SSO_LOADING](state, payload) {
    state.ssoIsLoading = payload;
  },
  [SET_EXTENSION_VERSION](state, {
    version,
    latestVersion
  }) {
    state.version = version;
    state.latestVersion = latestVersion;
  },
  [admin_store_mutation_types_LOGOUT](state) {
    const {
      companyDomain,
      ...freshState
    } = admin_store_state_state();
    Object.assign(state, freshState);
  },
  [AUTH_ERROR](state, payload) {
    state.status = payload;
  },
  [UPDATE_RECOMMENDATIONS](state, payload) {
    state.recommendations = payload.recommendations;
  },
  [UPDATE_USER_PREFERENCES](state, payload) {
    state.preferences = payload.preferences;
  },
  [UPDATE_ROLES](state, company) {
    state.reachableUsers = company.reachableUsers;
    state.reachableRoles = company.reachableRoles;
  }
});
;// CONCATENATED MODULE: ./src/modules/admin/store/index.ts




const adminStore = {
  namespaced: true,
  state: admin_store_state_state,
  getters: admin_store_getters,
  actions: admin_store_actions,
  mutations: admin_store_mutations
};
// EXTERNAL MODULE: ./node_modules/buffer/index.js
var buffer = __webpack_require__(8764);
;// CONCATENATED MODULE: ./src/modules/admin/service/index.ts


const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
class AdminService {
  constructor(adminClient, authClient, frontUrl, ssoUrl) {
    _defineProperty(this, "adminClient", void 0);
    _defineProperty(this, "authClient", void 0);
    _defineProperty(this, "frontUrl", void 0);
    _defineProperty(this, "ssoUrl", void 0);
    this.authClient = authClient;
    this.adminClient = adminClient;
    this.ssoUrl = ssoUrl;
    this.frontUrl = frontUrl;
  }
  login(payload) {
    return Promise.race([this.authClient.post("auth/login", {
      ...payload,
      source: "chrome"
    }), timeout(15 * 1000)]);
  }
  async loginFromToken(accessToken) {
    const res = await Promise.race([this.adminClient.get("login-with-token", {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }), timeout(15 * 1000)]);
    return res.data || res;
  }
  //PREFERENCES
  addPreference(payload) {
    return this.adminClient.post("preferences/add", payload);
  }
  removePreference(payload) {
    return this.adminClient.post("preferences/remove", payload);
  }
  getRedirectionUrl(sso, domain) {
    let baseUrl = `${this.ssoUrl}/${sso}`;
    const statePayload = {
      url: this.frontUrl,
      source: "chrome"
    };
    if (sso === "saml" && domain) {
      baseUrl = `${baseUrl}/${domain}`;
      statePayload.url = `https://${domain}.mayday.fr`;
    }
    const state = buffer/* Buffer.from */.lW.from(JSON.stringify(statePayload)).toString("base64");
    return `${baseUrl}?state=${state}`;
  }
  getRecommendations(conversationId, source, context) {
    let url = `recommend/${source.toLowerCase()}/${conversationId}`;
    if (context) url += `?context=${context}`;
    return this.adminClient.get(url);
  }
  verifyDomain(domain) {
    return this.adminClient.get(`sso/verify/${domain}`);
  }
}
const attachAdminService = (adminClient, authClient, frontUrl, ssoUrl) => {
  return new AdminService(adminClient, authClient, frontUrl, ssoUrl);
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/Login.vue?vue&type=template&id=74aee542&scoped=true&
var Loginvue_type_template_id_74aee542_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    class: _vm.tightScrollView ? 'scroll-tight' : 'scroll-body'
  }, [_c('div', {
    staticClass: "md-login-header bg-gradient-to-br from-blue to-blue-light"
  }, [_c('img', {
    staticClass: "md-mb-3 h-12 w-12",
    attrs: {
      "src": __webpack_require__(3597)
    }
  }), _c('h1', {
    staticClass: "md-mb-3 block text-3xl font-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("login.baseline.title")) + " ")]), _c('p', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s(_vm.$t("login.baseline.subtitle")))]), _vm.isDeprecated ? _c('card', {
    staticClass: "md-error-card text-gray-8",
    attrs: {
      "type": "danger"
    }
  }, [_c('div', {
    staticClass: "flex items-start"
  }, [_c('div', [_c('font-awesome-icon', {
    staticClass: "w-3 h-3 text-red",
    attrs: {
      "icon": ['fad', 'exclamation-triangle']
    }
  })], 1), _c('div', {
    staticClass: "md-pl-2 flex-1"
  }, [_c('span', {
    staticClass: "md-deprecated-message"
  }, [_vm._v(" " + _vm._s(_vm.$t("version-deprecated")) + " ")])])])]) : _vm._e()], 1), _vm.showSsoForm ? _c('SsoDomainForm', {
    on: {
      "valid-domain": function ($event) {
        return _vm.openSso('saml');
      },
      "close": function ($event) {
        _vm.showSsoForm = false;
      }
    }
  }) : _c('div', {
    staticClass: "-my-20 md-px-5"
  }, [_c('div', {
    staticClass: "h-1 rounded-t-md bg-blue"
  }), _c('div', {
    staticClass: "md-py-5 md-px-4 bg-white rounded-b-md"
  }, [_vm.pendingError.length > 0 ? _c('card', {
    staticClass: "md-error-card text-gray-8 md-mb-4",
    attrs: {
      "type": "danger"
    }
  }, [_c('div', {
    staticClass: "flex items-start"
  }, [_c('div', [_c('font-awesome-icon', {
    staticClass: "w-3 h-3 text-red",
    attrs: {
      "icon": ['fad', 'exclamation-triangle']
    }
  })], 1), _c('div', {
    staticClass: "md-pl-2 flex-1"
  }, [_c('p', {
    staticClass: "md-error-message",
    domProps: {
      "innerHTML": _vm._s(_vm.pendingError)
    }
  }), _vm.errorCode ? _c('div', {
    staticClass: "md-text-xs"
  }, [_vm._v(_vm._s(_vm.errorCode))]) : _vm._e()])])]) : _vm.weakConnection ? _c('card', {
    staticClass: "md-connection-card text-gray-8 md-mb-4",
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    staticClass: "flex items-start"
  }, [_c('div', [_c('font-awesome-icon', {
    staticClass: "w-3 h-3 text-red",
    attrs: {
      "icon": ['fad', 'exclamation-triangle']
    }
  })], 1), _c('div', {
    staticClass: "md-pl-2"
  }, [_c('span', {
    staticClass: "md-connection-message"
  }, [_vm._v(" " + _vm._s(_vm.$t("login.weak-connection")) + " " + _vm._s(_vm.$t("login.please-wait")) + " ")])])])]) : _vm._e(), _c('form', {
    attrs: {
      "role": "form",
      "data-form-type": "login"
    }
  }, [_c('base-input', {
    ref: "email",
    attrs: {
      "label": _vm.$t('login.form.email'),
      "placeholder": "john.doe@mayday.fr",
      "label-classes": "md-mb-1 md-text-sm",
      "addon-left-icon": ['fas', 'envelope'],
      "valid": _vm.isValidEmail()
    },
    model: {
      value: _vm.model.email,
      callback: function ($$v) {
        _vm.$set(_vm.model, "email", $$v);
      },
      expression: "model.email"
    }
  }), _c('base-input', {
    ref: "password",
    staticClass: "md-mt-3",
    attrs: {
      "label": _vm.$t('login.form.password'),
      "placeholder": "••••••••",
      "type": "password",
      "label-classes": "mb-1 md-text-sm",
      "addon-left-icon": ['fas', 'key'],
      "show-or-hide": true,
      "name": "password",
      "valid": _vm.isValidPassword()
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.login();
      }
    },
    model: {
      value: _vm.model.password,
      callback: function ($$v) {
        _vm.$set(_vm.model, "password", $$v);
      },
      expression: "model.password"
    }
  }), _c('a', {
    staticClass: "md-mt-1 text-right md-text-xs text-blue font-semibold",
    attrs: {
      "href": "https://app.mayday.fr/reset",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("login.forgot-password")) + " ")]), _c('div', {
    staticClass: "md-mt-10"
  }, [!_vm.authIsLoading ? _c('base-button', {
    staticClass: "md-px-5 md-py-3 w-full bg-blue text-white font-medium rounded-md",
    attrs: {
      "type": "primary",
      "disabled": _vm.modelIsInvalid
    },
    on: {
      "click": function ($event) {
        return _vm.login();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.form.login")))]) : _c('base-button', {
    staticClass: "md-px-5 md-py-3 w-full bg-blue text-white rounded-md",
    attrs: {
      "type": "primary"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "md-pb-10"
  }, [_c('div', {
    staticClass: "md-my-10 flex items-center text-gray-5 font-bold"
  }, [_c('Divider'), _c('div', {
    staticClass: "md-px-2"
  }, [_vm._v(_vm._s(_vm.$t("login.form.or")))]), _c('Divider')], 1), _c('div', {
    staticClass: "-mx-4 flex justify-between"
  }, [_c('div', {
    staticClass: "w-full md-px-4"
  }, [_c('base-button', {
    staticClass: "md-py-2 w-full border border-white bg-white/60",
    attrs: {
      "type": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.openSso('google');
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "h-6 w-6",
    attrs: {
      "src": __webpack_require__(8450),
      "alt": "google_logo.png"
    }
  })])])], 1), _c('div', {
    staticClass: "w-full md-px-4"
  }, [_c('base-button', {
    staticClass: "md-py-3 w-full border border-white bg-white/60",
    attrs: {
      "type": "secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.openSso('saml');
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center items-center"
  }, [_c('div', {
    staticClass: "h-4 w-4 flex items-center justify-center bg-gray-7 rounded-sm"
  }, [_c('font-awesome-icon', {
    staticClass: "h-2 w-2 inline-flex text-white",
    attrs: {
      "icon": ['fas', 'key']
    }
  })], 1), _c('span', {
    staticClass: "md-ml-1 text-gray-7 font-bold leading-3"
  }, [_vm._v("SSO")])])])], 1)]), _vm.companyDomain ? _c('div', {
    staticClass: "md-mt-2 flex items-center md-text-xs hover:text-blue cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.storeCompanyDomain(null);
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "md-mr-2",
    attrs: {
      "icon": "undo"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("dropdown.reset-domain")) + " ")], 1) : _vm._e()])])], 1), _c('Footer')], 1);
};
var Loginvue_type_template_id_74aee542_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/admin/Login.vue?vue&type=template&id=74aee542&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/components/SsoDomainForm.vue?vue&type=template&id=67ced0a4&scoped=true&
var SsoDomainFormvue_type_template_id_67ced0a4_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "-my-20 md-px-5"
  }, [_c('div', {
    staticClass: "h-1 rounded-t-md bg-blue"
  }), _c('div', {
    staticClass: "md-py-5 md-px-4 bg-white rounded-b-md"
  }, [_c('div', {
    staticClass: "md-mb-4 md-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("login.sso-instructions")) + " ")]), _vm.pendingError.length > 0 ? _c('card', {
    staticClass: "md-error-card text-gray-8 md-mb-4",
    attrs: {
      "type": "danger"
    }
  }, [_c('div', {
    staticClass: "flex items-start"
  }, [_c('div', [_c('font-awesome-icon', {
    staticClass: "w-3 h-3 text-red",
    attrs: {
      "icon": ['fad', 'exclamation-triangle']
    }
  })], 1), _c('div', {
    staticClass: "md-pl-2 flex-1"
  }, [_c('p', {
    staticClass: "md-error-message",
    domProps: {
      "innerHTML": _vm._s(_vm.pendingError)
    }
  }), _vm.errorCode ? _c('span', {
    staticClass: "md-text-xs"
  }, [_vm._v(_vm._s(_vm.errorCode))]) : _vm._e()])])]) : _vm._e(), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('base-input', {
    attrs: {
      "label": _vm.$t('login.form.domain'),
      "placeholder": "entreprise",
      "label-classes": "md-mb-1 md-text-sm",
      "addon-left-icon": ['fas', 'globe']
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.verifyDomain();
      }
    },
    model: {
      value: _vm.domain,
      callback: function ($$v) {
        _vm.domain = $$v;
      },
      expression: "domain"
    }
  }), !_vm.loading ? _c('base-button', {
    staticClass: "md-my-4 md-px-5 md-py-3 w-full bg-blue text-white font-medium rounded-md",
    attrs: {
      "disabled": _vm.invalidDomain,
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.verifyDomain();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("login.form.sso-cta")))]) : _c('base-button', {
    staticClass: "md-my-4 md-px-5 md-py-3 w-full bg-blue text-white rounded-md",
    attrs: {
      "type": "primary"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "md-mt-2 flex items-center md-text-xs hover:text-blue cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "md-mr-2",
    attrs: {
      "icon": "long-arrow-left"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("login.back-to-login")) + " ")], 1)]);
};
var SsoDomainFormvue_type_template_id_67ced0a4_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Card.vue?vue&type=template&id=c1ef75f2&
var Cardvue_type_template_id_c1ef75f2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative flex flex-col bg-white border border-1 rounded-sm",
    class: [{
      'md-card-lift--hover': _vm.hover
    }, {
      shadow: _vm.shadow
    }, {
      [`shadow-${_vm.shadowSize}`]: _vm.shadowSize
    }, {
      [`border-${_vm.type}`]: _vm.type
    }],
    on: {
      "click": function ($event) {
        return _vm.clickEvent();
      }
    }
  }, [_vm.$slots.header ? _c('div', {
    staticClass: "md-card-header",
    class: _vm.headerClasses
  }, [_vm._t("header")], 2) : _vm._e(), !_vm.noBody ? _c('div', {
    staticClass: "flex-1 md-card-body",
    class: _vm.bodyClasses
  }, [_vm._t("default")], 2) : _vm._e(), _vm.noBody ? _vm._t("default") : _vm._e(), _vm.$slots.footer ? _c('div', {
    staticClass: "md-card-footer",
    class: _vm.footerClasses
  }, [_vm._t("footer")], 2) : _vm._e()], 2);
};
var Cardvue_type_template_id_c1ef75f2_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Card.vue?vue&type=script&lang=js&
/* harmony default export */ var Cardvue_type_script_lang_js_ = ({
  name: "CardComponent",
  props: {
    type: {
      type: String,
      description: "Card type"
    },
    gradient: {
      type: String,
      description: "Card background gradient type (warning,danger etc)"
    },
    hover: {
      type: Boolean,
      description: "Whether card should move on hover"
    },
    shadow: {
      type: Boolean,
      description: "Whether card has shadow"
    },
    shadowSize: {
      type: String,
      description: "Card shadow size"
    },
    noBody: {
      type: Boolean,
      default: false,
      description: "Whether card should have wrapper body class"
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes"
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes"
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes"
    }
  },
  methods: {
    clickEvent() {
      this.$emit("click", true);
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Card.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_Cardvue_type_script_lang_js_ = (Cardvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Card.vue?vue&type=style&index=0&id=c1ef75f2&prod&lang=postcss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Card.vue?vue&type=style&index=0&id=c1ef75f2&prod&lang=postcss&

;// CONCATENATED MODULE: ./src/library/Card.vue



;


/* normalize component */

var Card_component = normalizeComponent(
  library_Cardvue_type_script_lang_js_,
  Cardvue_type_template_id_c1ef75f2_render,
  Cardvue_type_template_id_c1ef75f2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Card = (Card_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseInput.vue?vue&type=template&id=625170b3&scoped=true&
var BaseInputvue_type_template_id_625170b3_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-transparent border-none shadow-none",
    class: [{
      'md-input-group': _vm.hasIcon
    }, {
      'md-has-danger': _vm.error
    }, {
      'md-focused': _vm.focused
    }, {
      'md-has-label': _vm.label || _vm.$slots.label
    }, {
      'md-has-success': _vm.valid === true
    }, {
      'md-has-danger': _vm.valid === false
    }]
  }, [_vm._t("label", function () {
    return [_vm.label ? _c('label', {
      staticClass: "md-form-control-label",
      class: _vm.labelClasses
    }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.required ? _c('span', [_vm._v("*")]) : _vm._e(), _vm.tooltip ? _c('el-tooltip', {
      attrs: {
        "placement": "top",
        "effect": "light"
      },
      scopedSlots: _vm._u([{
        key: "content",
        fn: function () {
          return [_vm._t("tooltip-content")];
        },
        proxy: true
      }], null, true)
    }, [_c('i', {
      staticClass: "fa fa-info-circle info"
    })]) : _vm._e()], 1) : _vm._e()];
  }), _c('div', {
    staticClass: "md-input-group flex border border-gray-2 rounded-sm",
    class: [{
      'border-gray-6': _vm.focused
    }, {
      'md-is-valid': _vm.valid === true
    }, {
      'md-is-invalid': _vm.valid === false
    }]
  }, [_vm.addonLeftIcon || _vm.$slots.addonLeft ? _c('div', {
    staticClass: "md-input-group-prepend"
  }, [_c('span', {
    staticClass: "md-input-group-text"
  }, [_vm._t("addonLeft", function () {
    return [_c('font-awesome-icon', {
      staticClass: "w-3 h-3 fa",
      attrs: {
        "icon": _vm.addonLeftIcon
      }
    })];
  })], 2)]) : _vm._e(), _vm._t("default", function () {
    return [_c('input', _vm._g(_vm._b({
      ref: _vm.name,
      staticClass: "md-form-control",
      class: [{
        'md-is-valid': _vm.valid === true
      }, {
        'md-is-invalid': _vm.valid === false
      }, _vm.inputClasses],
      attrs: {
        "placeholder": _vm.placeholder,
        "aria-describedby": "md-addon-right md-addon-left"
      },
      domProps: {
        "value": _vm.value
      }
    }, 'input', _vm.$attrs, false), _vm.listeners))];
  }, null, _vm.slotData), _vm.showOrHide || _vm.$slots.showOrHide ? _c('div', {
    staticClass: "md-input-group-append"
  }, [_c('span', {
    staticClass: "md-input-group-text"
  }, [_c('button', {
    staticClass: "md-show-or-hide-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changeShowOrHide.apply(null, arguments);
      }
    }
  })])]) : _vm._e(), _vm.addonRightIcon || _vm.$slots.addonRight ? _c('div', {
    staticClass: "md-input-group-append"
  }, [_c('span', {
    staticClass: "md-input-group-text"
  }, [_vm._t("md-addonRight", function () {
    return [_c('font-awesome-icon', {
      staticClass: "w-3 h-3 fa",
      attrs: {
        "icon": _vm.addonRightIcon
      }
    })];
  })], 2)]) : _vm._e()], 2), _vm._t("infoBlock"), _vm._t("helpBlock", function () {
    return [_vm.error ? _c('div', {
      staticClass: "md-text-danger md-invalid-feedback",
      class: {
        'md-mt-2': _vm.hasIcon
      },
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e()];
  })], 2);
};
var BaseInputvue_type_template_id_625170b3_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseInput.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseInputvue_type_script_lang_js_ = ({
  inheritAttrs: false,
  name: "base-input",
  props: {
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    valid: {
      type: Boolean,
      description: "Whether is valid",
      default: undefined
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    name: {
      type: String,
      description: "Input name"
    },
    tooltip: {
      type: Boolean,
      description: "Input tooltip"
    },
    error: {
      type: String,
      description: "Input error (below input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    inputClasses: {
      type: String,
      description: "Input css classes"
    },
    value: {
      type: [String, Number],
      description: "Input value"
    },
    addonRightIcon: {
      type: Array,
      description: "Addon right icon"
    },
    showOrHide: {
      type: Boolean,
      default: true,
      description: "Show/Hide button for password field"
    },
    addonLeftIcon: {
      type: Array,
      description: "Addont left icon"
    },
    placeholder: {
      type: String,
      description: "Input placeholder"
    }
  },
  data() {
    return {
      focused: false,
      isHidden: !!this.showOrHide
    };
  },
  computed: {
    hideIcon() {
      return this.isHidden ? "eye" : "eye-slash";
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners
      };
    },
    hasIcon() {
      const {
        addonRight,
        addonLeft
      } = this.$slots;
      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    },
    changeShowOrHide() {
      const type = this.$refs[this.name].attributes.type.value;
      this.$refs[this.name].attributes.type.value = type === "password" ? "text" : "password";
      this.isHidden = !this.isHidden;
    }
  }
});
;// CONCATENATED MODULE: ./src/library/BaseInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_BaseInputvue_type_script_lang_js_ = (BaseInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseInput.vue?vue&type=style&index=0&id=625170b3&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseInput.vue?vue&type=style&index=0&id=625170b3&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseInput.vue?vue&type=style&index=1&id=625170b3&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseInput.vue?vue&type=style&index=1&id=625170b3&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/BaseInput.vue



;



/* normalize component */

var BaseInput_component = normalizeComponent(
  library_BaseInputvue_type_script_lang_js_,
  BaseInputvue_type_template_id_625170b3_scoped_true_render,
  BaseInputvue_type_template_id_625170b3_scoped_true_staticRenderFns,
  false,
  null,
  "625170b3",
  null
  
)

/* harmony default export */ var BaseInput = (BaseInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/components/SsoDomainForm.vue?vue&type=script&lang=js&




/* harmony default export */ var SsoDomainFormvue_type_script_lang_js_ = ({
  name: "sso-domain-form",
  components: {
    Card: Card,
    BaseButton: BaseButton,
    BaseInput: BaseInput
  },
  data() {
    return {
      domain: "",
      loading: false,
      pendingError: "",
      errorCode: ""
    };
  },
  computed: {
    invalidDomain() {
      return !(this.domain && this.domain.length > 0);
    }
  },
  methods: {
    async verifyDomain() {
      if (this.invalidDomain) {
        return;
      }
      this.loading = true;
      if (this.domain && this.domain.length > 0) {
        try {
          const res = await this.$store.$adminService.verifyDomain(this.domain);
          if (res.status === 200) {
            if (res.data.domain_validity) {
              this.storeCompanyDomain(this.domain);
              this.$nextTick(() => this.$emit("valid-domain"));
            } else {
              this.setPendingError("INVALID_DOMAIN");
            }
          } else {
            this.setPendingError(res.data.message);
          }
        } catch (err) {
          this.setPendingError(err.message);
        }
      }
      this.loading = false;
    },
    setPendingError(message) {
      switch (message) {
        case "INVALID_DOMAIN":
          this.pendingError = this.$t("login.errors.invalid-domain");
          this.errorCode = "ERRSSO01";
          break;
        default:
          this.pendingError = this.$t("login.errors.default");
          this.errorCode = "ERR00";
      }
    },
    ...mapActions("adminModule", ["storeCompanyDomain"])
  }
});
;// CONCATENATED MODULE: ./src/modules/admin/components/SsoDomainForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SsoDomainFormvue_type_script_lang_js_ = (SsoDomainFormvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/components/SsoDomainForm.vue?vue&type=style&index=0&id=67ced0a4&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/admin/components/SsoDomainForm.vue?vue&type=style&index=0&id=67ced0a4&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/admin/components/SsoDomainForm.vue



;


/* normalize component */

var SsoDomainForm_component = normalizeComponent(
  components_SsoDomainFormvue_type_script_lang_js_,
  SsoDomainFormvue_type_template_id_67ced0a4_scoped_true_render,
  SsoDomainFormvue_type_template_id_67ced0a4_scoped_true_staticRenderFns,
  false,
  null,
  "67ced0a4",
  null
  
)

/* harmony default export */ var SsoDomainForm = (SsoDomainForm_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/components/Footer.vue?vue&type=template&id=b0a6b532&
var Footervue_type_template_id_b0a6b532_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-px-5"
  }, [_c('base-swag', {
    staticClass: "md-mb-4 w-full rounded-l-sm rounded-r-sm"
  }), _c('div', {
    staticClass: "md-mb-3 flex justify-center md-text-xs font-semibold"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t("login.register.question")))]), _c('a', {
    staticClass: "text-blue md-text-xs md-ml-1",
    attrs: {
      "href": "https://app.mayday.fr/register",
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("login.register.action")) + " ")])]), !_vm.authorizedSession ? _c('div', {
    staticClass: "md-mb-6 flex justify-center text-[10px] text-gray-7 font-bold"
  }, [_vm._v(" " + _vm._s(`v${_vm.currentVersion}`) + " ")]) : _vm._e()], 1);
};
var Footervue_type_template_id_b0a6b532_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseSwag.vue?vue&type=template&id=762e6ee8&
var BaseSwagvue_type_template_id_762e6ee8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "h-[5px] w-full bg-center swag"
  });
};
var BaseSwagvue_type_template_id_762e6ee8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseSwag.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseSwagvue_type_script_lang_js_ = ({
  name: "BaseSwag"
});
;// CONCATENATED MODULE: ./src/library/BaseSwag.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_BaseSwagvue_type_script_lang_js_ = (BaseSwagvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseSwag.vue?vue&type=style&index=0&id=762e6ee8&prod&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseSwag.vue?vue&type=style&index=0&id=762e6ee8&prod&lang=css&

;// CONCATENATED MODULE: ./src/library/BaseSwag.vue



;


/* normalize component */

var BaseSwag_component = normalizeComponent(
  library_BaseSwagvue_type_script_lang_js_,
  BaseSwagvue_type_template_id_762e6ee8_render,
  BaseSwagvue_type_template_id_762e6ee8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseSwag = (BaseSwag_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/components/Footer.vue?vue&type=script&lang=js&


/* harmony default export */ var Footervue_type_script_lang_js_ = ({
  name: "FooterComponent",
  components: {
    BaseSwag: BaseSwag
  },
  computed: {
    ...mapGetters("adminModule", ["authorizedSession", "currentVersion"])
  }
});
;// CONCATENATED MODULE: ./src/modules/admin/components/Footer.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Footervue_type_script_lang_js_ = (Footervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/admin/components/Footer.vue





/* normalize component */
;
var Footer_component = normalizeComponent(
  components_Footervue_type_script_lang_js_,
  Footervue_type_template_id_b0a6b532_render,
  Footervue_type_template_id_b0a6b532_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Footer = (Footer_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Divider.vue?vue&type=template&id=73686d84&scoped=true&
var Dividervue_type_template_id_73686d84_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "divider",
    attrs: {
      "id": "divider"
    }
  });
};
var Dividervue_type_template_id_73686d84_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Divider.vue?vue&type=script&lang=js&
/* harmony default export */ var Dividervue_type_script_lang_js_ = ({
  name: "DividerComponent"
});
;// CONCATENATED MODULE: ./src/library/Divider.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_Dividervue_type_script_lang_js_ = (Dividervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Divider.vue?vue&type=style&index=0&id=73686d84&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Divider.vue?vue&type=style&index=0&id=73686d84&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Divider.vue



;


/* normalize component */

var Divider_component = normalizeComponent(
  library_Dividervue_type_script_lang_js_,
  Dividervue_type_template_id_73686d84_scoped_true_render,
  Dividervue_type_template_id_73686d84_scoped_true_staticRenderFns,
  false,
  null,
  "73686d84",
  null
  
)

/* harmony default export */ var Divider = (Divider_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/Login.vue?vue&type=script&lang=js&







/* harmony default export */ var Loginvue_type_script_lang_js_ = ({
  name: "LoginView",
  components: {
    SsoDomainForm: SsoDomainForm,
    Footer: Footer,
    BaseButton: BaseButton,
    BaseInput: BaseInput,
    Divider: Divider,
    Card: Card
  },
  props: {
    tightScrollView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      pendingError: "",
      errorCode: "",
      weakConnection: false,
      showSsoForm: false
    };
  },
  computed: {
    modelIsInvalid() {
      try {
        return !this.model.email.length || !this.model.password;
      } catch (e) {
        return true;
      }
    },
    ...mapState("adminModule", ["accessToken", "status", "companyDomain", "authIsLoading"]),
    ...mapGetters("adminModule", ["isDeprecated"])
  },
  methods: {
    isValidEmail() {
      if (this.model.email === "") {
        return undefined;
      }
      const re = /\S+@\S+\.\S+/;
      return re.test(this.model.email);
    },
    isValidPassword() {
      if (this.model.password === "") {
        return undefined;
      }
      return this.model.password.length >= 6;
    },
    async login() {
      if (this.modelIsInvalid) {
        return;
      }
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection) {
        if (connection.effectiveType !== "4g") this.weakConnection = true;
      }
      const loginData = await this.userLogin(this.model);
      this.$emit("login-data", loginData);
      this.weakConnection = false;
      const {
        accessToken,
        status
      } = this.$store.state.adminModule;
      if (accessToken) return;
      if (status) {
        switch (status) {
          case "404":
            this.pendingError = this.$t("login.errors.authentication");
            this.errorCode = "ERR01";
            break;
          case "401":
            this.pendingError = this.$t("login.errors.unverified");
            this.errorCode = "ERR02";
            break;
          case "429":
            this.pendingError = this.$t("login.errors.too-many-attempts");
            this.errorCode = "ERR03";
            break;
          default:
            this.pendingError = this.$t("login.errors.default");
            this.errorCode = "ERR00";
        }
      } else {
        this.pendingError = this.$t("login.errors.default");
      }
    },
    openSso(sso) {
      this.showSsoForm = false;
      if (sso !== "saml" || this.companyDomain) {
        const url = this.$store.$adminService.getRedirectionUrl(sso, this.companyDomain);
        this.startSsoLoading();
        window.open(url, "_blank");
      } else {
        this.showSsoForm = true;
      }
    },
    ...mapActions("adminModule", ["userLogin", "startSsoLoading", "storeCompanyDomain"])
  },
  watch: {
    status() {
      switch (this.status) {
        case "500":
          this.pendingError = this.$t("login.errors.server");
          this.errorCode = "ERR05";
          break;
        case "AUTHENTICATION_ERROR":
          this.pendingError = this.$t("login.errors.authentication");
          this.errorCode = "ERR02";
          break;
        case "NO_GROUPS_ASSIGNED":
          this.pendingError = this.$t("login.errors.permissions");
          this.errorCode = "ERR03";
          break;
        case "STORAGE_QUOTA_EXCEEDED":
          this.pendingError = `${this.$t("login.errors.tab-1")} <a href="https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&hl=fr" target="_blank">${this.$t("login.errors.tab-2")}</a> ${this.$t("login.errors.tab-3")}`;
          this.errorCode = "ERR04";
          break;
        default:
          this.pendingError = this.$t("login.errors.default");
          this.errorCode = "ERR00";
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/admin/Login.vue?vue&type=script&lang=js&
 /* harmony default export */ var admin_Loginvue_type_script_lang_js_ = (Loginvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/Login.vue?vue&type=style&index=0&id=74aee542&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/admin/Login.vue?vue&type=style&index=0&id=74aee542&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/admin/Login.vue



;


/* normalize component */

var Login_component = normalizeComponent(
  admin_Loginvue_type_script_lang_js_,
  Loginvue_type_template_id_74aee542_scoped_true_render,
  Loginvue_type_template_id_74aee542_scoped_true_staticRenderFns,
  false,
  null,
  "74aee542",
  null
  
)

/* harmony default export */ var Login = (Login_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/Preferences.vue?vue&type=template&id=8822e4a8&scoped=true&
var Preferencesvue_type_template_id_8822e4a8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "p-4 scroll-body"
  }, [_c('div', {
    staticClass: "general-info text-left"
  }, [_c('div', {
    staticClass: "flex flex-wrap"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('h1', {
    staticClass: "display-4 mb-1"
  }, [_vm._v(" " + _vm._s(_vm.$t("preferences.title", {
    username: _vm.username
  })) + " ")])]), _c('small', {
    staticClass: "w-full"
  }, [_vm._v(_vm._s(`v${_vm.currentVersion}`))])])]), _c('div', {
    staticClass: "appearence text-left"
  }, [_c('div', {
    staticClass: "flex flex-wrap"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "text-uppercase text-gray-6 mt-2 category-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("preferences.appearance")) + " ")])]), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.position.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.position.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "👈",
      "onText": "👉"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('EXTENSION_POSITION', $event);
      }
    },
    model: {
      value: _vm.switches.EXTENSION_POSITION,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "EXTENSION_POSITION", $$v);
      },
      expression: "switches.EXTENSION_POSITION"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("preferences.notifications.title")) + " ")]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.notifications.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "Non",
      "onText": "Oui"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('UNREAD_NOTIFICATIONS_ONLY', $event);
      }
    },
    model: {
      value: _vm.switches.UNREAD_NOTIFICATIONS_ONLY,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "UNREAD_NOTIFICATIONS_ONLY", $$v);
      },
      expression: "switches.UNREAD_NOTIFICATIONS_ONLY"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.language.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.language.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "🇫🇷",
      "onText": "🇬🇧"
    },
    model: {
      value: _vm.lang,
      callback: function ($$v) {
        _vm.lang = $$v;
      },
      expression: "lang"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.diag-xl.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.diag-xl.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "SM",
      "onText": "XL"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('XL_LINKED_DIAG_DISPLAY', $event);
      }
    },
    model: {
      value: _vm.switches.XL_LINKED_DIAG_DISPLAY,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "XL_LINKED_DIAG_DISPLAY", $$v);
      },
      expression: "switches.XL_LINKED_DIAG_DISPLAY"
    }
  })], 1), _c('div', {
    staticClass: "w-full2"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.article-xl.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.article-xl.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "SM",
      "onText": "XL"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('XL_LINKED_ARTICLE_DISPLAY', $event);
      }
    },
    model: {
      value: _vm.switches.XL_LINKED_ARTICLE_DISPLAY,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "XL_LINKED_ARTICLE_DISPLAY", $$v);
      },
      expression: "switches.XL_LINKED_ARTICLE_DISPLAY"
    }
  })], 1)])]), _c('hr', {
    staticClass: "container my-3"
  }), _c('div', {
    staticClass: "productivity text-left"
  }, [_c('div', {
    staticClass: "flex flex-wrap"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "text-uppercase text-gray-6 category-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("preferences.productivity")) + " ")])]), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("preferences.copy-paste-article.title")) + " ")]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.copy-paste-article.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "Non",
      "onText": "Oui"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('ARTICLE_COPY_PASTE_SHORTCUT', $event);
      }
    },
    model: {
      value: _vm.switches.ARTICLE_COPY_PASTE_SHORTCUT,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "ARTICLE_COPY_PASTE_SHORTCUT", $$v);
      },
      expression: "switches.ARTICLE_COPY_PASTE_SHORTCUT"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("preferences.copy-paste-diagnostic.title")) + " ")]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.copy-paste-diagnostic.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "Non",
      "onText": "Oui"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('ANSWER_COPY_PASTE_SHORTCUT', $event);
      }
    },
    model: {
      value: _vm.switches.ANSWER_COPY_PASTE_SHORTCUT,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "ANSWER_COPY_PASTE_SHORTCUT", $$v);
      },
      expression: "switches.ANSWER_COPY_PASTE_SHORTCUT"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.closure.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.closure.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "Non",
      "onText": "Oui"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('MODAL_CLOSURE_SHORTCUT', $event);
      }
    },
    model: {
      value: _vm.switches.MODAL_CLOSURE_SHORTCUT,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "MODAL_CLOSURE_SHORTCUT", $$v);
      },
      expression: "switches.MODAL_CLOSURE_SHORTCUT"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.automations.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.automations.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "Non",
      "onText": "Oui"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('FORCING_SHORTCUT', $event);
      }
    },
    model: {
      value: _vm.switches.FORCING_SHORTCUT,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "FORCING_SHORTCUT", $$v);
      },
      expression: "switches.FORCING_SHORTCUT"
    }
  })], 1), _c('div', {
    staticClass: "w-full"
  }, [_c('p', {
    staticClass: "lead subtitle"
  }, [_vm._v(_vm._s(_vm.$t("preferences.reset-nav.title")))]), _c('p', {
    staticClass: "text-gray-6"
  }, [_c('small', [_vm._v(_vm._s(_vm.$t("preferences.reset-nav.description")))])]), _c('base-switch', {
    staticClass: "toggle",
    attrs: {
      "offText": "Non",
      "onText": "Oui"
    },
    on: {
      "input": function ($event) {
        return _vm.updatePreference('RESET_NAVIGATION_PATH_AT_OPENING', $event);
      }
    },
    model: {
      value: _vm.switches.RESET_NAVIGATION_PATH_AT_OPENING,
      callback: function ($$v) {
        _vm.$set(_vm.switches, "RESET_NAVIGATION_PATH_AT_OPENING", $$v);
      },
      expression: "switches.RESET_NAVIGATION_PATH_AT_OPENING"
    }
  })], 1)])])]);
};
var Preferencesvue_type_template_id_8822e4a8_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/Preferences.vue?vue&type=script&lang=js&

/* harmony default export */ var Preferencesvue_type_script_lang_js_ = ({
  name: "PreferencesView",
  computed: {
    lang: {
      get() {
        return this.$i18n.locale === "en";
      },
      set(val) {
        this.$i18n.locale = val ? "en" : "fr";
        this.$store.dispatch("adminModule/updateAppLanguage", val ? "en" : "fr");
      }
    },
    ...mapState("adminModule", ["preferences", "username", "updateAppLanguage", "customWidth"]),
    ...mapGetters("adminModule", ["currentVersion"])
  },
  data() {
    return {
      switches: {
        EXTENSION_POSITION: false,
        ARTICLE_COPY_PASTE_SHORTCUT: false,
        ANSWER_COPY_PASTE_SHORTCUT: false,
        MODAL_CLOSURE_SHORTCUT: false,
        FORCING_SHORTCUT: false,
        UNREAD_NOTIFICATIONS_ONLY: false,
        XL_LINKED_DIAG_DISPLAY: false,
        XL_LINKED_ARTICLE_DISPLAY: false,
        RESET_NAVIGATION_PATH_AT_OPENING: false
      }
    };
  },
  mounted() {
    this.preferences.map(({
      preference
    }) => preference).forEach(preference => {
      this.switches[preference] = true;
    });
  },
  methods: {
    updatePreference(preferenceType, e) {
      if (e) {
        this.addPreference({
          preference: {
            preferenceType,
            preferenceValue: 1
          }
        });
      } else {
        const preferenceToDel = this.preferences.find(({
          preference
        }) => preference === preferenceType);
        if (preferenceToDel) {
          this.removePreference({
            preferenceId: preferenceToDel.id
          });
        }
      }
    },
    ...mapActions("adminModule", ["addPreference", "removePreference"])
  }
});
;// CONCATENATED MODULE: ./src/modules/admin/Preferences.vue?vue&type=script&lang=js&
 /* harmony default export */ var admin_Preferencesvue_type_script_lang_js_ = (Preferencesvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/admin/Preferences.vue?vue&type=style&index=0&id=8822e4a8&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/admin/Preferences.vue?vue&type=style&index=0&id=8822e4a8&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/admin/Preferences.vue



;


/* normalize component */

var Preferences_component = normalizeComponent(
  admin_Preferencesvue_type_script_lang_js_,
  Preferencesvue_type_template_id_8822e4a8_scoped_true_render,
  Preferencesvue_type_template_id_8822e4a8_scoped_true_staticRenderFns,
  false,
  null,
  "8822e4a8",
  null
  
)

/* harmony default export */ var Preferences = (Preferences_component.exports);
;// CONCATENATED MODULE: ./src/modules/admin/index.ts




const adminPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "adminModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      adminClient,
      authClient,
      frontUrl,
      ssoUrl
    } = options;
    store.registerModule(STORE_MODULE_NAME, adminStore, {
      preserveState: !!store.state[STORE_MODULE_NAME]
    });
    if (adminClient && authClient) {
      store.$adminService = attachAdminService(adminClient, authClient, frontUrl, ssoUrl);
    }
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) options.i18n.mergeLocaleMessage(locale, locales(key));
        }
      });
    }
    Vue.component("login-view", Login);
    Vue.component("preferences-view", Preferences);
  }
};
const AdminModule = {
  plugin: adminPlugin,
  store: adminStore,
  attachService: attachAdminService
};
;// CONCATENATED MODULE: ./src/modules/notification/service/notification.ts

class NotificationService {
  constructor(data) {
    _defineProperty(this, "data", void 0);
    this.data = data;
  }
  appendHeaders(headers) {
    return this.data.appendHeaders(headers);
  }
  /**
   * CREATE METHODS
   */
  async create(notification) {
    return this.data.create(notification);
  }
  async comment(taskId, comment, attachments) {
    return this.data.commentNotification(taskId, comment, attachments);
  }
  /**
   * READ METHODS
   */
  async get(types, size, page, unreadOnly, dateRange) {
    return this.data.getNotifications(types, size, page, unreadOnly, dateRange[0], dateRange[1]);
  }
  async getUrgents() {
    return this.data.getUrgentNotifications();
  }
  async getById(id) {
    return this.data.getNotificationById(id);
  }
  async getUnreadCount() {
    return this.data.getUnreadCount();
  }
  async getCreatedAgentNotifications(size, page, sortOption = "updatedAt", sortDirection = "desc", searchInput = "", targetGroupIds = []) {
    return this.data.getCreatedAgentNotifications(size, page, sortOption, sortDirection, searchInput, targetGroupIds);
  }
  /**
   * CACHE METHODS
   */
  async getUsers(userIds) {
    return this.data.getUsers(userIds);
  }
  async getContents(contentIds) {
    return this.data.getContents(contentIds);
  }
  async getCases(caseIds) {
    return this.data.getCases(caseIds);
  }
  async getTasks(taskIds) {
    return this.data.getTasks(taskIds);
  }
  /**
   * UPDATE METHODS
   */
  async read(notificationIds) {
    return this.data.readNotifications(notificationIds);
  }
  async readAll() {
    return this.data.readAllNotifications();
  }
  async update(notificationId, data) {
    return this.data.update(notificationId, data);
  }
  /**
   * DELETE METHODS
   */
  async delete(notificationId) {
    return this.data.delete(notificationId);
  }
}
;// CONCATENATED MODULE: ./src/modules/notification/service/notification.data.ts

function isResponseType(res) {
  return "data" in res;
}
const formatResponse = res => {
  if (isResponseType(res)) {
    return res.data;
  }
  return res;
};
class NotificationServiceData {
  constructor(notificationClient, adminClient, knowledgeClient) {
    _defineProperty(this, "notificationClient", void 0);
    _defineProperty(this, "adminClient", void 0);
    _defineProperty(this, "knowledgeClient", void 0);
    this.notificationClient = notificationClient;
    this.adminClient = adminClient;
    this.knowledgeClient = knowledgeClient;
  }
  appendHeaders(headers) {
    this.adminClient.appendHeaders(headers);
    this.knowledgeClient.appendHeaders(headers);
    this.notificationClient.appendHeaders(headers);
  }
  /**
   * CREATE METHODS
   */
  create(notification) {
    return this.notificationClient.post("notifications", notification).then(res => formatResponse(res));
  }
  commentNotification(taskId, comment, attachments) {
    return this.adminClient.post("comment-notification", {
      taskId,
      comment,
      attachments
    }).then(res => formatResponse(res));
  }
  /**
   * READ METHODS
   */
  getNotifications(types, size, page, unreadOnly, startDate, endDate) {
    const searchParams = new URLSearchParams({
      size: size.toString(),
      page: page.toString(),
      unreadOnly: unreadOnly.toString(),
      ...(unreadOnly ? {} : {
        withUrgents: "true"
      })
    });
    if (types && types.length) types.forEach(type => searchParams.append("types[]", type));
    if (startDate) searchParams.append("startDate", startDate.toISOString());
    if (endDate) searchParams.append("endDate", endDate.toISOString());
    return this.notificationClient.get(`notifications?${searchParams.toString()}`).then(res => formatResponse(res));
  }
  getUrgentNotifications() {
    return this.notificationClient.get("notifications/urgents").then(res => formatResponse(res));
  }
  getCreatedAgentNotifications(size, page, sortOption, sortDirection, searchInput, targetGroupIds) {
    const searchParams = new URLSearchParams({
      size: size.toString(),
      page: page.toString(),
      sortOption,
      sortDirection,
      searchInput
    });
    if (targetGroupIds && targetGroupIds.length) targetGroupIds.forEach(targetGroupId => searchParams.append("targetGroupIds[]", targetGroupId));
    return this.notificationClient.get(`notifications/agents?${searchParams.toString()}`).then(res => formatResponse(res));
  }
  getNotificationById(id) {
    return this.notificationClient.get(`notifications/${id}`).then(res => formatResponse(res));
  }
  getUnreadCount() {
    return this.notificationClient.get("notifications/unread-count").then(res => formatResponse(res));
  }
  /**
   * CACHE METHODS
   */
  getUsers(userIds) {
    const searchParams = new URLSearchParams();
    if (userIds && userIds.length) userIds.forEach(userId => searchParams.append("userIds[]", userId));
    return this.adminClient.get(`users?${searchParams.toString()}`).then(res => formatResponse(res));
  }
  getCases(caseIds) {
    const searchParams = new URLSearchParams();
    if (caseIds && caseIds.length) caseIds.forEach(caseId => searchParams.append("caseIds[]", caseId));
    return this.knowledgeClient.get(`case?${searchParams.toString()}`).then(res => {
      const data = formatResponse(res);
      return data.results;
    });
  }
  getContents(contentIds) {
    const searchParams = new URLSearchParams();
    if (contentIds && contentIds.length) contentIds.forEach(contentId => searchParams.append("contentIds[]", contentId));
    return this.knowledgeClient.get(`content?${searchParams.toString()}`).then(res => {
      const data = formatResponse(res);
      return data.results;
    });
  }
  getTasks(taskIds) {
    const searchParams = new URLSearchParams();
    if (taskIds && taskIds.length) taskIds.forEach(taskId => searchParams.append("taskIds[]", taskId));
    return this.adminClient.get(`tasks?${searchParams.toString()}`).then(res => formatResponse(res));
  }
  /**
   * UPDATE METHODS
   */
  readNotifications(ids) {
    return this.notificationClient.post("notifications/read", {
      ids
    }).then(res => formatResponse(res));
  }
  readAllNotifications() {
    return this.notificationClient.post("notifications/read-all").then(res => formatResponse(res));
  }
  update(notificationId, data) {
    return this.notificationClient.put(`/notifications/${notificationId}`, data).then(res => formatResponse(res));
  }
  /**
   * DELETE METHODS
   */
  delete(notificationId) {
    return this.notificationClient.delete(`notifications/${notificationId}`).then(res => formatResponse(res));
  }
}
;// CONCATENATED MODULE: ./src/modules/notification/service/index.ts


const attachNotificationService = (notificationClient, adminClient, knowledgeClient) => {
  return new NotificationService(new NotificationServiceData(notificationClient, adminClient, knowledgeClient));
};
;// CONCATENATED MODULE: ./src/modules/notification/types/index.ts
var NotificationMetadataType;
(function (NotificationMetadataType) {
  NotificationMetadataType["Agent"] = "Agent";
  NotificationMetadataType["Feedback"] = "Feedback";
  NotificationMetadataType["TaskComment"] = "TaskComment";
  NotificationMetadataType["InternalTaskComment"] = "InternalTaskComment";
  NotificationMetadataType["TaskMoved"] = "TaskMoved";
  NotificationMetadataType["TaskUpvoted"] = "TaskUpvoted";
  NotificationMetadataType["TaskAssigned"] = "TaskAssigned";
  NotificationMetadataType["ContentToVerify"] = "ContentToVerify";
  NotificationMetadataType["ContentMention"] = "ContentMention";
})(NotificationMetadataType || (NotificationMetadataType = {}));
;// CONCATENATED MODULE: ./src/modules/notification/store/mutation-types.ts
const notification_store_mutation_types_LOGOUT = "LOGOUT";
const SET_USER_ID = "SET_USER_ID";
const SET_POLLING_TIMER = "SET_POLLING_TIMER";
/**
 * NOTIFICATION
 */
const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
const UPDATE_URGENT_NOTIFICATIONS = "UPDATE_URGENT_NOTIFICATIONS";
const UPDATE_UNREAD_COUNT = "UPDATE_UNREAD_COUNT";
const IS_LOADING = "IS_LOADING";
const TASK_COMMENT_IS_LOADING = "TASK_COMMENT_IS_LOADING";
const UPDATE_FOCUS_TAB = "UPDATE_FOCUS_TAB";
const UPDATE_CURSOR = "UPDATE_CURSOR";
const RESET_STORE = "RESET_STORE";
// CACHE
const ADD_USER = "ADD_USER";
const ADD_CONTENT = "ADD_CONTENT";
const ADD_TASK = "ADD_TASK";
const ADD_CASE = "ADD_CASE";
/**
 * ADMIN PANEL CREATE NOTIFICATIONS
 */
const UPDATE_CREATED_AGENT_NOTIFICATIONS = "UPDATE_CREATED_AGENT_NOTIFICATIONS";
const UPDATE_FILTERS = "UPDATE_FILTERS";
const RESET_FILTERS = "RESET_FILTERS";
const IS_LOADING_AGENT_NOTIFICATIONS = "IS_LOADING_AGENT_NOTIFICATIONS";
const IS_DELETING_AGENT_NOTIFICATION = "IS_DELETING_AGENT_NOTIFICATION";
;// CONCATENATED MODULE: ./src/modules/notification/store/actions.ts




/* harmony default export */ var notification_store_actions = ({
  logout({
    commit
  }) {
    commit(notification_store_mutation_types_LOGOUT);
  },
  async init({
    commit,
    dispatch
  }, userId) {
    commit(SET_USER_ID, userId);
    dispatch("getNotifications");
  },
  async getNotifications({
    commit,
    state,
    getters,
    dispatch
  }, nextCursor = 0) {
    if (state.isLoading) return;
    const {
      filters
    } = getters;
    try {
      commit(IS_LOADING, true);
      const size = state.cursor + nextCursor;
      const {
        results: notifications,
        hasMore
      } = await this.$services.notifications.get(filters.types, size < 10 ? 10 : size, 1, filters.unreadOnly, filters.dateRange);
      commit(UPDATE_NOTIFICATIONS, {
        notifications,
        hasMore,
        cursor: notifications.length
      });
      dispatch("getUnreadCount");
    } catch (e) {
      commit(IS_LOADING, false);
      console.log(e);
    }
  },
  async getUrgentNotifications({
    commit
  }) {
    const urgentNotifications = await this.$services.notifications.getUrgents();
    commit(UPDATE_URGENT_NOTIFICATIONS, urgentNotifications);
  },
  async getNotificationById({
    commit,
    state,
    dispatch
  }, {
    id,
    isFromNotificationCenter
  }) {
    if (state.isLoading) return;
    try {
      commit(IS_LOADING, true);
      const newNotification = await this.$services.notifications.getById(id);
      if (!newNotification) return;
      const {
        metadata
      } = newNotification;
      // No return here as this if is only for the notification-center view
      if (metadata.type === "Agent" && isFromNotificationCenter) {
        dispatch("getCreatedAgentNotifications");
      }
      if (metadata.urgent) {
        return dispatch("getUrgentNotifications");
      }
      if (metadata.type === "Agent" && !metadata.isVisible) {
        return dispatch("deleteNotificationFromStore", id);
      }
      dispatch("getUnreadCount");
      const copy = [...state.notifications];
      let newCursor = state.cursor;
      const idx = copy.findIndex(({
        id: nid
      }) => nid === id);
      if (idx > -1) {
        copy[idx] = newNotification;
      } else {
        copy.unshift(newNotification);
        newCursor++;
      }
      commit(UPDATE_NOTIFICATIONS, {
        notifications: copy,
        hasMore: true,
        cursor: newCursor
      });
    } finally {
      commit(IS_LOADING, false);
    }
  },
  async deleteNotificationFromStore({
    commit,
    state,
    dispatch
  }, id) {
    const {
      notifications,
      urgentNotifications
    } = state;
    const copy = [...notifications].filter(e => e.id !== id);
    commit(UPDATE_NOTIFICATIONS, {
      notifications: copy,
      hasMore: state.hasMoreNotifications,
      cursor: copy.length
    });
    dispatch("getUnreadCount");
    if (urgentNotifications.findIndex(n => n.id === id) > -1) {
      dispatch("getUrgentNotifications");
    }
  },
  async getUnreadCount({
    commit
  }) {
    try {
      commit(IS_LOADING, true);
      const newUnreadCount = await this.$services.notifications.getUnreadCount();
      commit(UPDATE_UNREAD_COUNT, Number(newUnreadCount));
      commit(IS_LOADING, false);
    } catch (e) {
      commit(IS_LOADING, false);
      throw e;
    }
  },
  async readNotifications({
    commit,
    state
  }, notificationIds) {
    try {
      const res = await this.$services.notifications.read(notificationIds);
      if (res) {
        const {
          userId
        } = state;
        const newNotifications = [...state.notifications];
        notificationIds.forEach(id => {
          const index = newNotifications.findIndex(({
            _id
          }) => _id === id);
          newNotifications[index].userReads.push({
            userId,
            createdAt: String(Date.now())
          });
        });
        commit(UPDATE_NOTIFICATIONS, {
          notifications: newNotifications,
          hasMore: state.hasMoreNotifications,
          cursor: newNotifications.length
        });
        const newCount = state.unreadCount - notificationIds.length;
        commit(UPDATE_UNREAD_COUNT, newCount);
      }
    } catch (e) {
      console.log(e);
    }
  },
  async readAllNotifications({
    state,
    commit
  }) {
    const {
      userId,
      unreadCount
    } = state;
    if (unreadCount === 0) return;
    const res = await this.$services.notifications.readAll();
    if (res) {
      const newNotifications = [...state.notifications];
      newNotifications.forEach(({
        userReads
      }) => {
        if (userReads.findIndex(e => e.userId === userId) < 0) {
          userReads.push({
            userId,
            createdAt: String(Date.now())
          });
        }
      });
      commit(UPDATE_UNREAD_COUNT, 0);
      commit(UPDATE_NOTIFICATIONS, {
        notifications: newNotifications,
        hasMore: state.hasMoreNotifications,
        cursor: newNotifications.length
      });
    }
  },
  async commentNotification({
    state,
    commit
  }, {
    taskId,
    comment,
    attachments,
    notificationId
  }) {
    commit(TASK_COMMENT_IS_LOADING, true);
    const notificationsState = [...state.notifications];
    const {
      userId
    } = state;
    const newComment = await this.$services.notifications.comment(taskId, comment, attachments);
    const notificationIndex = notificationsState.findIndex(({
      id
    }) => id === notificationId);
    if (notificationIndex === -1) return;
    notificationsState[notificationIndex].metadata.thread.push({
      taskCommentId: newComment.id,
      body: newComment.comment,
      attachments: newComment.attachments,
      authorId: userId,
      createdAt: newComment.createdAt
    });
    notificationsState[notificationIndex].authorId = userId;
    commit(UPDATE_NOTIFICATIONS, {
      notifications: notificationsState,
      hasMore: state.hasMoreNotifications,
      cursor: state.cursor
    });
    commit(TASK_COMMENT_IS_LOADING, false);
  },
  async fetchUsers({
    state,
    commit
  }, notificationState) {
    try {
      commit(IS_LOADING, true);
      const userIds = Object.keys(state.users);
      const authorIds = [];
      state[notificationState].forEach(n => {
        const {
          thread,
          mentions,
          message
        } = n.metadata;
        authorIds.push(n.authorId);
        if (message && message.mentions) {
          message.mentions.forEach(mention => {
            if (mention.targetType === "User") authorIds.push(mention.targetId);
          });
        }
        if (mentions) {
          mentions.forEach(mention => {
            const splittedMention = mention.split("/");
            if (splittedMention[0] === "user") authorIds.push(splittedMention[1]);
          });
        }
        if (thread) {
          thread.forEach(m => {
            authorIds.push(m.authorId);
            if (!m.mentions) return;
            m.mentions.forEach(mention => {
              const splittedMention = mention.split("/");
              if (splittedMention[0] === "user") authorIds.push(splittedMention[1]);
            });
          });
        }
      });
      const uniqueUserIds = [...new Set(authorIds)];
      const toFetchUsers = uniqueUserIds.reduce((acc, val) => {
        if (val && !userIds.includes(val)) {
          acc.push(val);
        }
        return acc;
      }, []);
      if (toFetchUsers.length === 0) return;
      const newUsers = await this.$services.notifications.getUsers(toFetchUsers);
      toFetchUsers.forEach(userId => {
        const idx = newUsers.findIndex(fetchedUser => String(userId) === String(fetchedUser.id));
        const userToInsert = idx === -1 ? {
          id: userId,
          username: ""
        } : newUsers[idx];
        commit(ADD_USER, userToInsert);
      });
    } catch (e) {
      console.log(e);
    } finally {
      commit(IS_LOADING, false);
    }
  },
  async fetchContents({
    state,
    commit
  }) {
    const contentIds = Object.keys(state.contents);
    const toFetchContents = state.notifications.filter(notification => ["Article", "Diagnostic", "Step", "keyStep"].includes(notification.metadata.entityType || "")).reduce((acc, val) => {
      const contentId = val.metadata.entityId;
      if (contentId && !contentIds.includes(contentId) && !acc.includes(contentId)) {
        acc.push(contentId);
      }
      return acc;
    }, []);
    if (!toFetchContents.length) return;
    const newContents = await this.$services.notifications.getContents(toFetchContents);
    toFetchContents.forEach(contentId => {
      const idx = newContents.findIndex(fetchedContent => contentId === fetchedContent.id);
      const contentToInsert = idx === -1 ? {
        id: contentId,
        label: "",
        type: "Error"
      } : newContents[idx];
      commit(ADD_CONTENT, contentToInsert);
    });
  },
  async fetchCases({
    state,
    commit
  }) {
    const caseIds = Object.keys(state.cases);
    const toFetchCases = state.notifications.filter(notification => ["Case"].includes(notification.metadata.entityType || "")).reduce((acc, val) => {
      const caseId = val.metadata.entityId;
      if (caseId && !caseIds.includes(caseId) && !acc.includes(caseId)) {
        acc.push(caseId);
      }
      return acc;
    }, []);
    if (!toFetchCases.length) return;
    const newCases = await this.$services.notifications.getCases(toFetchCases);
    toFetchCases.forEach(caseId => {
      const idx = newCases.findIndex(fetchedCase => caseId === fetchedCase.id);
      const caseToInsert = idx === -1 ? {
        id: caseId,
        label: "",
        type: "Error"
      } : newCases[idx];
      commit(ADD_CASE, caseToInsert);
    });
  },
  async fetchTasks({
    state,
    commit
  }) {
    const taskIds = Object.keys(state.tasks);
    const toFetchTasks = state.notifications.filter(notification => ["TaskMoved", "TaskUpvoted", "TaskAssigned"].includes(notification.metadata.type)).reduce((acc, val) => {
      const {
        taskId
      } = val.metadata;
      if (taskId && !taskIds.includes(taskId) && !acc.includes(taskId)) {
        acc.push(taskId);
      }
      return acc;
    }, []);
    if (!toFetchTasks.length) return;
    const newTasks = await this.$services.notifications.getTasks(toFetchTasks);
    toFetchTasks.forEach(taskId => {
      const idx = newTasks.findIndex(fetchedTask => taskId === String(fetchedTask.id));
      if (idx > -1) commit(ADD_TASK, newTasks[idx]);
    });
  },
  async getCreatedAgentNotifications({
    commit,
    getters
  }) {
    const {
      currentPage,
      searchInput,
      targetGroups
    } = getters;
    try {
      commit(IS_LOADING_AGENT_NOTIFICATIONS, true);
      const notifications = await this.$services.notifications.getCreatedAgentNotifications(10, currentPage, "createdAt", "desc", searchInput, targetGroups.map(group => group.id));
      commit(UPDATE_CREATED_AGENT_NOTIFICATIONS, notifications);
    } catch (e) {
      console.log(e);
    } finally {
      commit(IS_LOADING_AGENT_NOTIFICATIONS, false);
    }
  },
  async addAgentNotification({
    getters
  }, {
    notification
  }) {
    const {
      userId
    } = getters;
    const {
      targetGroupIds,
      companyId,
      ...metadata
    } = notification;
    await this.$services.notifications.create({
      targetGroupIds,
      metadata,
      authorId: userId,
      companyId,
      type: NotificationMetadataType.Agent
    });
  },
  async updateAgentNotification({
    getters,
    commit,
    state
  }, {
    notificationId,
    metadata
  }) {
    const {
      createdAgentNotifications
    } = state;
    const {
      currentPage,
      total
    } = getters;
    const copy = [...createdAgentNotifications];
    const updatedNotification = await this.$services.notifications.update(notificationId, {
      type: NotificationMetadataType.Agent,
      metadata
    });
    const idx = copy.findIndex(notification => notification.id === notificationId);
    if (idx === -1) return;
    copy[idx] = updatedNotification;
    commit(UPDATE_CREATED_AGENT_NOTIFICATIONS, {
      results: copy,
      page: currentPage,
      total
    });
  },
  async deleteAgentNotification({
    dispatch,
    commit
  }, notificationId) {
    try {
      commit(IS_DELETING_AGENT_NOTIFICATION, true);
      const result = await this.$services.notifications.delete(notificationId);
      if (result) dispatch("getCreatedAgentNotifications");
    } catch (e) {
      console.log(e);
    } finally {
      commit(IS_DELETING_AGENT_NOTIFICATION, false);
    }
  },
  async updateFilters({
    commit,
    dispatch
  }, {
    field,
    value,
    isFromNotificationCenter = false
  }) {
    commit(UPDATE_FILTERS, {
      field,
      value
    });
    if (isFromNotificationCenter) dispatch("getCreatedAgentNotifications");else dispatch("getNotifications");
  },
  async resetFilters({
    commit,
    dispatch
  }, {
    isFromNotificationCenter = false
  }) {
    commit(RESET_FILTERS);
    if (isFromNotificationCenter) dispatch("getCreatedAgentNotifications");else dispatch("getNotifications");
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/store/utils.ts
/* eslint-disable no-use-before-define */
const buildNotification = (notification, currentUserId) => {
  const {
    authorId
  } = notification;
  const {
    type
  } = notification.metadata;
  if (type === "Agent") {
    const {
      entityId,
      entityType,
      label,
      body: agentBody,
      tags,
      attachments,
      urgent
    } = notification.metadata;
    const title = buildAgentTitle(label, urgent);
    const body = buildAgentBody(notification.updatedAt, tags, agentBody, "notifications.info.attached-content", entityId || "", entityType || "", attachments);
    return {
      title,
      body
    };
  }
  if (type === "TaskComment") {
    const {
      entityId,
      entityType,
      thread,
      mentions
    } = notification.metadata;
    const isMine = authorId === currentUserId;
    let isMention = false;
    if (mentions) {
      isMention = mentions.map(mention => {
        const splittedMention = mention.split("/");
        return splittedMention[0] === "user" && splittedMention[1] === currentUserId;
      }).includes(true);
    }
    let usedToBeMentionned = false;
    if (!isMention && thread && thread.length) {
      usedToBeMentionned = thread.map(comment => {
        if (!comment.mentions || !comment.mentions.length) return false;
        return comment.mentions.map(mention => {
          const splittedMention = mention.split("/");
          return splittedMention[0] === "user" && splittedMention[1] === currentUserId;
        }).includes(true);
      }).includes(true);
    }
    const tag = isMine ? "TaskMineComment" : isMention ? "MentionTaskComment" : usedToBeMentionned ? "UsedToBeMentionTaskComment" : "TaskComment";
    const text = `notifications.feedback.title.${tag}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", isMine);
    const body = buildTaskCommentBody(notification.updatedAt, thread, notification._id);
    return {
      title,
      body
    };
  }
  if (type === "InternalTaskComment") {
    const {
      entityId,
      entityType,
      body,
      attachments,
      mentions
    } = notification.metadata;
    const isMine = authorId === currentUserId;
    let isMention = false;
    if (mentions) {
      isMention = mentions.map(mention => {
        const splittedMention = mention.split("/");
        return splittedMention[0] === "user" && splittedMention[1] === currentUserId;
      }).includes(true);
    }
    const tag = isMine ? "InternalTaskMineComment" : isMention ? "MentionInternalTaskComment" : "InternalTaskComment";
    const text = `notifications.feedback.title.${tag}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", isMine);
    const formattedBody = buildInternalTaskCommentBody(notification.updatedAt, body, attachments);
    return {
      title,
      body: formattedBody
    };
  }
  if (type === "TaskMoved" || type === "TaskUpvoted") {
    const {
      entityId,
      entityType,
      taskId
    } = notification.metadata;
    const text = `notifications.feedback.title.${type}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "");
    const body = buildTaskBody(notification.updatedAt, taskId);
    return {
      title,
      body
    };
  }
  if (type === "TaskAssigned") {
    const {
      entityId,
      entityType,
      taskId
    } = notification.metadata;
    const text = `notifications.feedback.title.${type}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "");
    const body = buildTaskAssignedBody(notification.updatedAt, taskId, "notifications.info.task");
    return {
      title,
      body
      // lottiePath: "lottie/94640-checkbox.json"
    };
  }

  if (type === "Feedback") {
    const {
      entityId,
      entityType,
      body: feedbackBody,
      attachments
    } = notification.metadata;
    const text = `notifications.feedback.title.Feedback`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "");
    const body = buildFeedbackBody(notification.updatedAt, feedbackBody, attachments);
    return {
      title,
      body
    };
  }
  if (type === "ContentToVerify") {
    const {
      entityId,
      entityType
    } = notification.metadata;
    const text = "notifications.feedback.title.ContentToVerify";
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", true);
    const body = buildBaseBody(notification.createdAt);
    return {
      title,
      body,
      icon: {
        iconType: "fal",
        value: "shield-check",
        color: null
      }
    };
  }
  if (type === "ContentMention") {
    const {
      entityId,
      entityType
    } = notification.metadata;
    const text = `notifications.feedback.title.${type}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", false);
    const body = buildBaseBody(notification.createdAt);
    return {
      title,
      body
    };
  }
  if (type === "ContentThreadMessage") {
    const {
      entityId,
      entityType,
      message,
      type
    } = notification.metadata;
    const isMention = message.mentions.find(({
      targetId
    }) => targetId === currentUserId);
    const text = isMention ? `notifications.feedback.title.ContentThreadMention` : `notifications.feedback.title.${type}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", false);
    const body = buildMessageBody(message);
    return {
      title,
      body
    };
  }
  if (type === "ContentThreadVote") {
    const {
      entityId,
      entityType,
      message
    } = notification.metadata;
    const text = `notifications.feedback.title.ContentThreadVote`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", false);
    const body = buildMessageBody(message, notification.createdAt);
    return {
      title,
      body
    };
  }
  if (type === "ContentThreadStatus") {
    const {
      entityId,
      entityType,
      status
    } = notification.metadata;
    const text = `notifications.feedback.title.ContentThreadStatus.${status}`;
    const title = buildBaseTitle(authorId, text, entityId || "", entityType || "", false);
    const body = buildBaseBody(notification.createdAt);
    return {
      title,
      body
    };
  }
  // HANDLE UNKNOWN TYPE
  const title = [{
    name: "NotificationTitleAuthor",
    props: {
      authorId
    }
  }];
  const body = [{
    name: "NotificationHeader",
    props: {
      date: notification.updatedAt
    }
  }];
  return {
    title,
    body
  };
};
/*
 * BUILD COMPONENTS
 */
const buildBaseTitle = (authorId, text, entityId, entityType, isMine) => {
  return [{
    name: "NotificationTitleAuthor",
    props: {
      authorId,
      isMine
    }
  }, {
    name: "NotificationTitleText",
    props: {
      text,
      bold: false,
      trad: true,
      content: !!entityId
    }
  }, {
    name: "NotificationTitleContent",
    props: {
      entityId,
      entityType
    }
  }];
};
const buildAgentTitle = (text, urgent) => {
  return [{
    name: "NotificationTitleText",
    props: {
      text,
      bold: false,
      trad: false
    }
  }, ...(urgent ? [{
    name: "NotificationTitleUrgent",
    props: {}
  }] : [])];
};
const buildAgentBody = (date, tags, body, text, entityId, entityType, attachments) => {
  return [{
    name: "NotificationHeader",
    props: {
      date
    }
  }, {
    name: "NotificationTitleTags",
    props: {
      tags
    }
  }, {
    name: "NotificationEditor",
    props: {
      body
    }
  }, {
    name: "NotificationRedirection",
    props: {
      text,
      entityId,
      entityType,
      trad: true
    }
  }, {
    name: "NotificationAttachments",
    props: {
      attachments
    }
  }];
};
const buildTaskAssignedBody = (date, taskId, text) => {
  return [{
    name: "NotificationHeader",
    props: {
      date
    }
  }, {
    name: "NotificationMessage",
    props: {
      userId: null,
      isHighlight: true,
      taskId
    }
  }, {
    name: "NotificationRedirection",
    props: {
      text,
      entityId: taskId,
      entityType: "Task",
      trad: true
    }
  }];
};
const buildFeedbackBody = (date, body, attachments) => {
  return [{
    name: "NotificationHeader",
    props: {
      date
    }
  }, {
    name: "NotificationMessage",
    props: {
      userId: null,
      message: body,
      isHighlight: true
    }
  }, {
    name: "NotificationAttachments",
    props: {
      attachments
    }
  }];
};
const buildTaskBody = (date, taskId) => {
  return [{
    name: "NotificationHeader",
    props: {
      date
    }
  }, {
    name: "NotificationMessage",
    props: {
      userId: null,
      taskId,
      isHighlight: true
    }
  }];
};
const buildTaskCommentBody = (date, thread, notificationId) => {
  return [{
    name: "NotificationHeader",
    props: {
      date
    }
  }, {
    name: "NotificationThread",
    props: {
      thread
    }
  }, {
    name: "NotificationResponse",
    props: {
      notificationId,
      showAttachments: true
    }
  }];
};
const buildInternalTaskCommentBody = (date, body, attachments) => {
  return [{
    name: "NotificationMessage",
    props: {
      authorId: null,
      isHighlight: true,
      message: body,
      date: date,
      messageOptions: true
    }
  }, {
    name: "NotificationAttachments",
    props: {
      attachments
    }
  }];
};
const buildMessageBody = (message, date) => {
  const {
    body,
    createdAt,
    edited,
    editedDate,
    attachments
  } = message;
  const messageDate = edited ? editedDate : createdAt;
  return [{
    name: "NotificationMessage",
    props: {
      authorId: null,
      isHighlight: true,
      message: body,
      date: date || messageDate,
      edited,
      messageOptions: true
    }
  }, {
    name: "NotificationAttachments",
    props: {
      attachments
    }
  }];
};
const buildBaseBody = date => {
  return [{
    name: "NotificationHeader",
    props: {
      date
    }
  }];
};
;// CONCATENATED MODULE: ./src/modules/notification/store/getters.ts

const notification_store_getters_getters = {
  userId: state => {
    return state.userId;
  },
  notifications: state => {
    return state.notifications;
  },
  urgentNotifications: state => {
    return state.urgentNotifications;
  },
  hasMoreNotifications: state => {
    return state.hasMoreNotifications;
  },
  unreadCount: state => {
    return state.unreadCount;
  },
  isLoading: state => {
    return state.isLoading;
  },
  taskCommentIsLoading: state => {
    return state.taskCommentIsLoading;
  },
  cursor: state => {
    return state.cursor;
  },
  users: state => {
    return state.users;
  },
  getUsername: state => id => {
    if (!id) return "?";
    if (!state.users[id]) return null;
    return state.users[id].username || "?";
  },
  getTaskBody: state => id => {
    return state.tasks[id] ? state.tasks[id].body : "";
  },
  contents: state => {
    return state.contents;
  },
  cases: state => {
    return state.cases;
  },
  getEntityInfo: state => (id, type) => {
    const entityState = type === "Case" ? "cases" : "contents";
    return state[entityState][id] ? state[entityState][id] : {
      label: null,
      type: null
    };
  },
  resolveNotification: (_, getters) => notification => {
    const {
      userId
    } = getters;
    return buildNotification(notification, userId);
  },
  createdAgentNotifications: state => groups => {
    const {
      createdAgentNotifications
    } = state;
    return createdAgentNotifications.map(notification => {
      const notificationGroups = notification.targets.map(target => {
        const groupId = target.split("/")[1];
        return groups.find(userGroup => userGroup.id === groupId);
      }).filter(Boolean);
      const usersInGroups = notificationGroups.reduce((acc, group) => {
        group.users.forEach(user => acc.add(user.id));
        return acc;
      }, new Set());
      const totalUsersInGroups = usersInGroups.size || 1;
      const userReadsInGroups = notification.userReads.reduce((acc, {
        userId
      }) => {
        if (usersInGroups.has(userId)) acc.add(userId);
        return acc;
      }, new Set());
      return {
        ...notification,
        groups: notificationGroups,
        agent_readers_percentage: userReadsInGroups.size / totalUsersInGroups * 100
      };
    });
  },
  filters: state => {
    return state.filters;
  },
  currentPage: state => {
    return state.filters.currentPage;
  },
  searchInput: state => {
    return state.filters.searchInput;
  },
  targetGroups: state => {
    return state.filters.targetGroups;
  },
  total: state => {
    return state.total;
  },
  isLoadingAgentNotifications: state => {
    return state.isLoadingAgentNotifications;
  },
  isDeletingAgentNotification: state => {
    return state.isDeletingAgentNotification;
  }
};
/* harmony default export */ var notification_store_getters = (notification_store_getters_getters);
;// CONCATENATED MODULE: ./src/modules/notification/store/state.ts
const notification_store_state_state = () => ({
  /**
   * User
   */
  userId: "",
  /**
   * General
   */
  notifications: [],
  unreadNotifications: [],
  unreadCount: 0,
  hasMoreNotifications: true,
  urgentNotifications: [],
  isLoading: false,
  cursor: 5,
  poolingTimer: null,
  taskCommentIsLoading: false,
  currentPage: null,
  // cache
  users: {},
  contents: {},
  tasks: {},
  cases: {},
  /**
   * ADMIN PANEL
   */
  createdAgentNotifications: [],
  filters: {
    currentPage: 1,
    searchInput: "",
    targetGroups: [],
    types: [],
    unreadOnly: false,
    dateRange: [null, null]
  },
  total: 0,
  isLoadingAgentNotifications: false,
  isDeletingAgentNotification: false
});
;// CONCATENATED MODULE: ./src/modules/notification/store/mutations.ts


/* harmony default export */ var notification_store_mutations = ({
  [notification_store_mutation_types_LOGOUT](state) {
    Object.assign(state, notification_store_state_state());
  },
  [SET_USER_ID](state, userId) {
    state.userId = userId;
  },
  [RESET_STORE](state) {
    state.hasMoreNotifications = true;
    state.isLoading = false;
  },
  [SET_POLLING_TIMER](state, payload) {
    const {
      poolingTimer
    } = state;
    if (poolingTimer) clearTimeout(poolingTimer);
    state.poolingTimer = payload;
  },
  // NOTIFICATION
  [UPDATE_NOTIFICATIONS](state, payload) {
    state.notifications = payload.notifications;
    state.hasMoreNotifications = payload.hasMore;
    state.cursor = payload.cursor;
  },
  [UPDATE_URGENT_NOTIFICATIONS](state, payload) {
    state.urgentNotifications = payload;
  },
  [UPDATE_UNREAD_COUNT](state, payload) {
    state.unreadCount = payload > -1 ? payload : 0;
  },
  [IS_LOADING](state, payload) {
    state.isLoading = payload;
  },
  [TASK_COMMENT_IS_LOADING](state, payload) {
    state.taskCommentIsLoading = payload;
  },
  [UPDATE_CURSOR](state, payload) {
    state.cursor = payload;
  },
  [ADD_USER](state, payload) {
    state.users = Object.assign({}, state.users, {
      [payload.id]: payload
    });
  },
  [ADD_CONTENT](state, payload) {
    state.contents = Object.assign({}, state.contents, {
      [payload.id]: payload
    });
  },
  [ADD_CASE](state, payload) {
    state.cases = Object.assign({}, state.cases, {
      [payload.id]: payload
    });
  },
  [ADD_TASK](state, payload) {
    state.tasks = Object.assign({}, state.tasks, {
      [payload.id]: payload
    });
  },
  [UPDATE_CREATED_AGENT_NOTIFICATIONS](state, payload) {
    const {
      results,
      page,
      total
    } = payload;
    state.createdAgentNotifications = results;
    state.currentPage = page;
    state.total = total;
  },
  [UPDATE_FILTERS](state, payload) {
    const {
      field,
      value
    } = payload;
    const {
      filters
    } = state;
    filters[field] = value;
    state.filters = filters;
  },
  [RESET_FILTERS](state) {
    state.filters = notification_store_state_state().filters;
  },
  [IS_LOADING_AGENT_NOTIFICATIONS](state, payload) {
    state.isLoadingAgentNotifications = payload;
  },
  [IS_DELETING_AGENT_NOTIFICATION](state, payload) {
    state.isDeletingAgentNotification = payload;
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/store/index.ts




const notificationStore = {
  namespaced: true,
  state: notification_store_state_state,
  getters: notification_store_getters,
  actions: notification_store_actions,
  mutations: notification_store_mutations
};
;// CONCATENATED MODULE: ./src/modules/notification/store/plugin.ts

const notificationStorePlugin = store => {
  const moduleName = "notificationModule";
  const usersMutations = [`${moduleName}/${UPDATE_NOTIFICATIONS}`];
  const agentNotificationMutations = [`${moduleName}/${UPDATE_CREATED_AGENT_NOTIFICATIONS}`];
  const countMutation = [`${moduleName}/${UPDATE_UNREAD_COUNT}`];
  store.subscribe(mutation => {
    if (usersMutations.includes(mutation.type)) {
      store.dispatch(`${moduleName}/fetchUsers`, "notifications");
      store.dispatch(`${moduleName}/fetchContents`);
      store.dispatch(`${moduleName}/fetchCases`);
      store.dispatch(`${moduleName}/fetchTasks`);
    }
    if (agentNotificationMutations.includes(mutation.type)) {
      store.dispatch(`${moduleName}/fetchUsers`, "createdAgentNotifications");
    }
    if (countMutation.includes(mutation.type)) {
      store.$chromeEvent({
        message: "notificationsUpdate",
        count: mutation.payload
      });
    }
  });
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/Notification.vue?vue&type=template&id=786ec66e&scoped=true&
var Notificationvue_type_template_id_786ec66e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('NotificationMain', {
    staticClass: "notification__popover-main",
    attrs: {
      "is-from-notification-center": _vm.isFromNotificationCenter
    },
    on: {
      "go-to-content": function ($event) {
        return _vm.$emit('go-to-content', $event);
      }
    }
  })], 1);
};
var Notificationvue_type_template_id_786ec66e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationMain.vue?vue&type=template&id=14f8916a&scoped=true&
var NotificationMainvue_type_template_id_14f8916a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('NotificationMenu', {
    staticClass: "notification__popover-header",
    attrs: {
      "filters-opened": _vm.filtersOpened,
      "is-from-notification-center": _vm.isFromNotificationCenter
    },
    on: {
      "toggle-filters": function ($event) {
        _vm.filtersOpened = !_vm.filtersOpened;
      }
    }
  }), _c('NotificationList', {
    staticClass: "notification__popover-list",
    class: {
      'filters-opened': _vm.filtersOpened
    },
    attrs: {
      "is-from-notification-center": _vm.isFromNotificationCenter
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "get-more": _vm.scrollNotifications,
      "go-to-content": function ($event) {
        return _vm.$emit('go-to-content', $event);
      }
    }
  })], 1);
};
var NotificationMainvue_type_template_id_14f8916a_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationList.vue?vue&type=template&id=073c8db0&scoped=true&
var NotificationListvue_type_template_id_073c8db0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      'not-empty': _vm.notifications.length
    }
  }, [_c('LoaderLine', {
    attrs: {
      "loading": _vm.isLoading
    }
  }), _vm._l(_vm.notifications, function (notification) {
    return _c('div', {
      key: notification.id
    }, [_c('NotificationItem', {
      staticClass: "notification__item-container",
      attrs: {
        "notification": notification
      },
      on: {
        "close": function ($event) {
          return _vm.$emit('close');
        },
        "go-to-content": function ($event) {
          return _vm.$emit('go-to-content', $event);
        }
      }
    })], 1);
  }), _c('div', {
    staticClass: "notification__item-placeholder"
  }, [!_vm.notifications.length && !_vm.filtersApplied ? _c('div', {
    staticClass: "notification__item-empty"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6590)
    }
  }), _c('div', {
    staticClass: "empty-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.empty.title")) + " ")]), _c('div', {
    staticClass: "empty-description"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.empty.description")) + " ")])]) : _vm._e(), !_vm.notifications.length && _vm.filtersApplied ? _c('div', {
    staticClass: "notification__item-empty"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5363)
    }
  }), _c('div', {
    staticClass: "empty-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.empty.filtered-title")) + " ")]), _c('div', {
    staticClass: "empty-description"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.empty.filtered-description")) + " ")]), _c('base-button', {
    staticClass: "border notification__item-cta",
    on: {
      "click": function ($event) {
        return _vm.resetFilters({
          isFromNotificationCenter: _vm.isFromNotificationCenter
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.empty.cta")) + " ")])], 1) : _vm._e(), _c('div', {
    staticClass: "get-more-container"
  }, [_vm.hasMoreNotifications && !_vm.isLoading ? _c('base-button', {
    staticClass: "border notification__item-cta",
    attrs: {
      "outline": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('get-more');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.get-more")) + " ")]) : _c('LoaderLine', {
    attrs: {
      "loading": _vm.isLoading
    }
  })], 1)])], 2);
};
var NotificationListvue_type_template_id_073c8db0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationList.vue?vue&type=template&id=073c8db0&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/LoaderLine.vue?vue&type=template&id=2739b663&scoped=true&
var LoaderLinevue_type_template_id_2739b663_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_vm.loading ? _c('div', {
    staticClass: "loading_line_wrapper"
  }, [_vm._m(0)]) : _vm._e()]);
};
var LoaderLinevue_type_template_id_2739b663_scoped_true_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading_line"
  }, [_c('div', {
    staticClass: "loading_line_inner loading_line_inner--1"
  }), _c('div', {
    staticClass: "loading_line_inner loading_line_inner--2"
  })]);
}];

;// CONCATENATED MODULE: ./src/library/LoaderLine.vue?vue&type=template&id=2739b663&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/LoaderLine.vue?vue&type=script&lang=js&
/* harmony default export */ var library_LoaderLinevue_type_script_lang_js_ = ({
  name: "LoaderLine",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/library/LoaderLine.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_library_LoaderLinevue_type_script_lang_js_ = (library_LoaderLinevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/LoaderLine.vue?vue&type=style&index=0&id=2739b663&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/LoaderLine.vue?vue&type=style&index=0&id=2739b663&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/LoaderLine.vue



;


/* normalize component */

var library_LoaderLine_component = normalizeComponent(
  src_library_LoaderLinevue_type_script_lang_js_,
  LoaderLinevue_type_template_id_2739b663_scoped_true_render,
  LoaderLinevue_type_template_id_2739b663_scoped_true_staticRenderFns,
  false,
  null,
  "2739b663",
  null
  
)

/* harmony default export */ var library_LoaderLine = (library_LoaderLine_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationItem.vue?vue&type=template&id=ce157bca&scoped=true&
var NotificationItemvue_type_template_id_ce157bca_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      'has-not-read': !_vm.read
    },
    on: {
      "click": _vm.handleReadNotification
    }
  }, [_c('div', {
    staticClass: "notification__item-wrapper"
  }, [_c('NotificationAvatar', {
    attrs: {
      "authorId": _vm.notification.authorId
    }
  }), _c('div', {
    staticClass: "notification__item-main"
  }, [_c('NotificationTitle', {
    staticClass: "notification__item-header",
    attrs: {
      "components": _vm.resolvedNotification.title,
      "loading": _vm.loading
    },
    on: {
      "go-to-content": _vm.goToContent,
      "loading": function ($event) {
        _vm.loadingTitle = $event;
      }
    }
  }), _c('NotificationBody', {
    staticClass: "notification__item-body",
    attrs: {
      "components": _vm.resolvedNotification.body,
      "loading": _vm.loading
    },
    on: {
      "go-to-content": _vm.goToContent,
      "response": _vm.sendMessage,
      "loading": function ($event) {
        _vm.loadingBody = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "notification__item-checkbox"
  }, [!_vm.read ? _c('div', [_c('div', {
    on: {
      "click": _vm.handleReadNotification
    }
  })]) : _vm._e()])], 1)]);
};
var NotificationItemvue_type_template_id_ce157bca_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitle.vue?vue&type=template&id=20702ed0&scoped=true&
var NotificationTitlevue_type_template_id_20702ed0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('p', {
    staticClass: "notification__item-title"
  }, _vm._l(_vm.components, function (el) {
    return _c(el.name, _vm._b({
      key: el.id,
      tag: "component",
      on: {
        "go-to-content": function ($event) {
          return _vm.$emit('go-to-content');
        },
        "loading": function ($event) {
          return _vm.$emit('loading');
        }
      }
    }, 'component', el.props, false));
  }), 1)]);
};
var NotificationTitlevue_type_template_id_20702ed0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleText.vue?vue&type=template&id=7f87de22&scoped=true&
var NotificationTitleTextvue_type_template_id_7f87de22_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    style: _vm.fontWeight
  }, [_vm._v(_vm._s(_vm.displayText) + " ")]);
};
var NotificationTitleTextvue_type_template_id_7f87de22_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleText.vue?vue&type=script&lang=js&
/* harmony default export */ var NotificationTitleTextvue_type_script_lang_js_ = ({
  name: "NotificationTitleText",
  props: {
    text: {
      type: String,
      required: true
    },
    bold: {
      type: Boolean,
      default: false
    },
    trad: {
      type: Boolean,
      default: false
    },
    content: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fontWeight() {
      return this.bold && "font-weight: 700;";
    },
    displayText() {
      return this.trad ? this.$tc(this.text, this.content) : this.text;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleText.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationTitle_NotificationTitleTextvue_type_script_lang_js_ = (NotificationTitleTextvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleText.vue





/* normalize component */
;
var NotificationTitleText_component = normalizeComponent(
  NotificationTitle_NotificationTitleTextvue_type_script_lang_js_,
  NotificationTitleTextvue_type_template_id_7f87de22_scoped_true_render,
  NotificationTitleTextvue_type_template_id_7f87de22_scoped_true_staticRenderFns,
  false,
  null,
  "7f87de22",
  null
  
)

/* harmony default export */ var NotificationTitleText = (NotificationTitleText_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue?vue&type=template&id=7d094610&scoped=true&
var NotificationTitleContentvue_type_template_id_7d094610_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.entityId ? _c('span', {
    staticClass: "notification__title-content"
  }, [_vm.entityType === 'Diagnostic' ? _c('img', {
    attrs: {
      "src": __webpack_require__(6271)
    }
  }) : _vm.entityType === 'Article' ? _c('img', {
    attrs: {
      "src": __webpack_require__(2235)
    }
  }) : _vm.entityType === 'Step' || _vm.entityType === 'keyStep' ? _c('img', {
    attrs: {
      "src": __webpack_require__(1311)
    }
  }) : _vm.entityType === 'Case' ? _c('font-awesome-icon', {
    staticClass: "case-icon",
    attrs: {
      "icon": ['fad', 'folder']
    }
  }) : _vm._e(), _vm.type === 'Error' || !_vm.entityType ? _c('span', {
    staticClass: "disabled"
  }, [_vm._v(_vm._s(_vm.$t("notifications.info.content-error")))]) : _c('span', {
    on: {
      "click": function ($event) {
        return _vm.$emit('go-to-content');
      }
    }
  }, [_vm._v(_vm._s(_vm.label))])], 1) : _vm._e();
};
var NotificationTitleContentvue_type_template_id_7d094610_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue?vue&type=template&id=7d094610&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationTitleContentvue_type_script_lang_js_ = ({
  name: "NotificationTitleContent",
  props: {
    entityId: {
      type: String,
      default: ""
    },
    entityType: {
      type: String,
      default: ""
    }
  },
  computed: {
    label() {
      return this.getEntityInfo(this.entityId, this.entityType).label;
    },
    type() {
      return this.getEntityInfo(this.entityId, this.entityType).type;
    },
    ...mapGetters("notificationModule", ["getEntityInfo"])
  },
  watch: {
    label() {
      return this.$emit("loading", this.label === null);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationTitle_NotificationTitleContentvue_type_script_lang_js_ = (NotificationTitleContentvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue?vue&type=style&index=0&id=7d094610&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue?vue&type=style&index=0&id=7d094610&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleContent.vue



;


/* normalize component */

var NotificationTitleContent_component = normalizeComponent(
  NotificationTitle_NotificationTitleContentvue_type_script_lang_js_,
  NotificationTitleContentvue_type_template_id_7d094610_scoped_true_render,
  NotificationTitleContentvue_type_template_id_7d094610_scoped_true_staticRenderFns,
  false,
  null,
  "7d094610",
  null
  
)

/* harmony default export */ var NotificationTitleContent = (NotificationTitleContent_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleAuthor.vue?vue&type=template&id=244d419b&scoped=true&
var NotificationTitleAuthorvue_type_template_id_244d419b_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.username !== '?' ? _c('span', {
    staticClass: "notification__title-author"
  }, [_vm._v(" " + _vm._s(_vm.isMine ? _vm.$t("notifications.you") : _vm.username) + " ")]) : _c('span', {
    staticClass: "notification__title-author"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.info.author-error")) + " ")]);
};
var NotificationTitleAuthorvue_type_template_id_244d419b_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleAuthor.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationTitleAuthorvue_type_script_lang_js_ = ({
  name: "NotificationTitleAuthor",
  props: {
    authorId: {
      type: String,
      required: false
    },
    isMine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    username() {
      return this.getUsername(this.authorId);
    },
    ...mapGetters("notificationModule", ["getUsername"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleAuthor.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationTitle_NotificationTitleAuthorvue_type_script_lang_js_ = (NotificationTitleAuthorvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleAuthor.vue?vue&type=style&index=0&id=244d419b&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleAuthor.vue?vue&type=style&index=0&id=244d419b&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleAuthor.vue



;


/* normalize component */

var NotificationTitleAuthor_component = normalizeComponent(
  NotificationTitle_NotificationTitleAuthorvue_type_script_lang_js_,
  NotificationTitleAuthorvue_type_template_id_244d419b_scoped_true_render,
  NotificationTitleAuthorvue_type_template_id_244d419b_scoped_true_staticRenderFns,
  false,
  null,
  "244d419b",
  null
  
)

/* harmony default export */ var NotificationTitleAuthor = (NotificationTitleAuthor_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleUrgent.vue?vue&type=template&id=7165ff1c&
var NotificationTitleUrgentvue_type_template_id_7165ff1c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "relative"
  }, [_c('font-awesome-icon', {
    staticClass: "text-red cursor-pointer ml-1 relative peer",
    attrs: {
      "icon": ['fas', 'exclamation-circle']
    }
  }), _c('span', {
    staticClass: "absolute z-20 shadow px-2 py-1 text-xs bg-gray-9 text-white top-[calc(100%+4px)] -right-8 rounded whitespace-nowrap pointer-events-none opacity-0 peer-hover:opacity-100 transition-opacity"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.urgent")) + " ")])], 1);
};
var NotificationTitleUrgentvue_type_template_id_7165ff1c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-87.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleUrgent.vue?vue&type=script&lang=ts&
/* harmony default export */ var NotificationTitleUrgentvue_type_script_lang_ts_ = ({
  name: "NotificationTitleUrgent"
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleUrgent.vue?vue&type=script&lang=ts&
 /* harmony default export */ var NotificationTitle_NotificationTitleUrgentvue_type_script_lang_ts_ = (NotificationTitleUrgentvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleUrgent.vue





/* normalize component */
;
var NotificationTitleUrgent_component = normalizeComponent(
  NotificationTitle_NotificationTitleUrgentvue_type_script_lang_ts_,
  NotificationTitleUrgentvue_type_template_id_7165ff1c_render,
  NotificationTitleUrgentvue_type_template_id_7165ff1c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationTitleUrgent = (NotificationTitleUrgent_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitle.vue?vue&type=script&lang=js&




/* harmony default export */ var NotificationTitlevue_type_script_lang_js_ = ({
  name: "NotificationTitle",
  components: {
    NotificationTitleText: NotificationTitleText,
    NotificationTitleContent: NotificationTitleContent,
    NotificationTitleAuthor: NotificationTitleAuthor,
    NotificationTitleUrgent: NotificationTitleUrgent
  },
  props: {
    components: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitle.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationTitle_NotificationTitlevue_type_script_lang_js_ = (NotificationTitlevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitle.vue?vue&type=style&index=0&id=20702ed0&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitle.vue?vue&type=style&index=0&id=20702ed0&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitle.vue



;


/* normalize component */

var NotificationTitle_component = normalizeComponent(
  NotificationTitle_NotificationTitlevue_type_script_lang_js_,
  NotificationTitlevue_type_template_id_20702ed0_scoped_true_render,
  NotificationTitlevue_type_template_id_20702ed0_scoped_true_staticRenderFns,
  false,
  null,
  "20702ed0",
  null
  
)

/* harmony default export */ var NotificationTitle = (NotificationTitle_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationAvatar.vue?vue&type=template&id=5eae34b1&scoped=true&
var NotificationAvatarvue_type_template_id_5eae34b1_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notification__item-avatar"
  }, [_c('div', {
    staticClass: "md-avatar",
    style: [_vm.colorStyle, _vm.avatarSize]
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.username ? _vm.username[0].toUpperCase() : "?"))])])]);
};
var NotificationAvatarvue_type_template_id_5eae34b1_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationAvatar.vue?vue&type=script&lang=js&

const userColor = (str, s, l) => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = hash % 360;
  return `hsl(${h},${s}%,${l}%)`;
};
/* harmony default export */ var NotificationAvatarvue_type_script_lang_js_ = ({
  name: "NotificationAvatar",
  props: {
    authorId: {
      type: String,
      default: ""
    }
  },
  computed: {
    colorStyle() {
      return {
        background: this.username !== null && this.username !== "?" ? userColor(this.username, 70, 50) : "#adb5bd"
      };
    },
    avatarSize() {
      return {
        width: "30px",
        height: "30px"
      };
    },
    username() {
      return this.getUsername(this.authorId);
    },
    ...mapGetters("notificationModule", ["getUsername"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationAvatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationAvatarvue_type_script_lang_js_ = (NotificationAvatarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationAvatar.vue?vue&type=style&index=0&id=5eae34b1&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationAvatar.vue?vue&type=style&index=0&id=5eae34b1&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationAvatar.vue



;


/* normalize component */

var NotificationAvatar_component = normalizeComponent(
  NotificationBody_NotificationAvatarvue_type_script_lang_js_,
  NotificationAvatarvue_type_template_id_5eae34b1_scoped_true_render,
  NotificationAvatarvue_type_template_id_5eae34b1_scoped_true_staticRenderFns,
  false,
  null,
  "5eae34b1",
  null
  
)

/* harmony default export */ var NotificationAvatar = (NotificationAvatar_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationBody.vue?vue&type=template&id=11065d51&scoped=true&
var NotificationBodyvue_type_template_id_11065d51_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', _vm._l(_vm.components, function (el) {
    return _c(el.name, _vm._b({
      key: el.id,
      tag: "component",
      on: {
        "go-to-content": function ($event) {
          return _vm.$emit('go-to-content', $event);
        },
        "response": function ($event) {
          return _vm.$emit('response', $event);
        },
        "loading": function ($event) {
          return _vm.$emit('loading');
        }
      }
    }, 'component', el.props, false));
  }), 1);
};
var NotificationBodyvue_type_template_id_11065d51_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationHeader.vue?vue&type=template&id=667aee6a&scoped=true&
var NotificationHeadervue_type_template_id_667aee6a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notification__item-header"
  }, [_c('NotificationDate', {
    attrs: {
      "date": _vm.date
    }
  })], 1);
};
var NotificationHeadervue_type_template_id_667aee6a_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationDate.vue?vue&type=template&id=634556f6&scoped=true&
var NotificationDatevue_type_template_id_634556f6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "notification__title-date"
  }, [_vm._v(" " + _vm._s(_vm.displayDate) + " ")]);
};
var NotificationDatevue_type_template_id_634556f6_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationDate.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationDatevue_type_script_lang_js_ = ({
  name: "NotificationDate",
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      displayDate: ""
    };
  },
  mounted() {
    this.displayDate = this.timeSince(this.date);
  },
  computed: {
    ...mapGetters("notificationModule", ["notifications"])
  },
  methods: {
    dateParser(date) {
      return new Date(Date.parse(date)).toLocaleString().slice(0, 10);
    },
    timeSince(date) {
      if (!this.isIsoDate(date)) {
        date = new Date(parseInt(date, 10)).toISOString();
      }
      const seconds = Math.floor((Date.now() - Date.parse(date)) / 1000);
      const intervals = [{
        label: "h",
        seconds: 3600
      }, {
        label: "min",
        seconds: 60
      }, {
        label: "s",
        seconds: 1
      }];
      if (seconds < 2) {
        return this.$t("notifications.now");
      }
      if (seconds < 86400) {
        const interval = intervals.find(i => i.seconds < seconds);
        const count = Math.floor(seconds / interval.seconds);
        const time = `${count}${interval.label}`;
        return this.$t("notifications.time-ago", {
          time
        });
      }
      if (seconds < 86400 * 2) {
        return this.$t("notifications.yesterday");
      }
      return this.dateParser(date);
    },
    isIsoDate(str) {
      if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
      const d = new Date(str);
      return d.toISOString() === str;
    }
  },
  watch: {
    notifications() {
      this.displayDate = this.timeSince(this.date);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationDate.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationDatevue_type_script_lang_js_ = (NotificationDatevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationDate.vue?vue&type=style&index=0&id=634556f6&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationDate.vue?vue&type=style&index=0&id=634556f6&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationDate.vue



;


/* normalize component */

var NotificationDate_component = normalizeComponent(
  NotificationBody_NotificationDatevue_type_script_lang_js_,
  NotificationDatevue_type_template_id_634556f6_scoped_true_render,
  NotificationDatevue_type_template_id_634556f6_scoped_true_staticRenderFns,
  false,
  null,
  "634556f6",
  null
  
)

/* harmony default export */ var NotificationDate = (NotificationDate_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationHeader.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationHeadervue_type_script_lang_js_ = ({
  name: "NotificationHeader",
  components: {
    NotificationDate: NotificationDate
  },
  props: {
    date: {
      type: String,
      required: true
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationHeadervue_type_script_lang_js_ = (NotificationHeadervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationHeader.vue?vue&type=style&index=0&id=667aee6a&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationHeader.vue?vue&type=style&index=0&id=667aee6a&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationHeader.vue



;


/* normalize component */

var NotificationHeader_component = normalizeComponent(
  NotificationBody_NotificationHeadervue_type_script_lang_js_,
  NotificationHeadervue_type_template_id_667aee6a_scoped_true_render,
  NotificationHeadervue_type_template_id_667aee6a_scoped_true_staticRenderFns,
  false,
  null,
  "667aee6a",
  null
  
)

/* harmony default export */ var NotificationHeader = (NotificationHeader_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationMessage.vue?vue&type=template&id=4fdf4b6d&scoped=true&
var NotificationMessagevue_type_template_id_4fdf4b6d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "thread"
  }, [_c('div', {
    staticClass: "author"
  }, [_vm.authorId ? _c('span', [_vm._v(" " + _vm._s(_vm.displayUsername === "?" ? _vm.$t("notifications.info.author-error") : _vm.displayUsername))]) : _vm._e(), _vm.date ? _c('NotificationDate', {
    attrs: {
      "date": _vm.date
    }
  }) : _vm._e(), _vm.edited ? _c('span', {
    staticClass: "edited ml-1"
  }, [_vm._v(_vm._s(_vm.$t("notifications.info.edited")))]) : _vm._e()], 1), _vm.displayMessage ? _c('NotificationEditor', {
    class: {
      highlight: _vm.isHighlight
    },
    attrs: {
      "body": _vm.displayMessage,
      "message-options": _vm.messageOptions
    },
    on: {
      "go-to-content": function ($event) {
        return _vm.$emit('go-to-content', $event);
      }
    }
  }) : _vm._e(), _vm.hasAttachments ? _c('AttachmentList', {
    staticClass: "mt-1",
    attrs: {
      "attachments": _vm.attachments,
      "isInput": false,
      "displayHeader": true
    }
  }) : _vm._e()], 1);
};
var NotificationMessagevue_type_template_id_4fdf4b6d_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationEditor.vue?vue&type=template&id=3da1b8ae&scoped=true&
var NotificationEditorvue_type_template_id_3da1b8ae_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mayday-notification-editor text-edition text-left"
  }, [_vm.showEditor ? _c('mayday-editor', {
    ref: "notification-editor",
    attrs: {
      "editable": _vm.editable,
      "options": _vm.options,
      "placeholder": _vm.$t('notifications.feedback.response.placeholder'),
      "fetch-inline-content-handler": _vm.getContent,
      "fetch-inline-mention-handler": _vm.handleFetchInlineMention
    },
    on: {
      "update": _vm.onUpdate,
      "click:open-link": _vm.handleOpenLink,
      "click:inline-content": function ($event) {
        return _vm.$emit('go-to-content', $event);
      }
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  }) : _vm._e()], 1);
};
var NotificationEditorvue_type_template_id_3da1b8ae_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationEditor.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationEditorvue_type_script_lang_js_ = ({
  name: "NotificationEditor",
  props: {
    body: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    messageOptions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      content: "",
      options: {
        fontOptions: true,
        structurationOptions: true,
        tableOptions: false,
        richOptions: false,
        messageOptions: this.messageOptions,
        extraStructurationOptions: false,
        extraFontOptions: true,
        tocClickOptions: false,
        allowToc: false,
        colorOptions: true,
        hideDragHandle: true
      },
      showEditor: true
    };
  },
  created() {
    this.setEditorContent(this.body);
  },
  computed: {
    ...mapGetters("notificationModule", ["users"])
  },
  methods: {
    handleOpenLink({
      href
    }) {
      window.open(href, "_blank");
    },
    onUpdate(message) {
      this.$emit("input", message === "<p></p>" ? "" : message);
    },
    hackEditorContent(message) {
      this.showEditor = false;
      this.$nextTick(() => {
        this.showEditor = true;
        this.$nextTick(() => {
          this.setEditorContent(message);
        });
      });
    },
    setEditorContent(message) {
      const maydayEditor = this.$refs["notification-editor"];
      this.content = message;
      if (maydayEditor) {
        maydayEditor.editor.commands.setContent(this.content);
        maydayEditor.editor.commands.focus();
      }
    },
    focusEditor() {
      const maydayEditor = this.$refs["notification-editor"];
      if (maydayEditor) {
        maydayEditor.editor.commands.focus();
      }
    },
    handleFetchInlineMention({
      entityId,
      entityType
    }) {
      const user = this.users[entityId];
      if (!user) return null;
      const {
        username,
        isDeleted
      } = user;
      return {
        entityId,
        entityType,
        label: username,
        isDeleted
      };
    },
    ...mapActions("knowledgeModule", ["getContent"])
  },
  watch: {
    editable() {
      this.editor.setOptions({
        editable: this.editable
      });
    },
    reset() {
      this.hackEditorContent("");
    },
    body() {
      if (this.editable) return;
      this.hackEditorContent(this.body);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationEditor.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationEditorvue_type_script_lang_js_ = (NotificationEditorvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationEditor.vue?vue&type=style&index=0&id=3da1b8ae&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationEditor.vue?vue&type=style&index=0&id=3da1b8ae&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationEditor.vue



;


/* normalize component */

var NotificationEditor_component = normalizeComponent(
  NotificationBody_NotificationEditorvue_type_script_lang_js_,
  NotificationEditorvue_type_template_id_3da1b8ae_scoped_true_render,
  NotificationEditorvue_type_template_id_3da1b8ae_scoped_true_staticRenderFns,
  false,
  null,
  "3da1b8ae",
  null
  
)

/* harmony default export */ var NotificationEditor = (NotificationEditor_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/AttachmentList.vue?vue&type=template&id=538d6782&scoped=true&
var AttachmentListvue_type_template_id_538d6782_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.attachments.length ? _c('div', {
    staticClass: "attachments",
    class: {
      'custom-border-red mb-1 pb-1': _vm.displayDisableFileUpload
    }
  }, [_vm.displayHeader ? _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$tc("ask.attachment", _vm.attachments.length)) + " ")]) : _vm._e(), _vm._l(_vm.attachmentsToDisplay, function (attachment) {
    return _c('Attachment', {
      key: attachment.id,
      attrs: {
        "name": attachment.name,
        "id": attachment.id,
        "url": attachment.url,
        "size": attachment.size,
        "loading": attachment.loading,
        "error": attachment.error,
        "isInput": _vm.isInput,
        "attachment-width": _vm.attachmentWidth
      },
      on: {
        "disable-click": function ($event) {
          return _vm.$emit('disable-click', $event);
        },
        "delete-attachment": function ($event) {
          return _vm.$emit('delete-attachment', $event);
        }
      }
    });
  })], 2) : _vm._e(), _vm.displayDisableFileUpload ? _c('div', {
    staticClass: "disable-file-upload-message"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.errorText)) + " ")]) : _vm._e()]);
};
var AttachmentListvue_type_template_id_538d6782_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/Attachment.vue?vue&type=template&id=75349f68&scoped=true&
var Attachmentvue_type_template_id_75349f68_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['attachment', {
      'simple-attachment': !_vm.isInput
    }],
    style: _vm.dynamicStyle,
    on: {
      "click": _vm.triggerDownload,
      "mouseenter": function ($event) {
        _vm.hover = true;
      },
      "mouseleave": function ($event) {
        _vm.hover = false;
      }
    }
  }, [_c('div', {
    staticClass: "flex align-items-center attachment-title"
  }, [_c('div', {
    staticClass: "icon-wrapper mr-1"
  }, [!_vm.error ? _c('font-awesome-icon', {
    staticClass: "w-100 h-100",
    attrs: {
      "icon": ['fal', _vm.icon]
    }
  }) : _vm.isInput ? _c('font-awesome-icon', {
    staticClass: "icon-error",
    attrs: {
      "icon": ['fal', 'exclamation-triangle']
    }
  }) : _vm._e()], 1), _c('TextEllipsis', {
    staticClass: "attachment-name mr-1",
    attrs: {
      "text": _vm.name,
      "fontSize": "11px"
    }
  }), _vm.size && _vm.isInput ? _c('div', {
    staticClass: "attachment-size"
  }, [_vm._v("(" + _vm._s(_vm.size) + ")")]) : _vm._e()], 1), !_vm.isInput ? _c('div', {
    staticClass: "download"
  }, [_c('font-awesome-icon', {
    staticClass: "w-100 h-100",
    attrs: {
      "icon": ['fal', 'external-link']
    }
  })], 1) : _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.deleteAttachment
    }
  }, [!_vm.showLoading ? _c('font-awesome-icon', {
    staticClass: "close-icon",
    attrs: {
      "icon": ['fal', 'times']
    }
  }) : _c('font-awesome-icon', {
    staticClass: "close-icon icon-loading",
    attrs: {
      "icon": ['fas', 'spinner-third'],
      "spin": ""
    }
  })], 1)]);
};
var Attachmentvue_type_template_id_75349f68_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/TextEllipsisWithScroll.vue?vue&type=template&id=74a82a76&scoped=true&
var TextEllipsisWithScrollvue_type_template_id_74a82a76_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-wrapper",
    class: {
      'md-truncate': !_vm.scroll
    },
    style: _vm.fontStyle,
    attrs: {
      "id": _vm.textId
    },
    on: {
      "mouseenter": _vm.startScroll,
      "mouseleave": _vm.stopScroll
    }
  }, [_c('div', {
    staticClass: "md-temp",
    attrs: {
      "id": _vm.textId + '-temp'
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")]), _c('div', {
    style: _vm.scrollStyle
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])]);
};
var TextEllipsisWithScrollvue_type_template_id_74a82a76_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/TextEllipsisWithScroll.vue?vue&type=script&lang=js&


/* harmony default export */ var TextEllipsisWithScrollvue_type_script_lang_js_ = ({
  name: "text-ellipsis",
  props: {
    text: {
      type: String,
      required: false
    },
    stop: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
      default: "1rem"
    }
  },
  data() {
    return {
      textId: esm_browser_v4(),
      tempWidth: 0,
      loading: true,
      distance: 0,
      scroll: false,
      shadowRoot: getShadowRoot()
    };
  },
  computed: {
    scrollStyle() {
      if (this.stop) return "";
      const duration = Math.floor(this.distance / 60 * 1000);
      return `transition: transform ${duration}ms linear ${this.scroll ? "500ms" : "0ms"}; transform: translateX(-${this.distance}px)`;
    },
    fontStyle() {
      return `font-size: ${this.fontSize};`;
    }
  },
  methods: {
    startScroll() {
      this.calcTempWidth();
      const doc = this.shadowRoot ? this.shadowRoot : document;
      const el = doc.getElementById(this.textId);
      const width = el.getBoundingClientRect().width;
      this.distance = this.tempWidth - width;
      this.scroll = true;
    },
    stopScroll() {
      this.distance = 0;
      this.scroll = false;
    },
    calcTempWidth() {
      const doc = this.shadowRoot ? this.shadowRoot : document;
      const el = doc.getElementById(this.textId + "-temp");
      this.tempWidth = el.getBoundingClientRect().width;
      this.loading = false;
    }
  }
});
;// CONCATENATED MODULE: ./src/library/TextEllipsisWithScroll.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_TextEllipsisWithScrollvue_type_script_lang_js_ = (TextEllipsisWithScrollvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/TextEllipsisWithScroll.vue?vue&type=style&index=0&id=74a82a76&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/TextEllipsisWithScroll.vue?vue&type=style&index=0&id=74a82a76&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/TextEllipsisWithScroll.vue



;


/* normalize component */

var TextEllipsisWithScroll_component = normalizeComponent(
  library_TextEllipsisWithScrollvue_type_script_lang_js_,
  TextEllipsisWithScrollvue_type_template_id_74a82a76_scoped_true_render,
  TextEllipsisWithScrollvue_type_template_id_74a82a76_scoped_true_staticRenderFns,
  false,
  null,
  "74a82a76",
  null
  
)

/* harmony default export */ var TextEllipsisWithScroll = (TextEllipsisWithScroll_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/Attachment.vue?vue&type=script&lang=js&

/* harmony default export */ var Attachmentvue_type_script_lang_js_ = ({
  name: "attachment-display",
  components: {
    TextEllipsis: TextEllipsisWithScroll
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    isInput: {
      type: Boolean,
      default: false
    },
    attachmentWidth: {
      type: String,
      default: "39%"
    }
  },
  data() {
    return {
      tooltipDisabled: true,
      hover: false
    };
  },
  created() {
    this.fetchTooltipDisabled();
  },
  computed: {
    extension() {
      const re = /(?:\.([^.]+))?$/;
      return re.exec(this.name)[1];
    },
    showLoading() {
      return !this.hover && this.loading;
    },
    dynamicStyle() {
      return {
        "--attachment-width": this.attachmentWidth
      };
    },
    icon() {
      switch (this.extension) {
        case "png":
        case "jpeg":
        case "jpg":
          return "file-image";
        case "pdf":
          return "file-pdf";
        case "doc":
        case "docx":
          return "file-alt";
        default:
          return "file-alt";
      }
    }
  },
  methods: {
    fetchTooltipDisabled() {
      this.$nextTick(() => {
        const textEl = this.$refs[`attachment-name-${this.id}`];
        if (!textEl) return;
        this.tooltipDisabled = textEl.scrollWidth <= textEl.clientWidth;
      });
    },
    triggerDownload() {
      if (!this.isInput) window.open(this.url, "_blank");
      if (this.error) this.$emit("disable-click", "ask.disable-file-upload");
    },
    deleteAttachment() {
      this.$emit("delete-attachment", this.id);
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Attachments/Attachment.vue?vue&type=script&lang=js&
 /* harmony default export */ var Attachments_Attachmentvue_type_script_lang_js_ = (Attachmentvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/Attachment.vue?vue&type=style&index=0&id=75349f68&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Attachments/Attachment.vue?vue&type=style&index=0&id=75349f68&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Attachments/Attachment.vue



;


/* normalize component */

var Attachment_component = normalizeComponent(
  Attachments_Attachmentvue_type_script_lang_js_,
  Attachmentvue_type_template_id_75349f68_scoped_true_render,
  Attachmentvue_type_template_id_75349f68_scoped_true_staticRenderFns,
  false,
  null,
  "75349f68",
  null
  
)

/* harmony default export */ var Attachment = (Attachment_component.exports);
;// CONCATENATED MODULE: ./src/utils/resolveFilesNames.js
const resolveFilesNames = urls => {
  return urls.map((url, index) => {
    let name = url.split("/").slice(-1)[0];
    name = name.replace(/___[^.]+/, "");
    return {
      name,
      url,
      id: String(index)
    };
  });
};
/* harmony default export */ var utils_resolveFilesNames = (resolveFilesNames);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/AttachmentList.vue?vue&type=script&lang=js&



/* harmony default export */ var AttachmentListvue_type_script_lang_js_ = ({
  name: "attachment-list",
  components: {
    Attachment: Attachment
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    isInput: {
      type: Boolean,
      default: false
    },
    displayDisableFileUpload: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: ""
    },
    displayHeader: {
      type: Boolean,
      default: true
    },
    attachmentWidth: {
      type: String,
      default: "39%"
    }
  },
  computed: {
    enrichedAttachments() {
      return utils_resolveFilesNames(this.attachments);
    },
    attachmentsToDisplay() {
      return this.isInput ? this.attachments : this.enrichedAttachments;
    }
  },
  methods: {
    ...mapActions("attachmentModule", ["fetchFilesByIds"])
  }
});
;// CONCATENATED MODULE: ./src/library/Attachments/AttachmentList.vue?vue&type=script&lang=js&
 /* harmony default export */ var Attachments_AttachmentListvue_type_script_lang_js_ = (AttachmentListvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/AttachmentList.vue?vue&type=style&index=0&id=538d6782&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Attachments/AttachmentList.vue?vue&type=style&index=0&id=538d6782&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Attachments/AttachmentList.vue



;


/* normalize component */

var AttachmentList_component = normalizeComponent(
  Attachments_AttachmentListvue_type_script_lang_js_,
  AttachmentListvue_type_template_id_538d6782_scoped_true_render,
  AttachmentListvue_type_template_id_538d6782_scoped_true_staticRenderFns,
  false,
  null,
  "538d6782",
  null
  
)

/* harmony default export */ var AttachmentList = (AttachmentList_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationMessage.vue?vue&type=script&lang=js&




/* harmony default export */ var NotificationMessagevue_type_script_lang_js_ = ({
  name: "NotificationMessage",
  components: {
    NotificationDate: NotificationDate,
    NotificationEditor: NotificationEditor,
    AttachmentList: AttachmentList
  },
  props: {
    authorId: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String,
      required: false
    },
    edited: {
      type: Boolean,
      default: false
    },
    attachments: {
      type: Array,
      default: () => []
    },
    messageOptions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayMessage() {
      return this.taskId && !this.message ? this.getTaskBody(this.taskId) : this.message;
    },
    displayUsername() {
      return this.isMine ? this.$t("notifications.you") : this.getUsername(this.authorId);
    },
    isMine() {
      return this.authorId === this.userId;
    },
    hasAttachments() {
      return this.attachments && this.attachments.length;
    },
    ...mapGetters("notificationModule", ["userId", "getUsername", "getTaskBody"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationMessage.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationMessagevue_type_script_lang_js_ = (NotificationMessagevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationMessage.vue?vue&type=style&index=0&id=4fdf4b6d&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationMessage.vue?vue&type=style&index=0&id=4fdf4b6d&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationMessage.vue



;


/* normalize component */

var NotificationMessage_component = normalizeComponent(
  NotificationBody_NotificationMessagevue_type_script_lang_js_,
  NotificationMessagevue_type_template_id_4fdf4b6d_scoped_true_render,
  NotificationMessagevue_type_template_id_4fdf4b6d_scoped_true_staticRenderFns,
  false,
  null,
  "4fdf4b6d",
  null
  
)

/* harmony default export */ var NotificationMessage = (NotificationMessage_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationThread.vue?vue&type=template&id=60443971&scoped=true&
var NotificationThreadvue_type_template_id_60443971_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notification__item-thread"
  }, [_c('NotificationMessage', {
    key: _vm.thread[0].taskCommentId,
    staticClass: "notification__item-message",
    attrs: {
      "isHighlight": true,
      "authorId": _vm.thread[0].authorId,
      "message": _vm.thread[0].body,
      "date": _vm.thread[0].createdAt,
      "attachments": _vm.thread[0].attachments
    }
  }), _vm.hasMore ? _c('button', {
    staticClass: "notification__item-more",
    on: {
      "click": function ($event) {
        _vm.showAll = !_vm.showAll;
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['far', _vm.showAll ? 'compress-alt' : 'expand-alt']
    }
  }), _c('div', {
    staticClass: "notification__item-cta"
  }, [_vm._v(" " + _vm._s(_vm.showAll ? _vm.$t("notifications.show-less") : _vm.$tc("notifications.show-more", _vm.hiddenMessage)) + " ")])], 1) : _vm._e(), _c('div', {
    class: _vm.displayAnimation
  }, _vm._l(_vm.displayThread, function (message) {
    return _c('NotificationMessage', {
      key: message.taskCommentId,
      staticClass: "notification__item-message",
      attrs: {
        "authorId": message.authorId,
        "message": message.body,
        "createdAt": message.createdAt,
        "updatedAt": message.updatedAt,
        "attachments": message.attachments,
        "messageOptions": true,
        "edited": message.createdAt !== message.updatedAt
      }
    });
  }), 1)], 1);
};
var NotificationThreadvue_type_template_id_60443971_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationThread.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationThreadvue_type_script_lang_js_ = ({
  name: "NotificationThread",
  components: {
    NotificationMessage: NotificationMessage
  },
  props: {
    thread: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showAll: false,
      maxLength: 3
    };
  },
  computed: {
    displayThread() {
      if (this.showAll) return this.thread.slice(1);
      return this.hasMore ? this.thread.slice(-this.maxLength) : this.thread.slice(1);
    },
    hasMore() {
      return this.thread.length > this.maxLength + 1;
    },
    displayAnimation() {
      return this.showAll ? "background-animation" : "";
    },
    hiddenMessage() {
      return this.thread.length - (this.maxLength + 1);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationThread.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationThreadvue_type_script_lang_js_ = (NotificationThreadvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationThread.vue?vue&type=style&index=0&id=60443971&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationThread.vue?vue&type=style&index=0&id=60443971&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationThread.vue



;


/* normalize component */

var NotificationThread_component = normalizeComponent(
  NotificationBody_NotificationThreadvue_type_script_lang_js_,
  NotificationThreadvue_type_template_id_60443971_scoped_true_render,
  NotificationThreadvue_type_template_id_60443971_scoped_true_staticRenderFns,
  false,
  null,
  "60443971",
  null
  
)

/* harmony default export */ var NotificationThread = (NotificationThread_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationResponse.vue?vue&type=template&id=2ca99e39&scoped=true&
var NotificationResponsevue_type_template_id_2ca99e39_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [!_vm.response ? _c('base-button', {
    staticClass: "border notification__item-cta",
    on: {
      "click": function ($event) {
        return _vm.handleResponse();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.feedback.response.button")) + " ")]) : _c('div', {
    staticClass: "thread"
  }, [_c('div', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.username))]), _c('div', {
    staticClass: "response",
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        _vm.response = false;
      }
    }
  }, [_c('NotificationEditor', {
    staticClass: "editor-message",
    attrs: {
      "reset": _vm.reset,
      "body": _vm.message,
      "editable": true
    },
    on: {
      "input": function ($event) {
        _vm.message = $event;
      }
    }
  }), _vm.showAttachments ? _c('AddAttachment', {
    ref: "add-attachment",
    staticClass: "attachment-wrapper mr-1",
    attrs: {
      "disabled": _vm.fileInputDisable,
      "attachment-loading": _vm.attachmentLoading
    },
    on: {
      "new-attachment": _vm.handleFileChange,
      "disable-click": function ($event) {
        return _vm.showDisableFileUpload('ask.disable-file-upload');
      }
    },
    scopedSlots: _vm._u([{
      key: "slot-button",
      fn: function () {
        return [_c('div', {
          staticClass: "attachment-wrapper",
          class: _vm.attachmentLoading ? 'attachment-wrapper__disable' : 'attachment-wrapper__enable'
        }, [_c('font-awesome-icon', {
          staticClass: "attachment-icon",
          class: _vm.attachmentLoading ? 'attachment-icon__disable' : 'attachment-icon__enable',
          attrs: {
            "icon": ['fas', 'paperclip']
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 880205118)
  }) : _vm._e(), _c('div', {
    staticClass: "editor-send",
    class: _vm.isSendable ? 'editor-send__enable' : 'editor-send__disable'
  }, [!_vm.taskCommentIsLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', 'paper-plane']
    },
    on: {
      "click": function ($event) {
        return _vm.sendMessage();
      }
    }
  }) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1), _c('AttachmentList', {
    staticClass: "mt-1",
    attrs: {
      "attachments": _vm.attachments,
      "isInput": true,
      "displayDisableFileUpload": _vm.displayDisableFileUpload,
      "errorText": _vm.errorText
    },
    on: {
      "delete-attachment": _vm.handleDeleteAttachment
    }
  })], 1)], 1);
};
var NotificationResponsevue_type_template_id_2ca99e39_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/AddAttachment.vue?vue&type=template&id=32196e7b&scoped=true&
var AddAttachmentvue_type_template_id_32196e7b_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('label', {
    attrs: {
      "for": "file-upload"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "add-button-wrapper"
  }, [!_vm.attachmentLoading ? _vm._t("slot-button") : _c('font-awesome-icon', {
    staticClass: "close-icon icon-loading",
    attrs: {
      "icon": ['fas', 'spinner-third'],
      "spin": ""
    }
  })], 2)]), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-upload",
      "accept": "image/png, image/jpeg, .doc,.docx, application/pdf",
      "disabled": _vm.disabled || _vm.attachmentLoading,
      "multiple": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('new-attachment', $event);
      },
      "click": _vm.handleClickOnInput
    }
  })]);
};
var AddAttachmentvue_type_template_id_32196e7b_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/AddAttachment.vue?vue&type=script&lang=js&
/* harmony default export */ var AddAttachmentvue_type_script_lang_js_ = ({
  name: "add-attachment",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    attachmentLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) this.$emit("disable-click");
    },
    handleClickOnInput(event) {
      event.target.value = "";
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Attachments/AddAttachment.vue?vue&type=script&lang=js&
 /* harmony default export */ var Attachments_AddAttachmentvue_type_script_lang_js_ = (AddAttachmentvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Attachments/AddAttachment.vue?vue&type=style&index=0&id=32196e7b&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Attachments/AddAttachment.vue?vue&type=style&index=0&id=32196e7b&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Attachments/AddAttachment.vue



;


/* normalize component */

var AddAttachment_component = normalizeComponent(
  Attachments_AddAttachmentvue_type_script_lang_js_,
  AddAttachmentvue_type_template_id_32196e7b_scoped_true_render,
  AddAttachmentvue_type_template_id_32196e7b_scoped_true_staticRenderFns,
  false,
  null,
  "32196e7b",
  null
  
)

/* harmony default export */ var AddAttachment = (AddAttachment_component.exports);
;// CONCATENATED MODULE: ./src/modules/attachment/mixins/attachmentMixins.js


/* harmony default export */ var attachmentMixins = (() => {
  return {
    data() {
      return {
        attachments: [],
        attachmentLoading: false,
        errorText: "",
        displayDisableFileUpload: false
      };
    },
    computed: {
      fileInputDisable() {
        return this.attachments.length >= 3;
      }
    },
    methods: {
      fileSize(sizeInBytes) {
        const sizeInKo = Math.trunc(sizeInBytes / 1000);
        if (sizeInKo < 1000) return `${sizeInKo} Ko`;
        return `${Math.trunc(sizeInKo / 1000)} Mo`;
      },
      handleDeleteAttachment(id) {
        this.attachments = this.attachments.filter(attachment => attachment.id !== id);
        if (!this.attachments.length) this.attachmentLoading = false;
      },
      showDisableFileUpload(errorText) {
        this.displayDisableFileUpload = true;
        if (errorText) this.errorText = errorText;
        setTimeout(() => {
          this.displayDisableFileUpload = false;
        }, 5000);
      },
      async handleFileChange(e) {
        const previousAttachmentsLength = this.attachments.length;
        if (!e.target.files.length) return;
        if (e.target.files.length + previousAttachmentsLength > 3) {
          this.showDisableFileUpload("ask.too-many-files");
          return;
        }
        this.attachmentLoading = true;
        const filesAsArray = Array.from(e.target.files).reduce((acc, file) => {
          file.name;
          if (this.attachments.findIndex(at => at.name === file.name) > -1) {
            this.showDisableFileUpload("ask.existing-file");
          } else {
            acc.push(file);
          }
          return acc;
        }, []);
        const filesToUpload = filesAsArray.map((file, index) => {
          return {
            name: file.name,
            size: this.fileSize(file.size),
            id: String(previousAttachmentsLength + index),
            loading: true,
            error: false
          };
        });
        this.attachments.push(...filesToUpload);
        await Promise.all(filesAsArray.map(async (file, index) => {
          let currentIndexInAttachments = previousAttachmentsLength + index;
          try {
            const uploadedFile = await this.uploadFiles([file]);
            if (!uploadedFile[0]) {
              this.attachments[currentIndexInAttachments].loading = false;
              this.attachments[currentIndexInAttachments].error = true;
              this.showDisableFileUpload("ask.upload-problem");
            } else {
              this.attachments[currentIndexInAttachments].loading = false;
              this.attachments[currentIndexInAttachments].id = uploadedFile[0]._id;
              this.attachments[currentIndexInAttachments].url = uploadedFile[0].url;
            }
          } catch (e) {
            // 413 error is payload too big
            if (e.response && e.response.status === 413) {
              this.showDisableFileUpload("ask.file-too-big");
              this.attachments.pop();
            } else {
              this.showDisableFileUpload("ask.upload-problem");
              this.attachments[currentIndexInAttachments].error = true;
              this.attachments[currentIndexInAttachments].loading = false;
              this.attachmentLoading = false;
            }
          }
        }));
        this.attachmentLoading = false;
      },
      ...mapActions("feedbackModule", ["uploadFiles"])
    }
  };
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationResponse.vue?vue&type=script&lang=js&






/* harmony default export */ var NotificationResponsevue_type_script_lang_js_ = ({
  name: "MaydayWebNotificationResponse",
  components: {
    BaseButton: BaseButton,
    NotificationEditor: NotificationEditor,
    AddAttachment: AddAttachment,
    AttachmentList: AttachmentList
  },
  mixins: [attachmentMixins()],
  props: {
    notificationId: {
      type: String,
      required: true
    },
    showAttachments: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.$root.$on("comment-notification", payload => {
      if (payload.notificationId === this.notificationId) {
        this.response = false;
      }
    });
  },
  data() {
    return {
      response: false,
      message: "",
      reset: false
    };
  },
  computed: {
    attachmentsSendable() {
      let sendable = true;
      if (this.attachments.length) {
        sendable = this.attachments.map(at => !at.error || !at.loading).every(el => el);
      }
      return sendable && !this.attachmentLoading;
    },
    isSendable() {
      if (this.attachments.length && this.attachmentsSendable) return true;
      if (!this.attachments.length && this.message !== "") return true;
      return false;
    },
    ...mapState("adminModule", ["username"]),
    ...mapGetters("notificationModule", ["taskCommentIsLoading"])
  },
  methods: {
    handleResponse() {
      this.response = true;
      this.message = "";
      this.attachments = [];
      this.reset = !this.reset;
    },
    sendMessage() {
      if (!this.isSendable) return;
      const response = {
        comment: this.message,
        ...(this.showAttachments ? {
          attachments: this.attachments.map(at => at.url)
        } : {})
      };
      this.$emit("response", response);
      this.reset = !this.reset;
    }
  },
  watch: {
    reset() {
      this.attachments = [];
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationResponse.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationResponsevue_type_script_lang_js_ = (NotificationResponsevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationResponse.vue?vue&type=style&index=0&id=2ca99e39&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationResponse.vue?vue&type=style&index=0&id=2ca99e39&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationResponse.vue



;


/* normalize component */

var NotificationResponse_component = normalizeComponent(
  NotificationBody_NotificationResponsevue_type_script_lang_js_,
  NotificationResponsevue_type_template_id_2ca99e39_scoped_true_render,
  NotificationResponsevue_type_template_id_2ca99e39_scoped_true_staticRenderFns,
  false,
  null,
  "2ca99e39",
  null
  
)

/* harmony default export */ var NotificationResponse = (NotificationResponse_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationRedirection.vue?vue&type=template&id=20aea807&scoped=true&
var NotificationRedirectionvue_type_template_id_20aea807_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.entityId ? _c('div', {
    staticClass: "notification__item-cta"
  }, [_vm.entityType ? _c('base-button', {
    staticClass: "border mb-1",
    attrs: {
      "disabled": !_vm.entityType
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('go-to-content');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _c('el-tooltip', {
    staticClass: "disabled",
    attrs: {
      "content": _vm.$t('notifications.info.content-error')
    }
  }, [_c('base-button', [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])], 1)], 1) : _vm._e();
};
var NotificationRedirectionvue_type_template_id_20aea807_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationRedirection.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationRedirectionvue_type_script_lang_js_ = ({
  name: "NotificationRedirection",
  components: {
    BaseButton: BaseButton
  },
  props: {
    text: {
      type: String,
      required: true
    },
    entityId: {
      type: String,
      required: false
    },
    entityType: {
      type: String,
      required: false
    },
    trad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonText() {
      return this.trad ? this.$t(this.text) : this.text;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationRedirection.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationRedirectionvue_type_script_lang_js_ = (NotificationRedirectionvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationRedirection.vue?vue&type=style&index=0&id=20aea807&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationRedirection.vue?vue&type=style&index=0&id=20aea807&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationRedirection.vue



;


/* normalize component */

var NotificationRedirection_component = normalizeComponent(
  NotificationBody_NotificationRedirectionvue_type_script_lang_js_,
  NotificationRedirectionvue_type_template_id_20aea807_scoped_true_render,
  NotificationRedirectionvue_type_template_id_20aea807_scoped_true_staticRenderFns,
  false,
  null,
  "20aea807",
  null
  
)

/* harmony default export */ var NotificationRedirection = (NotificationRedirection_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleTags.vue?vue&type=template&id=f055b842&scoped=true&
var NotificationTitleTagsvue_type_template_id_f055b842_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tags.length > 0 ? _c('div', _vm._l(_vm.tags, function (tag) {
    return _c('div', {
      key: tag.id,
      staticClass: "tags"
    }, [_vm._v(_vm._s(tag))]);
  }), 0) : _vm._e();
};
var NotificationTitleTagsvue_type_template_id_f055b842_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleTags.vue?vue&type=script&lang=js&
/* harmony default export */ var NotificationTitleTagsvue_type_script_lang_js_ = ({
  name: "NotificationTitleTags",
  props: {
    tags: {
      type: Array
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleTags.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationTitle_NotificationTitleTagsvue_type_script_lang_js_ = (NotificationTitleTagsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationTitle/NotificationTitleTags.vue?vue&type=style&index=0&id=f055b842&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleTags.vue?vue&type=style&index=0&id=f055b842&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationTitle/NotificationTitleTags.vue



;


/* normalize component */

var NotificationTitleTags_component = normalizeComponent(
  NotificationTitle_NotificationTitleTagsvue_type_script_lang_js_,
  NotificationTitleTagsvue_type_template_id_f055b842_scoped_true_render,
  NotificationTitleTagsvue_type_template_id_f055b842_scoped_true_staticRenderFns,
  false,
  null,
  "f055b842",
  null
  
)

/* harmony default export */ var NotificationTitleTags = (NotificationTitleTags_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationAttachments.vue?vue&type=template&id=901bca7e&scoped=true&
var NotificationAttachmentsvue_type_template_id_901bca7e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.hasAttachments ? _c('AttachmentList', {
    staticClass: "mt-1",
    attrs: {
      "attachments": _vm.attachments,
      "isInput": false,
      "displayHeader": true
    }
  }) : _vm._e();
};
var NotificationAttachmentsvue_type_template_id_901bca7e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationAttachments.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationAttachmentsvue_type_script_lang_js_ = ({
  name: "notification-attachments",
  components: {
    AttachmentList: AttachmentList
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasAttachments() {
      return this.attachments && this.attachments.length;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationAttachments.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationAttachmentsvue_type_script_lang_js_ = (NotificationAttachmentsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationAttachments.vue





/* normalize component */
;
var NotificationAttachments_component = normalizeComponent(
  NotificationBody_NotificationAttachmentsvue_type_script_lang_js_,
  NotificationAttachmentsvue_type_template_id_901bca7e_scoped_true_render,
  NotificationAttachmentsvue_type_template_id_901bca7e_scoped_true_staticRenderFns,
  false,
  null,
  "901bca7e",
  null
  
)

/* harmony default export */ var NotificationAttachments = (NotificationAttachments_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationBody.vue?vue&type=script&lang=js&








/* harmony default export */ var NotificationBodyvue_type_script_lang_js_ = ({
  name: "NotificationBody",
  components: {
    NotificationMessage: NotificationMessage,
    NotificationResponse: NotificationResponse,
    NotificationThread: NotificationThread,
    NotificationEditor: NotificationEditor,
    NotificationRedirection: NotificationRedirection,
    NotificationTitleTags: NotificationTitleTags,
    NotificationHeader: NotificationHeader,
    NotificationAttachments: NotificationAttachments
  },
  props: {
    components: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationBody.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationBody_NotificationBodyvue_type_script_lang_js_ = (NotificationBodyvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationBody/NotificationBody.vue?vue&type=style&index=0&id=11065d51&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationBody.vue?vue&type=style&index=0&id=11065d51&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationBody/NotificationBody.vue



;


/* normalize component */

var NotificationBody_component = normalizeComponent(
  NotificationBody_NotificationBodyvue_type_script_lang_js_,
  NotificationBodyvue_type_template_id_11065d51_scoped_true_render,
  NotificationBodyvue_type_template_id_11065d51_scoped_true_staticRenderFns,
  false,
  null,
  "11065d51",
  null
  
)

/* harmony default export */ var NotificationBody = (NotificationBody_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationItem.vue?vue&type=script&lang=js&




/* harmony default export */ var NotificationItemvue_type_script_lang_js_ = ({
  name: "NotificationItem",
  components: {
    NotificationAvatar: NotificationAvatar,
    NotificationTitle: NotificationTitle,
    NotificationBody: NotificationBody
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingTitle: false,
      loadingBody: false
    };
  },
  computed: {
    loading() {
      return this.loadingTitle || this.loadingBody;
    },
    resolvedNotification() {
      return this.resolveNotification(this.notification);
    },
    isUrgent() {
      return !!this.notification.metadata.urgent;
    },
    read() {
      if (this.isUrgent) return true;
      return this.notification.userReads.findIndex(e => e.userId === this.userId) > -1;
    },
    ...mapGetters("notificationModule", ["userId", "resolveNotification"])
  },
  methods: {
    async goToContent(forceContent) {
      this.handleReadNotification();
      // this allow to open inline-contents in notifications body
      if (forceContent) {
        return this.$emit("go-to-content", forceContent);
      }
      const {
        entityId,
        entityType,
        lang,
        type,
        taskId,
        blockId,
        threadId,
        message
      } = this.notification.metadata;
      const messageId = message ? message.messageId : null;
      const redirectId = type === "TaskAssigned" ? taskId : entityId;
      const redirectType = type === "TaskAssigned" ? "Task" : entityType;
      this.$emit("go-to-content", {
        id: redirectId,
        type: redirectType,
        lang,
        blockId,
        threadId,
        messageId
      });
    },
    async sendMessage(comment) {
      const payload = {
        taskId: this.notification.metadata.taskId,
        ...comment,
        notificationId: this.notification._id
      };
      await this.commentNotification(payload);
      // reset input to response button
      this.$root.$emit("comment-notification", payload);
    },
    handleReadNotification() {
      if (!this.read) {
        this.readNotifications([this.notification._id]);
      }
    },
    ...mapActions("notificationModule", ["readNotifications", "commentNotification"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationList_NotificationItemvue_type_script_lang_js_ = (NotificationItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationItem.vue?vue&type=style&index=0&id=ce157bca&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationItem.vue?vue&type=style&index=0&id=ce157bca&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationItem.vue



;


/* normalize component */

var NotificationItem_component = normalizeComponent(
  NotificationList_NotificationItemvue_type_script_lang_js_,
  NotificationItemvue_type_template_id_ce157bca_scoped_true_render,
  NotificationItemvue_type_template_id_ce157bca_scoped_true_staticRenderFns,
  false,
  null,
  "ce157bca",
  null
  
)

/* harmony default export */ var NotificationItem = (NotificationItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationList.vue?vue&type=script&lang=js&




/* harmony default export */ var NotificationListvue_type_script_lang_js_ = ({
  name: "NotificationList",
  components: {
    LoaderLine: library_LoaderLine,
    BaseButton: BaseButton,
    NotificationItem: NotificationItem
  },
  props: {
    isFromNotificationCenter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filtersApplied() {
      return this.filters.unreadOnly || this.filters.types.length > 0 || this.filters.dateRange[0] || this.filters.dateRange[1];
    },
    ...mapGetters("notificationModule", ["notifications", "hasMoreNotifications", "isLoading", "filters"])
  },
  methods: {
    ...mapActions("notificationModule", ["resetFilters"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationList.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationList_NotificationListvue_type_script_lang_js_ = (NotificationListvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationList.vue?vue&type=style&index=0&id=073c8db0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationList.vue?vue&type=style&index=0&id=073c8db0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationList.vue



;


/* normalize component */

var NotificationList_component = normalizeComponent(
  NotificationList_NotificationListvue_type_script_lang_js_,
  NotificationListvue_type_template_id_073c8db0_scoped_true_render,
  NotificationListvue_type_template_id_073c8db0_scoped_true_staticRenderFns,
  false,
  null,
  "073c8db0",
  null
  
)

/* harmony default export */ var NotificationList = (NotificationList_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationMenu.vue?vue&type=template&id=201b78f3&scoped=true&
var NotificationMenuvue_type_template_id_201b78f3_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notification__menu-container"
  }, [_c('div', {
    staticClass: "notification__menu"
  }, [_c('div', {
    staticClass: "notification__menu-temp"
  }, [_vm._v(_vm._s(_vm.$t("notifications.title")))]), _c('div', {
    staticClass: "notification__menu-actions"
  }, [_vm.unreadCount > 0 ? _c('div', {
    staticClass: "notification__menu-filter__button",
    on: {
      "click": _vm.readAllNotifications
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.read-all")) + " ")]) : _vm._e(), _c('div', {
    class: ['notification__menu-filter__button', {
      selected: _vm.filtersOpened || _vm.filtersCount > 0
    }],
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle-filters');
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "notification__popover-icon",
    attrs: {
      "icon": ['fal', 'sliders-v']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("notifications.filters.button")) + " "), _vm.filtersCount > 0 ? _c('span', {
    staticClass: "notification__menu-filter__count"
  }, [_vm._v(" " + _vm._s(_vm.filtersCount) + " ")]) : _vm._e()], 1)])]), _vm.filtersOpened ? _c('div', [_c('div', {
    staticClass: "notification__menu-filters"
  }, [_c('div', {
    class: ['notification__menu-filter__checkbox', {
      selected: _vm.isSelected('unreadOnly')
    }],
    on: {
      "click": function ($event) {
        return _vm.updateFilter('unreadOnly');
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "notification__popover-icon",
    attrs: {
      "icon": ['fal', 'eye-slash']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("notifications.filters.unread")) + " ")], 1), _c('div', {
    class: ['notification__menu-filter__checkbox', {
      selected: _vm.isSelected('feedbackTypes')
    }],
    on: {
      "click": function ($event) {
        return _vm.updateFilter('types', _vm.feedbackTypes);
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "notification__popover-icon",
    attrs: {
      "icon": ['fal', 'megaphone']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("notifications.filters.feedback")) + " ")], 1), _c('div', {
    class: ['notification__menu-filter__checkbox', {
      selected: _vm.isSelected('infoTypes')
    }],
    on: {
      "click": function ($event) {
        return _vm.updateFilter('types', _vm.infoTypes);
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "notification__popover-icon",
    attrs: {
      "icon": ['fal', 'info-circle']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("notifications.filters.infos")) + " ")], 1), _c('div', {
    class: ['notification__menu-filter__select-container', {
      selected: _vm.isSelected('date')
    }]
  }, [_c('font-awesome-icon', {
    staticClass: "notification__popover-icon notification__popover-calendar-icon",
    attrs: {
      "icon": ['fal', 'calendar']
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.timeFilter,
      expression: "timeFilter"
    }],
    class: ['notification__menu-filter__select', {
      selected: _vm.isSelected('date')
    }],
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.timeFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        return _vm.updateFilter('date', $event);
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": !_vm.isSelected('date'),
      "selected": "",
      "value": "-1"
    }
  }, [_vm._v(" " + _vm._s(_vm.isSelected("date") ? _vm.$t("notifications.filters.reset") : _vm.$t("notifications.filters.date")) + " ")]), _vm._l(_vm.timeOptions, function (option, i) {
    return _c('option', {
      key: option.label,
      domProps: {
        "value": i
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(`notifications.filters.timeframes.${option.label}`)) + " ")]);
  })], 2)], 1)]), _c('div', {
    staticClass: "w-full border-t py-1 flex items-center justify-end"
  }, [_c('div', {
    class: ['notification__menu-filter__button', {
      disable: _vm.filtersCount <= 0
    }],
    on: {
      "click": _vm.resetFilters
    }
  }, [_c('font-awesome-icon', {
    staticClass: "notification__popover-icon",
    attrs: {
      "icon": ['fal', 'trash']
    }
  }), _vm._v(" " + _vm._s(_vm.$t("notifications.filters.reset")) + " ")], 1)])]) : _vm._e()]);
};
var NotificationMenuvue_type_template_id_201b78f3_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationMenu.vue?vue&type=script&lang=js&

/* harmony default export */ var NotificationMenuvue_type_script_lang_js_ = ({
  name: "NotificationMenu",
  props: {
    filtersOpened: {
      type: Boolean,
      default: true
    },
    isFromNotificationCenter: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    timeFilter: -1,
    timeOptions: [{
      scale: "day",
      number: 3,
      label: "3-last-days"
    }, {
      scale: "week",
      number: 1,
      label: "last-week"
    }, {
      scale: "week",
      number: 2,
      label: "2-last-weeks"
    }, {
      scale: "month",
      number: 1,
      label: "last-month"
    }, {
      scale: "month",
      number: 3,
      label: "3-last-months"
    }],
    feedbackTypes: ["TaskComment", "Feedback", "TaskUpvoted", "TaskMoved"],
    infoTypes: ["Agent"]
  }),
  computed: {
    unreadDisplay() {
      return this.unreadCount > 99 ? "99+" : this.unreadCount;
    },
    filtersCount() {
      let count = 0;
      if (this.filters.unreadOnly) {
        count++;
      }
      if (this.filters.types.length > 0) {
        if (this.filters.types.some(type => this.feedbackTypes.includes(type))) count++;
        if (this.filters.types.some(type => this.infoTypes.includes(type))) count++;
      }
      if (this.filters.dateRange[0] !== null) {
        count++;
      }
      return count;
    },
    ...mapGetters("notificationModule", ["unreadCount", "filters"])
  },
  methods: {
    isSelected(field) {
      if (field === "feedbackTypes") return this.filters.types.some(type => this.feedbackTypes.includes(type));
      if (field === "infoTypes") return this.filters.types.some(type => this.infoTypes.includes(type));
      if (field === "date") return this.timeFilter > -1;
      return !!this.filters[field];
    },
    updateFilter(field, event) {
      if (!field) return;
      if (field === "types") {
        this.updateFilters({
          field,
          value: this.filters.types.some(type => event.includes(type)) ? this.filters.types.filter(type => !event.includes(type)) : [...this.filters.types, ...event],
          isFromNotificationCenter: this.isFromNotificationCenter
        });
      } else if (field === "date") {
        if (event.target.value === "-1") {
          this.updateFilters({
            field: "dateRange",
            value: [null, null],
            isFromNotificationCenter: this.isFromNotificationCenter
          });
          return;
        }
        this.updateFilters({
          field: "dateRange",
          value: this.timeOptionToDates(this.timeOptions[event.target.value]),
          isFromNotificationCenter: this.isFromNotificationCenter
        });
      } else {
        this.updateFilters({
          field,
          value: !this.filters[field],
          isFromNotificationCenter: this.isFromNotificationCenter
        });
      }
    },
    timeOptionToDates(option) {
      const now = new Date();
      let startDate = new Date();
      let endDate = new Date();
      if (option.scale === "day") {
        startDate.setDate(now.getDate() - option.number);
      } else if (option.scale === "week") {
        startDate.setDate(now.getDate() - 7 * option.number);
      } else if (option.scale === "month") {
        startDate.setMonth(now.getMonth() - option.number);
      }
      return [startDate, endDate];
    },
    ...mapActions("notificationModule", ["readAllNotifications", "updateFilters", "getNotifications", "resetFilters"])
  },
  watch: {
    filters: {
      handler(value) {
        if (value.dateRange[0] === null) {
          this.timeFilter = -1;
        }
      },
      deep: true
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var NotificationList_NotificationMenuvue_type_script_lang_js_ = (NotificationMenuvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationList/NotificationMenu.vue?vue&type=style&index=0&id=201b78f3&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationMenu.vue?vue&type=style&index=0&id=201b78f3&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationList/NotificationMenu.vue



;


/* normalize component */

var NotificationMenu_component = normalizeComponent(
  NotificationList_NotificationMenuvue_type_script_lang_js_,
  NotificationMenuvue_type_template_id_201b78f3_scoped_true_render,
  NotificationMenuvue_type_template_id_201b78f3_scoped_true_staticRenderFns,
  false,
  null,
  "201b78f3",
  null
  
)

/* harmony default export */ var NotificationMenu = (NotificationMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationMain.vue?vue&type=script&lang=js&



/* harmony default export */ var NotificationMainvue_type_script_lang_js_ = ({
  name: "NotificationMain",
  components: {
    NotificationList: NotificationList,
    NotificationMenu: NotificationMenu
  },
  props: {
    isFromNotificationCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filtersOpened: false
    };
  },
  computed: {
    unreadDisplay() {
      return this.unreadCount > 99 ? "99+" : this.unreadCount;
    },
    ...mapGetters("notificationModule", ["unreadCount", "hasMoreNotifications", "isLoading"]),
    ...mapGetters("adminModule", ["isDeprecated"])
  },
  methods: {
    scrollNotifications() {
      return this.getNotifications(10);
    },
    ...mapActions("notificationModule", ["getNotifications", "readNotifications"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationMain.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_NotificationMainvue_type_script_lang_js_ = (NotificationMainvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/NotificationMain.vue?vue&type=style&index=0&id=14f8916a&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationMain.vue?vue&type=style&index=0&id=14f8916a&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/NotificationMain.vue



;


/* normalize component */

var NotificationMain_component = normalizeComponent(
  components_NotificationMainvue_type_script_lang_js_,
  NotificationMainvue_type_template_id_14f8916a_scoped_true_render,
  NotificationMainvue_type_template_id_14f8916a_scoped_true_staticRenderFns,
  false,
  null,
  "14f8916a",
  null
  
)

/* harmony default export */ var NotificationMain = (NotificationMain_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/Notification.vue?vue&type=script&lang=js&


/* harmony default export */ var Notificationvue_type_script_lang_js_ = ({
  name: "NotificationView",
  data() {
    return {
      visible: false
    };
  },
  props: {
    isFromNotificationCenter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NotificationMain: NotificationMain
  },
  mounted() {
    this.getUnreadCount();
    this.getNotifications();
  },
  methods: {
    ...mapActions("notificationModule", ["getNotifications", "getUnreadCount"])
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/Notification.vue?vue&type=script&lang=js&
 /* harmony default export */ var notification_Notificationvue_type_script_lang_js_ = (Notificationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/Notification.vue?vue&type=style&index=0&id=786ec66e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/Notification.vue?vue&type=style&index=0&id=786ec66e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/Notification.vue



;


/* normalize component */

var Notification_component = normalizeComponent(
  notification_Notificationvue_type_script_lang_js_,
  Notificationvue_type_template_id_786ec66e_scoped_true_render,
  Notificationvue_type_template_id_786ec66e_scoped_true_staticRenderFns,
  false,
  null,
  "786ec66e",
  null
  
)

/* harmony default export */ var Notification = (Notification_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/UrgentNotifications.vue?vue&type=template&id=4b06a072&scoped=true&
var UrgentNotificationsvue_type_template_id_4b06a072_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notifications",
    class: {
      expand: _vm.expand
    }
  }, [_c('div', {
    staticClass: "notifications__card"
  }, [_c('div', {
    staticClass: "notifications__circle"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'bell-exclamation']
    }
  }), _vm.count > 0 ? _c('span', {
    staticClass: "unread-count"
  }, [_vm._v(_vm._s(_vm.count))]) : _vm._e()], 1), _c('div', [_vm._v(_vm._s(_vm.$t("notifications.urgents.label")))]), _c('div', {
    staticClass: "notifications__dropdown",
    on: {
      "click": function ($event) {
        return _vm.handleExpand();
      }
    }
  }, [_c('span', {
    staticClass: "action"
  }, [_vm._v(_vm._s(_vm.$t("notifications.urgents.display")))]), _c('font-awesome-icon', {
    staticClass: "chevron-icon",
    attrs: {
      "icon": ['fal', _vm.expand ? 'chevron-up' : 'chevron-down']
    }
  })], 1)]), _c('div', {
    staticClass: "notifications__collapse",
    class: {
      'last-step': !_vm.notLastStep
    }
  }, [_c('div', {
    staticClass: "transition-wrapper"
  }, [_c('UrgentNotificationSlide', {
    staticClass: "transition-slide",
    style: _vm.slideTransition,
    attrs: {
      "not-last-slide": _vm.notLastSlide,
      "title": _vm.notLastSlide ? _vm.notifications[_vm.slideStep].metadata.label : '',
      "message": _vm.notLastSlide ? _vm.notifications[_vm.slideStep].metadata.body : ''
    }
  }), _c('UrgentNotificationSlide', {
    staticClass: "current-slide",
    attrs: {
      "not-last-slide": _vm.notLastStep,
      "slide-nbr": _vm.notLastStep ? _vm.step : -1,
      "title": _vm.notLastStep ? _vm.notifications[_vm.step].metadata.label : '',
      "message": _vm.notLastStep ? _vm.notifications[_vm.step].metadata.body : '',
      "has-linked-entity": !!_vm.notifications[_vm.step] && !!_vm.notifications[_vm.step].metadata.entityId
    },
    on: {
      "reach-content": function ($event) {
        return _vm.$emit('reach-content', _vm.notifications[_vm.step]);
      },
      "reset": function ($event) {
        return _vm.reset();
      },
      "hide": function ($event) {
        return _vm.handleExpand();
      }
    }
  })], 1), _c('div', {
    staticClass: "notifications__collapse-footer"
  }, [_c('div', {
    staticClass: "steps"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.urgents.count")) + " " + _vm._s(_vm.step + 1) + "/" + _vm._s(_vm.count) + " ")]), _vm.count > 1 ? _c('div', {
    staticClass: "nav"
  }, [_c('base-button', {
    staticClass: "action-btn",
    attrs: {
      "type": "danger",
      "size": "sm",
      "disabled": _vm.step === 0
    },
    on: {
      "click": function ($event) {
        return _vm.handlePrev();
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "chevron-icon",
    attrs: {
      "icon": ['fal', 'chevron-left']
    }
  })], 1), _c('base-button', {
    staticClass: "action-btn",
    attrs: {
      "type": "danger",
      "size": "sm",
      "disabled": _vm.step === _vm.count
    },
    on: {
      "click": function ($event) {
        return _vm.handleNext();
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "chevron-icon",
    attrs: {
      "icon": ['fal', 'chevron-right']
    }
  })], 1)], 1) : _vm._e()])])]);
};
var UrgentNotificationsvue_type_template_id_4b06a072_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/UrgentNotificationSlide.vue?vue&type=template&id=f91d3810&scoped=true&
var UrgentNotificationSlidevue_type_template_id_f91d3810_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.notLastSlide ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.hasLinkedEntity ? _c('div', {
    staticClass: "linked-content",
    on: {
      "click": function ($event) {
        return _vm.$emit('reach-content');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.urgents.linked-content")) + " "), _c('font-awesome-icon', {
    staticClass: "redirect-icon",
    attrs: {
      "icon": ['fal', 'external-link']
    }
  })], 1) : _vm._e()]), _c('mayday-editor', {
    key: _vm.slideNbr,
    ref: "editor",
    staticClass: "message",
    attrs: {
      "editable": false
    },
    on: {
      "click:open-link": _vm.handleOpenLink
    },
    model: {
      value: _vm.body,
      callback: function ($$v) {
        _vm.body = $$v;
      },
      expression: "body"
    }
  })], 1) : _c('div', {
    staticClass: "content reset-wrapper"
  }, [_c('font-awesome-icon', {
    staticClass: "check-icon",
    attrs: {
      "icon": ['fal', 'check']
    }
  }), _c('div', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.urgents.slide.all-read")) + " ")]), _c('base-button', {
    staticClass: "reset-btn",
    attrs: {
      "type": "primary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('reset');
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'undo']
    }
  }), _vm._v(_vm._s(_vm.$t("notifications.urgents.slide.reread")) + " ")], 1), _c('div', {
    staticClass: "hide-action",
    on: {
      "click": function ($event) {
        return _vm.$emit('hide');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("notifications.urgents.slide.hide")) + " ")])], 1)]);
};
var UrgentNotificationSlidevue_type_template_id_f91d3810_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/UrgentNotificationSlide.vue?vue&type=script&lang=js&

/* harmony default export */ var UrgentNotificationSlidevue_type_script_lang_js_ = ({
  name: "UrgentNotificationSlide",
  components: {
    BaseButton: BaseButton
  },
  props: {
    slideNbr: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    hasLinkedEntity: {
      type: Boolean,
      default: false
    },
    notLastSlide: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      body: this.message
    };
  },
  methods: {
    handleOpenLink({
      href
    }) {
      window.open(href, "_blank");
    }
  },
  watch: {
    message(val) {
      this.body = val;
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/components/UrgentNotificationSlide.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_UrgentNotificationSlidevue_type_script_lang_js_ = (UrgentNotificationSlidevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/components/UrgentNotificationSlide.vue?vue&type=style&index=0&id=f91d3810&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/components/UrgentNotificationSlide.vue?vue&type=style&index=0&id=f91d3810&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/notification/components/UrgentNotificationSlide.vue



;


/* normalize component */

var UrgentNotificationSlide_component = normalizeComponent(
  components_UrgentNotificationSlidevue_type_script_lang_js_,
  UrgentNotificationSlidevue_type_template_id_f91d3810_scoped_true_render,
  UrgentNotificationSlidevue_type_template_id_f91d3810_scoped_true_staticRenderFns,
  false,
  null,
  "f91d3810",
  null
  
)

/* harmony default export */ var UrgentNotificationSlide = (UrgentNotificationSlide_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/UrgentNotifications.vue?vue&type=script&lang=js&


/* harmony default export */ var UrgentNotificationsvue_type_script_lang_js_ = ({
  name: "UrgentNotifications",
  components: {
    UrgentNotificationSlide: UrgentNotificationSlide,
    BaseButton: BaseButton
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    customWidth: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      expand: false,
      step: 0,
      slideStep: 0,
      slideTransition: `transform: translateX(${this.customWidth - 32}px);`
    };
  },
  computed: {
    count() {
      return this.notifications.length;
    },
    notLastStep() {
      return !!this.notifications[this.step] && this.step < this.count;
    },
    notLastSlide() {
      return !!this.notifications[this.slideStep] && this.slideStep < this.count;
    }
  },
  methods: {
    handleExpand() {
      this.expand = !this.expand;
      if (this.expand) {
        this.step = 0;
        this.slideStep = 0;
      }
    },
    handlePrev() {
      this.slideStep = this.step;
      this.slideTransition = "transform: translateX(0px);";
      setTimeout(() => {
        this.step -= 1;
        this.slideTransition = `transform: translateX(${this.customWidth - 32}px); transition: transform 0.2s ease-in-out;`;
      }, 10);
    },
    handleNext() {
      const nextStep = this.step + 1;
      this.nextStep(nextStep);
    },
    reset() {
      const nextStep = 0;
      this.nextStep(nextStep);
    },
    nextStep(nextStep) {
      this.slideStep = nextStep;
      this.slideTransition = "transform: translateX(0px); transition: transform 0.2s ease-in-out;";
      setTimeout(() => {
        this.step = nextStep;
        this.slideTransition = `transform: translateX(${this.customWidth - 32}px);`;
      }, 210);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/notification/UrgentNotifications.vue?vue&type=script&lang=js&
 /* harmony default export */ var notification_UrgentNotificationsvue_type_script_lang_js_ = (UrgentNotificationsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/UrgentNotifications.vue?vue&type=style&index=0&id=4b06a072&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/UrgentNotifications.vue?vue&type=style&index=0&id=4b06a072&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/notification/UrgentNotifications.vue?vue&type=style&index=1&id=4b06a072&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/notification/UrgentNotifications.vue?vue&type=style&index=1&id=4b06a072&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/notification/UrgentNotifications.vue



;



/* normalize component */

var UrgentNotifications_component = normalizeComponent(
  notification_UrgentNotificationsvue_type_script_lang_js_,
  UrgentNotificationsvue_type_template_id_4b06a072_scoped_true_render,
  UrgentNotificationsvue_type_template_id_4b06a072_scoped_true_staticRenderFns,
  false,
  null,
  "4b06a072",
  null
  
)

/* harmony default export */ var UrgentNotifications = (UrgentNotifications_component.exports);
;// CONCATENATED MODULE: ./src/modules/notification/index.ts





const notificationPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "notificationModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      notificationClient,
      adminClient,
      knowledgeClient
    } = options;
    store.registerModule(STORE_MODULE_NAME, notificationStore, {
      preserveState: !!store.state[STORE_MODULE_NAME]
    });
    if (adminClient && knowledgeClient && notificationClient) {
      store.$services = {
        ...store.$services,
        notifications: attachNotificationService(notificationClient, adminClient, knowledgeClient)
      };
    }
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) options.i18n.mergeLocaleMessage(locale, locales(key));
        }
      });
    }
    Vue.component("notification-view", Notification);
    Vue.component("urgent-notifications", UrgentNotifications);
  }
};
const NotificationModule = {
  plugin: notificationPlugin,
  store: notificationStore,
  storePlugin: notificationStorePlugin,
  attachService: attachNotificationService
};
;// CONCATENATED MODULE: ./src/modules/log/store/actions.ts
const eventProcessing = data => {
  let path = data.path;
  let enrichedPath;
  // entity = 'Case'
  if (!data.type && data.path) {
    enrichedPath = data.path; // Keep list of objects
    path = data.path.filter(Boolean).map(({
      id
    }) => id);
  }
  return {
    id: data.id,
    knowledgeId: data.knowledgeId,
    type: data.type,
    caseParameters: data.caseParameters,
    parameters: data.parameters,
    labels: data.labels ? data.labels.map(l => l.id) : [],
    path,
    enrichedPath
  };
};
/* harmony default export */ var log_store_actions = ({
  async init(_, accessToken) {
    this.$logService.initWithAccessToken(accessToken);
  },
  async logEvent(_, {
    topic,
    event,
    url
  }) {
    if (event.content) {
      event.content = eventProcessing(event.content);
    }
    return this.$logService.logEvent({
      topic,
      event,
      url
    });
  }
});
;// CONCATENATED MODULE: ./src/modules/log/store/state.ts
const state = () => ({});
;// CONCATENATED MODULE: ./src/modules/log/store/index.ts


const logStore = {
  namespaced: true,
  state: state,
  actions: log_store_actions
};
;// CONCATENATED MODULE: ./src/modules/log/service/index.ts

class LogService {
  constructor(logClient) {
    _defineProperty(this, "logClient", void 0);
    this.logClient = logClient;
  }
  initWithAccessToken(accessToken) {
    this.logClient.setAccessToken(accessToken || "");
  }
  logEvent(payload) {
    this.logClient.send(payload);
  }
}
const attachLogService = logClient => {
  return new LogService(logClient);
};
;// CONCATENATED MODULE: ./src/modules/log/index.ts


const logPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "logModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      logClient
    } = options;
    if (!store.hasModule(STORE_MODULE_NAME)) {
      store.registerModule(STORE_MODULE_NAME, logStore, {
        preserveState: false
      });
    }
    if (logClient) {
      store.$logService = attachLogService(logClient);
    }
  }
};
const LogModule = {
  plugin: logPlugin,
  store: logStore,
  attachService: attachLogService
};
;// CONCATENATED MODULE: ./src/modules/userFavorites/store/mutation-types.ts
const userFavorites_store_mutation_types_LOGOUT = "LOGOUT";
// Favorites Mutations
const UPDATE_USER_TABS = "UPDATE_USER_TABS";
const UPDATE_CURRENT_TAB = "UPDATE_CURRENT_TAB";
const UPDATE_SEARCH_RESULTS = "UPDATE_SEARCH_RESULTS";
const UPDATE_FAVORITES = "UPDATE_FAVORITES";
const REMOVE_FAVORITE = "REMOVE_FAVORITE";
const LOADING_FAVORITES = "LOADING_FAVORITES";
const LOADING_USER_TABS = "LOADING_USER_TABS";
const LOADING_CURRENT_TAB = "LOADING_CURRENT_TAB";
const LOADING_SEARCH = "LOADING_SEARCH";
;// CONCATENATED MODULE: ./src/modules/userFavorites/store/actions.ts


/* harmony default export */ var userFavorites_store_actions = ({
  logout({
    commit
  }) {
    commit(userFavorites_store_mutation_types_LOGOUT);
  },
  async updateUserFavoritesOrder(_, favorites) {
    await this.$userDirectoryService.updateUserFavoritesOrder(favorites);
  },
  async fetchUserFavorites({
    commit,
    dispatch
  }) {
    const {
      enrichedChildren
    } = await this.$userDirectoryService.getUserFavorites();
    const filteredChildren = await dispatch("filterEmptyEnrichedChildren", enrichedChildren);
    commit(UPDATE_FAVORITES, filteredChildren);
  },
  async fetchUserTabs({
    commit
  }) {
    commit(LOADING_USER_TABS, true);
    const {
      userTabs
    } = await this.$userDirectoryService.getUserTabs();
    commit(UPDATE_USER_TABS, userTabs.tabs);
    commit(LOADING_USER_TABS, false);
  },
  async fetchCurrentTab({
    commit,
    dispatch
  }, id) {
    commit(LOADING_CURRENT_TAB, true);
    const {
      tab
    } = await this.$userDirectoryService.getCurrentTab(id);
    const filteredChildren = await dispatch("filterEmptyEnrichedChildren", tab.enrichedChildren);
    commit(UPDATE_CURRENT_TAB, filteredChildren);
    commit(LOADING_CURRENT_TAB, false);
  },
  async addUserFavorite({
    commit,
    dispatch,
    getters
  }, contentId) {
    const {
      currentTab
    } = getters;
    commit(LOADING_CURRENT_TAB, true);
    const {
      enrichedChildren
    } = await this.$userDirectoryService.addUserFavorite(contentId);
    const filteredChildren = await dispatch("filterEmptyEnrichedChildren", enrichedChildren);
    commit(UPDATE_FAVORITES, filteredChildren);
    if (currentTab[0] && currentTab[0].type === "UserFavoriteEntity") commit(UPDATE_CURRENT_TAB, filteredChildren);
    commit(LOADING_CURRENT_TAB, false);
  },
  async removeUserFavorite({
    commit,
    dispatch,
    getters
  }, favoriteId) {
    const {
      currentTab
    } = getters;
    commit(LOADING_CURRENT_TAB, true);
    const {
      enrichedChildren
    } = await this.$userDirectoryService.removeUserFavorite(favoriteId);
    const filteredChildren = await dispatch("filterEmptyEnrichedChildren", enrichedChildren);
    if (currentTab[0] && currentTab[0].type === "UserFavoriteEntity") commit(UPDATE_CURRENT_TAB, filteredChildren);
    commit(REMOVE_FAVORITE, favoriteId);
    commit(LOADING_CURRENT_TAB, false);
  },
  async removeFavoriteContent({
    getters,
    dispatch
  }, contentId) {
    const {
      favorites
    } = getters;
    const favoriteToRemove = favorites.find(f => {
      return f.entity.id === contentId;
    });
    if (favoriteToRemove) dispatch("removeUserFavorite", favoriteToRemove.id);
  },
  async searchFavorites({
    commit
  }, payload) {
    commit(LOADING_SEARCH, true);
    const favorites = await this.$userDirectoryService.search(payload);
    commit(UPDATE_SEARCH_RESULTS, favorites);
    commit(LOADING_SEARCH, false);
  },
  async closeSearch({
    commit
  }) {
    commit(LOADING_SEARCH, false);
    commit(UPDATE_SEARCH_RESULTS, []);
  },
  filterEmptyEnrichedChildren(_, enrichedChildren) {
    return enrichedChildren.reduce((acc, val) => {
      if (val.entity) acc.push(val);
      return acc;
    }, []);
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/store/getters.ts
const userFavorites_store_getters_getters = {
  favorites: state => state.userFavorites,
  favoriteIds: state => state.userFavorites.map(f => f.entity ? f.entity.id : null).filter(Boolean),
  userTabs: state => state.userTabs,
  currentTab: state => state.currentTab,
  searchResults: state => state.searchResults,
  itemIsFavorite: (_, getters) => itemId => getters.favorites.length ? getters.favorites.find(f => f.entity.id === itemId) : null,
  loadingFavorites: state => state.loadingFavorites,
  loadingUserTabs: state => state.loadingUserTabs,
  loadingCurrentTab: state => state.loadingCurrentTab,
  loadingSearch: state => state.loadingSearch
};
/* harmony default export */ var userFavorites_store_getters = (userFavorites_store_getters_getters);
;// CONCATENATED MODULE: ./src/modules/userFavorites/store/state.ts
const userFavorites_store_state_state = () => ({
  userFavorites: [],
  userTabs: [],
  currentTab: [],
  loadingUserTabs: false,
  loadingCurrentTab: false,
  loadingFavorites: false,
  searchResults: [],
  loadingSearch: false
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/store/mutations.ts


/* harmony default export */ var userFavorites_store_mutations = ({
  [userFavorites_store_mutation_types_LOGOUT](state) {
    Object.assign(state, userFavorites_store_state_state());
  },
  [UPDATE_USER_TABS](state, tabs) {
    state.userTabs = tabs;
  },
  [UPDATE_CURRENT_TAB](state, tab) {
    state.currentTab = tab;
  },
  [UPDATE_SEARCH_RESULTS](state, results) {
    state.searchResults = results;
  },
  [UPDATE_FAVORITES](state, favorites) {
    state.userFavorites = favorites;
  },
  [REMOVE_FAVORITE](state, favoriteId) {
    const favorites = [...state.userFavorites];
    const fIdx = favorites.findIndex(f => f.id === favoriteId);
    if (fIdx === -1) return;
    favorites.splice(fIdx, 1);
    state.userFavorites = favorites;
  },
  [LOADING_FAVORITES](state, isLoading) {
    state.loadingFavorites = isLoading;
  },
  [LOADING_USER_TABS](state, isLoading) {
    state.loadingUserTabs = isLoading;
  },
  [LOADING_CURRENT_TAB](state, isLoading) {
    state.loadingCurrentTab = isLoading;
  },
  [LOADING_SEARCH](state, isLoading) {
    state.loadingSearch = isLoading;
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/store/index.ts




const userFavoritesStore = {
  namespaced: true,
  state: userFavorites_store_state_state,
  getters: userFavorites_store_getters,
  actions: userFavorites_store_actions,
  mutations: userFavorites_store_mutations
};
;// CONCATENATED MODULE: ./src/modules/userFavorites/service/index.ts

class UserDirectoryService {
  constructor(apiClient) {
    _defineProperty(this, "apiClient", void 0);
    this.apiClient = apiClient;
  }
  async getUserTabs() {
    const res = await this.apiClient.get("user-tabs");
    return res.data || res;
  }
  async getCurrentTab(id) {
    const res = await this.apiClient.get(`tab/${id}`);
    return res.data || res;
  }
  async getUserFavorites() {
    const res = await this.apiClient.get("user-favorites-tab");
    return res.data || res;
  }
  async addUserFavorite(entityId) {
    const res = await this.apiClient.post("user-favorites", {
      entityId
    });
    return res.data || res;
  }
  async removeUserFavorite(entityId) {
    const res = await this.apiClient.delete(`user-favorites/${entityId}`);
    return res.data || res;
  }
  async updateUserFavoritesOrder(favorites) {
    const res = await this.apiClient.patch("user-favorites-tab", {
      favorites
    });
    return res.data || res;
  }
  async search({
    lang,
    query,
    filters
  }) {
    const res = await this.apiClient.post(`favorites/search?q=${query}&lang=${lang}`, {
      filters
    });
    return res.data || res;
  }
}
const attachUserDirectoryService = userDirectoryClient => {
  return new UserDirectoryService(userDirectoryClient);
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/UserFavorites.vue?vue&type=template&id=27889074&
var UserFavoritesvue_type_template_id_27889074_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Bar', {
    attrs: {
      "user-tabs": _vm.userTabs,
      "current-tab-id": _vm.currentTabId,
      "loading-user-tabs": _vm.loadingUserTabs
    },
    on: {
      "search": _vm.debounceSearch,
      "update-current-tab": _vm.handleUpdateCurrentTab,
      "close-search": _vm.handleCloseSearch
    }
  }), _c('List', {
    attrs: {
      "favorites": _vm.favoritesToDisplay,
      "loading": _vm.listLoading,
      "show-edition": _vm.currentTabIsEditable,
      "search-in-progress": _vm.searchInProgress,
      "current-tab-type": _vm.currentTabType
    },
    on: {
      "delete-favorite": _vm.handleRemoveUserFavorite,
      "update-order": _vm.updateUserFavoritesOrder,
      "select-item": function ($event) {
        return _vm.$emit('select-item', $event);
      }
    }
  })], 1);
};
var UserFavoritesvue_type_template_id_27889074_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesBar.vue?vue&type=template&id=239ae19b&scoped=true&
var FavoritesBarvue_type_template_id_239ae19b_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-favorites-bar",
    class: {
      'md-search-active': _vm.searchActive
    }
  }, [_c('div', {
    staticClass: "md-translate-container"
  }, [_c('FavoritesTabs', {
    attrs: {
      "tabs": _vm.userTabs,
      "activeTab": _vm.currentTabId
    },
    on: {
      "update-active-tab": function ($event) {
        return _vm.$emit('update-current-tab', $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "md-search-bar"
  }, [_c('div', {
    staticClass: "md-search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchInput,
      expression: "searchInput"
    }],
    ref: "fav-input",
    staticClass: "md-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.searchInput
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "escape", undefined, $event.key, undefined)) return null;
        return _vm.closeSearch.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.searchInput = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "md-search-button",
    on: {
      "click": _vm.focusSearch
    }
  }, [_c('font-awesome-icon', {
    staticClass: "md-search-icon",
    attrs: {
      "icon": ['fal', 'search']
    }
  }), _c('div', {
    staticClass: "md-close-container"
  }, [_c('font-awesome-icon', {
    staticClass: "md-close-icon",
    attrs: {
      "icon": ['fal', 'times']
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.closeSearch.apply(null, arguments);
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "md-grow-space"
  })])]);
};
var FavoritesBarvue_type_template_id_239ae19b_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesTabs.vue?vue&type=template&id=2c4e716d&scoped=true&
var FavoritesTabsvue_type_template_id_2c4e716d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-tabs"
  }, [_c('div', {
    staticClass: "md-tabs-header"
  }, _vm._l(_vm.enrichedTabs, function (tab) {
    return _c('div', {
      key: tab.id,
      staticClass: "md-tab",
      class: {
        'md-active': tab.id === _vm.activeTab
      },
      on: {
        "click": function ($event) {
          return _vm.setActiveTab(tab.id);
        }
      }
    }, [_c('div', {
      staticClass: "md-tab-icon"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": tab.icon
      }
    })], 1)]);
  }), 0), _vm.enrichedActiveTab ? _c('div', {
    staticClass: "md-tabs-content"
  }, [_vm._t(_vm.enrichedActiveTab.label)], 2) : _vm._e()]);
};
var FavoritesTabsvue_type_template_id_2c4e716d_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesTabs.vue?vue&type=script&lang=js&
const iconTypeMapping = {
  UserFavoritesTab: ["fal", "star"],
  CompanyFavoritesTab: ["fal", "thumbtack"]
};
/* harmony default export */ var FavoritesTabsvue_type_script_lang_js_ = ({
  name: "FavoritesTabs",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      default: ""
    }
  },
  computed: {
    enrichedActiveTab() {
      return this.tabs.find(tab => tab.id === this.activeTab);
    },
    enrichedTabs() {
      const enriched = this.tabs.map(tab => {
        return {
          ...tab,
          icon: iconTypeMapping[tab.type]
        };
      });
      return enriched;
    }
  },
  methods: {
    setActiveTab(id) {
      this.$emit("update-active-tab", id);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesTabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FavoritesTabsvue_type_script_lang_js_ = (FavoritesTabsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesTabs.vue?vue&type=style&index=0&id=2c4e716d&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesTabs.vue?vue&type=style&index=0&id=2c4e716d&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesTabs.vue



;


/* normalize component */

var FavoritesTabs_component = normalizeComponent(
  components_FavoritesTabsvue_type_script_lang_js_,
  FavoritesTabsvue_type_template_id_2c4e716d_scoped_true_render,
  FavoritesTabsvue_type_template_id_2c4e716d_scoped_true_staticRenderFns,
  false,
  null,
  "2c4e716d",
  null
  
)

/* harmony default export */ var FavoritesTabs = (FavoritesTabs_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesBar.vue?vue&type=script&lang=js&

/* harmony default export */ var FavoritesBarvue_type_script_lang_js_ = ({
  name: "FavoritesBar",
  components: {
    FavoritesTabs: FavoritesTabs
  },
  props: {
    userTabs: {
      type: Array,
      default: () => []
    },
    loadingUserTabs: {
      type: Boolean,
      default: false
    },
    currentTabId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      searchActive: false,
      searchInput: ""
    };
  },
  watch: {
    searchInput(val) {
      this.$emit("search", val);
    }
  },
  methods: {
    focusSearch() {
      this.searchActive = true;
      this.$refs["fav-input"].focus();
    },
    closeSearch() {
      this.searchActive = false;
      this.searchInput = "";
      this.$emit("close-search");
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FavoritesBarvue_type_script_lang_js_ = (FavoritesBarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesBar.vue?vue&type=style&index=0&id=239ae19b&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesBar.vue?vue&type=style&index=0&id=239ae19b&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesBar.vue



;


/* normalize component */

var FavoritesBar_component = normalizeComponent(
  components_FavoritesBarvue_type_script_lang_js_,
  FavoritesBarvue_type_template_id_239ae19b_scoped_true_render,
  FavoritesBarvue_type_template_id_239ae19b_scoped_true_staticRenderFns,
  false,
  null,
  "239ae19b",
  null
  
)

/* harmony default export */ var FavoritesBar = (FavoritesBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesList.vue?vue&type=template&id=15014a40&scoped=true&
var FavoritesListvue_type_template_id_15014a40_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-list-section"
  }, [_vm.showEdition ? _c('div', {
    staticClass: "md-filter"
  }, [_c('div', {
    staticClass: "md-edition",
    class: {
      editable: _vm.editable,
      invisible: _vm.hideEdition
    },
    on: {
      "click": function ($event) {
        _vm.editable = !_vm.editable;
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "md-edition__icon",
    attrs: {
      "icon": ['fal', `${_vm.editable ? 'times' : 'pen'}`]
    }
  }), _vm._v(" " + _vm._s(_vm.editable ? _vm.$t("favorites.cancel") : _vm.$t("favorites.modify")) + " ")], 1)]) : _vm._e(), _c('div', {
    staticClass: "md-favorites-list"
  }, [_vm.userFavorites.length || _vm.loading ? _c('div', {
    staticClass: "md-loading-container"
  }, [_vm.loading ? _c('LoaderSpinner') : _vm._e(), _c('draggable', {
    staticClass: "md-favorites-draggable",
    class: {
      'min-height-no-item': !_vm.userFavorites.length
    },
    attrs: {
      "animation": 200,
      "disabled": _vm.draggableDisabled,
      "draggable": ".md-item"
    },
    on: {
      "end": _vm.handleDraggable
    },
    model: {
      value: _vm.userFavorites,
      callback: function ($$v) {
        _vm.userFavorites = $$v;
      },
      expression: "userFavorites"
    }
  }, _vm._l(_vm.userFavorites, function (favorite) {
    return _c('Item', {
      key: favorite.id,
      staticClass: "md-item",
      attrs: {
        "editable": _vm.editable,
        "item": favorite.entity,
        "not-draggable": _vm.draggableDisabled
      },
      on: {
        "delete-item": function ($event) {
          return _vm.$emit('delete-favorite', favorite.id);
        }
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('select-item', favorite.entity);
        }
      }
    });
  }), 1)], 1) : _c('div', {
    staticClass: "md-empty-state"
  }, [_c('img', {
    staticClass: "md-empty-state-illustration",
    attrs: {
      "alt": "",
      "src": __webpack_require__(8510)
    }
  }), _vm.searchInProgress ? _c('div', [_c('div', {
    staticClass: "md-empty-state-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("favorites.search-empty-state.title")) + " ")]), _c('div', {
    staticClass: "md-empty-state-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("favorites.search-empty-state.subtitle")) + " ")])]) : _c('div', [_c('div', {
    staticClass: "md-empty-state-title"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.emptyState.title)) + " ")]), _c('div', {
    staticClass: "md-empty-state-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.emptyState.subtitle)) + " ")])])])])]);
};
var FavoritesListvue_type_template_id_15014a40_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesList.vue?vue&type=template&id=15014a40&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesItem.vue?vue&type=template&id=57d2f45f&scoped=true&
var FavoritesItemvue_type_template_id_57d2f45f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-favorites-item",
    class: _vm.itemType
  }, [_c('div', {
    staticClass: "md-favorites-item__body",
    class: {
      editable: _vm.editable
    }
  }, [_c('div', {
    staticClass: "md-left-icon"
  }, [_c('img', {
    staticClass: "md-type-icon",
    attrs: {
      "src": _vm.icon,
      "alt": "not_found"
    }
  }), _c('div', {
    staticClass: "md-delete-button",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$emit('delete-item');
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "md-trash-icon",
    attrs: {
      "icon": ['fal', 'trash']
    }
  })], 1)]), _c('TextEllipsis', {
    staticClass: "md-text-ellipsis",
    attrs: {
      "text": _vm.item.label,
      "fontSize": "14px"
    }
  }), !_vm.notDraggable ? _c('font-awesome-icon', {
    staticClass: "md-drag-icon",
    attrs: {
      "icon": ['fal', 'bars']
    }
  }) : _vm._e()], 1)]);
};
var FavoritesItemvue_type_template_id_57d2f45f_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesItem.vue?vue&type=script&lang=js&



/* harmony default export */ var FavoritesItemvue_type_script_lang_js_ = ({
  name: "FavoritesItem",
  components: {
    TextEllipsis: TextEllipsisWithScroll
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    notDraggable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      switch (this.itemType) {
        case "article":
          return (article_icon_v2_default());
        default:
          return (diag_icon_default());
      }
    },
    itemType() {
      switch (this.item.type) {
        case "Article":
          return "article";
        default:
          return "diag";
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FavoritesItemvue_type_script_lang_js_ = (FavoritesItemvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesItem.vue?vue&type=style&index=0&id=57d2f45f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesItem.vue?vue&type=style&index=0&id=57d2f45f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesItem.vue



;


/* normalize component */

var FavoritesItem_component = normalizeComponent(
  components_FavoritesItemvue_type_script_lang_js_,
  FavoritesItemvue_type_template_id_57d2f45f_scoped_true_render,
  FavoritesItemvue_type_template_id_57d2f45f_scoped_true_staticRenderFns,
  false,
  null,
  "57d2f45f",
  null
  
)

/* harmony default export */ var FavoritesItem = (FavoritesItem_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/LoaderSpinner.vue?vue&type=template&id=5af909ce&scoped=true&
var LoaderSpinnervue_type_template_id_5af909ce_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loader-spinner"
  }, [_c('font-awesome-icon', {
    staticClass: "icon-spinner",
    attrs: {
      "icon": ['fas', 'spinner-third'],
      "spin": ""
    }
  })], 1);
};
var LoaderSpinnervue_type_template_id_5af909ce_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/LoaderSpinner.vue?vue&type=script&lang=js&
/* harmony default export */ var LoaderSpinnervue_type_script_lang_js_ = ({
  name: "LoaderSpinner"
});
;// CONCATENATED MODULE: ./src/library/LoaderSpinner.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_LoaderSpinnervue_type_script_lang_js_ = (LoaderSpinnervue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/LoaderSpinner.vue?vue&type=style&index=0&id=5af909ce&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/LoaderSpinner.vue?vue&type=style&index=0&id=5af909ce&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/library/LoaderSpinner.vue



;


/* normalize component */

var LoaderSpinner_component = normalizeComponent(
  library_LoaderSpinnervue_type_script_lang_js_,
  LoaderSpinnervue_type_template_id_5af909ce_scoped_true_render,
  LoaderSpinnervue_type_template_id_5af909ce_scoped_true_staticRenderFns,
  false,
  null,
  "5af909ce",
  null
  
)

/* harmony default export */ var LoaderSpinner = (LoaderSpinner_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesList.vue?vue&type=script&lang=js&


/* harmony default export */ var FavoritesListvue_type_script_lang_js_ = ({
  name: "FavoritesItem",
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    searchInProgress: {
      type: Boolean,
      default: false
    },
    showEdition: {
      type: Boolean,
      default: true
    },
    currentTabType: {
      type: String,
      default: "UserFavoritesTab"
    }
  },
  data() {
    return {
      editable: false,
      userFavorites: []
    };
  },
  computed: {
    hideEdition() {
      return !this.userFavorites.length;
    },
    draggableDisabled() {
      return !this.editable || this.searchInProgress;
    },
    emptyState() {
      switch (this.currentTabType) {
        case "UserFavoritesTab":
          return {
            title: "favorites.empty-state.user-favorites.title",
            subtitle: "favorites.empty-state.user-favorites.subtitle"
          };
        case "CompanyFavoritesTab":
          return {
            title: "favorites.empty-state.company-favorites.title",
            subtitle: "favorites.empty-state.company-favorites.subtitle"
          };
        default:
          return {
            title: "favorites.empty-state.user-favorites.title",
            subtitle: "favorites.empty-state.user-favorites.subtitle"
          };
      }
    }
  },
  watch: {
    favorites(val) {
      this.userFavorites = val;
    },
    showEdition(val) {
      if (!val) this.editable = false;
    }
  },
  components: {
    Item: FavoritesItem,
    LoaderSpinner: LoaderSpinner
  },
  methods: {
    handleDraggable() {
      const orderedFavoritesIds = this.userFavorites.map(f => f.id);
      this.$emit("update-order", orderedFavoritesIds);
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesList.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FavoritesListvue_type_script_lang_js_ = (FavoritesListvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesList.vue?vue&type=style&index=0&id=15014a40&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesList.vue?vue&type=style&index=0&id=15014a40&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesList.vue



;


/* normalize component */

var FavoritesList_component = normalizeComponent(
  components_FavoritesListvue_type_script_lang_js_,
  FavoritesListvue_type_template_id_15014a40_scoped_true_render,
  FavoritesListvue_type_template_id_15014a40_scoped_true_staticRenderFns,
  false,
  null,
  "15014a40",
  null
  
)

/* harmony default export */ var FavoritesList = (FavoritesList_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/UserFavorites.vue?vue&type=script&lang=js&
const typeMappingFilters = {
  UserFavoritesTab: {
    type: "UserFavoriteEntity",
    isUserDependant: true
  },
  CompanyFavoritesTab: {
    type: "CompanyFavoriteEntity",
    isUserDependant: false
  }
};




/* harmony default export */ var UserFavoritesvue_type_script_lang_js_ = ({
  name: "UserFavorites",
  components: {
    Bar: FavoritesBar,
    List: FavoritesList
  },
  props: {
    language: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentTabId: "",
      currentTabType: "",
      query: "",
      searchInProgress: false,
      debounceSearch: lodash_debounce_default()(query => {
        this.handleSearch(query);
      }, 200)
    };
  },
  computed: {
    favoritesToDisplay() {
      if (this.query && (!this.searchResults || !this.searchResults.length)) return [];
      return this.searchResults && this.searchResults.length ? this.searchResults : this.currentTab;
    },
    listLoading() {
      return !this.loadingUserTabs && this.loadingCurrentTab || this.loadingSearch;
    },
    currentTabIsEditable() {
      if (!this.currentTabType) return true;
      return typeMappingFilters[this.currentTabType].isUserDependant;
    },
    ...mapGetters("userFavoritesModule", ["userTabs", "currentTab", "searchResults", "loading", "loadingUserTabs", "loadingCurrentTab", "loadingSearch"])
  },
  async mounted() {
    await this.fetchUserTabs();
    await this.handleUpdateCurrentTab(this.userTabs[0].id);
  },
  methods: {
    handleSearch(query) {
      this.query = query;
      this.searchInProgress = true;
      if (!query) return;
      this.searchFavorites({
        lang: this.language,
        query,
        filters: {
          ...typeMappingFilters[this.currentTabType],
          ancestorId: this.currentTabId
        }
      });
    },
    handleCloseSearch() {
      this.searchInProgress = false;
      this.closeSearch();
    },
    async handleUpdateCurrentTab(e) {
      this.currentTabId = e;
      this.currentTabType = this.userTabs.find(tab => tab.id === e).type;
      await this.fetchCurrentTab(e);
    },
    async handleRemoveUserFavorite(e) {
      return this.removeUserFavorite(e);
    },
    ...mapActions("userFavoritesModule", ["fetchUserTabs", "fetchCurrentTab", "removeUserFavorite", "updateUserFavoritesOrder", "searchFavorites", "closeSearch"])
  },
  watch: {
    query: {
      handler(newValue) {
        if (newValue === "") this.closeSearch();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/UserFavorites.vue?vue&type=script&lang=js&
 /* harmony default export */ var userFavorites_UserFavoritesvue_type_script_lang_js_ = (UserFavoritesvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/userFavorites/UserFavorites.vue





/* normalize component */
;
var UserFavorites_component = normalizeComponent(
  userFavorites_UserFavoritesvue_type_script_lang_js_,
  UserFavoritesvue_type_template_id_27889074_render,
  UserFavoritesvue_type_template_id_27889074_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UserFavorites = (UserFavorites_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesBadge.vue?vue&type=template&id=524616a0&scoped=true&
var FavoritesBadgevue_type_template_id_524616a0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['md-favorites__popover-trigger', _vm.active ? 'active' : '']
  }, [_c('div', {
    staticClass: "md-favorites__popover-star"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fas', 'star']
    }
  })], 1)]);
};
var FavoritesBadgevue_type_template_id_524616a0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesBadge.vue?vue&type=script&lang=js&
/* harmony default export */ var FavoritesBadgevue_type_script_lang_js_ = ({
  name: "FavoritesBadge",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesBadge.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FavoritesBadgevue_type_script_lang_js_ = (FavoritesBadgevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-68.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-68.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-68.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-68.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/userFavorites/components/FavoritesBadge.vue?vue&type=style&index=0&id=524616a0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesBadge.vue?vue&type=style&index=0&id=524616a0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/userFavorites/components/FavoritesBadge.vue



;


/* normalize component */

var FavoritesBadge_component = normalizeComponent(
  components_FavoritesBadgevue_type_script_lang_js_,
  FavoritesBadgevue_type_template_id_524616a0_scoped_true_render,
  FavoritesBadgevue_type_template_id_524616a0_scoped_true_staticRenderFns,
  false,
  null,
  "524616a0",
  null
  
)

/* harmony default export */ var FavoritesBadge = (FavoritesBadge_component.exports);
;// CONCATENATED MODULE: ./src/modules/userFavorites/index.ts




const userFavoritesPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "userFavoritesModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      knowledgeClient
    } = options;
    store.registerModule(STORE_MODULE_NAME, userFavoritesStore, {
      preserveState: !!store.state[STORE_MODULE_NAME]
    });
    if (knowledgeClient) {
      store.$userDirectoryService = attachUserDirectoryService(knowledgeClient);
    }
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) options.i18n.mergeLocaleMessage(locale, locales(key));
        }
      });
    }
    Vue.component("user-favorites", UserFavorites);
    Vue.component("favorites-badge", FavoritesBadge);
  }
};
const UserFavoritesModule = {
  plugin: userFavoritesPlugin,
  store: userFavoritesStore
};
;// CONCATENATED MODULE: ./src/modules/feedback/service/index.ts

class FeedbackService {
  constructor(apiClient, knowledgeClient) {
    _defineProperty(this, "apiClient", void 0);
    _defineProperty(this, "knowledgeClient", void 0);
    this.apiClient = apiClient;
    this.knowledgeClient = knowledgeClient;
  }
  async getFeedbacks(page) {
    const res = await this.apiClient.get(`feedbacks?page=${page}`);
    return res.data || res;
  }
  async getFeedback(feedbackId) {
    const res = await this.apiClient.get(`feedback/${feedbackId}`);
    return res.data || res;
  }
  async getUnreadCommentCount() {
    const res = await this.apiClient.get(`feedback/comment/unread-count`);
    return res.data || res;
  }
  async postFeedback(feedback) {
    const res = await this.apiClient.post("feedback", feedback);
    return res.data || res;
  }
  async feedbackComment(feedbackId, comment, attachments) {
    const res = await this.apiClient.post(`feedback/${feedbackId}/comment`, {
      comment,
      attachments
    });
    return res.data || res;
  }
  async readFeedbackComments(feedbackId) {
    const res = await this.apiClient.post(`feedback/read/${feedbackId}`);
    return res.data || res;
  }
  async uploadFiles(files) {
    const formData = new FormData();
    files.forEach(file => formData.append("files", file));
    const res = await this.knowledgeClient.request({
      url: `../contents/attach-files`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    });
    return res.data || res;
  }
}
const attachFeedbackService = (feedbackClient, knowledgeClient) => {
  return new FeedbackService(feedbackClient, knowledgeClient);
};
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/Feedback.vue?vue&type=template&id=50ece7c0&
var Feedbackvue_type_template_id_50ece7c0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('BaseTabs', {
    attrs: {
      "active-tab": _vm.activeTab,
      "tabs": _vm.getTabs
    },
    on: {
      "update-tab": _vm.handleSelectTab
    },
    scopedSlots: _vm._u([{
      key: "new",
      fn: function () {
        return [_c('NewFeedback', _vm._b({
          on: {
            "cancel": _vm.handleCancel,
            "send-feedback": _vm.sendFeedback,
            "refresh-roles": _vm.handleRefreshRoles
          }
        }, 'NewFeedback', _vm.$props, false))];
      },
      proxy: true
    }, {
      key: "history",
      fn: function () {
        return [_c('HistoryFeedback', {
          on: {
            "select-item": _vm.handeSelectItem,
            "new-feedback": function ($event) {
              return _vm.handleSelectTab(0);
            }
          }
        })];
      },
      proxy: true
    }])
  });
};
var Feedbackvue_type_template_id_50ece7c0_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/HistoryFeedback.vue?vue&type=template&id=4e79db93&scoped=true&
var HistoryFeedbackvue_type_template_id_4e79db93_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "feedback-history"
  }, [_vm.loading ? _c('LoaderSpinner') : _vm._e(), _vm._l(_vm.feedbacks, function (feedback) {
    return _c('FeedbackCollapse', {
      key: feedback._id,
      attrs: {
        "feedback": feedback
      },
      on: {
        "select-item": _vm.handleSelectItem,
        "read-comments": _vm.handleReadComments
      }
    });
  }), _vm.page < _vm.pages && !!_vm.feedbacks.length ? _c('base-button', {
    attrs: {
      "outline": "",
      "size": "sm",
      "type": "submit"
    },
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(_vm.$t("ask.show-more")) + " ")]) : _vm._e(), !_vm.feedbacks.length ? _c('div', {
    staticClass: "empty-state"
  }, [_c('img', {
    attrs: {
      "alt": "no-feedback",
      "src": __webpack_require__(7374)
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t("ask.empty")))]), _c('base-button', {
    staticClass: "mr-0 bg-blue",
    attrs: {
      "outline": "",
      "size": "sm",
      "text-color": "white",
      "type": "submit"
    },
    on: {
      "click": _vm.handleNewFeedback
    }
  }, [_vm._v(_vm._s(_vm.$t("ask.new-feedback")) + " ")])], 1) : _vm._e()], 2);
};
var HistoryFeedbackvue_type_template_id_4e79db93_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/modules/feedback/components/HistoryFeedback.vue?vue&type=template&id=4e79db93&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/FeedbackCollapse.vue?vue&type=template&id=a493ef0a&scoped=true&
var FeedbackCollapsevue_type_template_id_a493ef0a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['feedback-collapse', {
      opened: _vm.cardOpened
    }]
  }, [_c('div', {
    class: ['feedback-card', {
      opened: _vm.cardOpened
    }],
    on: {
      "click": function ($event) {
        return _vm.focusFeedback();
      }
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "feedback-card__loading"
  }, [_c('LoaderLine', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1) : _vm._e(), _c('div', [_c('div', {
    staticClass: "relative"
  }, [_c('font-awesome-icon', {
    class: ['feedback-card__icon', {
      opened: _vm.cardOpened
    }],
    attrs: {
      "icon": ['fal', 'megaphone']
    }
  }), _vm.hasUnreadComment > 0 ? _c('span', {
    class: ['feedback-card__unread-count', {
      opened: _vm.cardOpened
    }]
  }, [_vm._v(" ! ")]) : _vm._e()], 1), _c('div', {
    staticClass: "feedback-card__content"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.$t("ask.sent-at"))), _c('span', [_vm._v(_vm._s(_vm.createdAt))]), _vm.feedback.entityId ? _c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'link']
    }
  }) : _vm._e()], 1), _c('div', [_vm._v(" " + _vm._s(_vm.$t("ask.sent-to"))), _c('span', [_vm._v(_vm._s(_vm.feedback.assignee.username || _vm.feedback.assignee.name))])])])]), _c('div', [_c('div', {
    class: ['feedback-card__status', _vm.feedback.status.value, {
      opened: _vm.cardOpened
    }]
  }, [_vm._v(" " + _vm._s(this.$t(`ask.status.${_vm.feedback.status.value}`)) + " ")]), _c('font-awesome-icon', {
    class: ['feedback-card__arrow ', {
      opened: _vm.cardOpened
    }],
    attrs: {
      "icon": ['fal', 'chevron-down']
    }
  })], 1)]), _c('div', {
    staticClass: "feedback-collapse__content z-10",
    style: `${_vm.calculateMaxHeight}`
  }, [_vm.entity.id ? _c('div', {
    staticClass: "feedback-collapse__content__header"
  }, [_vm.entity.label ? _c('div', {
    staticClass: "feedback-collapse__entity"
  }, [_vm._v(" " + _vm._s(_vm.$t("ask.content")) + " "), _c('div', {
    on: {
      "click": _vm.openEntity
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.entity.label))]), _c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'external-link-square']
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm.thread.length ? _c('div', {
    staticClass: "comments-collapse"
  }, [_vm.thread.length ? _c('div', {
    staticClass: "comments-collapse__button-white",
    on: {
      "click": _vm.openComments
    }
  }, [_c('div', {
    class: ['comments-collapse__button-body', {
      unread: _vm.hasUnreadComment
    }, {
      opened: _vm.commentsOpened
    }]
  }, [_vm._v(" " + _vm._s(_vm.$t("ask.comments")) + " "), _vm.thread.length ? _c('span', [_vm._v(_vm._s(_vm.thread.length))]) : _vm._e(), _c('font-awesome-icon', {
    class: ['comments-collapse__button__icon ', {
      opened: _vm.commentsOpened
    }],
    attrs: {
      "icon": ['fal', 'chevron-down']
    }
  })], 1)]) : _vm._e(), _c('div', {
    ref: "commentsCollapse",
    staticClass: "comments-collapse__content",
    style: _vm.calculateCommentsMaxHeight,
    on: {
      "click": _vm.readComments
    }
  }, _vm._l(_vm.thread, function (comment, i) {
    return _c('FeedbackComment', {
      key: comment.id,
      attrs: {
        "comment": comment,
        "unread": i === _vm.thread.length - 1 && _vm.hasUnreadComment
      }
    });
  }), 1), _vm.commentsOpened ? _c('div', {
    staticClass: "comments-collapse__input"
  }, [_c('div', {
    staticClass: "flex items-center gap-2 relative border border-gray-2 rounded w-full"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.response,
      expression: "response"
    }],
    ref: "responseInput",
    staticClass: "send-comment__input",
    attrs: {
      "type": "text",
      "placeholder": this.$t('ask.answer')
    },
    domProps: {
      "value": _vm.response
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleNewComment.apply(null, arguments);
      },
      "focus": _vm.readComments,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.response = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('AddAttachment', {
    ref: "add-attachment",
    staticClass: "attachment-wrapper mr-1",
    attrs: {
      "disabled": _vm.fileInputDisable,
      "attachment-loading": _vm.attachmentLoading
    },
    on: {
      "new-attachment": _vm.handleFileChange,
      "disable-click": function ($event) {
        return _vm.showDisableFileUpload('ask.disable-file-upload');
      }
    },
    scopedSlots: _vm._u([{
      key: "slot-button",
      fn: function () {
        return [_c('div', {
          staticClass: "attachment-wrapper",
          class: _vm.attachmentLoading ? 'attachment-wrapper__disable' : 'attachment-wrapper__enable'
        }, [_c('font-awesome-icon', {
          staticClass: "attachment-icon",
          class: _vm.attachmentLoading ? 'attachment-icon__disable' : 'attachment-icon__enable',
          attrs: {
            "icon": ['fal', 'paperclip']
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 861292193)
  }), _c('button', {
    staticClass: "send-comment__button",
    attrs: {
      "disabled": !_vm.isSendable
    },
    on: {
      "click": _vm.handleNewComment
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['fal', 'paper-plane']
    }
  })], 1)], 1)])]) : _vm._e(), _c('AttachmentList', {
    staticClass: "mt-1",
    attrs: {
      "attachments": _vm.attachments,
      "isInput": true,
      "displayDisableFileUpload": _vm.displayDisableFileUpload,
      "errorText": _vm.errorText
    },
    on: {
      "delete-attachment": _vm.handleDeleteAttachment
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "feedback-collapse__body"
  }, [_c('p', {
    staticClass: "feedback-collapse__body__label"
  }, [_vm._v(" " + _vm._s(this.$t("ask.label-text")) + ": ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sanitize(this.body))
    }
  }), _vm.hasAttachments ? _c('AttachmentList', {
    staticClass: "mt-1",
    attrs: {
      "attachments": _vm.feedback.attachments,
      "isInput": false,
      "displayHeader": true
    }
  }) : _vm._e()], 1)])]);
};
var FeedbackCollapsevue_type_template_id_a493ef0a_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/FeedbackComment.vue?vue&type=template&id=0fff4ebf&scoped=true&
var FeedbackCommentvue_type_template_id_0fff4ebf_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['feedback-comment', {
      unread: _vm.unread
    }]
  }, [_c('div', {
    staticClass: "feedback-comment__header"
  }, [_c('Avatar', {
    attrs: {
      "username": _vm.comment.author.username
    }
  }), _c('div', {
    staticClass: "username"
  }, [_vm._v(" " + _vm._s(_vm.comment.author.username) + " ")]), _vm.isEdited ? _c('span', {
    staticClass: "comment-is-edited ml-1"
  }, [_vm._v(_vm._s(_vm.$t("notifications.info.edited")))]) : _vm._e(), _c('div', {
    staticClass: "date"
  }, [_vm._v(" " + _vm._s(_vm.createdAt) + " ")])], 1), _vm.comment.comment ? _c('NotificationEditor', {
    attrs: {
      "body": _vm.comment.comment,
      "editable": false,
      "messageOptions": true
    }
  }) : _vm._e(), _vm.hasAttachments ? _c('AttachmentList', {
    staticClass: "mt-1",
    attrs: {
      "attachments": _vm.comment.attachments,
      "isInput": false,
      "displayHeader": true
    }
  }) : _vm._e()], 1);
};
var FeedbackCommentvue_type_template_id_0fff4ebf_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Avatar.vue?vue&type=template&id=4a7fea66&
var Avatarvue_type_template_id_4a7fea66_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-avatar",
    style: [_vm.colorStyle, _vm.avatarSize]
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.capitalLetter))])]);
};
var Avatarvue_type_template_id_4a7fea66_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Avatar.vue?vue&type=script&lang=js&
const Avatarvue_type_script_lang_js_userColor = (str, s, l) => {
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = hash % 360;
  return `hsl(${h},${s}%,${l}%)`;
};
/* harmony default export */ var Avatarvue_type_script_lang_js_ = ({
  name: "user-avatar",
  props: {
    username: {
      type: String,
      default: ""
    }
  },
  computed: {
    capitalLetter() {
      return this.username.charAt(0).toUpperCase();
    },
    colorStyle() {
      return {
        background: this.username !== null && this.username !== "?" ? Avatarvue_type_script_lang_js_userColor(this.username, 70, 50) : "#0081f9"
      };
    },
    avatarSize() {
      return {
        width: "24px",
        height: "24px"
      };
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Avatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_Avatarvue_type_script_lang_js_ = (Avatarvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Avatar.vue?vue&type=style&index=0&id=4a7fea66&prod&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Avatar.vue?vue&type=style&index=0&id=4a7fea66&prod&lang=css&

;// CONCATENATED MODULE: ./src/library/Avatar.vue



;


/* normalize component */

var Avatar_component = normalizeComponent(
  library_Avatarvue_type_script_lang_js_,
  Avatarvue_type_template_id_4a7fea66_render,
  Avatarvue_type_template_id_4a7fea66_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Avatar = (Avatar_component.exports);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(7856);
;// CONCATENATED MODULE: ./src/utils/dompurify.js

const sanitize = body => purify.sanitize(body, {
  FORBID_TAGS: ["script"]
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/FeedbackComment.vue?vue&type=script&lang=js&




/* harmony default export */ var FeedbackCommentvue_type_script_lang_js_ = ({
  name: "FeedbackComment",
  data() {
    return {
      sanitize: sanitize
    };
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    unread: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Avatar: Avatar,
    AttachmentList: AttachmentList,
    NotificationEditor: NotificationEditor
  },
  computed: {
    hasAttachments() {
      return this.comment.attachments && this.comment.attachments.length;
    },
    isEdited() {
      return this.comment.updatedAt && this.comment.createdAt !== this.comment.updatedAt;
    },
    createdAt() {
      return new Date(parseInt(this.comment.createdAt)).toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "numeric",
        year: "2-digit"
      });
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/components/FeedbackComment.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FeedbackCommentvue_type_script_lang_js_ = (FeedbackCommentvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/FeedbackComment.vue?vue&type=style&index=0&id=0fff4ebf&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/feedback/components/FeedbackComment.vue?vue&type=style&index=0&id=0fff4ebf&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/feedback/components/FeedbackComment.vue



;


/* normalize component */

var FeedbackComment_component = normalizeComponent(
  components_FeedbackCommentvue_type_script_lang_js_,
  FeedbackCommentvue_type_template_id_0fff4ebf_scoped_true_render,
  FeedbackCommentvue_type_template_id_0fff4ebf_scoped_true_staticRenderFns,
  false,
  null,
  "0fff4ebf",
  null
  
)

/* harmony default export */ var FeedbackComment = (FeedbackComment_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/FeedbackCollapse.vue?vue&type=script&lang=js&








/* harmony default export */ var FeedbackCollapsevue_type_script_lang_js_ = ({
  name: "FeedbackCollapse",
  props: {
    feedback: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      focusedFeedback: null,
      thread: [],
      body: "",
      cardOpened: false,
      commentsOpened: false,
      editingAnswer: false,
      response: "",
      entity: {
        id: null,
        label: null,
        type: null
      },
      loading: false,
      sanitize: sanitize
    };
  },
  components: {
    FeedbackComment: FeedbackComment,
    LoaderLine: library_LoaderLine,
    AttachmentList: AttachmentList,
    AddAttachment: AddAttachment
  },
  mixins: [attachmentMixins()],
  computed: {
    createdAt() {
      return new Date(parseInt(this.feedback.createdAt)).toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "numeric",
        year: "2-digit"
      });
    },
    calculateMaxHeight() {
      const transform = "transform: translateY(0px);";
      if (this.cardOpened) {
        if (this.commentsOpened) return transform + "max-height: none;";
        return transform + "max-height: " + 100 + this.thread.length * 100 + "px;";
      }
      return "max-height:0px";
    },
    calculateCommentsMaxHeight() {
      if (this.commentsOpened) {
        return "max-height:200px;";
      }
      return "max-height:0px";
    },
    hasUnreadComment() {
      return this.feedback.unreadCommentsCount > 0;
    },
    hasAttachments() {
      return this.feedback.attachments && this.feedback.attachments.length;
    },
    attachmentsSendable() {
      let sendable = true;
      if (this.attachments.length) {
        sendable = this.attachments.map(at => !at.error || !at.loading).every(el => el);
      }
      return sendable && !this.attachmentLoading;
    },
    isSendable() {
      return this.attachments.length && this.attachmentsSendable || !this.attachments.length && this.response.length;
    }
  },
  methods: {
    async focusFeedback() {
      if (!this.loading) {
        if (!this.cardOpened && this.body === "") {
          this.loading = true;
          this.focusedFeedback = await this.getFeedback(this.feedback.id);
          this.thread = this.focusedFeedback.comment;
          this.body = this.focusedFeedback.body;
          this.entity = {
            id: this.focusedFeedback.entityId,
            label: this.focusedFeedback.entityLabel,
            type: this.focusedFeedback.entityType,
            knowledgeId: this.focusedFeedback.knowledgeId
          };
        }
        this.cardOpened = !this.cardOpened;
        this.commentsOpened = false;
        this.loading = false;
      }
    },
    async handleNewComment() {
      if (!this.isSendable) return;
      try {
        const newComment = await this.feedbackComment({
          feedbackId: this.focusedFeedback.id,
          comment: this.response,
          attachments: this.attachments.map(at => at.url)
        });
        this.thread.push(newComment);
        this.response = "";
        this.attachments = [];
        this.editingAnswer = false;
        setTimeout(() => {
          this.$refs.commentsCollapse.scrollTop = this.$refs.commentsCollapse.scrollHeight;
        }, 100);
      } catch (e) {
        // DO SOMETHINGS
      }
    },
    openComments() {
      this.$refs.commentsCollapse.scrollTo({
        top: this.$refs.commentsCollapse.scrollHeight,
        behavior: "smooth"
      });
      this.commentsOpened = !this.commentsOpened;
    },
    openEntity() {
      this.$emit("select-item", this.entity);
    },
    readComments() {
      if (this.hasUnreadComment && this.commentsOpened) {
        this.$emit("read-comments", this.feedback.id);
      }
    },
    ...mapActions("feedbackModule", ["getFeedback", "feedbackComment"])
  },
  watch: {
    response() {
      const input = this.$refs.responseInput;
      if (input.scrollHeight > input.clientHeight) {
        input.style.height = input.scrollHeight + "px";
      } else {
        input.style.height = "34px";
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/components/FeedbackCollapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FeedbackCollapsevue_type_script_lang_js_ = (FeedbackCollapsevue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/FeedbackCollapse.vue?vue&type=style&index=0&id=a493ef0a&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/feedback/components/FeedbackCollapse.vue?vue&type=style&index=0&id=a493ef0a&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/feedback/components/FeedbackCollapse.vue



;


/* normalize component */

var FeedbackCollapse_component = normalizeComponent(
  components_FeedbackCollapsevue_type_script_lang_js_,
  FeedbackCollapsevue_type_template_id_a493ef0a_scoped_true_render,
  FeedbackCollapsevue_type_template_id_a493ef0a_scoped_true_staticRenderFns,
  false,
  null,
  "a493ef0a",
  null
  
)

/* harmony default export */ var FeedbackCollapse = (FeedbackCollapse_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/HistoryFeedback.vue?vue&type=script&lang=js&




/* harmony default export */ var HistoryFeedbackvue_type_script_lang_js_ = ({
  name: "HistoryFeedback",
  components: {
    LoaderSpinner: LoaderSpinner,
    FeedbackCollapse: FeedbackCollapse,
    BaseButton: BaseButton
  },
  data() {
    return {
      page: 1,
      loading: false
    };
  },
  computed: {
    ...mapGetters("feedbackModule", ["feedbacks", "pages", "unreadCommentCount"])
  },
  async created() {
    this.loading = true;
    await this.getFeedbacks();
    await this.getUnreadCommentCount();
    this.loading = false;
  },
  methods: {
    handleSelectItem(item) {
      this.$emit("select-item", item);
    },
    handleReadComments(feedbackId) {
      this.readFeedbackComments(feedbackId);
    },
    handleNewFeedback() {
      this.$emit("new-feedback");
    },
    showMore() {
      this.page += 1;
      this.getFeedbacks(this.page);
    },
    ...mapActions("feedbackModule", ["getFeedbacks", "readFeedbackComments", "getUnreadCommentCount"])
  },
  watch: {
    unreadCommentCount: {
      async handler(newValue, oldValue) {
        if (newValue > oldValue) {
          this.loading = true;
          await this.getFeedbacks();
          this.loading = false;
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/components/HistoryFeedback.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_HistoryFeedbackvue_type_script_lang_js_ = (HistoryFeedbackvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/HistoryFeedback.vue?vue&type=style&index=0&id=4e79db93&prod&scoped=true&lang=css&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/feedback/components/HistoryFeedback.vue?vue&type=style&index=0&id=4e79db93&prod&scoped=true&lang=css&

;// CONCATENATED MODULE: ./src/modules/feedback/components/HistoryFeedback.vue



;


/* normalize component */

var HistoryFeedback_component = normalizeComponent(
  components_HistoryFeedbackvue_type_script_lang_js_,
  HistoryFeedbackvue_type_template_id_4e79db93_scoped_true_render,
  HistoryFeedbackvue_type_template_id_4e79db93_scoped_true_staticRenderFns,
  false,
  null,
  "4e79db93",
  null
  
)

/* harmony default export */ var HistoryFeedback = (HistoryFeedback_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Tabs.vue?vue&type=template&id=be0780da&scoped=true&
var Tabsvue_type_template_id_be0780da_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "md-tabs"
  }, [_c('div', {
    staticClass: "md-tabs-header"
  }, _vm._l(_vm.tabs, function (tab, index) {
    return _c('div', {
      key: index,
      staticClass: "md-tab",
      class: {
        'md-active': index === _vm.activeTab
      },
      on: {
        "click": function ($event) {
          return _vm.setActiveTab(index);
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": tab.icon
      }
    }), _c('div', {
      staticClass: "md-tab__label"
    }, [_vm._v(" " + _vm._s(tab.label) + " "), tab.notifContent ? _c('span', {
      staticClass: "fa-layers-counter fa-2x md-tab__notif bg-red"
    }, [_vm._v(" " + _vm._s(tab.notifContent) + " ")]) : _vm._e()])], 1);
  }), 0), _c('div', {
    staticClass: "md-tabs-content"
  }, [_vm._t(_vm.tabs[_vm.activeTab].name)], 2)]);
};
var Tabsvue_type_template_id_be0780da_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Tabs.vue?vue&type=script&lang=js&
/* harmony default export */ var Tabsvue_type_script_lang_js_ = ({
  name: "BaseTabs",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: Number,
      default: 0
    }
  },
  methods: {
    setActiveTab(index) {
      this.$emit("update-tab", index);
    }
  }
});
;// CONCATENATED MODULE: ./src/library/Tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_Tabsvue_type_script_lang_js_ = (Tabsvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/Tabs.vue?vue&type=style&index=0&id=be0780da&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/Tabs.vue?vue&type=style&index=0&id=be0780da&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/Tabs.vue



;


/* normalize component */

var Tabs_component = normalizeComponent(
  library_Tabsvue_type_script_lang_js_,
  Tabsvue_type_template_id_be0780da_scoped_true_render,
  Tabsvue_type_template_id_be0780da_scoped_true_staticRenderFns,
  false,
  null,
  "be0780da",
  null
  
)

/* harmony default export */ var Tabs = (Tabs_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/NewFeedback.vue?vue&type=template&id=4ea6d485&scoped=true&
var NewFeedbackvue_type_template_id_4ea6d485_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bg-white flex-grow flex flex-col space-between"
  }, [_c('div', {
    staticClass: "p-4 flex-1 flex flex-col space-y-3"
  }, [_c('base-input', {
    staticClass: "feedback-input text-left flex-1",
    attrs: {
      "label-classes": "!font-semibold !text-black",
      "label": _vm.$t('ask.label-text'),
      "show-or-hide": false
    }
  }, [_c('textarea', {
    ref: "feedback-textarea",
    staticClass: "textarea border-none",
    attrs: {
      "id": "feedback-textarea",
      "placeholder": _vm.$t('ask.placeholder'),
      "rows": "8"
    },
    domProps: {
      "value": _vm.savedFeedback
    },
    on: {
      "input": _vm.handleEditFeedback,
      "keydown": _vm.handleKeydown
    }
  })]), _c('div', {
    staticClass: "flex align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "!font-semibold !text-black"
  }, [_vm._v(" " + _vm._s(_vm.$tc("ask.attachment", _vm.attachments.length)) + " ")]), _c('base-file-input', {
    attrs: {
      "disabled": _vm.fileInputDisable,
      "loading": _vm.attachmentLoading
    },
    on: {
      "change": _vm.handleFileChange,
      "disable-click": function ($event) {
        return _vm.showDisableFileUpload('ask.disable-file-upload');
      }
    }
  })], 1), _c('div', {
    staticClass: "mt-0"
  }, [_c('AttachmentList', {
    attrs: {
      "attachments": _vm.attachments,
      "isInput": true,
      "displayDisableFileUpload": _vm.displayDisableFileUpload,
      "errorText": _vm.errorText,
      "displayHeader": false,
      "attachment-width": '49%'
    },
    on: {
      "delete-attachment": _vm.handleDeleteAttachment,
      "disable-click": function ($event) {
        return _vm.showDisableFileUpload();
      }
    }
  })], 1), _c('base-input', {
    staticClass: "text-left",
    attrs: {
      "label-classes": "!font-semibold !text-black",
      "label": _vm.$t('ask.label-target'),
      "show-or-hide": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.collaboratorId,
      expression: "collaboratorId"
    }],
    staticClass: "border-none w-full p-2 cursor-pointer",
    attrs: {
      "required": ""
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.collaboratorId = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ask.target-placeholder")) + " ")]), _vm.assignableEntities.collaborator.length ? _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ask.collaborators")) + " ")]) : _vm._e(), _vm._l(_vm.assignableEntities.collaborator, function (recipient) {
    return _c('option', {
      key: recipient.value.id,
      domProps: {
        "value": recipient.value
      }
    }, [_vm._v(" " + _vm._s(recipient.username) + " ")]);
  }), _vm.assignableEntities.group.length ? _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ask.groups")) + " ")]) : _vm._e(), _vm._l(_vm.assignableEntities.group, function (recipient) {
    return _c('option', {
      key: recipient.value.id,
      domProps: {
        "value": recipient.value
      }
    }, [_vm._v(" " + _vm._s(recipient.username) + " ")]);
  })], 2)]), _vm.focusContentLabel ? _c('div', [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "w-3/4 text-sm flex flex-col space-y-2"
  }, [_c('span', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$t("ask.link")))]), _c('span', [_vm._v(_vm._s(_vm.focusContentLabel))])]), _c('base-switch', {
    attrs: {
      "off-text": null,
      "on-text": null
    },
    model: {
      value: _vm.hasNodeLinked,
      callback: function ($$v) {
        _vm.hasNodeLinked = $$v;
      },
      expression: "hasNodeLinked"
    }
  })], 1)]) : _vm._e()], 1), _c('div', {
    staticClass: "flex flex-row-reverse bg-gray-2 w-full px-4 py-3"
  }, [_c('base-button', {
    staticClass: "mr-0 bg-blue",
    attrs: {
      "disabled": !_vm.formValidated,
      "outline": "",
      "size": "sm",
      "text-color": "white",
      "type": "submit"
    },
    on: {
      "click": _vm.sendFeedback
    }
  }, [_vm._v(_vm._s(_vm.$t("ask.cta")) + " ")]), _c('base-button', {
    staticClass: "mr-2 bg-transparent",
    attrs: {
      "size": "sm",
      "text-color": "blue",
      "type": "button"
    },
    on: {
      "click": _vm.resetFeedback
    }
  }, [_vm._v(_vm._s(_vm.$t("ask.cancel")) + " ")])], 1)]);
};
var NewFeedbackvue_type_template_id_4ea6d485_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseSwitch.vue?vue&type=template&id=f1d78538&scoped=true&
var BaseSwitchvue_type_template_id_f1d78538_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "custom-toggle",
    class: _vm.switchClass
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm.model
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.model = $$c;
        }
      }
    }
  }), _c('span', {
    staticClass: "custom-toggle-slider rounded-full",
    attrs: {
      "data-label-off": _vm.offText,
      "data-label-on": _vm.onText
    }
  })]);
};
var BaseSwitchvue_type_template_id_f1d78538_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseSwitch.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseSwitchvue_type_script_lang_js_ = ({
  name: "base-switch",
  props: {
    value: [Array, Boolean],
    type: String,
    onText: {
      type: String,
      default: "Oui"
    },
    offText: {
      type: String,
      default: "Non"
    }
  },
  computed: {
    switchClass() {
      const baseClass = "custom-toggle-";
      if (this.type) {
        return baseClass + this.type;
      }
      return "";
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    triggerToggle() {
      this.model = !this.model;
    }
  }
});
;// CONCATENATED MODULE: ./src/library/BaseSwitch.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_BaseSwitchvue_type_script_lang_js_ = (BaseSwitchvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseSwitch.vue?vue&type=style&index=0&id=f1d78538&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseSwitch.vue?vue&type=style&index=0&id=f1d78538&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/BaseSwitch.vue



;


/* normalize component */

var BaseSwitch_component = normalizeComponent(
  library_BaseSwitchvue_type_script_lang_js_,
  BaseSwitchvue_type_template_id_f1d78538_scoped_true_render,
  BaseSwitchvue_type_template_id_f1d78538_scoped_true_staticRenderFns,
  false,
  null,
  "f1d78538",
  null
  
)

/* harmony default export */ var BaseSwitch = (BaseSwitch_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseFileInput.vue?vue&type=template&id=321db500&scoped=true&
var BaseFileInputvue_type_template_id_321db500_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      'opacity-50 cursor-not-allowed': _vm.disabled
    }
  }, [_c('label', {
    attrs: {
      "for": "file-upload"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "add-button btn-sm btn-outline-submit"
  }, [!_vm.loading ? _c('div', [_vm._v(" " + _vm._s(_vm.$t("ask.add")) + " ")]) : _c('font-awesome-icon', {
    staticClass: "close-icon icon-loading",
    attrs: {
      "icon": ['fas', 'spinner-third'],
      "spin": ""
    }
  })], 1)]), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-upload",
      "accept": "image/png, image/jpeg, .doc,.docx, application/pdf",
      "disabled": _vm.disabled || _vm.loading,
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileChange,
      "click": _vm.handleClickOnInput
    }
  })]);
};
var BaseFileInputvue_type_template_id_321db500_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseFileInput.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseFileInputvue_type_script_lang_js_ = ({
  name: "base-file-input",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleFileChange(e) {
      this.$emit("change", e);
    },
    handleClick() {
      if (this.disabled) this.$emit("disable-click");
    },
    handleClickOnInput(event) {
      event.target.value = "";
    }
  }
});
;// CONCATENATED MODULE: ./src/library/BaseFileInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var library_BaseFileInputvue_type_script_lang_js_ = (BaseFileInputvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/library/BaseFileInput.vue?vue&type=style&index=0&id=321db500&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/library/BaseFileInput.vue?vue&type=style&index=0&id=321db500&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/library/BaseFileInput.vue



;


/* normalize component */

var BaseFileInput_component = normalizeComponent(
  library_BaseFileInputvue_type_script_lang_js_,
  BaseFileInputvue_type_template_id_321db500_scoped_true_render,
  BaseFileInputvue_type_template_id_321db500_scoped_true_staticRenderFns,
  false,
  null,
  "321db500",
  null
  
)

/* harmony default export */ var BaseFileInput = (BaseFileInput_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/NewFeedback.vue?vue&type=script&lang=js&








/* harmony default export */ var NewFeedbackvue_type_script_lang_js_ = ({
  name: "FeedbackView",
  components: {
    BaseButton: BaseButton,
    BaseSwitch: BaseSwitch,
    BaseInput: BaseInput,
    BaseFileInput: BaseFileInput,
    AttachmentList: AttachmentList
  },
  data() {
    return {
      collaboratorId: "",
      hasNodeLinked: true,
      assignableEntities: {
        group: [],
        collaborator: []
      }
    };
  },
  mixins: [attachmentMixins()],
  created() {
    this.$emit("refresh-roles");
  },
  watch: {
    reportRecipients: {
      handler: function () {
        this.assignableEntities = {
          group: [],
          collaborator: []
        };
        this.reportRecipients.forEach(recipient => {
          this.assignableEntities[recipient.value.type].push(recipient);
        });
      },
      immediate: true
    }
  },
  props: {
    source: {
      type: String,
      default: "diagnostic"
    },
    reportRecipients: {
      type: Array,
      default: () => []
    },
    collectionPath: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    mainContent: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    feedbackContext() {
      let rawPath = [...this.collectionPath, ...this.contentParents];
      if (this.modalType === "article" && this.source === "article") {
        rawPath = [...rawPath, this.modalContent];
      }
      return {
        path: rawPath.map(el => String(el.id)),
        tags: rawPath.map(el => el.label)
      };
    },
    path() {
      return this.feedbackContext.path;
    },
    pathTags() {
      return this.feedbackContext.tags || [];
    },
    attachmentsSendable() {
      let sendable = true;
      this.attachments.forEach(at => {
        if (at.error || at.loading) sendable = false;
      });
      return sendable;
    },
    formValidated() {
      return this.savedFeedback.length > 0 && this.collaboratorId !== "" && !this.attachmentLoading && this.attachmentsSendable;
    },
    focusedContent() {
      if (this.mainContent && this.mainContent.type === "Knowledge") return {};
      return this.source === "diagnostic" ? this.mainContent : this.modalContent;
    },
    mainContentUrl() {
      const {
        type,
        id
      } = this.focusedContent;
      if (!type || !id) return null;
      if (type === "Case") return `knowledge/case/${id}`;
      if (["Article", "Diagnostic"].includes(type)) {
        return `knowledge/content/${id}`;
      }
      if (["Step", "keyStep"].includes(type)) {
        const main = this.contentParents[0];
        if (!main) return null;
        return `knowledge/content/${main.id}/step/${id}`;
      }
      return null;
    },
    focusContentLabel() {
      return this.focusedContent ? this.focusedContent.label : null;
    },
    fileInputDisable() {
      return this.attachments.length >= 3;
    },
    ...mapGetters("feedbackModule", ["savedFeedback"])
  },
  methods: {
    handleKeydown(e) {
      e.stopPropagation();
    },
    handleEditFeedback(e) {
      const {
        value
      } = e.target;
      this.setFeedback(value);
      this.$emit("edit-feedback");
      e.stopPropagation();
    },
    async sendFeedback() {
      const {
        id,
        type
      } = this.collaboratorId;
      const payload = {
        log: {
          topic: this.hasNodeLinked ? "CONTENT_FEEDBACK" : "GENERAL_FEEDBACK",
          event: {
            feedback: {
              recipientId: type === "collaborator" ? id : null,
              groupId: type === "group" ? id : null,
              path: [this.mainContentUrl],
              tags: this.pathTags,
              feedback: this.savedFeedback,
              hasNodeLinked: this.hasNodeLinked,
              entityType: this.focusedContent ? this.focusedContent.type : null,
              entityId: this.focusedContent ? this.focusedContent.id : null,
              attachments: this.attachments.map(file => file.url)
            },
            ...(this.hasNodeLinked && this.focusedContent ? {
              content: this.focusedContent
            } : {}),
            location: this.source
          },
          url: window.location.href
        },
        knowledge: {
          recipientId: type === "collaborator" ? id : null,
          groupId: type === "group" ? id : null,
          path: [this.mainContentUrl],
          tags: this.pathTags,
          feedback: this.savedFeedback,
          hasNodeLinked: this.hasNodeLinked,
          ...(this.hasNodeLinked && this.focusedContent ? {
            entityId: this.focusedContent.id,
            entityType: this.focusedContent.type
          } : {}),
          attachments: this.attachments.map(file => file.url)
        }
      };
      try {
        const res = await this.postFeedback(payload.knowledge);
        if (res.message) {
          this.resetFeedback();
          this.$emit("send-feedback", payload);
        }
      } catch (error) {
        console.log(error);
      }
    },
    resetFeedback() {
      if (this.collaboratorId || this.savedFeedback || !this.hasNodeLinked) {
        this.collaboratorId = "";
        this.hasNodeLinked = true;
        this.attachments = [];
        this.setFeedback("");
        return;
      }
      this.$emit("cancel");
    },
    ...mapActions("feedbackModule", ["setFeedback", "postFeedback"]),
    ...mapActions("adminModule", ["updateRoles"])
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/components/NewFeedback.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_NewFeedbackvue_type_script_lang_js_ = (NewFeedbackvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-63.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/components/NewFeedback.vue?vue&type=style&index=0&id=4ea6d485&prod&lang=postcss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/modules/feedback/components/NewFeedback.vue?vue&type=style&index=0&id=4ea6d485&prod&lang=postcss&scoped=true&

;// CONCATENATED MODULE: ./src/modules/feedback/components/NewFeedback.vue



;


/* normalize component */

var NewFeedback_component = normalizeComponent(
  components_NewFeedbackvue_type_script_lang_js_,
  NewFeedbackvue_type_template_id_4ea6d485_scoped_true_render,
  NewFeedbackvue_type_template_id_4ea6d485_scoped_true_staticRenderFns,
  false,
  null,
  "4ea6d485",
  null
  
)

/* harmony default export */ var NewFeedback = (NewFeedback_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-86.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/modules/feedback/Feedback.vue?vue&type=script&lang=js&




/* harmony default export */ var Feedbackvue_type_script_lang_js_ = ({
  name: "FeedbackView",
  components: {
    BaseTabs: Tabs,
    NewFeedback: NewFeedback,
    HistoryFeedback: HistoryFeedback
  },
  props: {
    source: {
      type: String,
      default: "diagnostic"
    },
    reportRecipients: {
      type: Array,
      default: () => []
    },
    collectionPath: {
      type: Array,
      default: () => []
    },
    contentParents: {
      type: Array,
      default: () => []
    },
    mainContent: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      collaboratorId: null,
      hasNodeLinked: false,
      activeTab: 0
    };
  },
  computed: {
    getTabs() {
      return [{
        icon: ["fal", "pen"],
        label: this.$t("ask.tab-new"),
        name: "new"
      }, {
        icon: ["fal", "paper-plane"],
        label: this.$t("ask.tab-history"),
        name: "history",
        notifContent: this.unreadCommentCount > 0 ? "!" : null
      }];
    },
    feedbackContext() {
      let rawPath = [...this.collectionPath, ...this.contentParents];
      if (this.modalType === "article" && this.source === "article") {
        rawPath = [...rawPath, this.modalContent];
      }
      return {
        path: rawPath.map(el => String(el.id)),
        tags: rawPath.map(el => el.label)
      };
    },
    path() {
      return this.feedbackContext.path;
    },
    pathTags() {
      return this.feedbackContext.tags;
    },
    formValidated() {
      return this.savedFeedback.length > 0 && this.collaboratorId !== null;
    },
    focusedContent() {
      if (this.path.length < 2) return {};
      return this.source === "diagnostic" ? this.mainContent : this.modalContent;
    },
    mainContentUrl() {
      const {
        type,
        id
      } = this.focusedContent;
      if (!type || !id) return null;
      if (type === "Case") return `knowledge/case/${id}`;
      if (["Article", "Diagnostic"].includes(type)) {
        return `knowledge/content/${id}`;
      }
      if (["Step", "keyStep"].includes(type)) {
        const main = this.contentParents[0];
        if (!main) return null;
        return `knowledge/content/${main.id}/step/${id}`;
      }
      return null;
    },
    focusContentLabel() {
      return this.focusedContent ? this.focusedContent.label : null;
    },
    ...mapGetters("feedbackModule", ["savedFeedback", "unreadCommentCount"])
  },
  methods: {
    async sendFeedback(payload) {
      this.$emit("send-feedback", payload.log);
    },
    handeSelectItem(item) {
      this.$emit("select-item", item);
    },
    handleSelectTab(tab) {
      this.activeTab = tab;
    },
    handleRefreshRoles() {
      this.$emit("refresh-roles");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    ...mapActions("feedbackModule", ["setFeedback"])
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/Feedback.vue?vue&type=script&lang=js&
 /* harmony default export */ var feedback_Feedbackvue_type_script_lang_js_ = (Feedbackvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/modules/feedback/Feedback.vue





/* normalize component */
;
var Feedback_component = normalizeComponent(
  feedback_Feedbackvue_type_script_lang_js_,
  Feedbackvue_type_template_id_50ece7c0_render,
  Feedbackvue_type_template_id_50ece7c0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Feedback = (Feedback_component.exports);
;// CONCATENATED MODULE: ./src/modules/feedback/store/mutation-types.ts
const feedback_store_mutation_types_LOGOUT = "LOGOUT";
// Feedback Mutations
const SET_FEEDBACK = "SET_FEEDBACK";
const UPDATE_FEEDBACKS = "UPDATE_FEEDBACKS";
const LOADING_FEEDBACKS = "LOADING_FEEDBACKS";
const SET_UNREAD_COMMENT_COUNT = "SET_UNREAD_COMMENT_COUNT";
;// CONCATENATED MODULE: ./src/modules/feedback/store/actions.ts

/* harmony default export */ var feedback_store_actions = ({
  logout({
    commit
  }) {
    commit(feedback_store_mutation_types_LOGOUT);
  },
  async setFeedback({
    commit
  }, feedback) {
    commit(SET_FEEDBACK, feedback);
  },
  async postFeedback({
    commit
  }, payload) {
    return this.$feedbackService.postFeedback(payload);
  },
  async getFeedbacks({
    commit,
    getters
  }, page) {
    try {
      const {
        feedbacks: currentFeedbacks
      } = getters;
      const currentPage = page || 1;
      commit(LOADING_FEEDBACKS, true);
      const {
        feedbacks: newFeedbacks,
        ...res
      } = await this.$feedbackService.getFeedbacks(currentPage);
      const feedbacks = page > 1 ? [...currentFeedbacks, ...newFeedbacks] : newFeedbacks;
      commit(UPDATE_FEEDBACKS, {
        feedbacks,
        ...res
      });
    } catch (e) {
      console.log(e);
    } finally {
      commit(LOADING_FEEDBACKS, false);
    }
  },
  async getFeedback({
    commit
  }, feedbackId) {
    return this.$feedbackService.getFeedback(feedbackId);
  },
  async feedbackComment({
    commit
  }, {
    feedbackId,
    comment,
    attachments
  }) {
    return this.$feedbackService.feedbackComment(feedbackId, comment, attachments);
  },
  async getUnreadCommentCount({
    commit
  }) {
    const count = await this.$feedbackService.getUnreadCommentCount();
    commit(SET_UNREAD_COMMENT_COUNT, count);
  },
  async uploadFiles({
    commit
  }, files) {
    return this.$feedbackService.uploadFiles(files);
  },
  async readFeedbackComments({
    commit,
    getters
  }, feedbackId) {
    await this.$feedbackService.readFeedbackComments(feedbackId);
    const feedbacks = getters.feedbacks;
    feedbacks.find(feedback => feedback.id === feedbackId).unreadCommentsCount = 0;
    const unreadCommentCount = getters.unreadCommentCount - 1;
    commit(SET_UNREAD_COMMENT_COUNT, unreadCommentCount);
    commit(UPDATE_FEEDBACKS, {
      feedbacks
    });
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/store/getters.ts
const feedback_store_getters_getters = {
  savedFeedback: state => state.savedFeedback,
  feedbacks: state => state.feedbacks,
  currentPage: state => state.currentPage,
  pages: state => state.pages,
  feedbackTotal: state => state.total,
  loadingFeedbacks: state => state.loadingFeedbacks,
  unreadCommentCount: state => state.unreadCommentCount
};
/* harmony default export */ var feedback_store_getters = (feedback_store_getters_getters);
;// CONCATENATED MODULE: ./src/modules/feedback/store/state.ts
const feedback_store_state_state = () => ({
  savedFeedback: "",
  feedbacks: [],
  currentPage: 1,
  pages: 0,
  total: 0,
  loadingFeedbacks: false,
  unreadCommentCount: 0
});
;// CONCATENATED MODULE: ./src/modules/feedback/store/mutations.ts


/* harmony default export */ var feedback_store_mutations = ({
  [feedback_store_mutation_types_LOGOUT](state) {
    Object.assign(state, feedback_store_state_state());
  },
  [SET_FEEDBACK](state, feedback) {
    state.savedFeedback = feedback;
  },
  [UPDATE_FEEDBACKS](state, {
    feedbacks,
    total,
    pages
  }) {
    state.feedbacks = feedbacks;
    state.total = total;
    state.pages = pages;
  },
  [LOADING_FEEDBACKS](state, isLoading) {
    state.loadingFeedbacks = isLoading;
  },
  [SET_UNREAD_COMMENT_COUNT](state, count) {
    state.unreadCommentCount = count > -1 ? count : 0;
  }
});
;// CONCATENATED MODULE: ./src/modules/feedback/store/index.ts




const feedbackStore = {
  namespaced: true,
  state: feedback_store_state_state,
  getters: feedback_store_getters,
  actions: feedback_store_actions,
  mutations: feedback_store_mutations
};
;// CONCATENATED MODULE: ./src/modules/feedback/index.ts




const feedbackPlugin = {
  install(Vue, options = {}) {
    const STORE_MODULE_NAME = "feedbackModule";
    console.log(`[${STORE_MODULE_NAME}] Vue version ${Vue.version}`);
    if (options.store == null) {
      console.error(`[${STORE_MODULE_NAME}] vuex store instance not provided, editor library loading aborted`);
      return;
    }
    const {
      store,
      adminClient,
      knowledgeClient
    } = options;
    store.registerModule(STORE_MODULE_NAME, feedbackStore, {
      preserveState: !!store.state[STORE_MODULE_NAME]
    });
    if (adminClient && knowledgeClient) {
      store.$feedbackService = attachFeedbackService(adminClient, knowledgeClient);
    }
    if (options.i18n == null) {
      console.warn(`[${STORE_MODULE_NAME}] vue-i18n instance not provided, translation might not work`);
    } else {
      // use webpack to load all locales
      const locales = __webpack_require__(3631);
      locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
          const locale = matched[1];
          if (options.i18n) options.i18n.mergeLocaleMessage(locale, locales(key));
        }
      });
    }
    Vue.component("feedback-view", Feedback);
    Vue.component("new-feedback", NewFeedback);
  }
};
const FeedbackModule = {
  plugin: feedbackPlugin,
  store: feedbackStore
};
;// CONCATENATED MODULE: ./src/main.ts






// import { LayoutsModule } from "@/modules/layouts";


// import { Library } from "@/library";

// UMD auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof __webpack_require__.g !== "undefined") {
  GlobalVue = __webpack_require__.g.Vue;
}
if (GlobalVue != null) {
  // GlobalVue.use(KnowledgeModule.plugin);
  // GlobalVue.use(SearchModule.plugin);
  // GlobalVue.use(ModalModule.plugin);
  // GlobalVue.use(AdminModule.plugin);
  // GlobalVue.use(NotificationModule.plugin);
  // GlobalVue.use(LogModule.plugin);
  // GlobalVue.use(LayoutsModule);
  // GlobalVue.use(UserFavoritesModule.plugin);
  // GlobalVue.use(Library);
}

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=mayday-modules.umd.js.map